const data = [
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:07:12.727Z",
    key: "emergence-ballet-algorithmique",
    name: "Émergence, ballet algorithmique",
    description:
      "Paris Opera first official NFT collection: 'Emergence, an algorithmic ballet' by Obvious",
    exchange_url:
      "https://opensea.io/collection/emergence-ballet-algorithmique",
    external_url: "https://nft.operadeparis.fr",
    banner_image_url:
      "https://i.seadn.io/gcs/files/52ce76064d31ed4de2bd9e639f4526e4.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/18617d582eb90eb503f9063fb254f858.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/18617d582eb90eb503f9063fb254f858.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/acec667771406384f78e029da3debe2d.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/DV9cUTRBHe",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 217,
      floor_price: 0.048797,
      floor_price_symbol: "ETH",
      total_minted: 217,
      total_supply: null,
      total_volume: 15.876546199945425,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 106,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.1497787377353342,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xe7ad762f2bdac61025cc66db01cecf5106c029e8",
      },
    ],
    id: 1,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:07:12.245Z",
    key: "construction-token-by-jeff-davis",
    name: "Construction Token by Jeff Davis",
    description: null,
    exchange_url:
      "https://opensea.io/collection/construction-token-by-jeff-davis",
    external_url: "https://artblocks.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/ef2c459a8ae055f06e76a22d8b1c468c.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/1ot1dyAyjWb_06B3XJqN6ChLQg_opOt8mHdYNRvn_xa_sYHWNPACgnQr5_8ljT_gMzlM_CG96oNm7qIiWHa1t6lF?w=500&auto=format",
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/1ot1dyAyjWb_06B3XJqN6ChLQg_opOt8mHdYNRvn_xa_sYHWNPACgnQr5_8ljT_gMzlM_CG96oNm7qIiWHa1t6lF?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 275,
      floor_price: 1.5,
      floor_price_symbol: "ETH",
      total_minted: 275,
      total_supply: null,
      total_volume: 2739.3034233133,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 1.75,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -1,
      total_sales: 862,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 3.177846198739327,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 1.75,
    },
    contracts: [
      {
        contract_address: "0x059edd72cd353df5106d2b9cc5ab83a52287ac3a",
      },
    ],
    id: 2,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:06:36.287Z",
    key: "cigawrettepacks",
    name: "Cigawrette Packs",
    description:
      "An experimental literature project of 9999 NFTs exploring the space between PFP and utility.",
    exchange_url: "https://opensea.io/collection/cigawrettepacks",
    external_url: "http://www.cigawrettepacks.shop",
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/5fabbfebaf952d151ea67614a371d419.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 226.50665460699997,
      num_owners: 1887,
      floor_price: 0.026495,
      floor_price_symbol: "ETH",
      total_minted: 1887,
      total_supply: null,
      total_volume: 191.75092806343412,
      one_day_volume: 0.4075967000000001,
      seven_day_volume: 3.6248314399999995,
      thirty_day_volume: 12.253810439999953,
      one_day_volume_change: -20,
      seven_day_volume_change: -146,
      thirty_day_volume_change: 477,
      total_sales: 6625,
      one_day_sales: 19,
      seven_day_sales: 160,
      thirty_day_sales: 626,
      total_average_price: 0.028943536311461755,
      one_day_average_price: 0.02145245789473685,
      seven_day_average_price: 0.0226551965,
      thirty_day_average_price: 0.0195747770607028,
    },
    contracts: [
      {
        contract_address: "0xeed41d06ae195ca8f5cacace4cd691ee75f0683f",
      },
    ],
    id: 3,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:06:28.787Z",
    key: "pepe-rocks",
    name: "Pepe Rocks",
    description: "stay strong.",
    exchange_url: "https://opensea.io/collection/pepe-rocks",
    external_url: "https://mint.fun/0x2981cEfDdcc7F690C01d9BFDa473e21B588D3740",
    banner_image_url:
      "https://i.seadn.io/gcs/files/8bf0f79f7883a0025b470a831d95d4c7.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/8bf0f79f7883a0025b470a831d95d4c7.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/8bf0f79f7883a0025b470a831d95d4c7.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/31a8287322cef32ab556587c6c516d15.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 363,
      floor_price: 0.005,
      floor_price_symbol: "ETH",
      total_minted: 363,
      total_supply: null,
      total_volume: 0.0153,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 3,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.0051,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x2981cefddcc7f690c01d9bfda473e21b588d3740",
      },
    ],
    id: 4,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:06:11.249Z",
    key: "endless-nameless-by-rafael-rozendaal",
    name: "Endless Nameless by Rafaël Rozendaal",
    description:
      "Art Blocks Collection: Curated\n\nHeritage Art Blocks Collection: Curated series 4\n\nProject Description: Endless Nameless is an exploration of composition. We start with a square. The square is divided into sections. The sections are filled with color pairs. Sometimes all colors are used. Sometimes fewer colors are used.",
    exchange_url:
      "https://opensea.io/collection/endless-nameless-by-rafael-rozendaal",
    external_url: "https://artblocks.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/ef2c459a8ae055f06e76a22d8b1c468c.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/539d066c3b32ba565331f302ee38d532.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/539d066c3b32ba565331f302ee38d532.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/c62c13447486c43c52d60a9f37c970e5.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 66.69999999999999,
      num_owners: 605,
      floor_price: 0.11885460000000003,
      floor_price_symbol: "ETH",
      total_minted: 605,
      total_supply: null,
      total_volume: 2017.5715441585635,
      one_day_volume: 0,
      seven_day_volume: 0.0667,
      thirty_day_volume: 0.1571,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: -8,
      total_sales: 1537,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 2,
      total_average_price: 1.3126685388149404,
      one_day_average_price: 0,
      seven_day_average_price: 0.0667,
      thirty_day_average_price: 0.07855,
    },
    contracts: [
      {
        contract_address: "0xa7d8d9ef8d8ce8992df33d8b8cf4aebabd5bd270",
      },
    ],
    id: 5,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:07:23.907Z",
    key: "boneheadz-official",
    name: "BoneHeadz Official",
    description:
      "BoneHeadz is a collection of 5,000 freely minted and upgradeable NFTs on the Ethereum Blockchain. Every BoneHead was minted for free and grants access to tomb raiding. Holders pay a small toll to raid a tomb, collect loot & upgrade their NFTs or die trying every season. The players with the most loot at the end of the season collect their share of the ETH prize pool.",
    exchange_url: "https://opensea.io/collection/boneheadz-official",
    external_url: "https://bonehead.io/",
    banner_image_url:
      "https://i.seadn.io/gae/ngCIbbWxE42oVQaspuGNQAmnnPVO1QhdU9hFhBAoiafGVIm_yd5NMnR-mIoFNsL0dxjfMVf2Zqhk6QvyuValjq2K1SulfS0UtUV_WQ?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/85aT4Q8IY6LGhHInZtOEf8IuxliE2pc73uoac2XfEksY8XU0qHy74TPc8OvTdCZPs02y3PplFpqrEkqNfqe-0foQAFOtFdDWGP5ZhQ?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/85aT4Q8IY6LGhHInZtOEf8IuxliE2pc73uoac2XfEksY8XU0qHy74TPc8OvTdCZPs02y3PplFpqrEkqNfqe-0foQAFOtFdDWGP5ZhQ?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/MJZPIgjfdnFwQvlOhEQGesUICbc6RVJKwkHlWzTKFg1T8cw19P11EqR-N2Ri-xkPVanchQw-0VBG1kxnd4OiPT0uDnDOGA-1ZMaacg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/boneheadz",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 2323,
      floor_price: 0.002,
      floor_price_symbol: "ETH",
      total_minted: 2323,
      total_supply: null,
      total_volume: 194.76527329202534,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 4895,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.03978861558570487,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x010a45801ee731e016aaaa68ee570b9950be0e37",
      },
    ],
    id: 6,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:07:12.727Z",
    key: "emergence-ballet-algorithmique",
    name: "Émergence, ballet algorithmique",
    description:
      "Paris Opera first official NFT collection: 'Emergence, an algorithmic ballet' by Obvious",
    exchange_url:
      "https://opensea.io/collection/emergence-ballet-algorithmique",
    external_url: "https://nft.operadeparis.fr",
    banner_image_url:
      "https://i.seadn.io/gcs/files/52ce76064d31ed4de2bd9e639f4526e4.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/18617d582eb90eb503f9063fb254f858.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/18617d582eb90eb503f9063fb254f858.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/acec667771406384f78e029da3debe2d.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/DV9cUTRBHe",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 217,
      floor_price: 0.048797,
      floor_price_symbol: "ETH",
      total_minted: 217,
      total_supply: null,
      total_volume: 15.876546199945425,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 106,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.1497787377353342,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xe7ad762f2bdac61025cc66db01cecf5106c029e8",
      },
    ],
    id: 7,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:07:49.804Z",
    key: "3dbirds",
    name: "3DBirds",
    description:
      "3D Birds is a collection created by two friends who presented their vision of art through 3D modeling and put their heart and soul into this collection.\r\nThe main goal of the collection remains unchanged. It is to create a unique community of holders and fans of 3D Birds, as well as to give people the opportunity to enjoy the art and even to learn something new and unusual with the help of our works.",
    exchange_url: "https://opensea.io/collection/3dbirds",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/8d455ffba49d2f36fac2ac66d909530d.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/1a2585f7ca4cf5422b0fd3817f33446a.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/1a2585f7ca4cf5422b0fd3817f33446a.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/4fadc8478076bd9950cbcd0c694b340e.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/a8U3B6QXZz",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 4583,
      floor_price: 0.003,
      floor_price_symbol: "ETH",
      total_minted: 4583,
      total_supply: null,
      total_volume: 199.587001381496,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 13086,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.015251948752979978,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xcb897d3a455f55e38ea192ea85af8cd19ca65239",
      },
    ],
    id: 8,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:07:23.907Z",
    key: "boneheadz-official",
    name: "BoneHeadz Official",
    description:
      "BoneHeadz is a collection of 5,000 freely minted and upgradeable NFTs on the Ethereum Blockchain. Every BoneHead was minted for free and grants access to tomb raiding. Holders pay a small toll to raid a tomb, collect loot & upgrade their NFTs or die trying every season. The players with the most loot at the end of the season collect their share of the ETH prize pool.",
    exchange_url: "https://opensea.io/collection/boneheadz-official",
    external_url: "https://bonehead.io/",
    banner_image_url:
      "https://i.seadn.io/gae/ngCIbbWxE42oVQaspuGNQAmnnPVO1QhdU9hFhBAoiafGVIm_yd5NMnR-mIoFNsL0dxjfMVf2Zqhk6QvyuValjq2K1SulfS0UtUV_WQ?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/85aT4Q8IY6LGhHInZtOEf8IuxliE2pc73uoac2XfEksY8XU0qHy74TPc8OvTdCZPs02y3PplFpqrEkqNfqe-0foQAFOtFdDWGP5ZhQ?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/85aT4Q8IY6LGhHInZtOEf8IuxliE2pc73uoac2XfEksY8XU0qHy74TPc8OvTdCZPs02y3PplFpqrEkqNfqe-0foQAFOtFdDWGP5ZhQ?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/MJZPIgjfdnFwQvlOhEQGesUICbc6RVJKwkHlWzTKFg1T8cw19P11EqR-N2Ri-xkPVanchQw-0VBG1kxnd4OiPT0uDnDOGA-1ZMaacg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/boneheadz",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 2323,
      floor_price: 0.002,
      floor_price_symbol: "ETH",
      total_minted: 2323,
      total_supply: null,
      total_volume: 194.76527329202534,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 4895,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.03978861558570487,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x010a45801ee731e016aaaa68ee570b9950be0e37",
      },
    ],
    id: 9,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:07:12.727Z",
    key: "emergence-ballet-algorithmique",
    name: "Émergence, ballet algorithmique",
    description:
      "Paris Opera first official NFT collection: 'Emergence, an algorithmic ballet' by Obvious",
    exchange_url:
      "https://opensea.io/collection/emergence-ballet-algorithmique",
    external_url: "https://nft.operadeparis.fr",
    banner_image_url:
      "https://i.seadn.io/gcs/files/52ce76064d31ed4de2bd9e639f4526e4.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/18617d582eb90eb503f9063fb254f858.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/18617d582eb90eb503f9063fb254f858.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/acec667771406384f78e029da3debe2d.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/DV9cUTRBHe",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 217,
      floor_price: 0.048797,
      floor_price_symbol: "ETH",
      total_minted: 217,
      total_supply: null,
      total_volume: 15.876546199945425,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 106,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.1497787377353342,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xe7ad762f2bdac61025cc66db01cecf5106c029e8",
      },
    ],
    id: 10,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:07:49.804Z",
    key: "3dbirds",
    name: "3DBirds",
    description:
      "3D Birds is a collection created by two friends who presented their vision of art through 3D modeling and put their heart and soul into this collection.\r\nThe main goal of the collection remains unchanged. It is to create a unique community of holders and fans of 3D Birds, as well as to give people the opportunity to enjoy the art and even to learn something new and unusual with the help of our works.",
    exchange_url: "https://opensea.io/collection/3dbirds",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/8d455ffba49d2f36fac2ac66d909530d.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/1a2585f7ca4cf5422b0fd3817f33446a.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/1a2585f7ca4cf5422b0fd3817f33446a.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/4fadc8478076bd9950cbcd0c694b340e.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/a8U3B6QXZz",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 4583,
      floor_price: 0.003,
      floor_price_symbol: "ETH",
      total_minted: 4583,
      total_supply: null,
      total_volume: 199.587001381496,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 13086,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.015251948752979978,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xcb897d3a455f55e38ea192ea85af8cd19ca65239",
      },
    ],
    id: 11,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:07:23.907Z",
    key: "boneheadz-official",
    name: "BoneHeadz Official",
    description:
      "BoneHeadz is a collection of 5,000 freely minted and upgradeable NFTs on the Ethereum Blockchain. Every BoneHead was minted for free and grants access to tomb raiding. Holders pay a small toll to raid a tomb, collect loot & upgrade their NFTs or die trying every season. The players with the most loot at the end of the season collect their share of the ETH prize pool.",
    exchange_url: "https://opensea.io/collection/boneheadz-official",
    external_url: "https://bonehead.io/",
    banner_image_url:
      "https://i.seadn.io/gae/ngCIbbWxE42oVQaspuGNQAmnnPVO1QhdU9hFhBAoiafGVIm_yd5NMnR-mIoFNsL0dxjfMVf2Zqhk6QvyuValjq2K1SulfS0UtUV_WQ?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/85aT4Q8IY6LGhHInZtOEf8IuxliE2pc73uoac2XfEksY8XU0qHy74TPc8OvTdCZPs02y3PplFpqrEkqNfqe-0foQAFOtFdDWGP5ZhQ?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/85aT4Q8IY6LGhHInZtOEf8IuxliE2pc73uoac2XfEksY8XU0qHy74TPc8OvTdCZPs02y3PplFpqrEkqNfqe-0foQAFOtFdDWGP5ZhQ?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/MJZPIgjfdnFwQvlOhEQGesUICbc6RVJKwkHlWzTKFg1T8cw19P11EqR-N2Ri-xkPVanchQw-0VBG1kxnd4OiPT0uDnDOGA-1ZMaacg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/boneheadz",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 2323,
      floor_price: 0.002,
      floor_price_symbol: "ETH",
      total_minted: 2323,
      total_supply: null,
      total_volume: 194.76527329202534,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 4895,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.03978861558570487,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x010a45801ee731e016aaaa68ee570b9950be0e37",
      },
    ],
    id: 12,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:07:12.727Z",
    key: "emergence-ballet-algorithmique",
    name: "Émergence, ballet algorithmique",
    description:
      "Paris Opera first official NFT collection: 'Emergence, an algorithmic ballet' by Obvious",
    exchange_url:
      "https://opensea.io/collection/emergence-ballet-algorithmique",
    external_url: "https://nft.operadeparis.fr",
    banner_image_url:
      "https://i.seadn.io/gcs/files/52ce76064d31ed4de2bd9e639f4526e4.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/18617d582eb90eb503f9063fb254f858.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/18617d582eb90eb503f9063fb254f858.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/acec667771406384f78e029da3debe2d.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/DV9cUTRBHe",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 217,
      floor_price: 0.048797,
      floor_price_symbol: "ETH",
      total_minted: 217,
      total_supply: null,
      total_volume: 15.876546199945425,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 106,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.1497787377353342,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xe7ad762f2bdac61025cc66db01cecf5106c029e8",
      },
    ],
    id: 13,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:07:12.245Z",
    key: "construction-token-by-jeff-davis",
    name: "Construction Token by Jeff Davis",
    description: null,
    exchange_url:
      "https://opensea.io/collection/construction-token-by-jeff-davis",
    external_url: "https://artblocks.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/ef2c459a8ae055f06e76a22d8b1c468c.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/1ot1dyAyjWb_06B3XJqN6ChLQg_opOt8mHdYNRvn_xa_sYHWNPACgnQr5_8ljT_gMzlM_CG96oNm7qIiWHa1t6lF?w=500&auto=format",
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/1ot1dyAyjWb_06B3XJqN6ChLQg_opOt8mHdYNRvn_xa_sYHWNPACgnQr5_8ljT_gMzlM_CG96oNm7qIiWHa1t6lF?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 275,
      floor_price: 1.5,
      floor_price_symbol: "ETH",
      total_minted: 275,
      total_supply: null,
      total_volume: 2739.3034233133,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 1.75,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -1,
      total_sales: 862,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 3.177846198739327,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 1.75,
    },
    contracts: [
      {
        contract_address: "0x059edd72cd353df5106d2b9cc5ab83a52287ac3a",
      },
    ],
    id: 14,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:06:36.287Z",
    key: "cigawrettepacks",
    name: "Cigawrette Packs",
    description:
      "An experimental literature project of 9999 NFTs exploring the space between PFP and utility.",
    exchange_url: "https://opensea.io/collection/cigawrettepacks",
    external_url: "http://www.cigawrettepacks.shop",
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/5fabbfebaf952d151ea67614a371d419.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 226.50665460699997,
      num_owners: 1887,
      floor_price: 0.026495,
      floor_price_symbol: "ETH",
      total_minted: 1887,
      total_supply: null,
      total_volume: 191.75092806343412,
      one_day_volume: 0.4075967000000001,
      seven_day_volume: 3.6248314399999995,
      thirty_day_volume: 12.253810439999953,
      one_day_volume_change: -20,
      seven_day_volume_change: -146,
      thirty_day_volume_change: 477,
      total_sales: 6625,
      one_day_sales: 19,
      seven_day_sales: 160,
      thirty_day_sales: 626,
      total_average_price: 0.028943536311461755,
      one_day_average_price: 0.02145245789473685,
      seven_day_average_price: 0.0226551965,
      thirty_day_average_price: 0.0195747770607028,
    },
    contracts: [
      {
        contract_address: "0xeed41d06ae195ca8f5cacace4cd691ee75f0683f",
      },
    ],
    id: 15,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:06:28.787Z",
    key: "pepe-rocks",
    name: "Pepe Rocks",
    description: "stay strong.",
    exchange_url: "https://opensea.io/collection/pepe-rocks",
    external_url: "https://mint.fun/0x2981cEfDdcc7F690C01d9BFDa473e21B588D3740",
    banner_image_url:
      "https://i.seadn.io/gcs/files/8bf0f79f7883a0025b470a831d95d4c7.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/8bf0f79f7883a0025b470a831d95d4c7.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/8bf0f79f7883a0025b470a831d95d4c7.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/31a8287322cef32ab556587c6c516d15.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 363,
      floor_price: 0.005,
      floor_price_symbol: "ETH",
      total_minted: 363,
      total_supply: null,
      total_volume: 0.0153,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 3,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.0051,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x2981cefddcc7f690c01d9bfda473e21b588d3740",
      },
    ],
    id: 16,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:06:11.249Z",
    key: "endless-nameless-by-rafael-rozendaal",
    name: "Endless Nameless by Rafaël Rozendaal",
    description:
      "Art Blocks Collection: Curated\n\nHeritage Art Blocks Collection: Curated series 4\n\nProject Description: Endless Nameless is an exploration of composition. We start with a square. The square is divided into sections. The sections are filled with color pairs. Sometimes all colors are used. Sometimes fewer colors are used.",
    exchange_url:
      "https://opensea.io/collection/endless-nameless-by-rafael-rozendaal",
    external_url: "https://artblocks.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/ef2c459a8ae055f06e76a22d8b1c468c.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/539d066c3b32ba565331f302ee38d532.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/539d066c3b32ba565331f302ee38d532.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/c62c13447486c43c52d60a9f37c970e5.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 66.69999999999999,
      num_owners: 605,
      floor_price: 0.11885460000000003,
      floor_price_symbol: "ETH",
      total_minted: 605,
      total_supply: null,
      total_volume: 2017.5715441585635,
      one_day_volume: 0,
      seven_day_volume: 0.0667,
      thirty_day_volume: 0.1571,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: -8,
      total_sales: 1537,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 2,
      total_average_price: 1.3126685388149404,
      one_day_average_price: 0,
      seven_day_average_price: 0.0667,
      thirty_day_average_price: 0.07855,
    },
    contracts: [
      {
        contract_address: "0xa7d8d9ef8d8ce8992df33d8b8cf4aebabd5bd270",
      },
    ],
    id: 17,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:06:07.554Z",
    key: "flowers-by-rvig",
    name: "Flowers by RVig",
    description:
      "Art Blocks Collection: Presents\n\nHeritage Art Blocks Collection: Factory\n\nProject Description: Beautiful bouquets of generative flowers, with fascinating diversity in numbers, shapes and colour combinations. Each one has its own personality, its own character, and is always stunning and surprising, as you can expect with flowers in their natural form.",
    exchange_url: "https://opensea.io/collection/flowers-by-rvig",
    external_url: "https://artblocks.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/ef2c459a8ae055f06e76a22d8b1c468c.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/T72cuZfLtsIGmcV4W5vwV_1_YTkoBCs3x41VuI61TpvU01StjXU8fdSu3vQ_uLGIcpt-OJ2kuhWxT_pIYruWtl4fNnuYvucQlxCUaA?w=500&auto=format",
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/T72cuZfLtsIGmcV4W5vwV_1_YTkoBCs3x41VuI61TpvU01StjXU8fdSu3vQ_uLGIcpt-OJ2kuhWxT_pIYruWtl4fNnuYvucQlxCUaA?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 62.40106666666667,
      num_owners: 3075,
      floor_price: 0.0125,
      floor_price_symbol: "ETH",
      total_minted: 3075,
      total_supply: null,
      total_volume: 2145.953215705298,
      one_day_volume: 0,
      seven_day_volume: 0.030400000000000003,
      thirty_day_volume: 0.20840000000000003,
      one_day_volume_change: 0,
      seven_day_volume_change: -1,
      thirty_day_volume_change: -29,
      total_sales: 8357,
      one_day_sales: 0,
      seven_day_sales: 3,
      thirty_day_sales: 17,
      total_average_price: 0.25678511615475624,
      one_day_average_price: 0,
      seven_day_average_price: 0.010133333333333334,
      thirty_day_average_price: 0.012258823529411766,
    },
    contracts: [
      {
        contract_address: "0xa7d8d9ef8d8ce8992df33d8b8cf4aebabd5bd270",
      },
    ],
    id: 18,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:06:07.145Z",
    key: "dolphin1",
    name: "Crypto Dolphin 1",
    description:
      "Una serie di buffi e simpatici delfini che fanno una bella vita...",
    exchange_url: "https://opensea.io/collection/dolphin1",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/9aadeba18d8e83a50d921b6b5653f6a8.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "https://www.instagram.com/graffic72/",
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 0.01,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 19,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:05:59.423Z",
    key: "birdsong-quartet-by-klara-of-the-laughing-roses",
    name: "Birdsong Quartet by Klara of the Laughing Roses",
    description:
      'Klara, once a humble art teacher from the scenic town of Daegu, returns to Opensea with her latest NFT series:  "Birdsong Quartet.” This series was born from the solitude of her studio, where the only soundtrack to her creation was a collection of old, soulful jazz records and the melody of birdsong drifting through her window. Inspired by the spontaneous swing of life, akin to the improvised rhythms of jazz, each artwork marks a distinct part of the day—from the first light of dawn to the tranquil drawing of dusk. Developed with assistance from Midjourney, "Birdsong Quartet" unfolds like a visual concert that resonates with the ebb and flow of the creative process. This collection celebrates the beauty and spontaneity of life, reminding us that like music, beauty is ever-present—if we\'re only willing to listen.',
    exchange_url:
      "https://opensea.io/collection/birdsong-quartet-by-klara-of-the-laughing-roses",
    external_url: "https://orangehare.io/",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/622d72d9a67936bc07a7bb44dff3a92c.gif?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/622d72d9a67936bc07a7bb44dff3a92c.gif?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/39fa8cfe4585efd33381076632ad6a34.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/r9u2tmd25j",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 63,
      floor_price: 0.004,
      floor_price_symbol: "ETH",
      total_minted: 63,
      total_supply: null,
      total_volume: 0.013799999999999998,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 2,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.006899999999999999,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xd89c9d33f71472242da78417aa5bd6ae6870dab0",
      },
    ],
    id: 20,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:05:52.272Z",
    key: "blotter-party",
    name: "Blotter Party by Trippy Labs",
    description: "\t~~**₲Ɇ₦Ɇ₴ł₴**~~\n",
    exchange_url: "https://opensea.io/collection/blotter-party",
    external_url: "https://blotterparty.com/",
    banner_image_url:
      "https://i.seadn.io/gae/bvuT1s6q0mqR4ANa9hI-jiyoscwv4CyBmyus-8sB9Hejtowlzxa0cvsJbikebTi2ix308NskBic37JTOOOA_CY6b3mTNvjdeHvHSPw?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/W4X5j1fgGxrSPVjsCiAvBbr1b7NJ2yarx9jWdi34W_XBmE5uHjrW0vCkmH27F1sI0AVCzXUo-ZtWVbIInyTpT9qPNr4A_etocSFC?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/W4X5j1fgGxrSPVjsCiAvBbr1b7NJ2yarx9jWdi34W_XBmE5uHjrW0vCkmH27F1sI0AVCzXUo-ZtWVbIInyTpT9qPNr4A_etocSFC?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/W4X5j1fgGxrSPVjsCiAvBbr1b7NJ2yarx9jWdi34W_XBmE5uHjrW0vCkmH27F1sI0AVCzXUo-ZtWVbIInyTpT9qPNr4A_etocSFC?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 73,
      floor_price: 0.27767940004,
      floor_price_symbol: "ETH",
      total_minted: 73,
      total_supply: null,
      total_volume: 125.00889999999998,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 63,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 1.9842682539682537,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x342ebddbd8a002f8cd3a6bad0c4e27b9941b0555",
      },
    ],
    id: 21,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:05:48.327Z",
    key: "tokyoluv-collection",
    name: "Tokyoluv's Collection",
    description: "Fresh Mint Only",
    exchange_url: "https://opensea.io/collection/tokyoluv-collection",
    external_url: "http://www.tokyoluv.com",
    banner_image_url:
      "https://i.seadn.io/gae/Ei1-oE2Wwa4euvrKzE-X9Ro3_87eduS8qxTvXOwg3GFwSgnNB_RAHY_7aQgK_tbVO4m8Nrlz2SXUQgQz8YoVWV2st_9hkdwwsiFZSQ?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/fGJjbDFrNwNWq9BCoIHWihd0cOnKTjPogQZcpwOyX4Y9NrJN01SjRK1vXCeb57pLiamlFRtETnacQliNHRfZF5Eg9kpq_of7yR9-AQ?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/fGJjbDFrNwNWq9BCoIHWihd0cOnKTjPogQZcpwOyX4Y9NrJN01SjRK1vXCeb57pLiamlFRtETnacQliNHRfZF5Eg9kpq_of7yR9-AQ?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/4oXabuIM3GAAPXNNEjUUH6cGLaWXl6b2s1qlz-x3JFfRDPqs52ILWadTxfs9lAlQI9zVbnR6P1BkasgbZzrLZrkt4z2mwEiPWaXv_4E?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 100,
      floor_price: 0.09,
      floor_price_symbol: "ETH",
      total_minted: 100,
      total_supply: null,
      total_volume: 8.44379999999999,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 78,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.10825384615384603,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 22,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:05:41.084Z",
    key: "ai-horticulture-vignettes-from-the-greenhouse-of-t",
    name: "AI Horticulture Vignettes from the Greenhouse of the Future by Helena Sarin",
    description: null,
    exchange_url:
      "https://opensea.io/collection/ai-horticulture-vignettes-from-the-greenhouse-of-t",
    external_url: "https://www.proof.xyz/curated/evolving-pixels",
    banner_image_url:
      "https://i.seadn.io/gcs/files/bf0bac18ef12860f6ea233ef2bdec954.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/02268b5e99b892d5b706319b230dbe07.png?w=500&auto=format",
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/02268b5e99b892d5b706319b230dbe07.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 77,
      floor_price: 0.44853300311568495,
      floor_price_symbol: "ETH",
      total_minted: 77,
      total_supply: null,
      total_volume: 27.458789999999993,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 83,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.33082879518072283,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x48b17a2c46007471b3eb72d16268eaecdd1502b7",
      },
    ],
    id: 23,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:04:59.271Z",
    key: "thisisarealnft",
    name: "This is a real nft",
    description: "This is a real nft",
    exchange_url: "https://opensea.io/collection/thisisarealnft",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gae/rt-LLsVRWFNd3C23NumdmNg__A9uIbErYLi5wytY0iB7kSPQJrhS0XGRUJxTbEzq365bn-dheI-BIaPE4jd_ofRQf4mEOJ2rKtAjTg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/rt-LLsVRWFNd3C23NumdmNg__A9uIbErYLi5wytY0iB7kSPQJrhS0XGRUJxTbEzq365bn-dheI-BIaPE4jd_ofRQf4mEOJ2rKtAjTg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/rt-LLsVRWFNd3C23NumdmNg__A9uIbErYLi5wytY0iB7kSPQJrhS0XGRUJxTbEzq365bn-dheI-BIaPE4jd_ofRQf4mEOJ2rKtAjTg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/rt-LLsVRWFNd3C23NumdmNg__A9uIbErYLi5wytY0iB7kSPQJrhS0XGRUJxTbEzq365bn-dheI-BIaPE4jd_ofRQf4mEOJ2rKtAjTg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "graffic72/",
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 0.01,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 24,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:04:34.648Z",
    key: "marscatsvoyage",
    name: "Mars Cats Voyage",
    description:
      "The first limited collection of 10000 unique NFTs following our Cats' voyage to Mars, their meeting with [Mars Alien Cats](https://opensea.io/collection/marsaliencats), and giving holders the chance to be part of the adventure.\n\nTo find out how you can suit up your eligible Mars Cat (get a packed spacesuit) or get an already suited cat, visit the [Mars Cats in Spacesuits](https://opensea.io/collection/marscatsinspacesuits) collection.\n",
    exchange_url: "https://opensea.io/collection/marscatsvoyage",
    external_url: "https://marscatsvoyage.com",
    banner_image_url:
      "https://i.seadn.io/gae/EoSMMroVRT_xx6I4N-8OFF3G1BNpIG2p2hdt0AKDny3ut3lJccwu38dnVYOxJ_ceyJ69Tq83mnk6bwYyxUn5kmZeZz4wzrltlZlU?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/SGQmZ6ORiw_pT5kCBJujPnqc7OrKEPW8WsI-rUcRxnLzgJJjLYWmeQWifOMZobIfBJwUvJ7M5Zy4tvqs6-VKANAylDvz9jF9EDu3hA?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/SGQmZ6ORiw_pT5kCBJujPnqc7OrKEPW8WsI-rUcRxnLzgJJjLYWmeQWifOMZobIfBJwUvJ7M5Zy4tvqs6-VKANAylDvz9jF9EDu3hA?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/go2qGVOOUotHPWyp7wSyZNybX84W88hDKhYUkvf83w3XCbICdcFprtM8pzX1glvGjZBE9VghYZyA7KXFYKy_Lgs1YlQ5cp1koPoqeA?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/mcv",
    telegram_url: null,
    twitter_username: "marscatsvoyage",
    wiki_url: null,
    instagram_username: "marscats_voyage",
    stats: {
      market_cap: 294.1181138000001,
      num_owners: 3480,
      floor_price: 0.0267,
      floor_price_symbol: "ETH",
      total_minted: 3480,
      total_supply: null,
      total_volume: 2987.4024451868736,
      one_day_volume: 0.0708,
      seven_day_volume: 1.0305470000000003,
      thirty_day_volume: 3.7559465000000003,
      one_day_volume_change: -0.1157,
      seven_day_volume_change: -11,
      thirty_day_volume_change: -42,
      total_sales: 15480,
      one_day_sales: 3,
      seven_day_sales: 35,
      thirty_day_sales: 132,
      total_average_price: 0.19298465408183937,
      one_day_average_price: 0.0236,
      seven_day_average_price: 0.02944420000000001,
      thirty_day_average_price: 0.028454140151515154,
    },
    contracts: [
      {
        contract_address: "0xdd467a6c8ae2b39825a452e06b4fa82f73d4253d",
      },
    ],
    id: 25,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:04:30.983Z",
    key: "quirklings",
    name: "Quirklings",
    description: null,
    exchange_url: "https://opensea.io/collection/quirklings",
    external_url: "https://quirkies.io/quirklings",
    banner_image_url:
      "https://i.seadn.io/gae/pI3uBSM5DpmqYt1i5Pyx0CSJxYnae7Vha3w6vlhIUOhOdWE6tB0S8B79upSyIfryizxSevPlyCRbpeQBHB2yykcUaVLymcinu0ZhNQQ?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/PA3dXgasRMonEKbxVeSw4LhU3h9dfznzAJRsqkgmRQXQxgjkh-lGaYo3pda7reNVFk0gP6v0wWI1uK5XtaIoAiAJ81lG29tf2Mk5m6U?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/PA3dXgasRMonEKbxVeSw4LhU3h9dfznzAJRsqkgmRQXQxgjkh-lGaYo3pda7reNVFk0gP6v0wWI1uK5XtaIoAiAJ81lG29tf2Mk5m6U?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/td57c4dbtHM5hrNtp0hYM_OXckaK0DUZ0HZak4NmMUcW8SSmBvdNGijnKdiD8mjJAUkpWTPHdMOCEI0ZGbc7e34h7O-5BTSPWcebbzk?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 453.16527337499997,
      num_owners: 2634,
      floor_price: 0.052848,
      floor_price_symbol: "ETH",
      total_minted: 2634,
      total_supply: null,
      total_volume: 4276.959554944497,
      one_day_volume: 0.23509999999999998,
      seven_day_volume: 1.120887,
      thirty_day_volume: 5.452176999999999,
      one_day_volume_change: -0.1513500000000001,
      seven_day_volume_change: -2,
      thirty_day_volume_change: -94,
      total_sales: 18892,
      one_day_sales: 5,
      seven_day_sales: 24,
      thirty_day_sales: 100,
      total_average_price: 0.22638998279401315,
      one_day_average_price: 0.04701999999999999,
      seven_day_average_price: 0.046703625,
      thirty_day_average_price: 0.05452176999999999,
    },
    contracts: [
      {
        contract_address: "0x8f1b132e9fd2b9a2b210baa186bf1ae650adf7ac",
      },
    ],
    id: 26,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:04:16.534Z",
    key: "classof2022",
    name: "Class Of 2022",
    description:
      "Let’s celebrate the new year with a project dedicated to the graduating class of 2022.",
    exchange_url: "https://opensea.io/collection/classof2022",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/5f994c759b63b28ecf873df3b0f2f851.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/ca1da638b0225dee2f89d1827ce798aa.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/ca1da638b0225dee2f89d1827ce798aa.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/ca1da638b0225dee2f89d1827ce798aa.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 570,
      floor_price: 0.0075,
      floor_price_symbol: "ETH",
      total_minted: 570,
      total_supply: null,
      total_volume: 16.887293284498757,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 1870,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.00903063812005281,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x57bea3c01c74e6a1baec7a063852098e6d8605dd",
      },
    ],
    id: 27,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:03:32.926Z",
    key: "digizips",
    name: "DigiZips",
    description:
      "777 pixel sharks created by d3fb0t,\nthat never stop swimming ,  never look down,  and only look up! Zipsharks is an Artist support and Alpha community . Together we navigate the dangerous waters of the open sea",
    exchange_url: "https://opensea.io/collection/digizips",
    external_url: "https://discord.gg/UMNefkr9xF",
    banner_image_url:
      "https://i.seadn.io/gcs/files/c50daafb16dbc5ba0d65ab16609defe4.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/70a12b4396c7cd9befc3ff51f6c80c56.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/70a12b4396c7cd9befc3ff51f6c80c56.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/70a12b4396c7cd9befc3ff51f6c80c56.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 124,
      floor_price: 0.005,
      floor_price_symbol: "ETH",
      total_minted: 124,
      total_supply: null,
      total_volume: 0.05667999999999999,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 11,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.005152727272727272,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x1204bc4558fc85cda299e28ea6a6e0b7fb999c08",
      },
    ],
    id: 28,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:03:29.235Z",
    key: "degenforestdao",
    name: "DEGEN FOREST",
    description:
      "Here at Degen Forest, we see NFTs as more than just kick-ass art. We believe in their potential to create real value and opportunities for everyone involved.  Our mission is to bring 🏗️ cutting-edge technology to the masses, creating a world where everyone can thrive 💵 in a safe and secure digital environment.",
    exchange_url: "https://opensea.io/collection/degenforestdao",
    external_url: "https://degenforest.com/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/fd31dee3e766081d808fb6a22ce7b51e.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/d42851eab4457e8d20a6b2230af33683.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/d42851eab4457e8d20a6b2230af33683.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/ccb7c5e3fb389bf1f9c8d7cde8903aa4.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/degenforest",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 160,
      floor_price: 0.0537,
      floor_price_symbol: "ETH",
      total_minted: 160,
      total_supply: null,
      total_volume: 8.84779,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0411,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 3,
      total_sales: 109,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 3,
      total_average_price: 0.08117238532110091,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.013699999999999999,
    },
    contracts: [
      {
        contract_address: "0xcd0c2a8801ebff4b9b62a19255523f256e70b88a",
      },
    ],
    id: 29,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:03:28.845Z",
    key: "galactic-secret-agency",
    name: "Galactic Secret Agency",
    description:
      "THE GSA is a Macroverse 🌎World\n\nThe Galactic Secret Agency is a collection of 10.000 unique Ethelon Agents. Each OG Alien is a unique character generated from over 170 hand-drawn assets. Holding GSA agents grants you access to the Macroverse ecosystem, new upgrades and the opportunity to participate in a universe of storytelling.\n\nwww.Macroverse.world/gsa",
    exchange_url: "https://opensea.io/collection/galactic-secret-agency",
    external_url: "https://www.macroverse.world/gsa",
    banner_image_url:
      "https://i.seadn.io/gcs/files/b563d804840e116f21fbee9ea7b4189c.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/611b76330308a75d4059778c7380de3c.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/611b76330308a75d4059778c7380de3c.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/a9589282f148b72a307dde1448044666.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/macroverse",
    telegram_url: null,
    twitter_username: "GSA_nft",
    wiki_url: null,
    instagram_username: "macroversehq",
    stats: {
      market_cap: 15.392835,
      num_owners: 2654,
      floor_price: 0.0012,
      floor_price_symbol: "ETH",
      total_minted: 2654,
      total_supply: null,
      total_volume: 432.00294588522553,
      one_day_volume: 0,
      seven_day_volume: 0.00309,
      thirty_day_volume: 0.00309,
      one_day_volume_change: 0,
      seven_day_volume_change: 2,
      thirty_day_volume_change: -2,
      total_sales: 6704,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 2,
      total_average_price: 0.06443958023347636,
      one_day_average_price: 0,
      seven_day_average_price: 0.001545,
      thirty_day_average_price: 0.001545,
    },
    contracts: [
      {
        contract_address: "0x6184f10302cebeea0211f9310225f051cc549626",
      },
    ],
    id: 30,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:03:21.125Z",
    key: "themonkeycube",
    name: "THE MONKEY CUBE",
    description:
      "Un nuovo progetto di cubo-scimmia: una scimmia al giorno, per 100 giorni",
    exchange_url: "https://opensea.io/collection/themonkeycube",
    external_url: "https://twitter.com/Gianlucagreco72",
    banner_image_url:
      "https://i.seadn.io/gae/A9T7Tqiz-DrIk5iKGANJQfUHCefsA7OWpNh8bTMi0C60C3cz17_ZEk7BVQHRlH9YssgjBX6FDinztA3_ioY5sIHMlp9zc1RaGg09?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/XsbP6KDRcSbXOl8yyWtD2kBH36CdsUnU7klg_cFuTUWwW3gDYt6M9qLgv14RPP3qbZMMz4Jts8nvNKpx5ZWyx8CA8GzL29nhjzNl5Q?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/XsbP6KDRcSbXOl8yyWtD2kBH36CdsUnU7klg_cFuTUWwW3gDYt6M9qLgv14RPP3qbZMMz4Jts8nvNKpx5ZWyx8CA8GzL29nhjzNl5Q?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/XsbP6KDRcSbXOl8yyWtD2kBH36CdsUnU7klg_cFuTUWwW3gDYt6M9qLgv14RPP3qbZMMz4Jts8nvNKpx5ZWyx8CA8GzL29nhjzNl5Q?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/graffic72",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "https://www.instagram.com/graffic72/",
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 0.01,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 31,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:03:03.109Z",
    key: "toortuga-collection",
    name: "TOORTUGA COLLECTION",
    description: "Toortuga è un essere tranquillo ma imprevedibile...",
    exchange_url: "https://opensea.io/collection/toortuga-collection",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gae/dZK9ZI9WO4wwWd9vhQtRGUgemjIADZWrWoPXNasUOvUf0ayqu7cG9pI_LFJUQK7GKePFkAREBFKEmqFcVupmfa4k_yLHKu6ZVfu8zJc?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/jkzGvC8axBFfzeNUlkDv8ryHdLoUhwwc2Vs-dr5XAgWS-FyIp4W0-OOm6ISJwf1eMBqcCVPZG14gWoIbSuaiL2Mrj84BUmTff-AkNA?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "https://www.instagram.com/p/CZ-ayEPjwlw/",
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 0.01,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 32,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:03:02.704Z",
    key: "honeyjar",
    name: "Honey Jar (Gen 1)",
    description: "The Jars to rule all of BeraLand",
    exchange_url: "https://opensea.io/collection/honeyjar",
    external_url: "https://0xhoneyjar.xyz/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/264cbae90011ab16e023dc657c149731.png?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/cad7dec80689c7357906f80c904c2ea8.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 224.07701989578536,
      num_owners: 2512,
      floor_price: 0.031195,
      floor_price_symbol: "ETH",
      total_minted: 2512,
      total_supply: null,
      total_volume: 214.5311479503968,
      one_day_volume: 0.42088099999999995,
      seven_day_volume: 4.382026000989999,
      thirty_day_volume: 31.734013373919975,
      one_day_volume_change: -0.23677100000000018,
      seven_day_volume_change: -101,
      thirty_day_volume_change: 133,
      total_sales: 2853,
      one_day_sales: 13,
      seven_day_sales: 155,
      thirty_day_sales: 618,
      total_average_price: 0.07519493443757336,
      one_day_average_price: 0.032375461538461534,
      seven_day_average_price: 0.02827113549025806,
      thirty_day_average_price: 0.05134953620375401,
    },
    contracts: [
      {
        contract_address: "0xa20cf9b0874c3e46b344deaeea9c2e0c3e1db37d",
      },
    ],
    id: 33,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:02:36.146Z",
    key: "thetwoboys",
    name: "The Two Boys By Froopyland",
    description:
      "Froopy-di scoop, scoopdidy Froopdidy scoop, scoopdidy Froopdidy froop",
    exchange_url: "https://opensea.io/collection/thetwoboys",
    external_url: "https://thetwoboys.xyz/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/8c6f170e50b43bc5a6c0d3c6cbb1218a.png?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/d545ba2cfd136c429e04422187f70b03.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/thetwoboys",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 11.25,
      num_owners: 703,
      floor_price: 0.029,
      floor_price_symbol: "ETH",
      total_minted: 703,
      total_supply: null,
      total_volume: 7.364100997999994,
      one_day_volume: 0.0045,
      seven_day_volume: 0.0045,
      thirty_day_volume: 0.0045,
      one_day_volume_change: 0.0045,
      seven_day_volume_change: 1,
      thirty_day_volume_change: -3,
      total_sales: 398,
      one_day_sales: 1,
      seven_day_sales: 1,
      thirty_day_sales: 1,
      total_average_price: 0.01850276632663315,
      one_day_average_price: 0,
      seven_day_average_price: 0.0045,
      thirty_day_average_price: 0.0045,
    },
    contracts: [
      {
        contract_address: "0xececafd6dbf4ebb7c79077beb17c72d43abc7707",
      },
    ],
    id: 34,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:02:28.527Z",
    key: "baby-apes-official",
    name: "Baby Ape Club",
    description:
      "Baby Apes is a collection of 5,000 unique, hand-drawn NFTs that live on the Ethereum blockchain. Each Baby Ape features its own personality, defined by a combination of unique traits, from expressive eyes to adorable outfits, creating a playful and nostalgic vibe. As a Baby Ape holder, you gain exclusive access to a vibrant community, event invites, custom merch, surprise NFT drops, and interactive experiences in the metaverse. Plus, some Baby Apes come with rare accessories, making them even more collectible. All Baby Apes bring joy, but some are extra special!\nWe are the original LBAC.\n\nOur Ape brothers are the [Lil Mutants](https://opensea.io/collection/lil-mutants) aka LMAC\n\nTwitter: [@BabyApeClub](https://twitter.com/BabyApeClub)\nDiscord: [Lil Baby Ape Club](https://discord.gg/4P5sbNhur2)\n",
    exchange_url: "https://opensea.io/collection/baby-apes-official",
    external_url: "https://www.lilbabyapes.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/a6b991edc11285440f44bbca89617435.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/e996beb817ef3cb9ff88fdc9396d5ae7.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/e996beb817ef3cb9ff88fdc9396d5ae7.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/09bf9a4ae6fc72455b5e112922f1b227.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/4P5sbNhur2",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "lilbabyapeclub.eth",
    stats: {
      market_cap: 41.3168,
      num_owners: 2344,
      floor_price: 0.0095,
      floor_price_symbol: "ETH",
      total_minted: 2344,
      total_supply: null,
      total_volume: 1471.0968951784585,
      one_day_volume: 0.011300000000000001,
      seven_day_volume: 0.049600000000000005,
      thirty_day_volume: 0.07939999999999998,
      one_day_volume_change: 2,
      seven_day_volume_change: 4,
      thirty_day_volume_change: 4,
      total_sales: 8323,
      one_day_sales: 2,
      seven_day_sales: 6,
      thirty_day_sales: 8,
      total_average_price: 0.1767507984114452,
      one_day_average_price: 0.005650000000000001,
      seven_day_average_price: 0.008266666666666669,
      thirty_day_average_price: 0.009924999999999998,
    },
    contracts: [
      {
        contract_address: "0x918f677b3ab4b9290ca96a95430fd228b2d84817",
      },
    ],
    id: 35,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:01:52.427Z",
    key: "babydogearmy",
    name: "Baby Doge Army",
    description:
      "[Stake your 2D NFT to mint a 1:1 of your 2D NFT in 3D ](https://stake.babydogenft.com/)\r\n\r\n[View our 3D BabyDoge collection](https://opensea.io/collection/baby-doge-3d)\r\n\r\nEach 2D NFT can be used to play in the Decentraland Metaverse as Baby Doge!\r\n\r\nOur collection donated $400,000 to the ASPCA, Humane Society, & Best Friends animal shelter!",
    exchange_url: "https://opensea.io/collection/babydogearmy",
    external_url: "http://babydogenft.com",
    banner_image_url:
      "https://i.seadn.io/gae/56It4l6oPGd2Axx0TU-uhbboTPfj87x8vvuLl2lVtRet8QwnKm0JhTqLqzrLTv_s_1BXl1iRMMJvnQqCHfP8zph1kY0vBGzUBOdU?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/UxHLh-T9AiPgbVrVlqqSv0gzzWmWEnXssaVHMLYR3G-SseecrPLtznlmnRtXdipFNAVKkUeToghE53iDsdbxQriUSR_ru_dLJT-r3g?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/UxHLh-T9AiPgbVrVlqqSv0gzzWmWEnXssaVHMLYR3G-SseecrPLtznlmnRtXdipFNAVKkUeToghE53iDsdbxQriUSR_ru_dLJT-r3g?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/A5obmv6dV3b0RssaDQjkywB5SeBcYPxc_wYQr90u4N7QDWLIbKiLmo1FTxDoUYy3O6_ldr7pZd62ABgcz3OqJ2EkKYX9EtY5e_cjL_s?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: "https://t.me/babydogecoin",
    twitter_username: null,
    wiki_url: null,
    instagram_username: "thebabydogecoin",
    stats: {
      market_cap: 301.77231975,
      num_owners: 2347,
      floor_price: 0.038959,
      floor_price_symbol: "ETH",
      total_minted: 2347,
      total_supply: null,
      total_volume: 1790.282275544727,
      one_day_volume: 0.0276,
      seven_day_volume: 0.362163,
      thirty_day_volume: 4.297998999999996,
      one_day_volume_change: 0.007599999999999999,
      seven_day_volume_change: 1,
      thirty_day_volume_change: -311,
      total_sales: 10391,
      one_day_sales: 1,
      seven_day_sales: 12,
      thirty_day_sales: 95,
      total_average_price: 0.17229162501633405,
      one_day_average_price: 0,
      seven_day_average_price: 0.030180250000000002,
      thirty_day_average_price: 0.04524209473684207,
    },
    contracts: [
      {
        contract_address: "0xd9f092bdf2b6eaf303fc09cc952e94253ae32fae",
      },
    ],
    id: 36,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:01:34.350Z",
    key: "parallelalpha",
    name: "Parallel Alpha",
    description:
      "Parallel is a Sci-Fi Franchise and Trading Card Game (TCG) empowering collectors to truly own their cards and other game items. The cards can be used to build a deck and play in an online PC game which is currently in Beta.",
    exchange_url: "https://opensea.io/collection/parallelalpha",
    external_url: "http://www.parallel.life",
    banner_image_url:
      "https://i.seadn.io/gae/YPGHP7VAvzy-MCVU67CV85gSW_Di6LWbp-22LGEb3H6Yz9v4wOdAaAhiswnwwL5trMn8tZiJhgbdGuBN9wvpH10d_oGVjVIGM-zW5A?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/ad1e0678638ae7ae9c7eb4ef88c3f409.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/ad1e0678638ae7ae9c7eb4ef88c3f409.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/Nnp8Pdo6EidK7eBduGnAn_JBvFsYGhNGMJ_fHJ_mzGMN_2Khu5snL5zmiUMcSsIqtANh19KqxXDs0iNq_aYbKC5smO3hiCSw9PlL?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/paralleltcg",
    telegram_url: null,
    twitter_username: "ParallelTCG",
    wiki_url: null,
    instagram_username: "parallel_tcg",
    stats: {
      market_cap: 6.275026293733491,
      num_owners: 63664,
      floor_price: 0.0004,
      floor_price_symbol: "ETH",
      total_minted: 63664,
      total_supply: null,
      total_volume: 80571.16431891141,
      one_day_volume: 0.21049889999999993,
      seven_day_volume: 4.574318232815068,
      thirty_day_volume: 18.283668295027244,
      one_day_volume_change: -57,
      seven_day_volume_change: 573,
      thirty_day_volume_change: 580,
      total_sales: 310852,
      one_day_sales: 121,
      seven_day_sales: 936,
      thirty_day_sales: 1713,
      total_average_price: 0.25919461453975334,
      one_day_average_price: 0.001739660330578512,
      seven_day_average_price: 0.004887092129075928,
      thirty_day_average_price: 0.010673478280809834,
    },
    contracts: [
      {
        contract_address: "0x76be3b62873462d2142405439777e971754e8e77",
      },
    ],
    id: 37,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:01:13.266Z",
    key: "gooberland",
    name: "GooberLand",
    description:
      "Gooberland is a collection of 1/1 characters called goobers that are just vibin in GooberLand looking to make new friends! \r\n\r\nIn GooberLand anything and everything is possible. It’s a weird place, it’s a fun place and there’s always something to get into. It’s filled with goofy goobers with big personalities.\r\n\r\nThere’s Shroomie goobs, spooky goobs, mystical goobs, evil goobs and more! You name it we’ve probably got it here in GooberLand 🤪",
    exchange_url: "https://opensea.io/collection/gooberland",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gae/vyHT4t43a4uV2FY3I6CiDTnO-ofy7HirDIbiaDbtc8pVe1fwrhKN-0XujF1hz8yXPNndHwq_Klje_gwVpLw9LQvtbUxx-gJlMJSr1g?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/Rg0806I5NrzgTv7hgoZY-jcOq5n8Iz1iqlpgnLEPXxX9xyzkTz5t0xJ7S-Ov8yHMTxwYJ-j3ZpRf_HNA5Noz4w6du4qy_PcEAsTV?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/discord.gg/gooberland",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 148,
      floor_price: 0.01437940004000001,
      floor_price_symbol: "ETH",
      total_minted: 148,
      total_supply: null,
      total_volume: 48.76375999231023,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.019799999999999998,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 2,
      total_sales: 273,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 2,
      total_average_price: 0.17862183147366384,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.009899999999999999,
    },
    contracts: [
      {
        contract_address: "0xb97f3d31ca650486b92b32dcba797070a2c04d82",
      },
    ],
    id: 38,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:58:52.865Z",
    key: "tubby-cats",
    name: "tubby cats",
    description:
      "bringing colour & creativity to the NFT space by supporting artists and spreading good vibes\n\nwith over 1600+ hand-created traits and a custom image generation algorithm, each tubby cat feels uniquely delicious. tubby cats was created by an artist-led team, [@tubbystudios](https://twitter.com/tubbystudios).\n\ntubby cats are in the public domain. feel free to use them in any way you want!\n\n[twitter](https://twitter.com/tubbycatsnft) | [discord](https://discord.gg/tubbycatsnft) | [website](https://tubbycats.xyz)",
    exchange_url: "https://opensea.io/collection/tubby-cats",
    external_url: "http://tubbycats.xyz",
    banner_image_url:
      "https://i.seadn.io/gcs/files/ce79bded2f387e9bbb8153da5a5750f0.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/ce79bded2f387e9bbb8153da5a5750f0.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/ce79bded2f387e9bbb8153da5a5750f0.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/TyPJi06xkDXOWeK4wYBCIskRcSJpmtVfVcJbuxNXDVsC39IC_Ls5taMlxpZPYMoUtlPH7YkQ4my1nwUGDIB5C01r97TPlYhkolk-TA?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/tubbycatsnft",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 467.5371137941202,
      num_owners: 7410,
      floor_price: 0.021917,
      floor_price_symbol: "ETH",
      total_minted: 7410,
      total_supply: null,
      total_volume: 18800.02254644285,
      one_day_volume: 0.40531800000000007,
      seven_day_volume: 2.384796999899998,
      thirty_day_volume: 11.138007344344441,
      one_day_volume_change: 0.07536500000000002,
      seven_day_volume_change: -26,
      thirty_day_volume_change: -133,
      total_sales: 44376,
      one_day_sales: 19,
      seven_day_sales: 102,
      thirty_day_sales: 411,
      total_average_price: 0.42365293281149385,
      one_day_average_price: 0.02133252631578948,
      seven_day_average_price: 0.023380362744117627,
      thirty_day_average_price: 0.02709977456044876,
    },
    contracts: [
      {
        contract_address: "0xca7ca7bcc765f77339be2d648ba53ce9c8a262bd",
      },
    ],
    id: 39,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:58:19.607Z",
    key: "vrwd",
    name: "Virus World",
    description: null,
    exchange_url: "https://opensea.io/collection/vrwd",
    external_url: "https://virusworld.org",
    banner_image_url:
      "https://i.seadn.io/gcs/files/49cd8d1848d2252faa37776e30ba153a.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/892e205b7e8594ebef395a5d7f5017ca.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/892e205b7e8594ebef395a5d7f5017ca.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/892e205b7e8594ebef395a5d7f5017ca.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/U9myPpCsrm",
    telegram_url: "https://t.me/Virus_Wrold_Official",
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 622,
      floor_price: 0.004499,
      floor_price_symbol: "ETH",
      total_minted: 622,
      total_supply: null,
      total_volume: 92.06896838999259,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 353,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.2608186073370895,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x85afc9021403571ffc292f28cbe9c12b6a76d69e",
      },
    ],
    id: 40,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:57:37.406Z",
    key: "unvoiced-echoes",
    name: "Unvoiced Echoes",
    description:
      '"Unvoiced Echoes" is a poignant anthology of illustrations, each silently articulating the often unseen and unspoken battles with depression among men. Through stark monochromatic imagery, this collection evokes the complex tapestry of solitude, introspection, and resilience. The drawings stand as a silent testament to the internal struggles and the profound strength in vulnerability, inviting reflection and understanding on a subject shrouded in societal silence.',
    exchange_url: "https://opensea.io/collection/unvoiced-echoes",
    external_url: "https://rebelants.io",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/60186b3e50c84abfe81ff2d8b29f87c9.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/60186b3e50c84abfe81ff2d8b29f87c9.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/14a8d83ace012e180312d525484bc6a0.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 3,
      floor_price: 0.02,
      floor_price_symbol: "ETH",
      total_minted: 3,
      total_supply: null,
      total_volume: 0.02,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 2,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.01,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x94ad47732633542f226140fb65dc1d5fd947001c",
      },
    ],
    id: 41,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:57:26.563Z",
    key: "ethsenders",
    name: "ETH Senders",
    description:
      "7,777 degens delve into the depths of blockchain, searching for opportunities to send their ETH for nothing. Mint for free, but send ETH here: 0xB35da4b1a270A0faf487Ce015f803A83179408D0",
    exchange_url: "https://opensea.io/collection/ethsenders",
    external_url: "http://ethsenders.xyz",
    banner_image_url:
      "https://i.seadn.io/gcs/files/c57b9f4ffd2aedd2b5e9022a8eeca5e7.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/c57b9f4ffd2aedd2b5e9022a8eeca5e7.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/c57b9f4ffd2aedd2b5e9022a8eeca5e7.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/78d3aa54ebb40bac8be2eedc60dc91df.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 2606,
      floor_price: 0.0005,
      floor_price_symbol: "ETH",
      total_minted: 2606,
      total_supply: null,
      total_volume: 66.59106310047694,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 6780,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.00982169072278421,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x0a78c052bbbf4ed294c273cbe06255d7d94a7340",
      },
    ],
    id: 42,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:57:15.040Z",
    key: "mystery-box-inbetweeners-",
    name: "inBetweeners - Mystery Box?",
    description:
      "The inBetweeners Mystery Box is a tool that puts bear holders in the position of power to redeem a bonus gift that suits their needs and wants. Over time, a variety of rewards can be found within the box - available to be redeemed at different opportunities. The key to activating your box, is holding an inBetweeners Bear NFT. Keep in mind, when you open a mystery box - your mystery box will be burned and you will never be able to open it again.\n\nThe inBetweeners project is being built with full focus on the collection of 10,777 bears. Partnerships, access and utility to come for inBetweeners is with the bears themselves and will always be the priority. Think of the mystery box as a bonus gift that you can redeem along the way. The more bears you hold, the more reward opportunities you qualify for.",
    exchange_url: "https://opensea.io/collection/mystery-box-inbetweeners-",
    external_url: "http://inbetweeners.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/cf77e7a61cc1342793fed06d72439651.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/b1460bb56b01d391c929d8ffc51d8b97.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/b1460bb56b01d391c929d8ffc51d8b97.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/fd9de20e96b158ebb4ce343128846afe.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/F7Sy7RVzxU",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1457,
      floor_price: 0.018742,
      floor_price_symbol: "ETH",
      total_minted: 1457,
      total_supply: null,
      total_volume: 38.38039218999994,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0618,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 6,
      total_sales: 1160,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 9,
      total_average_price: 0.03308654499137926,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.006866666666666667,
    },
    contracts: [
      {
        contract_address: "0xe187c672179d25fc57044cf0bc353790f7ac614e",
      },
    ],
    id: 43,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:57:04.101Z",
    key: "zurdosiete",
    name: "ZUSI",
    description: null,
    exchange_url: "https://opensea.io/collection/zurdosiete",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/s/raw/files/35cb01fef1cd57d186d1358c0f282a07.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 0.007,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x32324e9e9083ed2ab03be56c45a4fcda01fe574f",
      },
    ],
    id: 44,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:56:59.663Z",
    key: "pota",
    name: "Pixel of the Apes",
    description: null,
    exchange_url: "https://opensea.io/collection/pota",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/84270509e8c7a265e2cfbc10a94c99a7.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 116,
      floor_price: 0.74992940004,
      floor_price_symbol: "ETH",
      total_minted: 116,
      total_supply: null,
      total_volume: 67.64735880703125,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 1.159001,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 2,
      total_sales: 47,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 3,
      total_average_price: 1.43930550653258,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.38633366666666663,
    },
    contracts: [
      {
        contract_address: "0x8f126b06cf9d0e651e1114779c8d966d1a5ddf6e",
      },
    ],
    id: 45,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:56:41.189Z",
    key: "graffic-collection",
    name: "GRAFFIC Collection",
    description: null,
    exchange_url: "https://opensea.io/collection/graffic-collection",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url: null,
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 0.01,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 46,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:56:13.681Z",
    key: "ina-vare-2021",
    name: "INA VARE 2021",
    description:
      "VHS processed image, video, and gif collection by artist INA VARE, all created in the year 2021. \r\nArtworks are manipulated through analog glitch hardware, VHS video gear then brought it back to the digital world.",
    exchange_url: "https://opensea.io/collection/ina-vare-2021",
    external_url: "http://inavare.xyz",
    banner_image_url:
      "https://i.seadn.io/gae/DgNyxd3nZ5nmw1R-pdU72bSndNr5uueuwNDqP0EXj0xoimOHCTosIBi6uP9m3Xoya9sIpylyaDESphbLVHI_vkBjGFs-CQM7LyjKJY0?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/4E75kQjk4mjitTV2U6NHEVK8qXY9y2lRlH9gPUanN-X6C_ylI3z5H05NSW_kXh5YMTPn-06De6FvJV6va4BRQjQQDFFubWeacC1tCzo?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/4E75kQjk4mjitTV2U6NHEVK8qXY9y2lRlH9gPUanN-X6C_ylI3z5H05NSW_kXh5YMTPn-06De6FvJV6va4BRQjQQDFFubWeacC1tCzo?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/L1C-8AT-2J2CXpndIsS3_ukTbxSQNl-Vw7iMm95MfjHEXouTeMe-fjXfOYfEVnAnVoMhVZyMbw2TzaTvlVqE9IFscgUwPI9mBQAvWg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/EvyU65Fkvf",
    telegram_url: null,
    twitter_username: "ina_vare",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 11,
      floor_price: 1,
      floor_price_symbol: "ETH",
      total_minted: 11,
      total_supply: null,
      total_volume: 1.2800000000000002,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 19,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.06736842105263159,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 47,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:55:09.786Z",
    key: "aeb-begins",
    name: "AEB BEGINS",
    description: null,
    exchange_url: "https://opensea.io/collection/aeb-begins",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/6a13c4e14fffa97064414cefd771871a.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/6a13c4e14fffa97064414cefd771871a.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/6a13c4e14fffa97064414cefd771871a.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/24be494910d931456c446f1ece9c6559.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 11.493823881491043,
      num_owners: 432,
      floor_price: 0.011971,
      floor_price_symbol: "ETH",
      total_minted: 432,
      total_supply: null,
      total_volume: 7.237375800080194,
      one_day_volume: 0.016,
      seven_day_volume: 0.06218480008020402,
      thirty_day_volume: 0.142484800080204,
      one_day_volume_change: 0.00401519991979599,
      seven_day_volume_change: 11,
      thirty_day_volume_change: 4,
      total_sales: 294,
      one_day_sales: 8,
      seven_day_sales: 12,
      thirty_day_sales: 17,
      total_average_price: 0.02461692449006869,
      one_day_average_price: 0.002,
      seven_day_average_price: 0.005182066673350335,
      thirty_day_average_price: 0.008381458828247293,
    },
    contracts: [
      {
        contract_address: "0x7516ce30a4abadef77f7dd878bb849f0291c3771",
      },
    ],
    id: 48,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:54:52.282Z",
    key: "metroverse-blackout",
    name: "Metroverse Blackout",
    description:
      "Metroverse is a land trading NFT strategy game on Ethereum. \n\n[GENESIS](https://opensea.io/collection/metroverse-genesis) | [BLACKOUT](https://opensea.io/collection/metroverse-blackout) | [MINI](https://opensea.io/collection/metroverse-genesis-mini) | [PASS](https://opensea.io/collection/metroverse-pass) | [MAYORS](https://opensea.io/collection/metroverse-mayor)\n\nView the Metroverse code and data [here](https://github.com/MetroverseCode).",
    exchange_url: "https://opensea.io/collection/metroverse-blackout",
    external_url: "http://metroverse.com",
    banner_image_url:
      "https://i.seadn.io/gae/w_Vjsvin-u4NMtJs6FSRYpqVIgs0o2BEzItDivWWWKQAND78BCx6XBJNCqzRL7T4xqOx0TYpm8V3ksTpSwB2pbmrwranSQnZlwVLAHc?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/xCw4Vw_xgeXr5LSDuHPlxL47_7IrSxo27h_wyGykoFPVSPetjFL0glTbbDgyKkgG0MfDL3LZfll3kA-JloZvzjuRTFeXuZgN3CwnDQU?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/xCw4Vw_xgeXr5LSDuHPlxL47_7IrSxo27h_wyGykoFPVSPetjFL0glTbbDgyKkgG0MfDL3LZfll3kA-JloZvzjuRTFeXuZgN3CwnDQU?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/fEG---SD6R5_03CgukRs78mWP5pWKlMx2Z2qgR_d0W30gtV9PEOnWPjZWjv1OHKoQoy6ARATQDijH7OuVjMm0KLHdiwl706vwDxjAhA?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/metroverse",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 21.2096,
      num_owners: 2353,
      floor_price: 0.0022,
      floor_price_symbol: "ETH",
      total_minted: 2353,
      total_supply: null,
      total_volume: 5298.468994473824,
      one_day_volume: 0,
      seven_day_volume: 0.006399999999999999,
      thirty_day_volume: 0.022,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 6732,
      one_day_sales: 0,
      seven_day_sales: 3,
      thirty_day_sales: 11,
      total_average_price: 0.7870571887216019,
      one_day_average_price: 0,
      seven_day_average_price: 0.002133333333333333,
      thirty_day_average_price: 0.002,
    },
    contracts: [
      {
        contract_address: "0x25cd67e2dfec471acd3cdd3b22ccf7147596dd8b",
      },
    ],
    id: 49,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:54:48.508Z",
    key: "selfie20xx",
    name: "Selfie20XX",
    description: "Timeless selfies",
    exchange_url: "https://opensea.io/collection/selfie20xx",
    external_url: "https://selfie20xx.xyz/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/0916cde498fa2a32c3f373f277a643de.png?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/4a69440466c3207036e64a8df39dcb06.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 919,
      floor_price: 0.0009,
      floor_price_symbol: "ETH",
      total_minted: 919,
      total_supply: null,
      total_volume: 0.026697000000000005,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 6,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.004449500000000001,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x3abcf9fd789775792b6c6cbe3598ee828c73882f",
      },
    ],
    id: 50,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:53:25.461Z",
    key: "xcopy-remnants",
    name: "REMNANTS",
    description: "+",
    exchange_url: "https://opensea.io/collection/xcopy-remnants",
    external_url: "https://xcopy.art",
    banner_image_url:
      "https://i.seadn.io/s/raw/files/04587c1c4bc2ca0c14172b87b133faf1.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/cabbf873885f022c70e0553186cdab46.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/cabbf873885f022c70e0553186cdab46.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/7a45e45e99a5a4db9a45310e15d200ba.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 1242.5,
      num_owners: 191,
      floor_price: 5.439,
      floor_price_symbol: "ETH",
      total_minted: 191,
      total_supply: null,
      total_volume: 702.2082499900004,
      one_day_volume: 0,
      seven_day_volume: 4.97,
      thirty_day_volume: 8.77,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -3,
      total_sales: 150,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 2,
      total_average_price: 4.681388333266669,
      one_day_average_price: 0,
      seven_day_average_price: 4.97,
      thirty_day_average_price: 4.385,
    },
    contracts: [
      {
        contract_address: "0xdfea2b364db868b1d2601d6b833d74db4de94460",
      },
    ],
    id: 51,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:53:10.085Z",
    key: "wall-street-bulls-interns",
    name: "Wall St Bulls Interns",
    description:
      "The Wall Street Bulls Interns are a sister collection to the Wall Street Bulls (https://opensea.io/collection/wall-street-bulls), designed and illustrated by Cam Rackam and the Wall St Memes Team.\r\n\r\nNeed free work? Can't convince your staff to pick up extra hours? No one wants to come in on a Saturday? Don't worry, we are providing Interns to all Wall St Bulls that hold more than 3 Bulls. Need a reminder to eat more fish? Looking for someone to pick up your dry-cleaning? Trying to find that special person who won't mix up messages from your wife with the messages from your gf? Then put your trust in these caffeine and debt addled little cuties. Sure, they Prozac. Yes, they Vape. Of course they can pick up a few coffees for the office. These Interns have one chance to get their hoof in the door and that's you. \r\n\r\nIntern utility includes FREE access to poker games, a financial advisor channel (Monday-Friday). Treat your interns well!",
    exchange_url: "https://opensea.io/collection/wall-street-bulls-interns",
    external_url: "https://wallstreetbulls.io/interns",
    banner_image_url:
      "https://i.seadn.io/gae/TUL9uiYSwigEC9mbLUYsb8f_SGG-erg1YH4WRvxszDwWsm9ayhOzVqWXY_W4cch6R23f8A4nTnQ0_Y7guCz6JnAMH258UauRcE3vfA?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/Qk0x1OoIGmkuNvBthfAI06iv_tXbdQCkNDUTMjzSU3M0C7fG6H-S2wKGxUy6lF2beUTsMWTN5dnKJFkNH0jUUrT2Hp0DrhGDTILi?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/Qk0x1OoIGmkuNvBthfAI06iv_tXbdQCkNDUTMjzSU3M0C7fG6H-S2wKGxUy6lF2beUTsMWTN5dnKJFkNH0jUUrT2Hp0DrhGDTILi?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/6PwJERqkKJvQw81Rki0zhD_tDtofcsajWkZRJjLcuJy_SbMNKPnJ7KAK38HFMwpe2NK1DwRpS4WcqdOwT7BpfDbEBl4FRZ5XFa3_cA?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/RPwexZWrBu",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "wallstbets",
    stats: {
      market_cap: 27.71130036363636,
      num_owners: 1172,
      floor_price: 0.0181,
      floor_price_symbol: "ETH",
      total_minted: 1172,
      total_supply: null,
      total_volume: 107.58203189005134,
      one_day_volume: 0.073098,
      seven_day_volume: 0.135598,
      thirty_day_volume: 0.28669800000000006,
      one_day_volume_change: 0.03689799999999999,
      seven_day_volume_change: 9,
      thirty_day_volume_change: 10,
      total_sales: 738,
      one_day_sales: 4,
      seven_day_sales: 11,
      thirty_day_sales: 24,
      total_average_price: 0.1457751109621292,
      one_day_average_price: 0.0182745,
      seven_day_average_price: 0.012327090909090909,
      thirty_day_average_price: 0.011945750000000003,
    },
    contracts: [
      {
        contract_address: "0x911e72ebfe9b93d593311d3e886ba8201c356564",
      },
    ],
    id: 52,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:53:02.811Z",
    key: "colettexdourdarcels",
    name: "colette x Dour Darcels",
    description:
      "A collection of 25 x 1/1 NFTs to celebrate the 25th anniversary of colette & the 10th anniversary of the Darcel Disappoints exhibition ‘150/15’.",
    exchange_url: "https://opensea.io/collection/colettexdourdarcels",
    external_url: "http://dourdarcels.io",
    banner_image_url:
      "https://i.seadn.io/gae/3Jt6qzBz4yuRFowykVaP7d_iJVYYWgPoi1EwncxvuKDjeFDE8eZrk3jBeT056V_Q0vCyMcZrWJW9sOYZFaaaL2D57BBHqETesV_1?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/GziLNDZpqovHr96bIGZJpicV5N1NHqJwVl_mBh3ZXGeobY5qr6JOzvbVlVMqO7yLnPU2E4CQfaebxDAFyqJsruP_PXZ6zrsx-Jk83g?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/GziLNDZpqovHr96bIGZJpicV5N1NHqJwVl_mBh3ZXGeobY5qr6JOzvbVlVMqO7yLnPU2E4CQfaebxDAFyqJsruP_PXZ6zrsx-Jk83g?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/A7VQMaLyG5EeBZqgiMua6_g2zN4VTFYJTrV7PBezk3DAUjjuE8Ew7VKhbdzK-L9W4fyzsKsEqyCKCZq6WQAZNQKbFdpfceXlfP4C?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/dourdarcelsnft",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "dourdarcelsNFT",
    stats: {
      market_cap: 0,
      num_owners: 23,
      floor_price: 0.3,
      floor_price_symbol: "ETH",
      total_minted: 23,
      total_supply: null,
      total_volume: 81.61198115796877,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 32,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 2.550374411186524,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x6d93d3fd7bb8baebf853be56d0198989db655e40",
      },
    ],
    id: 53,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:52:44.580Z",
    key: "hd-pass",
    name: "HD Pass",
    description:
      "A private group dedicated to cultivating the next generation of creators and builders in Web3. HD Pass holders have exclusive access to Hangout DAO along with all the tools and benefits.",
    exchange_url: "https://opensea.io/collection/hd-pass",
    external_url: "https://www.hangoutdao.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/40cb469bcf4f92baa1cd99c3cad6929f.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/40cb469bcf4f92baa1cd99c3cad6929f.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/40cb469bcf4f92baa1cd99c3cad6929f.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/44cd62b46b8a2a385de76d16681da088.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/hangoutdao",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0.0058,
      num_owners: 322,
      floor_price: 0.02999940004000001,
      floor_price_symbol: "ETH",
      total_minted: 322,
      total_supply: null,
      total_volume: 571.5606882019893,
      one_day_volume: 0,
      seven_day_volume: 0.0058,
      thirty_day_volume: 0.0058,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: -1,
      total_sales: 729,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 1,
      total_average_price: 0.7840338658463502,
      one_day_average_price: 0,
      seven_day_average_price: 0.0058,
      thirty_day_average_price: 0.0058,
    },
    contracts: [
      {
        contract_address: "0x82f8b200758d2a5cd5d584e8ee06e4182526b0ae",
      },
    ],
    id: 54,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:52:22.192Z",
    key: "the-association-nft",
    name: "The Association",
    description:
      "A collection of dynamic NFTs that change in appearance over time based on player and team on-court performance, brought to you by the NBA and NBPA. Visit TheAssociationNFT.com for more details.",
    exchange_url: "https://opensea.io/collection/the-association-nft",
    external_url: "http://theassociationnft.com",
    banner_image_url:
      "https://i.seadn.io/gae/LPb7_f93tQmoQtgkOKXFjT6yLBPcbjEm3RY3QuaDiWRB4k4G6DqcWVA8P6i7QydP4sHIE-JFg_0JluB9dS49OlTzyaNIe6mujWUzFA?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/TUSwb2UlfbnzeTS8bUTDtbevHvt7jx0gqelsYbhohmPiLhhyt8ZJQK351ZYeWYt3zZxFJG7jm2TBIzKTESuuj1ApIN1N4gP6uGnXfA?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/TUSwb2UlfbnzeTS8bUTDtbevHvt7jx0gqelsYbhohmPiLhhyt8ZJQK351ZYeWYt3zZxFJG7jm2TBIzKTESuuj1ApIN1N4gP6uGnXfA?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/drr38djJp4zJAseF4_BGcuCsxDfpjsHOjIz7wRWUXMxDO5jMFBnYBeU8e9lWdtv0hEvO5hx-W6AUOZMfH0GsL8MkJmbLydgUICjm5Q?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/nba",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 468.3348857142857,
      num_owners: 14121,
      floor_price: 0.0034,
      floor_price_symbol: "ETH",
      total_minted: 14121,
      total_supply: null,
      total_volume: 6003.190221012449,
      one_day_volume: 0.0043,
      seven_day_volume: 0.1093,
      thirty_day_volume: 0.28330000000000005,
      one_day_volume_change: -2,
      seven_day_volume_change: 5,
      thirty_day_volume_change: -3,
      total_sales: 31542,
      one_day_sales: 1,
      seven_day_sales: 7,
      thirty_day_sales: 13,
      total_average_price: 0.19032370239719895,
      one_day_average_price: 0.0043,
      seven_day_average_price: 0.015614285714285712,
      thirty_day_average_price: 0.021792307692307698,
    },
    contracts: [
      {
        contract_address: "0xd7bea2b69c7a1015aadaa134e564eee6d34149c0",
      },
    ],
    id: 55,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:52:11.245Z",
    key: "8thprojecteditions",
    name: "8th project Edition Manifold",
    description:
      "New collection of Geo portrait ( multiple edition ) developed under the smart contract manifold and designed by 8th project.\nSome of the portraits are still in the old collection, which in time will be transferred here. \nOld collection: https://opensea.io/collection/8thproject",
    exchange_url: "https://opensea.io/collection/8thprojecteditions",
    external_url: "http://8th-project.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/80874de10d18360b55e23bd626040335.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/0439071b745184e616095969f2476c6a.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/0439071b745184e616095969f2476c6a.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/10bc007d4498f98e89a43368088ea085.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 269,
      floor_price: 0.010483442456322207,
      floor_price_symbol: "ETH",
      total_minted: 269,
      total_supply: null,
      total_volume: 17.027900000000002,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 245,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.06950163265306124,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x8e23082ba7d0242085cb25f03fa976a0447f27e7",
      },
    ],
    id: 56,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:52:03.800Z",
    key: "bae-apes-nft-official",
    name: "Bae Apes Official NFT",
    description:
      "[Official Site](hub.xyz/bae-apes-nft) | [Exclusives](https://opensea.io/collection/bae-apes-exclusives) | [Rewards](https://opensea.io/collection/bae-apes-rewards)\r\n\r\n**100% SOLD OUT**\r\n \r\nBae Apes is a collection of 5,000 female PFPs found on the ETH Blockchain. Holders get access to staking, Merch, exclusive giveaways, and first access to future collections including ZomBaes. \r\n\r\nJoin us in the Banana Coast!",
    exchange_url: "https://opensea.io/collection/bae-apes-nft-official",
    external_url: "https://thebaeapes.com/",
    banner_image_url:
      "https://i.seadn.io/gae/g_oihDP63F0Sx7y8jKrtJRSEf8hULkKrRGw99cr-49d6S_UXbeFdLR1EdTzEcs0kd1E5wkJ61Ae3Qw2IIGMQdF-tzGjISLvXbppZNjk?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/wO1E9dw0EP4qYZqYETy9_xxo29U6RwURN7RVU217EdCUKEq1nwC3H09vzmFn5d8nCuD0qHeFiC4MHKxCuYIlqCBCAC8X4rif2r94PA?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/wO1E9dw0EP4qYZqYETy9_xxo29U6RwURN7RVU217EdCUKEq1nwC3H09vzmFn5d8nCuD0qHeFiC4MHKxCuYIlqCBCAC8X4rif2r94PA?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/kVwhHJQoy5ORp81bP27M6UtPvDIcxfCPYWu5e_uPxtjhd2704sdmL9RLIXRSoeNfQjPRY-FYllYFLeXXn_ECBBxBGPtZkoKBJJsn?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/FfAPcu2BBq",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "baeapes/",
    stats: {
      market_cap: 17.913083333333333,
      num_owners: 979,
      floor_price: 0.004158,
      floor_price_symbol: "ETH",
      total_minted: 979,
      total_supply: null,
      total_volume: 59.264527988800026,
      one_day_volume: 0,
      seven_day_volume: 0.0215,
      thirty_day_volume: 0.1438,
      one_day_volume_change: 0,
      seven_day_volume_change: -14,
      thirty_day_volume_change: 7,
      total_sales: 2598,
      one_day_sales: 0,
      seven_day_sales: 6,
      thirty_day_sales: 28,
      total_average_price: 0.02281159660846806,
      one_day_average_price: 0,
      seven_day_average_price: 0.003583333333333333,
      thirty_day_average_price: 0.005135714285714286,
    },
    contracts: [
      {
        contract_address: "0xb56011fbfdafe460b905a40a4845a49c94712272",
      },
    ],
    id: 57,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:51:34.244Z",
    key: "people-of-eden",
    name: "People Of Eden",
    description:
      "The People of Eden is first of its kind DeFi PFP collection combining art, robust utility, and storytelling to communicate the importance of financial freedom through an open yet decentralized ecosystem using $MAHA and $ARTH. \r\n\r\nEach NFT is backed by at least 100 MAHA. To mint a NFT visit https://peopleofeden.com",
    exchange_url: "https://opensea.io/collection/people-of-eden",
    external_url: "https://peopleofeden.com/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/e7e2d4212cfc41c398bc020b41fd8506.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/b2d6c75ab3a91a63f91decb46a4263bd.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/b2d6c75ab3a91a63f91decb46a4263bd.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/8cd60a089da2240460d8d9d7b6010c5c.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/mahadao",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "peopleofeden",
    stats: {
      market_cap: 13.456000000000003,
      num_owners: 787,
      floor_price: 0.004,
      floor_price_symbol: "ETH",
      total_minted: 787,
      total_supply: null,
      total_volume: 16.923759998999987,
      one_day_volume: 0,
      seven_day_volume: 0.05800000000000001,
      thirty_day_volume: 0.0994,
      one_day_volume_change: 0,
      seven_day_volume_change: 5,
      thirty_day_volume_change: 11,
      total_sales: 244,
      one_day_sales: 0,
      seven_day_sales: 5,
      thirty_day_sales: 11,
      total_average_price: 0.06935967212704913,
      one_day_average_price: 0,
      seven_day_average_price: 0.011600000000000003,
      thirty_day_average_price: 0.009036363636363638,
    },
    contracts: [
      {
        contract_address: "0xbdd8f4daf71c2cb16cce7e54bb81ef3cfcf5aacb",
      },
    ],
    id: 58,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:50:55.582Z",
    key: "darkkingisme-1",
    name: "DarkKingIsMe",
    description:
      "These elements extend the basic syntax by adding additional features. Not all Markdown applications support these elements.",
    exchange_url: "https://opensea.io/collection/darkkingisme-1",
    external_url: null,
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/22c0bfd42b6fea025fe6d2764b9820c0.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/22c0bfd42b6fea025fe6d2764b9820c0.jpg?w=500&auto=format",
    image_url: null,
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 4,
      floor_price: 0.01,
      floor_price_symbol: "ETH",
      total_minted: 4,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x9bf19ceffcd795ec8b4dfa93d7ffebe1c7b425f9",
      },
    ],
    id: 59,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:50:55.202Z",
    key: "trumppunks-1",
    name: "TrumpPunks",
    description: "Make NFT's great again! TRUMP 2024🇺🇸🦅",
    exchange_url: "https://opensea.io/collection/trumppunks-1",
    external_url: "https://www.donaldjtrump.com/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/81f07dad40a6f29d1ae58180cdbdf206.png?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/edf6a440a7da7154de23bb8c53e91ec2.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 10.115,
      num_owners: 1686,
      floor_price: 0.0032,
      floor_price_symbol: "ETH",
      total_minted: 1686,
      total_supply: null,
      total_volume: 0.15320699999999998,
      one_day_volume: 0,
      seven_day_volume: 0.005,
      thirty_day_volume: 0.005,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 1,
      total_sales: 56,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 1,
      total_average_price: 0.002735839285714285,
      one_day_average_price: 0,
      seven_day_average_price: 0.005,
      thirty_day_average_price: 0.005,
    },
    contracts: [
      {
        contract_address: "0x001674e08d37a9bb39c70a599ffa53d7c901b385",
      },
    ],
    id: 60,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:50:44.721Z",
    key: "internetswag",
    name: "internet swag",
    description:
      "Internet Swag merges fashion and digital art, empowering you to express your unique style in the virtual realm. Own a piece of art that represents your personality and captivates the online world.",
    exchange_url: "https://opensea.io/collection/internetswag",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/89d8a34f7b3edc28d51367ab82a835ec.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/0531e051c6c5193ba067e54e9a7a5dd4.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/0531e051c6c5193ba067e54e9a7a5dd4.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/9e07a668dcd83c2865f9728c10a3a3f3.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1700,
      floor_price: 0.001,
      floor_price_symbol: "ETH",
      total_minted: 1700,
      total_supply: null,
      total_volume: 22.175442632080028,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 4360,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.005086110695431199,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xb0fcb43d3701f00afd2fb3d5f577a806f551d2f2",
      },
    ],
    id: 61,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:50:21.347Z",
    key: "the-grapes",
    name: "The Grapes",
    description:
      "Grapes are a delightfully fun and globally appealing collection of 3,333 hand-crafted NFTs.\r\n\r\nGrapes is a cross-media, family-friendly entertainment IP that transcends Web3 with gaming, TV, products & licensing at the heart.\r\n\r\nDesigned and launched by the VIKER team which is invested in by Animoca Brands. \r\n\r\nBehind Grapes is a wealth of experience with more than 500+ million downloads over their careers. \r\n\r\nBen Cusack led Square Enix’s Mobile Studios, launching Lara Croft, Final Fantasy, Championship Manager as well as Space Invaders & many more.\r\n\r\nDan Beasley has been integral to taking many influencers and TV brands to mobile for the first time, including Who Wants to be a Millionaire with Sony Pictures, Mr Bean, KSI & Logan Paul. \r\n\r\nGrapes are advised by some of Web3’s most recognisable industry leaders including Yat Siu & Robby Yung (Animoca Brands) XtremeTom (Cool Cats) Keith Rumjahn (Founder OliveX & Memeland advisor) & Sebastien Borget (The Sandbox)\r\n\r\nGrape things are coming!",
    exchange_url: "https://opensea.io/collection/the-grapes",
    external_url: "http://www.joingrapes.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/c90e409791067a684d9d1da4c87ab633.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/1ffce3907fbbf9db9c3197074ba27f82.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/1ffce3907fbbf9db9c3197074ba27f82.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/711edf308fbce1b1d04a47eb1337a8ce.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/joingrapes",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 118.84604616216222,
      num_owners: 929,
      floor_price: 0.032446,
      floor_price_symbol: "ETH",
      total_minted: 929,
      total_supply: null,
      total_volume: 11122.628079915969,
      one_day_volume: 0.8057580000000002,
      seven_day_volume: 1.3197190000000008,
      thirty_day_volume: 6.582008101000009,
      one_day_volume_change: 0.7602580000000002,
      seven_day_volume_change: 26,
      thirty_day_volume_change: 16,
      total_sales: 18149,
      one_day_sales: 20,
      seven_day_sales: 37,
      thirty_day_sales: 163,
      total_average_price: 0.612850739981044,
      one_day_average_price: 0.04028790000000001,
      seven_day_average_price: 0.035668081081081104,
      thirty_day_average_price: 0.040380417797546066,
    },
    contracts: [
      {
        contract_address: "0xe1dc516b1486aba548eecd2947a11273518434a4",
      },
    ],
    id: 62,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:50:14.141Z",
    key: "uwucrew",
    name: "uwucrew",
    description:
      "Build a personal relationship with anime art and the artists behind them ✨\nArt by [@fungibleartist](https://twitter.com/fungibleartist)🎨\n\nuwucrew features an incredibly vibrant art-focused community with a focus on artist support and representation.\n\nMade with love by uwu Labs",
    exchange_url: "https://opensea.io/collection/uwucrew",
    external_url: "https://uwucrew.art",
    banner_image_url:
      "https://i.seadn.io/gcs/files/31c1406ea1acb3091887b8d25482f883.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/8258f51cc78afdda678335b3a5749599.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/8258f51cc78afdda678335b3a5749599.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/3e7b77af8d453180de0090fa3cc2fb46.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/uwucrew",
    telegram_url: null,
    twitter_username: "uwucrewnft",
    wiki_url: null,
    instagram_username: "uwucrew.art",
    stats: {
      market_cap: 175.3310460909091,
      num_owners: 3575,
      floor_price: 0.0181069,
      floor_price_symbol: "ETH",
      total_minted: 3575,
      total_supply: null,
      total_volume: 4731.188654970936,
      one_day_volume: 0.0169,
      seven_day_volume: 0.19967300000000002,
      thirty_day_volume: 1.2279879999999996,
      one_day_volume_change: 0.000099999999999999,
      seven_day_volume_change: 9,
      thirty_day_volume_change: 0,
      total_sales: 19949,
      one_day_sales: 1,
      seven_day_sales: 11,
      thirty_day_sales: 36,
      total_average_price: 0.2371642014622756,
      one_day_average_price: 0,
      seven_day_average_price: 0.01815209090909091,
      thirty_day_average_price: 0.03411077777777777,
    },
    contracts: [
      {
        contract_address: "0xf75140376d246d8b1e5b8a48e3f00772468b3c0c",
      },
    ],
    id: 63,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:50:13.604Z",
    key: "the-greats",
    name: "The Greats by Wolfgang Beltracchi",
    description:
      "The first ever Digital Fine Art Collection by the most prolific art forger of the 20th century, Wolfgang Beltracchi.",
    exchange_url: "https://opensea.io/collection/the-greats",
    external_url: "https://www.greats.art/",
    banner_image_url:
      "https://i.seadn.io/gae/7n5JRWczVRG-NPxqjln_ar3XuXfEL3VnOQzLif_PhGbtdY1_TkGeOyDk9qXzq8qlPdGE4CyuKIDz9DO09oYLS-EHuXSnhM_1uEMR?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/jiKMt0xsANV3CVc8Cg9Y3-uytPX4nodLnoi5KG6H1SYxaeovS_p2F59nam4i5x1YEmoh8EZqJ0F9kdpNNkfo2ATJbf2MC2nZy9Sd?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/vshW7SJjhn",
    telegram_url: null,
    twitter_username: "TheGreatsArt",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 418,
      floor_price: 0.128999,
      floor_price_symbol: "ETH",
      total_minted: 418,
      total_supply: null,
      total_volume: 185.17423345483655,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.28500000000000003,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -2,
      total_sales: 385,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 8,
      total_average_price: 0.4809720349476274,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.035625000000000004,
    },
    contracts: [
      {
        contract_address: "0xe0fa9fb0e30ca86513642112bee1cbbaa2a0580d",
      },
    ],
    id: 64,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:49:29.619Z",
    key: "wotf-character-proofs",
    name: "Wonders of The First: Character Proofs",
    description:
      "The owner of these collectible art proofs are granted [certain IP rights](https://web-assets.blokpax.com/wotf-character-proofs-nft-license-terms.pdf).",
    exchange_url: "https://opensea.io/collection/wotf-character-proofs",
    external_url: "https://www.wondersotf.xyz/",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/f8836acdcd549d4fba00211fb3b0f901.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/f8836acdcd549d4fba00211fb3b0f901.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/3f47be91a23c55852f80248c52c6ad56.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/wondersotf",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 1330,
      num_owners: 6471,
      floor_price: 0.064999,
      floor_price_symbol: "ETH",
      total_minted: 6471,
      total_supply: null,
      total_volume: 128.98174480992276,
      one_day_volume: 0,
      seven_day_volume: 0.266,
      thirty_day_volume: 2.8159715999360397,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 10,
      total_sales: 818,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 34,
      total_average_price: 0.15767939463315742,
      one_day_average_price: 0,
      seven_day_average_price: 0.133,
      thirty_day_average_price: 0.08282269411576587,
    },
    contracts: [
      {
        contract_address: "0x05f08b01971cf70bcd4e743a8906790cfb9a8fb8",
      },
    ],
    id: 65,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:49:18.721Z",
    key: "queenapes",
    name: "Queen Apes",
    description:
      "Also Available: [Apocalyptic Apes](https://opensea.io/collection/apocalyptic-apes) & [Apocalyptic Ape Labs](https://opensea.io/collection/apocalyptic-apes-juice)\n\nWe are a community brought together by a collection of 8,888 uniquely illustrated post apocalypse themed ape NFTs, on the Ethereum blockchain. Inspired by dystopian futures in games, movies, and other media, the Apocalyptic Apes have travelled back in time to help prevent the future from which they came.",
    exchange_url: "https://opensea.io/collection/queenapes",
    external_url: "https://apocalypticapes.com/",
    banner_image_url:
      "https://i.seadn.io/gae/LnoTmIgAJ_OCBNFlJkKirFMH3Z_T6Lcx5imKr9tQiUfhVSIcH6qqZZyk9Sw9f5U9qPVihKmiaCT4dchc9fIqja1_NDdKW5gULYOgMA4?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/LnoTmIgAJ_OCBNFlJkKirFMH3Z_T6Lcx5imKr9tQiUfhVSIcH6qqZZyk9Sw9f5U9qPVihKmiaCT4dchc9fIqja1_NDdKW5gULYOgMA4?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/LnoTmIgAJ_OCBNFlJkKirFMH3Z_T6Lcx5imKr9tQiUfhVSIcH6qqZZyk9Sw9f5U9qPVihKmiaCT4dchc9fIqja1_NDdKW5gULYOgMA4?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/sCZzlyKzo3CBALdLtXwGHRhF_8Dlq9kQYYpwF3CD7240cVHkdmbkECviWY3_3eCcL-_7Qb58tdS4C_1BXbRi-FfTMkfJlJrwsYx8Jg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/EGwcRZ3zxq",
    telegram_url: "https://t.me/fityeth",
    twitter_username: null,
    wiki_url: null,
    instagram_username: "ApocalypticApes/",
    stats: {
      market_cap: 39.1028,
      num_owners: 2155,
      floor_price: 0.005298,
      floor_price_symbol: "ETH",
      total_minted: 2155,
      total_supply: null,
      total_volume: 879.918619439411,
      one_day_volume: 0,
      seven_day_volume: 0.0176,
      thirty_day_volume: 0.02891599,
      one_day_volume_change: 0,
      seven_day_volume_change: 2,
      thirty_day_volume_change: -13,
      total_sales: 7834,
      one_day_sales: 0,
      seven_day_sales: 4,
      thirty_day_sales: 7,
      total_average_price: 0.11232047733461974,
      one_day_average_price: 0,
      seven_day_average_price: 0.0044,
      thirty_day_average_price: 0.004130855714285714,
    },
    contracts: [
      {
        contract_address: "0x1417404d0d92f9d21b046afbaa9d1c4e17c4c723",
      },
    ],
    id: 66,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:49:11.624Z",
    key: "gazeraw",
    name: "Gazer - Abyss World",
    description:
      "The Gazer collection - a set of Genesis NFTs on Abyss World, created by the passionate team at Metagame Industries. This open-world Action-RPG offers a limited first batch of 2,100 Genesis NFTs exclusively available to our early community members. Join us in revolutionizing the Web3 gaming industry and rising from the depths of the abyss!To delve into the benefits and entitlements accompanying this NFT collection, please refer to the article below: https://medium.com/@ABYSS_WORLD/abyss-world-gazer-nft-mint-is-coming-e1bc176c3e54",
    exchange_url: "https://opensea.io/collection/gazeraw",
    external_url: "https://abyssworld.games/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/43100e7477c11391473d111946e2f5ca.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/6f90be381fabb6de428dff653a3babe4.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/6f90be381fabb6de428dff653a3babe4.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/43c2dd9ae0fe6a7d10e9b26bcae97b2b.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1221,
      floor_price: 0.011493,
      floor_price_symbol: "ETH",
      total_minted: 1221,
      total_supply: null,
      total_volume: 999.0800686670094,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0046,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -6,
      total_sales: 1792,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.5575223597472151,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0046,
    },
    contracts: [
      {
        contract_address: "0x73cdc2344db9a4cccdf14a3f852cdc972e3a2848",
      },
    ],
    id: 67,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:48:46.704Z",
    key: "matr1x-kuku",
    name: "MATR1X KUKU",
    description:
      "KUKU is an NFT entity of unparalleled significance in the MATR1X platform, embodying the spirit of creativity and unity in the Web3 era.\r\n\r\n**Exclusive Benefits with KUKU:**\r\n\r\n1.**Elite Status in MATR1X:** As a KUKU holder, enjoy a share in the profits of the Matr1x creators' ecosystem.\r\n2.**Loyal Companion in Gaming:** KUKU stands as a unique in-game ally, providing access to exclusive in-game NFTs within the MATR1X ecosystem.\r\n3.**Earn with Staking:** Stake your KUKU to receive exclusive, evolving MATR1X FIRE ornament treasures.\r\n4.**Exclusive Physical and Digital Merchandise:** Take ownership of unique Matr1x IP merchandise, bridging the gap between the digital and physical realms.\r\n\r\nKUKU is a commitment to innovation, engagement, and reward in our community. Join us in shaping the future of Web3 interaction and achievement.\r\n\r\nRead more on our Twitter: [@matr1xoffical](https://twitter.com/Matr1xOfficial) and official website:[matr1x.io/kuku](https://www.matr1x.io/kuku).",
    exchange_url: "https://opensea.io/collection/matr1x-kuku",
    external_url: "https://www.matr1x.io/",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/35bf5601546e7403b6ad22cb98d59b42.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/35bf5601546e7403b6ad22cb98d59b42.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/9088493e46dedf99d3e0e6610cd668fc.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: "https://t.me/matr1xofficial",
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 876.0733362857143,
      num_owners: 1901,
      floor_price: 0.1999481,
      floor_price_symbol: "ETH",
      total_minted: 1901,
      total_supply: null,
      total_volume: 29340.682295874234,
      one_day_volume: 0,
      seven_day_volume: 0.919969,
      thirty_day_volume: 5.600152999999999,
      one_day_volume_change: 0,
      seven_day_volume_change: -5,
      thirty_day_volume_change: -701,
      total_sales: 16512,
      one_day_sales: 0,
      seven_day_sales: 7,
      thirty_day_sales: 38,
      total_average_price: 1.7769308560970345,
      one_day_average_price: 0,
      seven_day_average_price: 0.13142414285714285,
      thirty_day_average_price: 0.14737244736842103,
    },
    contracts: [
      {
        contract_address: "0x596a5cd859ad53fec23cd3fcd77522f0b407920d",
      },
    ],
    id: 68,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:48:42.902Z",
    key: "primate-social-society-official",
    name: "Primate Social Society",
    description:
      "The first deflationary collection of Ape Avatars. 2705 burned, bringing the total supply down to 7295 (01/13/23). PSS NFTs are a membership card to the Society, and grant access to members-only benefits including free kitten companions, gorillas, breeding, and future RPG. \n\nSacrifice 5 PSS to earn $SILVER! https://opensea.io/collection/pss-silverbacks-official \n\nWebsite: https://www.primatesocialsociety.com/  \nTwitter: https://twitter.com/PrimatesSociety \nDiscord: https://discord.gg/8sKG8P7mdS\nWhitepaper: https://docs.primatesocialsociety.com/primate-social-society/apes-on-the-opensea   ",
    exchange_url:
      "https://opensea.io/collection/primate-social-society-official",
    external_url: "https://www.primatesocialsociety.com/",
    banner_image_url:
      "https://i.seadn.io/gae/sUw0LUugFsiGQ0lAosfTHdxZhqhyMGv2SmbB5t0mmfsNVjW-Xw-Gecz8B_JvpBF4rKla2s8ajxKErrYr4pvFCklQniorWIplT2vX?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/A6WQaYS7HsdpOd63YxHb_BNG7PKNnM85xYi4fXZRnGY2IZxm1dW1WGKTS3ce8rzYWeoQeSElMx9REx6MqyBuat72qPAlt4jOB_UD?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/A6WQaYS7HsdpOd63YxHb_BNG7PKNnM85xYi4fXZRnGY2IZxm1dW1WGKTS3ce8rzYWeoQeSElMx9REx6MqyBuat72qPAlt4jOB_UD?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/cGZDhzDL6hiSPHeXhFNuLPEILQBsGEu8KqFjHizUGCuWpDAbSqGzIrJspePNemKf0n2ecccXP2MR477JBKNyio3gXYrcP3ltSjxrgA?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/8sKG8P7mdS",
    telegram_url: "https://t.me/primatesocialsociety",
    twitter_username: "@PrimatesSociety",
    wiki_url: null,
    instagram_username: "primatesocialsociety",
    stats: {
      market_cap: 0,
      num_owners: 2385,
      floor_price: 0.008293,
      floor_price_symbol: "ETH",
      total_minted: 2385,
      total_supply: null,
      total_volume: 455.1685345789769,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 5995,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.07592469300733559,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x76e51bc8fa0beebcf3e45de408fa43c9dc5ffb27",
      },
    ],
    id: 69,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:48:39.066Z",
    key: "early-retired-penguins-club",
    name: "Early Retired Penguins Club",
    description:
      "Cuteness crawling up your hooman soul. Ever seen Peng this cute? Explore the world of 8,888 Penguins with ERPC.",
    exchange_url: "https://opensea.io/collection/early-retired-penguins-club",
    external_url: "https://earlypenguins.xyz",
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/s/raw/files/044fde7539c262e224900c0234461c16.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 2.6634232,
      num_owners: 1737,
      floor_price: 0.0008,
      floor_price_symbol: "ETH",
      total_minted: 1737,
      total_supply: null,
      total_volume: 5.143209998894718,
      one_day_volume: 0,
      seven_day_volume: 0.0002998,
      thirty_day_volume: 0.1767981599999999,
      one_day_volume_change: 0,
      seven_day_volume_change: -10,
      thirty_day_volume_change: 14,
      total_sales: 1901,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 17,
      total_average_price: 0.002705528668540094,
      one_day_average_price: 0,
      seven_day_average_price: 0.0002998,
      thirty_day_average_price: 0.010399891764705876,
    },
    contracts: [
      {
        contract_address: "0x496334db43c4b80149cc9a9036b955c717f2fa19",
      },
    ],
    id: 70,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:47:44.361Z",
    key: "petal-headz",
    name: "Petal Headz",
    description:
      "Petal Headz is a collection of 1/1 flowers created by Evan Hilton. Each flower was grown in unique environments blossoming one of a kind traits and personalities. Owning a Petal Head will unlock access to collectables, content, and future utility from Evan.\r\n\r\nEach flower goes through three Growth States before turning into a 1/1 Petal Head:\r\n1. Seed\r\n2. Sprout\r\n3. Blossoming",
    exchange_url: "https://opensea.io/collection/petal-headz",
    external_url: "https://www.petalheadz.com/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/c509b8dcc32d50d4f1e7148cdea771a0.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/32e0c1e9d66f8d9447f2838252e83381.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/32e0c1e9d66f8d9447f2838252e83381.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/eef31e0c405d0d0e88232756f96e38d6.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 98,
      floor_price: 0.136599,
      floor_price_symbol: "ETH",
      total_minted: 98,
      total_supply: null,
      total_volume: 69.5646304249033,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.425561799965386,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 192,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 5,
      total_average_price: 0.362315783463038,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0851123599930772,
    },
    contracts: [
      {
        contract_address: "0xb22e278c16be72ca95ad6921729c3a21d4c09e82",
      },
    ],
    id: 71,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:47:03.520Z",
    key: "futr-one",
    name: "FUTR",
    description:
      "The official PFP collection of [Mintify](https://mintify.xyz) designed by [Nostalgic Scarlett](https://twitter.com/NostalgicScarl1). Her work has been featured on SuperRare and Foundation. [Join our 17,000+ members](https://discord.gg/mintify) on Discord.\r\n\r\nYou are also entitled to a commercial license, please read the terms here: [https://docs.mintify.xyz/legal/terms-of-use](https://docs.mintify.xyz/legal/terms-of-use)",
    exchange_url: "https://opensea.io/collection/futr-one",
    external_url: "http://mintify.xyz",
    banner_image_url:
      "https://i.seadn.io/gcs/files/3ef6ca7e5591187426c57c5aab9245e7.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/7a2aeb1eaf97abb4122903270539b9a8.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/7a2aeb1eaf97abb4122903270539b9a8.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/f1f7a39135dced852c73788b54553311.webp?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/mintify",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 63.70540451851853,
      num_owners: 1337,
      floor_price: 0.017099,
      floor_price_symbol: "ETH",
      total_minted: 1337,
      total_supply: null,
      total_volume: 242.21521456216504,
      one_day_volume: 0.01846,
      seven_day_volume: 0.34407800000000005,
      thirty_day_volume: 1.3476319999999995,
      one_day_volume_change: -0.177258,
      seven_day_volume_change: 16,
      thirty_day_volume_change: -5,
      total_sales: 12160,
      one_day_sales: 1,
      seven_day_sales: 27,
      thirty_day_sales: 91,
      total_average_price: 0.019919014355441203,
      one_day_average_price: 0,
      seven_day_average_price: 0.01274362962962963,
      thirty_day_average_price: 0.014809142857142852,
    },
    contracts: [
      {
        contract_address: "0xb948f35c1c35206a5fb23b77f9e52a01b793c909",
      },
    ],
    id: 72,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:46:01.524Z",
    key: "grift-szn",
    name: "GRIFT SZN",
    description: "Official grift",
    exchange_url: "https://opensea.io/collection/grift-szn",
    external_url: "https://grifters.wtf",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/6c11ef69a4d0e95449723a8575d12f97.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/6c11ef69a4d0e95449723a8575d12f97.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/b6adc269eb1c29645acdfc7cdde3992e.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 4.485,
      num_owners: 130,
      floor_price: 1.799,
      floor_price_symbol: "ETH",
      total_minted: 130,
      total_supply: null,
      total_volume: 134.67221699999996,
      one_day_volume: 1.52,
      seven_day_volume: 5.98,
      thirty_day_volume: 7.23,
      one_day_volume_change: 1,
      seven_day_volume_change: 4,
      thirty_day_volume_change: 4,
      total_sales: 113,
      one_day_sales: 1,
      seven_day_sales: 4,
      thirty_day_sales: 5,
      total_average_price: 1.191789530973451,
      one_day_average_price: 1.52,
      seven_day_average_price: 1.495,
      thirty_day_average_price: 1.4460000000000002,
    },
    contracts: [
      {
        contract_address: "0x55fda4cf1e821c6f13372d6337303a97eea829c1",
      },
    ],
    id: 73,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:45:54.010Z",
    key: "thecryptobabypunks",
    name: "The CryptoBabyPunks",
    description:
      "999 unique CryptoBabyPunks born on the Ethereum Blockchain in march 2021.            \n               \n1200Ξ volume in the first collection on OpenSea Shared Storefront smart contract (ERC1155).       \nThanks to Samuel Cardillo (CTO RTFKT : [@CardilloSamuel](https://twitter.com/CardilloSamuel) ❤️) we migrated to our own ERC721 contract.       \n       \nTwitter : [@cryptobabypunks](https://twitter.com/cryptobabypunks)      \n🍼 CRYPTOBABYPUNKS TYPES :        \n\n👶 Girl/Boy = 976/999      \n🧟‍♂️ Zombies = 14/999     \n🐵 Apes = 6/999        \n👽 Aliens = 3/999       \n       \n47 ≠ ATTRIBUTES :        \n🍼 0 attribute = 5/999      \n🍼 1 attribute = 50/999        \n🍼 2 attributes = 701/999       \n🍼 3 attributes = 243/999        \n          \nnot affiliated w/ Yuga Labs / Larva Labs",
    exchange_url: "https://opensea.io/collection/thecryptobabypunks",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gae/AJ2cP_WAelOOWrvl-GA-XggG7lu8rE8JqaXQDtAIXzsBXiG2rcMxv_FZbwZEszVLai2Oz507PDu4VT-vS3zTePbCvf_qwHv4pWjRig?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/AJ2cP_WAelOOWrvl-GA-XggG7lu8rE8JqaXQDtAIXzsBXiG2rcMxv_FZbwZEszVLai2Oz507PDu4VT-vS3zTePbCvf_qwHv4pWjRig?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/AJ2cP_WAelOOWrvl-GA-XggG7lu8rE8JqaXQDtAIXzsBXiG2rcMxv_FZbwZEszVLai2Oz507PDu4VT-vS3zTePbCvf_qwHv4pWjRig?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/bAaNGyrV-m78znAsFMR8ixF-88i3l3z7KSG2tSKq5Hnq9p7PDz3Seyv9A03SZlQ4lnwzmunN82u3RiMahRyPXRvAnuy8z0im1aDfFg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 544,
      floor_price: 0.010485,
      floor_price_symbol: "ETH",
      total_minted: 544,
      total_supply: null,
      total_volume: 28.24828999998394,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.009,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -5,
      total_sales: 143,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.1975404895103772,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.009,
    },
    contracts: [
      {
        contract_address: "0xfa262a0ec445c0cf1f95fc8cb8a810e9dcb871b0",
      },
    ],
    id: 74,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:45:23.740Z",
    key: "symmetry-breaking",
    name: "Symmetry Breaking by TheFormatix",
    description:
      "Symmetry Breaking is an experimental generative art collection on the Ethereum Blockchain. The collection contains 700 unique NFTs [ERC-721] inspired by Jack Butcher’s “Trademark” project. The collection is an addition to my Preserving Symmetry collection.\n\nImmerse yourself in the beauty of simplicity and random color combinations. Random generation of unique patterns from various squares of random color. The background shade directly depends on the main color.\n\nSymmetry Breaking is free to mint, just pay for gas fees.\n\nPlease note, this collection is an independent homage and not officially affiliated with Jack Butcher or Trademark. All rights and ownership of the Trademark project belong to their respective owners.\n\nMade by TheFormatix with love!\n\nFEBRUARY © 2024",
    exchange_url: "https://opensea.io/collection/symmetry-breaking",
    external_url: "http://linktr.ee/theformatix",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/da2d341c167e8b6325059edb85e52f83.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/da2d341c167e8b6325059edb85e52f83.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/b7d8ae0ac34c0f616647fee55be4ddc9.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 110,
      floor_price: 0.001,
      floor_price_symbol: "ETH",
      total_minted: 110,
      total_supply: null,
      total_volume: 0.004,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 1,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.004,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x99dac72f163ac98e81cf207711ec0f77bba4cf17",
      },
    ],
    id: 75,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:45:02.201Z",
    key: "anticyclone-by-william-mapan",
    name: "Anticyclone by William Mapan",
    description:
      'Art Blocks Collection: Curated\n\nHeritage Art Blocks Collection: Curated series 7\n\nProject Description: Anticyclones are a weather phenomena.\nThey pierce through darkness to instill peace and calm. Their planetary scale reminds us of how little we are and how powerful they can be.\n\nHigh pressure, rotation, air flow… The "Anticyclone" series is an artistic exploration and interpretation of those concepts.\n\nThe rendering borrows its aesthetics from traditional and organic media like paper and crayons, to lend an analog/archival look.\n\n"Can a computer draw like a human?"\nThe question is asked and challenged once more through "Anticyclone".\n\n[Press the left/right keys to explore the different steps building the final image. Bottom/top for the first/last step. Can be intense for your machine]',
    exchange_url: "https://opensea.io/collection/anticyclone-by-william-mapan",
    external_url: "https://artblocks.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/6a0193895d5538c3e04da84ec9ec4f76.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/A5QPbhrbiDiUsmLw5fc6p9uWc8rDFspy16_yCLlJHDVWGVnvPUeEtWG4FvrE1kIgdzjHpoRV0ZEX-5qhIy6qqChc-be0ALrtMRpMXg?w=500&auto=format",
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/A5QPbhrbiDiUsmLw5fc6p9uWc8rDFspy16_yCLlJHDVWGVnvPUeEtWG4FvrE1kIgdzjHpoRV0ZEX-5qhIy6qqChc-be0ALrtMRpMXg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 1520,
      num_owners: 412,
      floor_price: 2.7,
      floor_price_symbol: "ETH",
      total_minted: 412,
      total_supply: null,
      total_volume: 7195.55123842514,
      one_day_volume: 0,
      seven_day_volume: 1.9,
      thirty_day_volume: 10.8,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -2,
      total_sales: 1557,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 4,
      total_average_price: 4.621420191666757,
      one_day_average_price: 0,
      seven_day_average_price: 1.9,
      thirty_day_average_price: 2.7,
    },
    contracts: [
      {
        contract_address: "0xa7d8d9ef8d8ce8992df33d8b8cf4aebabd5bd270",
      },
    ],
    id: 76,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:44:36.879Z",
    key: "meridian-by-matt-deslauriers",
    name: "Meridian by Matt DesLauriers",
    description:
      "Art Blocks Collection: Presents\n\nHeritage Art Blocks Collection: Playground\n\nProject Description: Stratified landforms constructed from many small strokes of colour. The hash of each token describes a coordinate within a multidimensional generative space, locating a unique composition that lies along one of many possible longitudes.",
    exchange_url: "https://opensea.io/collection/meridian-by-matt-deslauriers",
    external_url: "https://artblocks.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/ef2c459a8ae055f06e76a22d8b1c468c.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/o5Tt1FbaINxqvS47-r3weuCEaTKGbc5yZJS0yXtDyBDwVeyYVWr7angBivb3iGXKc_1Q-a-DBwxu_VMynRnPbJHVnkt4u1pbBTDz?w=500&auto=format",
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/o5Tt1FbaINxqvS47-r3weuCEaTKGbc5yZJS0yXtDyBDwVeyYVWr7angBivb3iGXKc_1Q-a-DBwxu_VMynRnPbJHVnkt4u1pbBTDz?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 628,
      floor_price: 3.299,
      floor_price_symbol: "ETH",
      total_minted: 628,
      total_supply: null,
      total_volume: 22242.665618285373,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 11.766099999999998,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -6,
      total_sales: 2097,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 4,
      total_average_price: 10.606898244294408,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 2.9415249999999995,
    },
    contracts: [
      {
        contract_address: "0xa7d8d9ef8d8ce8992df33d8b8cf4aebabd5bd270",
      },
    ],
    id: 77,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:44:28.921Z",
    key: "the-1336-coach-pop-collection",
    name: "The 1336 Coach Pop Collection",
    description:
      "The 1336 Coach Pop Collection commemorates the new all-time winningest coach in NBA History. Each NFT will highlight a hand-drawn play with a digital signature from Coach Pop’s arsenal, featured against a backdrop of the different courts Spurs teams have played on during his tenure. \r\n\r\nContinuing the long-standing partnership between the Spurs & San Antonio Food Bank, 100% of the proceeds from this historic and unique collection will directly benefit the fight against hunger and feeding hope to the San Antonio and Southwest Texas community.",
    exchange_url: "https://opensea.io/collection/the-1336-coach-pop-collection",
    external_url: "https://www.nba.com/spurs/",
    banner_image_url:
      "https://i.seadn.io/gae/7tf3ek_2ju5otpDG0qjVOzfdz9SiDnlRMdex4MZ1-jqieJNBNxPWqgUXkRwlIMTKMZjr_RVLWtpKSoc2n378WT8LM4Y0LUEFOsNo?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/SemminnnHEuqC2sKAiuHeBYXrQxCZLFLRsBUk9J3BrNQ3zYhC-n5G6nJzjaVTdveHNaSMhe9243NInfS9MM4pRauX0BVQ1YOBIbVqw?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/SemminnnHEuqC2sKAiuHeBYXrQxCZLFLRsBUk9J3BrNQ3zYhC-n5G6nJzjaVTdveHNaSMhe9243NInfS9MM4pRauX0BVQ1YOBIbVqw?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/Hp5mF2mW9U-pKN6tenU85WP6jkYSlnfmixMZFYccSRHxRbfSi_Z_pNHWtI-pCbPJ_HXEtHVRu5LylAK99qhE9ujvccUL1YINlzgOGQ?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "spurs",
    stats: {
      market_cap: 0,
      num_owners: 410,
      floor_price: 0.02,
      floor_price_symbol: "ETH",
      total_minted: 410,
      total_supply: null,
      total_volume: 94.13133864407905,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 869,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.1083214483821393,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 78,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:43:51.024Z",
    key: "lysergiclabsshroomz",
    name: "Lysergic Labs Shroomz",
    description:
      "10,000 unique (and deflationary) 3D-animated trippy mushrooms - with face tats - and custom music!",
    exchange_url: "https://opensea.io/collection/lysergiclabsshroomz",
    external_url: "https://shroomz.cool/",
    banner_image_url:
      "https://i.seadn.io/gae/-E72Rd0B2w7bT-0ZS9fKNGb0iUWNcuKCDmZDXGA-LyxFY2pHY_dITFy4pVt-qgwK3Ez0pwRqTlKlb9Ps1d8icpoG8fP9J9t0W1heeg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/dAeujgAMjdYOeJJh_y4rfqohP4Mbv5L1pJdsNyQCrdxINhsIAWeXnK3D_YkAwYuayEcEVXNglBX51xaHXclOdsLuIx5SWQ-6JV3jvuU?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/dAeujgAMjdYOeJJh_y4rfqohP4Mbv5L1pJdsNyQCrdxINhsIAWeXnK3D_YkAwYuayEcEVXNglBX51xaHXclOdsLuIx5SWQ-6JV3jvuU?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/A139s_lTPWVRRfrtrI1yiHqu6xp5Yevk7gPdf2cLMsGDm9xXge7-n5bp-X37QbekHTEXFb8zVTmmKQYUo1R7YAdZwFxKulgjW9VvvBU?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/CvcqKNBah4",
    telegram_url: null,
    twitter_username: "shroomzNFT",
    wiki_url: null,
    instagram_username: "lysergiclabs",
    stats: {
      market_cap: 17.088000000000008,
      num_owners: 3103,
      floor_price: 0.006785,
      floor_price_symbol: "ETH",
      total_minted: 3103,
      total_supply: null,
      total_volume: 790.1940585430489,
      one_day_volume: 0.01,
      seven_day_volume: 0.03800000000000002,
      thirty_day_volume: 0.06910000000000004,
      one_day_volume_change: 0.01,
      seven_day_volume_change: 16,
      thirty_day_volume_change: -13,
      total_sales: 6753,
      one_day_sales: 5,
      seven_day_sales: 19,
      thirty_day_sales: 39,
      total_average_price: 0.11701378032623262,
      one_day_average_price: 0.002,
      seven_day_average_price: 0.002000000000000001,
      thirty_day_average_price: 0.001771794871794873,
    },
    contracts: [
      {
        contract_address: "0x4ebdd33ca183a8a5f82c43831df5147ea0e16b93",
      },
    ],
    id: 79,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:43:50.546Z",
    key: "metatravelers",
    name: "MetaTravelers: Nibiru",
    description:
      "Genesis Stone: https://opensea.io/collection/metatravelers-genesis-stone  \nNibiru Comics: https://opensea.io/collection/metatravelers-nibiru-comics\n\n#About MetaTravelers\n\nWe are a cross-metaverse ecosystem of avatar embodiment driven by deep lore and emerging technologies.\n\n#Embody the Nibiru\nAs the first known guild to unlock the power of the Genesis Stone, Nibiru travelers portal hop across the metagalaxy while uncovering secrets of ancient civilizations, precious artifacts, and new realms. \n\nLearn more: [Website](https://metatravelers.io/)  \nStay updated: [Twitter](https://twitter.com/metatravelers)  \nExplore with the community: [Discord](https://discord.gg/MetaTravelers)  ",
    exchange_url: "https://opensea.io/collection/metatravelers",
    external_url: "http://metatravelers.io",
    banner_image_url:
      "https://i.seadn.io/gae/je7QAfdEFuc8Cqo-gR9AetvcCX22yGdr2jN39PoogqYGbn7P2E3tLE9zZ2zDUBlnp79kPWic4CLf0qQjOLaZLpdztbLBBQhxurO1aQ?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/zfDmPI303SzdW-yHSzaI6qYa7OzLt00s2bNJunVpgFuCBk3m4KtCIqIVQL2kUN8oX1PdFTBzQZXNEIdJQZT7vlEvnQA1mih6vCwrzA?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/zfDmPI303SzdW-yHSzaI6qYa7OzLt00s2bNJunVpgFuCBk3m4KtCIqIVQL2kUN8oX1PdFTBzQZXNEIdJQZT7vlEvnQA1mih6vCwrzA?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/o188a7rJC6irq7MheuNbDG3qGWsj060KCyR_KLXRxRd8v3mfjJQfAfwdlgKUeEKGYx3sWyWspi_PvetZTCQdPLRCuQc2M0VRpg8ILQ?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/MetaTravelers",
    telegram_url: null,
    twitter_username: "MetaTravelers",
    wiki_url: null,
    instagram_username: "MetaTravelers",
    stats: {
      market_cap: 27.996227875,
      num_owners: 2713,
      floor_price: 0.007477,
      floor_price_symbol: "ETH",
      total_minted: 2713,
      total_supply: null,
      total_volume: 642.4327233147444,
      one_day_volume: 0,
      seven_day_volume: 0.028798999999999998,
      thirty_day_volume: 0.11958699999999998,
      one_day_volume_change: 0,
      seven_day_volume_change: 7,
      thirty_day_volume_change: -11,
      total_sales: 6886,
      one_day_sales: 0,
      seven_day_sales: 8,
      thirty_day_sales: 21,
      total_average_price: 0.09329548697571077,
      one_day_average_price: 0,
      seven_day_average_price: 0.003599875,
      thirty_day_average_price: 0.005694619047619047,
    },
    contracts: [
      {
        contract_address: "0x5372f926b34be60ac1436372107c3ee8c6e056e5",
      },
    ],
    id: 80,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:43:20.359Z",
    key: "influence-crewmates",
    name: "Influence Crewmates",
    description:
      "[Influence](https://influenceth.io) is a space strategy MMO, set in a realistic asteroid belt in the Adalia system, after an ill-fated journey aboard the Arvad, a generational ship fleeing from a dying Earth.\n\n**NOTE**: Influence metadata is dynamic. Please be cautious when purchasing and do NOT trust metadata without also checking the source contracts.\n\n**NOTE**: This collection is the successor to the [Influence Crew](https://opensea.io/collection/influence-crew) collection. After crewmates are bridged back from L2 they will be part of this collection.",
    exchange_url: "https://opensea.io/collection/influence-crewmates",
    external_url: "https://influenceth.io",
    banner_image_url:
      "https://i.seadn.io/s/raw/files/5e4f9377fd635e426326d74215f344a9.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/a71a1a2d58c28a1090a8526ea601d594.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/a71a1a2d58c28a1090a8526ea601d594.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/54a20e224fba59c03b4fc22cf2064ff1.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/influenceth",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 50,
      floor_price: 0.003,
      floor_price_symbol: "ETH",
      total_minted: 50,
      total_supply: null,
      total_volume: 0.6689700000000001,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 21,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.031855714285714286,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xb5cc57cd1f9a9be85a50604b0591a53d89bd4884",
      },
    ],
    id: 81,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:43:09.322Z",
    key: "animal-character-art",
    name: "Animal Character Art",
    description: null,
    exchange_url: "https://opensea.io/collection/animal-character-art",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/s/raw/files/bf28c81f6dcd8d7acf31e4b794959604.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 2,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x88fb43b6215901a834af7d0155a50f721b35a2e2",
      },
    ],
    id: 82,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:42:54.300Z",
    key: "meebits",
    name: "Meebits",
    description:
      "The Meebits are 20,000 unique 3D voxel characters, created by a custom generative algorithm, then registered on the Ethereum blockchain.",
    exchange_url: "https://opensea.io/collection/meebits",
    external_url: "https://meebits.app/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/cbeed39f76506b4baf71005d7127d0df.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/8b42d3e2feaaa217fcad2b3bae281550.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/8b42d3e2feaaa217fcad2b3bae281550.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/2d036c8c2bed042a1588622c3173677f.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.com/invite/meebits",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 13119.833760908314,
      num_owners: 6423,
      floor_price: 0.6589,
      floor_price_symbol: "ETH",
      total_minted: 6423,
      total_supply: null,
      total_volume: 184368.7706380587,
      one_day_volume: 115.93672900000001,
      seven_day_volume: 308.9875344461131,
      thirty_day_volume: 438.9739525321131,
      one_day_volume_change: -57,
      seven_day_volume_change: 408,
      thirty_day_volume_change: 295,
      total_sales: 50667,
      one_day_sales: 171,
      seven_day_sales: 471,
      thirty_day_sales: 738,
      total_average_price: 3.6388333755315827,
      one_day_average_price: 0.6779925672514621,
      seven_day_average_price: 0.6560244892698792,
      thirty_day_average_price: 0.5948156538375516,
    },
    contracts: [
      {
        contract_address: "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7",
      },
    ],
    id: 83,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:42:32.538Z",
    key: "bera-punk",
    name: "Bera Punk",
    description: "Ooga Booga Bera Punks",
    exchange_url: "https://opensea.io/collection/bera-punk",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/858475f2a79df2ce627722dcdef6dd81.png?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/780af37d2d62e7e20eb69f4868d407ca.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 8.989749999999999,
      num_owners: 449,
      floor_price: 0.01067,
      floor_price_symbol: "ETH",
      total_minted: 449,
      total_supply: null,
      total_volume: 5.19387603382322,
      one_day_volume: 0,
      seven_day_volume: 0.007699999999999999,
      thirty_day_volume: 0.05199959991796121,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: -4,
      total_sales: 161,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 6,
      total_average_price: 0.0322600995889641,
      one_day_average_price: 0,
      seven_day_average_price: 0.00385,
      thirty_day_average_price: 0.008666599986326868,
    },
    contracts: [
      {
        contract_address: "0x1b4b506619caa3ef6ed5ee85325ea0e8b8feb041",
      },
    ],
    id: 84,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:42:12.999Z",
    key: "regular-jobs",
    name: "Regular Jobs",
    description:
      "Work hard + earn $REG token. Boost your salary with the Teamwork Bonus, up to 4x. https://regular.world",
    exchange_url: "https://opensea.io/collection/regular-jobs",
    external_url: "http://regular.world",
    banner_image_url:
      "https://i.seadn.io/gcs/files/334ec60a9014123a8587e8090ab6f50a.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/3bd41fda2919eaaf1b9f6338ac0e6bd7.webp?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/3bd41fda2919eaaf1b9f6338ac0e6bd7.webp?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/3bd41fda2919eaaf1b9f6338ac0e6bd7.webp?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/regulars-nft",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 10.7312,
      num_owners: 1199,
      floor_price: 0.002966,
      floor_price_symbol: "ETH",
      total_minted: 1199,
      total_supply: null,
      total_volume: 82.6135096888009,
      one_day_volume: 0,
      seven_day_volume: 0.0016,
      thirty_day_volume: 0.0139,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -52,
      total_sales: 1869,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 5,
      total_average_price: 0.04420198485222092,
      one_day_average_price: 0,
      seven_day_average_price: 0.0016,
      thirty_day_average_price: 0.00278,
    },
    contracts: [
      {
        contract_address: "0x878adc4ef1948180434005d6f2eb91f0af3e0d15",
      },
    ],
    id: 85,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:42:00.785Z",
    key: "heisei-milady-maker",
    name: "heisei milady maker !!!",
    description:
      "ɪɴsᴘɪʀᴇᴅ ʙʏ ᴛʜᴇ ᴄᴜᴛᴇsᴛ miladymaker ᴀɴᴅ ᴛʜᴇ ᴄᴜᴛᴇsᴛ ʜᴇɪsᴇɪ ʏ2ᴋ ᴄᴜʟᴛᴜʀᴇ⋆.✩₊ 💖࿐ ᴀʀᴛ ɪs ʜᴀɴᴅᴍᴀᴅᴇ ᴀɴᴅ sᴇʟᴇᴄᴛᴇᴅ ᴛʜᴇ ᴄᴜᴛᴇsᴛ˚✩💘",
    exchange_url: "https://opensea.io/collection/heisei-milady-maker",
    external_url: "https://www.scatter.art/heisei-milady-maker-1?tab=mint",
    banner_image_url:
      "https://i.seadn.io/gcs/files/0d4a55a21145b0c7b94d53fb804d4616.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/0d4a55a21145b0c7b94d53fb804d4616.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/0d4a55a21145b0c7b94d53fb804d4616.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/fde120e26efb4c8237ec008407895985.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 621,
      floor_price: 0.01737940004000001,
      floor_price_symbol: "ETH",
      total_minted: 621,
      total_supply: null,
      total_volume: 18.929448939990003,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.011356000000000002,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 2,
      total_sales: 574,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 3,
      total_average_price: 0.03297813404179443,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.003785333333333334,
    },
    contracts: [
      {
        contract_address: "0x2d471c659682e92c79261124b5357ae90ff68dea",
      },
    ],
    id: 86,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:41:53.390Z",
    key: "metahero-mintpass",
    name: "MetaHero: MintPass",
    description:
      "Reserve mints with MintPass. Our MintPass 1 grants access to an unredeemed MetaHero, generated upon mint.",
    exchange_url: "https://opensea.io/collection/metahero-mintpass",
    external_url: "https://inhabitantsuniverse.com/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/c2d59f0c1ac8a70a02285e66561aa7dd.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/ae75252f81a883b26de6b682a3f0f948.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/ae75252f81a883b26de6b682a3f0f948.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/073e59ea0c32b37bc8ad81927d57acd9.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/pixelvault",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0.0458,
      num_owners: 6503,
      floor_price: 0.0058,
      floor_price_symbol: "ETH",
      total_minted: 6503,
      total_supply: null,
      total_volume: 31642.299757636567,
      one_day_volume: 0,
      seven_day_volume: 0.0687,
      thirty_day_volume: 1.276849,
      one_day_volume_change: 0,
      seven_day_volume_change: -5,
      thirty_day_volume_change: -48,
      total_sales: 38845,
      one_day_sales: 0,
      seven_day_sales: 3,
      thirty_day_sales: 26,
      total_average_price: 0.8145784465860875,
      one_day_average_price: 0,
      seven_day_average_price: 0.0229,
      thirty_day_average_price: 0.04910957692307692,
    },
    contracts: [
      {
        contract_address: "0x33cfae13a9486c29cd3b11391cc7eca53822e8c7",
      },
    ],
    id: 87,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:41:20.749Z",
    key: "shadesmusic",
    name: "$Shades",
    description:
      '"$Shades (feat. AI Niki, AI Jay-Z & AI Drake)" Brought to you by SHADES This is our first-ever song, Featuring AI Niki, AI Jay-Z, and AI Drake with unexpected samples from Elizabeth Warren and Elon Musk. Exclusive to our loyal $Shades holders',
    exchange_url: "https://opensea.io/collection/shadesmusic",
    external_url: "http://linktr.ee/shadescoin",
    banner_image_url:
      "https://i.seadn.io/gcs/files/9f4ced167df69635dece08bc9788a393.gif?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/417922f78fd19df747f99d2fab5a57ac.gif?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/417922f78fd19df747f99d2fab5a57ac.gif?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/4a6ceceacf3952b14e8077ebc4c8a0f0.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: "https://t.me/Shadescoin",
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 4,
      floor_price: 1,
      floor_price_symbol: "ETH",
      total_minted: 4,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 88,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:41:20.258Z",
    key: "kikosvip",
    name: "Kiko's VIP",
    description:
      "Kiko's VIP are the bomb. With access to the Inner Circle, steep discounts on Derivatives, and enjoyment of experiences crafted only for VIP members!",
    exchange_url: "https://opensea.io/collection/kikosvip",
    external_url: "https://www.kikomints.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/22d2101213b117dfed43c621fcaf5fc2.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/f1890f784a89e019f767a2186e642000.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/f1890f784a89e019f767a2186e642000.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/7991f909cb6ae5ad56520b7228ff481f.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/kikomints",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 532,
      floor_price: 0.00668940004000001,
      floor_price_symbol: "ETH",
      total_minted: 532,
      total_supply: null,
      total_volume: 8.628122009999986,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.045568000000000004,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 9,
      total_sales: 291,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 9,
      total_average_price: 0.029649903814432943,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.005063111111111112,
    },
    contracts: [
      {
        contract_address: "0x4e5da991b56f7b90b5a63da8d1daa45fe841d5fb",
      },
    ],
    id: 89,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:40:33.738Z",
    key: "urban-punk-official",
    name: "Urban Punk Official",
    description:
      "Urban Punk is an NFT collection on the Ethereum blockchain consisting of 10,000 collectible Urban Punks with commercial rights. Yes they are late and gate crashed the party.\r\n\r\nBy CryptoBroNYC.ETH",
    exchange_url: "https://opensea.io/collection/urban-punk-official",
    external_url: "https://urbanpunk.xyz/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/6fa5a5de833fcd48a86c71296dc862a8.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/d8dac54e5308e1284d37e782bf63d023.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/d8dac54e5308e1284d37e782bf63d023.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/ca0487ddd9f2711a8fa645c84a5ed750.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 3.447433,
      num_owners: 381,
      floor_price: 0.0002,
      floor_price_symbol: "ETH",
      total_minted: 381,
      total_supply: null,
      total_volume: 343.1038417316623,
      one_day_volume: 0.001,
      seven_day_volume: 0.003103,
      thirty_day_volume: 0.012092249999999999,
      one_day_volume_change: 1,
      seven_day_volume_change: 1,
      thirty_day_volume_change: -22,
      total_sales: 1437,
      one_day_sales: 1,
      seven_day_sales: 9,
      thirty_day_sales: 39,
      total_average_price: 0.23876398172001553,
      one_day_average_price: 0.001,
      seven_day_average_price: 0.000344777777777778,
      thirty_day_average_price: 0.000310057692307692,
    },
    contracts: [
      {
        contract_address: "0x3bf0d09463f3ab326eb213f653325896a8c2cba4",
      },
    ],
    id: 90,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:40:25.635Z",
    key: "early-retired-cats-club-ercc",
    name: "Early Retired Cats Club",
    description:
      "Cuteness crawling up your hooman soul.\r\nEver seen Meows this cute? Explore the world of 1,930 Cats with ERCC.",
    exchange_url: "https://opensea.io/collection/early-retired-cats-club-ercc",
    external_url: "https://ercc.world",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/c2d2cff1e45cfe134e01306486458a7a.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/c2d2cff1e45cfe134e01306486458a7a.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/6fe7c508d3d7449671b88f18ea8234b8.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/tzXagrVa8H",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 66.48861696969698,
      num_owners: 698,
      floor_price: 0.04539,
      floor_price_symbol: "ETH",
      total_minted: 698,
      total_supply: null,
      total_volume: 3180.6171866910363,
      one_day_volume: 0.7273370000000003,
      seven_day_volume: 2.2737040000000004,
      thirty_day_volume: 11.761231999999971,
      one_day_volume_change: -0.17626299999999984,
      seven_day_volume_change: -15,
      thirty_day_volume_change: 139,
      total_sales: 8977,
      one_day_sales: 23,
      seven_day_sales: 66,
      thirty_day_sales: 253,
      total_average_price: 0.3543073617791062,
      one_day_average_price: 0.03162334782608697,
      seven_day_average_price: 0.03445006060606061,
      thirty_day_average_price: 0.046487083003952455,
    },
    contracts: [
      {
        contract_address: "0xc5990790f28aec6c5bda469cf7052b996c36ba7f",
      },
    ],
    id: 91,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:40:14.399Z",
    key: "constructs-by-tristan-rettich",
    name: "CONSTRUCTS By Tristan Rettich",
    description:
      " Chaotic matter settled into abstract sculptures, designed to soothe & stimulate your senses. 333 Pieces of AI generated fine art.",
    exchange_url: "https://opensea.io/collection/constructs-by-tristan-rettich",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/9fc3ac27806373b1e550de3d76380f85.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/f5afc0ff3fa9d4de9b582511ead79c95.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/f5afc0ff3fa9d4de9b582511ead79c95.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/aed8f9bcc53672ab783c5562c8298c7f.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/EneSfsnZ4a",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 4.4622,
      num_owners: 170,
      floor_price: 0.016595,
      floor_price_symbol: "ETH",
      total_minted: 170,
      total_supply: null,
      total_volume: 85.95894216779683,
      one_day_volume: 0,
      seven_day_volume: 0.0134,
      thirty_day_volume: 0.10428399999999999,
      one_day_volume_change: 0,
      seven_day_volume_change: -2,
      thirty_day_volume_change: -5,
      total_sales: 867,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 6,
      total_average_price: 0.09914526201591331,
      one_day_average_price: 0,
      seven_day_average_price: 0.0134,
      thirty_day_average_price: 0.017380666666666666,
    },
    contracts: [
      {
        contract_address: "0xea65da2804210e33b10cd188920019cc5d716b5e",
      },
    ],
    id: 92,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:40:03.079Z",
    key: "wilderpals-gen",
    name: "Wilder PALs: GEN",
    description:
      "These 3,696 lifeforms are known as GENs, short for Generators and are the Genesis Collection of the Wilder PALs industry. They are multi-functional telekinetic lifeforms whose bodies appear as an amalgamation of solidified material chunks composed in an orb-like arrangement with various overlaps, layers, and intersections. GENs can collect resources, process data, decrypt codes, project holograms, guide players, record, surveil, levitate, be channeled, and more. \r\n\r\nTheir primary function is as a generator which can materialize animate and inanimate novel creations by processing resources and energy particles with their Reactor Cores and outputting them back into the environment as repurposed matter.\r\n\r\n[GENs Trailer](https://www.youtube.com/watch?v=_sJtaezJQVE)\r\n\r\n[GENs ZINE](https://zine.wilderworld.com/a-new-genesis-collection-is-born-introducing-wilder-gens/)\r\n\r\n[Wilder World OpenSea](https://opensea.io/collection/wilderworld)",
    exchange_url: "https://opensea.io/collection/wilderpals-gen",
    external_url: "https://app.wilderworld.com/market/pals.gen",
    banner_image_url:
      "https://i.seadn.io/gcs/files/29f1f7ee9559d07dda6b48042fc600e4.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/29f1f7ee9559d07dda6b48042fc600e4.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/29f1f7ee9559d07dda6b48042fc600e4.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/0e9cc5ef2f7c49e0d49d12e94a6898e0.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: "https://t.me/wilder_world",
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 862.9802399999999,
      num_owners: 998,
      floor_price: 0.22854,
      floor_price_symbol: "ETH",
      total_minted: 998,
      total_supply: null,
      total_volume: 257.96419242444483,
      one_day_volume: 0.62,
      seven_day_volume: 3.5051999999999994,
      thirty_day_volume: 11.592087999999999,
      one_day_volume_change: -3,
      seven_day_volume_change: 1,
      thirty_day_volume_change: -5,
      total_sales: 1380,
      one_day_sales: 2,
      seven_day_sales: 15,
      thirty_day_sales: 45,
      total_average_price: 0.18693057422061218,
      one_day_average_price: 0.31,
      seven_day_average_price: 0.23367999999999997,
      thirty_day_average_price: 0.25760195555555554,
    },
    contracts: [
      {
        contract_address: "0x90a1f4b78fa4198bb620b7686f510fd476ec7a0b",
      },
    ],
    id: 93,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:39:48.508Z",
    key: "superfuzz-the-good-guys",
    name: "Superfuzz The Good Guys",
    description:
      '"The Good Guys" is the second monster-centric release by Superfuzz. This batch of 7,600 unique, programmatically generated NFT’s focuses on cheeky, eccentric monsters infused with poppy, bright colour ways and a touch of nostalgic flair.',
    exchange_url: "https://opensea.io/collection/superfuzz-the-good-guys",
    external_url: "https://superfuzz.io/",
    banner_image_url:
      "https://i.seadn.io/gae/gfZgH1FEb0hJHS9eeHlMfbJC2__HszrfPXnUPh8o_9eJbIWuqXilA9BUHBvzpYr-_m-VnzHtW-XeCjNqLUnXPDzFQ6KZ1Jao1w6wlw?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/eGu29DQk0iHYSQPWHPh1iXfw1s7NuOTnniaoh-5Zza-DiUBGxdGSEuhVZG_IXbHQocmF_-ksfqO0g_yTll1jZ7owCjr9AToxlaKTmw?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/eGu29DQk0iHYSQPWHPh1iXfw1s7NuOTnniaoh-5Zza-DiUBGxdGSEuhVZG_IXbHQocmF_-ksfqO0g_yTll1jZ7owCjr9AToxlaKTmw?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/Kp8Xx2BGU-JzJWbYx_QlDqpAg-3qXlDqP1Iuy58jodKlRH-F8Q_spX5dBox_wBTiJkfniYFMAhD1J3ek4xmzPFBiveg3lBunQLrQ?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/7Ayw95cYuY",
    telegram_url: null,
    twitter_username: "superfuzznft",
    wiki_url: null,
    instagram_username: "superfuzz.io/",
    stats: {
      market_cap: 0,
      num_owners: 3223,
      floor_price: 0.001,
      floor_price_symbol: "ETH",
      total_minted: 3223,
      total_supply: null,
      total_volume: 757.5609472494332,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0098,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 6873,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.11022274803570976,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0098,
    },
    contracts: [
      {
        contract_address: "0x5c400511fb292a50b4d81e601815f617db804302",
      },
    ],
    id: 94,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:39:36.698Z",
    key: "ghouls-dbs",
    name: "Ghouls By Dead Birds Society",
    description:
      "A fun Moonbirds PFP derivative created by Dead Birds Society members. Each Ghoul unlocks full access to our community plus bonus benefits.",
    exchange_url: "https://opensea.io/collection/ghouls-dbs",
    external_url: "http://ghouls.deadbirds.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/23d367f8d9a60d03ff23a78e98a7fb9e.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/180c4c45b5084469c78079e52a24f5c2.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/180c4c45b5084469c78079e52a24f5c2.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/b3765e73aa582b96319ca7aa22d490ea.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/dead-birds-society",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 413,
      floor_price: 0.002699,
      floor_price_symbol: "ETH",
      total_minted: 413,
      total_supply: null,
      total_volume: 136.35798404877994,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 758,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.179891799536649,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x97f66251c3dcad07c373cd46d6287959fe6698cf",
      },
    ],
    id: 95,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:39:21.580Z",
    key: "kaiju-queenz-genesis",
    name: "Kaiju Queenz Genesis",
    description:
      "Kaiju Queenz is a community-driven collection of 3,333 randomly generated NFTs on the Ethereum blockchain. The Kaiju Queenz have returned to the metaverse to reunite with their families and guide the future of the Kaijus. This is where we learn, build, and spread good vibes.",
    exchange_url: "https://opensea.io/collection/kaiju-queenz-genesis",
    external_url: "https://www.kaijuqueenz.co/",
    banner_image_url:
      "https://i.seadn.io/gae/zKmmSx8z0KkRI7nXQbqWPLnoR9js29nDGje_CfPPsIGKpgizxhK72DeAYzNnsn0Rz6MdaIdn0bxnRHv-DdOdqAFikB0n6nJQp1UM81w?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/LXwU3FNIELLcuNkRi5I-qEwgXxmsX49Tvmw3AdXX9KLNjv1_GXrkobZJPnt9m1JwucCrTnaeCgzSmODkFXJwZL_aeKZ-VRI8p3B-?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/LXwU3FNIELLcuNkRi5I-qEwgXxmsX49Tvmw3AdXX9KLNjv1_GXrkobZJPnt9m1JwucCrTnaeCgzSmODkFXJwZL_aeKZ-VRI8p3B-?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/D-Wt8m2uI-jL58c7KsmNUAHMf4_-uQ7at74UhTUgZL9SfUr8pImA_4mGnyznhxF3hIwlDsLnkKX1vlkxpcOu6OBjJJHuzZ-a1iVfww?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 2115,
      floor_price: 0.01,
      floor_price_symbol: "ETH",
      total_minted: 2115,
      total_supply: null,
      total_volume: 191.59765678581718,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 2438,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.07858804626161492,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x413d4f3e116bc364e4799f2e7137029c41563cd5",
      },
    ],
    id: 96,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:39:06.124Z",
    key: "fantasy-creatures-27",
    name: "Fantasy Creatures",
    description:
      "This NFT features a collection of mythical creatures such as dragons, unicorns, phoenixes, and mermaids, set in a stunning fantasy world. They are surrounded by magical elements like glowing forests, shimmering waterfalls, and floating orbs. The artistic style is highly detailed, with vibrant colors and harmonious lighting effects, creating a captivating and imaginative atmosphere.\n\n",
    exchange_url: "https://opensea.io/collection/fantasy-creatures-27",
    external_url: null,
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/caa6c73aa04f43d7d83683f7bc301492.webp?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/caa6c73aa04f43d7d83683f7bc301492.webp?w=500&auto=format",
    image_url: null,
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 0.3,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xb173a399ad2102c0513824f31f46153c0fc9908d",
      },
    ],
    id: 97,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:38:17.677Z",
    key: "cryptoskunkz",
    name: "CryptoSkunkz Official NFT Collection",
    description: null,
    exchange_url: "https://opensea.io/collection/cryptoskunkz",
    external_url: "https://cryptoskunkz.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/9beddc5e0e766c8e0ba546707253615f.jpg?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/20accfb29765e624c6508143563e9aae.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: "https://t.me/cryptoskunksofficial",
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 197,
      floor_price: 0.2,
      floor_price_symbol: "ETH",
      total_minted: 197,
      total_supply: null,
      total_volume: 9.443699999999998,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 92,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.10264891304347824,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x666bec108bbad9082fefa39b0b79eb90e12fc580",
      },
    ],
    id: 98,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:38:10.105Z",
    key: "facanft",
    name: "FACA (Fine-Ass CryptoApes)",
    description:
      "FACA or Fine-Ass CryptoApes is a limited collection of 1,800 randomly generated pixel-Ape characters. Each FACA is unique with several attributes that altogether define its scarcity level. This is the only batch ever-produced at our Factory.",
    exchange_url: "https://opensea.io/collection/facanft",
    external_url: "http://facafactory.com",
    banner_image_url:
      "https://i.seadn.io/gae/IJA3GKVnskqeDOtKi9CcTAuAootG0WqqgzawzMnetAdLLjU41VepLgUmOAe3HGFon6Z5FDs3N9dFq2V4qaO_Cn01vJEprx0UYEpWZzU?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/W4eC0jGUlmI1108WDcC6n8gXd48L2oz_vUSaVJfoYtcx4BcF8AnZCz2YItWUdOq74_nfmlKIn8C5KuepzNgIpcM4m2JAmAdv0VsepQ?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/faca",
    telegram_url: null,
    twitter_username: "facafactory",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 645,
      floor_price: 0.1,
      floor_price_symbol: "ETH",
      total_minted: 645,
      total_supply: null,
      total_volume: 82.42892724504168,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 635,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.12980933424416013,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xfa17634d561a0cd2090a5b1cbb95c972f77d2534",
      },
    ],
    id: 99,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:38:09.659Z",
    key: "ashcarbon",
    name: "Ash Chapter One: Carbon",
    description: "ASH CHAPTER ONE: CARBON",
    exchange_url: "https://opensea.io/collection/ashcarbon",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gae/4DTaZQx5_bh4XNAnAQmr0iYiXXqVbpOkg2TO6ft3yjMOpX7FWTh4JgxmAaeOHBSusB5-ee9vGGfNZtIFsKc9B9imFIYgO0WT8R_UhQ?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/hZFrSk9GngXGC9VAPJWydKbbV4d0gqVhPCH5Cy22RgPfzOXa456hYvi9kL5kif_mVpxjwxbXGo7F1FgWMx6CWVv38pw5VkhxZK3wWg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/hZFrSk9GngXGC9VAPJWydKbbV4d0gqVhPCH5Cy22RgPfzOXa456hYvi9kL5kif_mVpxjwxbXGo7F1FgWMx6CWVv38pw5VkhxZK3wWg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/hZFrSk9GngXGC9VAPJWydKbbV4d0gqVhPCH5Cy22RgPfzOXa456hYvi9kL5kif_mVpxjwxbXGo7F1FgWMx6CWVv38pw5VkhxZK3wWg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 140.07,
      num_owners: 519,
      floor_price: 0.32,
      floor_price_symbol: "ETH",
      total_minted: 519,
      total_supply: null,
      total_volume: 730.6847802000004,
      one_day_volume: 0,
      seven_day_volume: 0.42,
      thirty_day_volume: 1.095,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 425,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 4,
      total_average_price: 1.7192583063529423,
      one_day_average_price: 0,
      seven_day_average_price: 0.21,
      thirty_day_average_price: 0.27375,
    },
    contracts: [
      {
        contract_address: "0xb89fe5a72b3a71e585f468c3ff2d1f67df13b256",
      },
    ],
    id: 100,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:37:36.099Z",
    key: "exclusible-penthouse-v2",
    name: "Exclusible Penthouse V2",
    description:
      "Each of the Exclusible Penthouse consists of a magical 500sqm space that allows NFT enthusiasts to host online meetups and events for up to 50 guests. Collectors of these prime pieces of luxury real estate can showcase their NFT artwork portfolios on the walls and personally curate and customize their environment. With this range of 5,000 luxury penthouses, available in three color variations (quartz, ruby and obsidian), showcasing various panoramic views, including Paris, Miami, Las Vegas, Dubai and New Caledonia, we present Exclusible’s latest metaverse real estate project.\n\nVisit Exclusible Social Hub : \nhttps://spatial.io/s/Exclusible-PENTHOUSE-Community-Hub-62af0244cf4de80001162a0b?share=2877538224121845204",
    exchange_url: "https://opensea.io/collection/exclusible-penthouse-v2",
    external_url: "http://www.exclusible.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/d1ce2b116557ffd5ce522e4ad14f3717.gif?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/24be964299e70942093aa2d04fb5cec6.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "exclusible",
    stats: {
      market_cap: 0,
      num_owners: 1742,
      floor_price: 0.006,
      floor_price_symbol: "ETH",
      total_minted: 1742,
      total_supply: null,
      total_volume: 629.4671948878487,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.021239,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -9,
      total_sales: 2796,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 3,
      total_average_price: 0.2251313286437227,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.007079666666666667,
    },
    contracts: [
      {
        contract_address: "0xded7720e7e1682cf67345273837ca0c80ba669ef",
      },
    ],
    id: 101,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:37:32.224Z",
    key: "dreamlab-reflections",
    name: "REFLECTIONS by Jacob Riglin",
    description:
      "Reflections is the first of its kind generative photography project that harnesses the serendipity of on-chain mechanics to compose 1,111 unique one of a kind NFTs.\n\nEach piece is a unique combination of 5 core layers; left, right, top, bottom, and a sky; and additional special layers, sourced from over 30 scenes which draw from a lifetime of travels, across more than 70 countries.",
    exchange_url: "https://opensea.io/collection/dreamlab-reflections",
    external_url: "http://reflections.dreamlab.art",
    banner_image_url:
      "https://i.seadn.io/gae/nkmbpfM10pLdzE5L-Qx_phXxK01BhXZhHETeR0S6OXGmPNjPfLkiEpuMei7RDYDBmlaMoWEg5TK6osFxThKwAywppgAZ4zeHZVAzmV4?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/o8VadX_ZN9ftSXrzfN6L8ihDedxGswaUHkvWMWEdinOS53XIFr7UKoWQ3zJUSpGS4ysMT7cgmOrl-3TKPYn4AfhI3-hr6TwhH0lj?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "jacob",
    stats: {
      market_cap: 0,
      num_owners: 744,
      floor_price: 0.022682,
      floor_price_symbol: "ETH",
      total_minted: 744,
      total_supply: null,
      total_volume: 290.885287444368,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 1127,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.2581058451147897,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x91a5d4f6e691432a58d5579ae45955210ec6a2f1",
      },
    ],
    id: 102,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:37:13.463Z",
    key: "fightcard",
    name: "FightCardNFT",
    description:
      "2 artist fight, 1 artist wins - collectors determine the results",
    exchange_url: "https://opensea.io/collection/fightcard",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/f4c3f4b0f6fe552d4af4199f48bdc01e.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/2731bd3076a4819312ec771e3c6ef4e0.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/2731bd3076a4819312ec771e3c6ef4e0.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/2731bd3076a4819312ec771e3c6ef4e0.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0.009,
      num_owners: 379,
      floor_price: 0.0268989,
      floor_price_symbol: "ETH",
      total_minted: 379,
      total_supply: null,
      total_volume: 12.581779000000004,
      one_day_volume: 0,
      seven_day_volume: 0.0015,
      thirty_day_volume: 0.0015,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 1,
      total_sales: 237,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 1,
      total_average_price: 0.05308767510548525,
      one_day_average_price: 0,
      seven_day_average_price: 0.0015,
      thirty_day_average_price: 0.0015,
    },
    contracts: [
      {
        contract_address: "0x9b65bc656f0d2d95b08860494af49c97ad2d6ee3",
      },
    ],
    id: 103,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:35:59.442Z",
    key: "superlativesecretsociety",
    name: "The Superlative Secret Society",
    description:
      "Superlative Secret Society are collectible #NFTs inspired by primary personality traits. SuperlativeSS has been built by a passionate team and a powerful grassroots community. The project offers incredible utility and is dedicated to supporting the next generation of artists.\n\nSSS Opensea Collection\nhttps://opensea.io/collection/superlativesecretsociety\n\nRepus Opensea Collection \nhttps://opensea.io/collection/the-repus\n\nArtifacts Opensea Collection\nhttps://opensea.io/collection/superlative-artifacts",
    exchange_url: "https://opensea.io/collection/superlativesecretsociety",
    external_url: "https://superlativesecretsociety.io",
    banner_image_url:
      "https://i.seadn.io/gae/BrmTHvkTkDE-F0sK_vJxak-zdcjHznd1wtywMXQ2GkeDR1ibMNJuvdInzffq5bOErH6UbIrSLEt_2Dts2T2T-pZECPPcRWxHAYQ8vQ?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/Zhik-cNQqS-j4ubU9Hp_JtdwnipwIxm7AYwiuo1OmvO55Q0GYICGHE1LMwdQNx4pgkzLKvP7m-NG0TkaOjn4LavxjejFNwCi0rA4?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/Zhik-cNQqS-j4ubU9Hp_JtdwnipwIxm7AYwiuo1OmvO55Q0GYICGHE1LMwdQNx4pgkzLKvP7m-NG0TkaOjn4LavxjejFNwCi0rA4?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/KXiwhGlX-mGtcqDt1OYoWoZWa7kPvaKNx3g_ZJGa34SGz2H1FmH7NWqJTGWVftAECvz2H89QiNpmlQ6gzqN_vMjgkp6FzU6pRNfg8g?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/b5X8VvaCuf",
    telegram_url: null,
    twitter_username: "SuperlativeSS",
    wiki_url: null,
    instagram_username: "superlativesecretsociety",
    stats: {
      market_cap: 27.532959999999996,
      num_owners: 5897,
      floor_price: 0.00368,
      floor_price_symbol: "ETH",
      total_minted: 5897,
      total_supply: null,
      total_volume: 5175.937742481504,
      one_day_volume: 0.007,
      seven_day_volume: 0.024799999999999996,
      thirty_day_volume: 0.29156899999999997,
      one_day_volume_change: -0.0005,
      seven_day_volume_change: -2,
      thirty_day_volume_change: -30,
      total_sales: 22977,
      one_day_sales: 3,
      seven_day_sales: 10,
      thirty_day_sales: 71,
      total_average_price: 0.22526603744968898,
      one_day_average_price: 0.002333333333333334,
      seven_day_average_price: 0.00248,
      thirty_day_average_price: 0.004106605633802816,
    },
    contracts: [
      {
        contract_address: "0xa7ee407497b2aeb43580cabe2b04026b5419d1dc",
      },
    ],
    id: 104,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:35:55.821Z",
    key: "ashley-longshore-chapter-one",
    name: "Ashley Longshore Chapter 1: ROAR",
    description:
      "THE ASHLEY LONGSHORE GENESIS COLLECTION: 862 unique NFTs based on portraits from her auspicious Rizzoli coffee table book, ROAR! A Collection of Mighty Women. ",
    exchange_url: "https://opensea.io/collection/ashley-longshore-chapter-one",
    external_url:
      "https://ashleylongshore.com/pages/ashley-longshore-nft-drop-chapter-1-roar",
    banner_image_url:
      "https://i.seadn.io/gae/9_1twU-0w15rGEfWIyv-SyABnSybp_8SyMrkeEa3lAvXH4No0F-Fnt_7Pl2gM78rQAfrIvTIxUN7r0cWUdXElJq8pTjriRWRlJaLgw?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/2H3aG8XyPmIWL8AvKm8A-AM7xg-EGXxolniPykQb8BpB_iBNHRLLnQ7N9KcJ51DlWAY0rNgnj8oQiVRRV0b-ugqw_GXXBOCumsr5Xw?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/2H3aG8XyPmIWL8AvKm8A-AM7xg-EGXxolniPykQb8BpB_iBNHRLLnQ7N9KcJ51DlWAY0rNgnj8oQiVRRV0b-ugqw_GXXBOCumsr5Xw?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/Zz9HC3Ef1AzjgSEzsiM9n6X7iAEhdQOHXYolGdX63k1ccbLIxWrlR_MNJWTwYo0csfiSNe9izPqrnRP8NBbR0NPyaHuN5qXw6ZLieQ?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/gehbJXT9fh",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "ashleylongshoreart",
    stats: {
      market_cap: 4.31,
      num_owners: 347,
      floor_price: 0.0162,
      floor_price_symbol: "ETH",
      total_minted: 347,
      total_supply: null,
      total_volume: 630.0822115762252,
      one_day_volume: 0.005,
      seven_day_volume: 0.005,
      thirty_day_volume: 0.0317,
      one_day_volume_change: 0.005,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 1,
      total_sales: 1671,
      one_day_sales: 1,
      seven_day_sales: 1,
      thirty_day_sales: 3,
      total_average_price: 0.3770689476817625,
      one_day_average_price: 0,
      seven_day_average_price: 0.005,
      thirty_day_average_price: 0.010566666666666665,
    },
    contracts: [
      {
        contract_address: "0x32a705510790abfeee275f505c1e2d273595e62c",
      },
    ],
    id: 105,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:35:40.286Z",
    key: "bad-luck-club-memberships",
    name: "Bad Luck Club Memberships",
    description:
      "Home of Bad Luck Club membership tokens. The higher the tier, the better chances of securing mints, giveaways, and more!",
    exchange_url: "https://opensea.io/collection/bad-luck-club-memberships",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/94be8c04bf3b8bf0dd7515767db269b4.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/5a26c512a39d03da6afff40d1bd5c118.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/5a26c512a39d03da6afff40d1bd5c118.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/CUEddQ6NRcNyX4b30rRrwTOYAuuf5Y7pbOm7fysCBOxQoZKzgpgiSNlrbx5Jy9kJJmkup1tshhZgPquz-KoORLz9AVUeix9A5o_Hhg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/badluckclub",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1897,
      floor_price: 0.009,
      floor_price_symbol: "ETH",
      total_minted: 1897,
      total_supply: null,
      total_volume: 11.434330799578015,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 662,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.017272403020510595,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x231fef9943e942df34d7cf623a7a0314eff959ec",
      },
    ],
    id: 106,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:35:39.871Z",
    key: "jay-pegs-auto-mart",
    name: "Jay Pegs Auto Mart",
    description: "The World's #1 2007 Kia Sedona Superstore",
    exchange_url: "https://opensea.io/collection/jay-pegs-auto-mart",
    external_url: "https://jaypegsautomart.com/lot",
    banner_image_url:
      "https://i.seadn.io/gae/rVBTrkwVuHjO648WItwqjGqX_nz3EA03DFNMvnP8cEwtIIfh6HFTRWtpwwitJxe7Rm-NP0aDkAdEy5bna50XL7R-1NSf6dqIMm436Bk?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/tsM-4CCcupVVrq3kTayVp4loFatfinoAvKM_aZKCH3vtdmVv-wxAqWksy4DvXYaCs_6ctYtc84Veievsac00VGFCdRC5_vIenP--8Q?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/tsM-4CCcupVVrq3kTayVp4loFatfinoAvKM_aZKCH3vtdmVv-wxAqWksy4DvXYaCs_6ctYtc84Veievsac00VGFCdRC5_vIenP--8Q?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/8Dl9d5x3xvZG3mDtpiyYFwfjl_4axKYXJ8iQuHGF6a4CTYQW5lQlpI04Xwyz9Xg6K0t3H4qWx2eh43NkxWz1mZTySnUX2lTfZBJ4rg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/DjnpPJm6yM",
    telegram_url: "https://t.me/joinchat/kjAtYO3LNA42YmY5",
    twitter_username: "jaypegsautomart",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1468,
      floor_price: 0.005,
      floor_price_symbol: "ETH",
      total_minted: 1468,
      total_supply: null,
      total_volume: 115.5456400012344,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.041999,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 8,
      total_sales: 1294,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 14,
      total_average_price: 0.08929338485412242,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.002999928571428572,
    },
    contracts: [
      {
        contract_address: "0xf210d5d9dcf958803c286a6f8e278e4ac78e136e",
      },
    ],
    id: 107,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:35:39.491Z",
    key: "synesthesia-collective",
    name: "Synesthesia Collective",
    description:
      "The Synesthesia Collective is an exploration into the connection between different human senses and their cognitive pathways. Blending the experiences of sight and sound, Synesthesia are randomly generated using random musical recordings and stored on the Ethereum blockchain as ERC-721 tokens. \n\n**The Synesthesia Collective is limited to 1,111 unique pieces.**\n\n**1111x1111px**",
    exchange_url: "https://opensea.io/collection/synesthesia-collective",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gae/jz8m20Z3mjW-GyEibFK5kFASjOLTi_2_zxa-HJ20wMscVfGWXin9s5FaSvhBL_JZzcuWz92kq3IfL0nAq2Dj7yxF2vNdD1H1MBqw?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/gaEIt7YP0NKETbOGNAULMq5tJ5QhA1x3RAdVheIbj_JgFeSglPEqc-mUYBstiyoZU4LxvB4Qp2b4-HIrGDkIiJAf2VGRnwm4vVfbihU?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/gaEIt7YP0NKETbOGNAULMq5tJ5QhA1x3RAdVheIbj_JgFeSglPEqc-mUYBstiyoZU4LxvB4Qp2b4-HIrGDkIiJAf2VGRnwm4vVfbihU?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/gaEIt7YP0NKETbOGNAULMq5tJ5QhA1x3RAdVheIbj_JgFeSglPEqc-mUYBstiyoZU4LxvB4Qp2b4-HIrGDkIiJAf2VGRnwm4vVfbihU?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: "SynesthesiaNFT",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 577,
      floor_price: 0.1,
      floor_price_symbol: "ETH",
      total_minted: 577,
      total_supply: null,
      total_volume: 128.2925770992366,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 829,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.15475582279763161,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x043474a14f17cf4f48bd07b385c077c45fd6707e",
      },
    ],
    id: 108,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:35:39.045Z",
    key: "urscompanions",
    name: "URS Companions",
    description:
      "URS Companion Claim Check: https://ursproject.io/claim-check . The URS Project is a revolutionary 3d animated collection of 10K avatars that live on the Ethereum blockchain, created by a team of elite and world-class Korean artists. In 2130, while humanity was forced underground, URS (Underground Robogenetic Survivalists) were created to access the warp gates which connected to the earth’s scorched surface and gather essential supplies. Each URS is a high quality 3d animated video while also serving as an entry into a community and roadmap that includes free mints for holders, merchandise, metaverse items and games, and more. The Project URS Genesis Project: https://opensea.io/collection/theprojecturs",
    exchange_url: "https://opensea.io/collection/urscompanions",
    external_url: "https://ursproject.io",
    banner_image_url:
      "https://i.seadn.io/gae/rIL2udaosNTwe6JhzwcPnlk9ZC7vJG_UhfyH2jIUq1QKjHsKE-Xf50tZ1a2J8PstGP6NGiwQHVw0NLDGeLjLDGbzunZYdKgf85mbcg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/T9vc8q_tPF4dudv3vayYdS3XX-w3S0P2fFzvKq1SKSlPjOO-oKAD4BeQ8mb4xjBlVnN9XC_aaL22g7zpBfS76if4FoQsYpnkWemo23I?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/T9vc8q_tPF4dudv3vayYdS3XX-w3S0P2fFzvKq1SKSlPjOO-oKAD4BeQ8mb4xjBlVnN9XC_aaL22g7zpBfS76if4FoQsYpnkWemo23I?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/YRJaqcvhn117Uys_mqOK8CtT7i87hE5roAzXzxl-NsF1PVT4xIztAoffD7fKeay4JRLRbw4D00fxTdSRNQGChXNeAnM9KEfxn6BM?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/vutKFPaUXU",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "urs_project",
    stats: {
      market_cap: 0,
      num_owners: 1291,
      floor_price: 0.0088,
      floor_price_symbol: "ETH",
      total_minted: 1291,
      total_supply: null,
      total_volume: 3.6393740662124614,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 202,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.018016703298081492,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x7ad940ed9308545990497dd04e76df7d3c127ed4",
      },
    ],
    id: 109,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T22:35:35.160Z",
    key: "rarityjumppampers",
    name: "Rarity Jump: Pampers",
    description:
      "Pampers is the PFP of the Rarity Jump collection.\nAll rights granted to RJ Genesis will apply to PAMPERS.\n-3 PFP burners and certain traits will play a game, the winner will be entitled to participate in the Main challenge.\n-Main Challenge winners, PFP burners and ALL RARITY JUMP GENESIS HOLDERS will have the right to CLAIM for the ERC404 contract according to the values of the NFTs they hold and the rankings they have won. \n-ERC404 will be released after the main challenge.",
    exchange_url: "https://opensea.io/collection/rarityjumppampers",
    external_url: "https://rarityjump.xyz/",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/03c7337958289c7bece601b37cbf43ca.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/03c7337958289c7bece601b37cbf43ca.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/b0351ce5243465259ef5b0171bdcfda6.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 106,
      floor_price: 0.005,
      floor_price_symbol: "ETH",
      total_minted: 106,
      total_supply: null,
      total_volume: 0.06960000000000001,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 2,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.034800000000000005,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x3260214fb24d0f65515b509ec4001f1efc892d06",
      },
    ],
    id: 110,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:08:41.305Z",
    key: "grumbies-eternal-entry",
    name: "Grumbies Eternal Entry",
    description:
      "The Grumbies Eternal Entry is an access pass to the Grumbies ecosystem that gives you discounts and preferred access to games and experiences to win Ethereum. Our first game [Genesis Battle](https://battle.grumbies.io) has begun! View the Collection [here](https://opensea.io/collection/grumbies-genesis-battle), and stay tuned for future games!",
    exchange_url: "https://opensea.io/collection/grumbies-eternal-entry",
    external_url: "https://www.grumbies.io/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/94d2e12b0c74952c0fdc36a6da0ec939.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/3b7da03e6ab51103021adf26ba03eb0b.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/3b7da03e6ab51103021adf26ba03eb0b.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/3b7da03e6ab51103021adf26ba03eb0b.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 773,
      floor_price: 0.0015,
      floor_price_symbol: "ETH",
      total_minted: 773,
      total_supply: null,
      total_volume: 22.967537058999973,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 677,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.03392546094386997,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x4b0d8beb9b6c7f284c9daec8427d4c7815dd1bc5",
      },
    ],
    id: 111,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:08:32.699Z",
    key: "ftc-official",
    name: "FTC Official",
    description:
      "The first NFT meme project in history that paid 0.01 ETH to the minters instead of charging anything!  Never underestimate the power of memes fcker. Fck u all! Roadmap? Fck that too 🖕",
    exchange_url: "https://opensea.io/collection/ftc-official",
    external_url: "https://www.nftftc.com/",
    banner_image_url:
      "https://i.seadn.io/gae/dxkiVfP9_jruxGSxepfayTRcJRi-i8sMq15M9hkHOIluDwDS5CKK9MdHWNnFKGSM6YhoEcYdT38ZTxEdgOaKqHw4BU660oZMqvyf9bo?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/RhzQV-Yob2oSx7b6o38A7oZiy9HvcIMmQG9dHLnd8QZVjiNZfyyjn_raadxmjlEd3gFoh8CVl97keY7zN7e1-Qu_Sy8xJwkcYC_QdWY?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/RhzQV-Yob2oSx7b6o38A7oZiy9HvcIMmQG9dHLnd8QZVjiNZfyyjn_raadxmjlEd3gFoh8CVl97keY7zN7e1-Qu_Sy8xJwkcYC_QdWY?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/SII-3FIDlQ3UvWiBph-LsWAcmh27QI4YabNHSSylQ_VRRonSZxPi_BPdiZdYcMRx2qlu1HruVJqaBN1qBOoelOQjPsCyGh9_DtRJbw?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/eED9KazKXJ",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 29.42295,
      num_owners: 2186,
      floor_price: 0.013396,
      floor_price_symbol: "ETH",
      total_minted: 2186,
      total_supply: null,
      total_volume: 2434.730748225931,
      one_day_volume: 0,
      seven_day_volume: 0.0477,
      thirty_day_volume: 0.12458999999999999,
      one_day_volume_change: 0,
      seven_day_volume_change: 6,
      thirty_day_volume_change: -10,
      total_sales: 11831,
      one_day_sales: 0,
      seven_day_sales: 6,
      thirty_day_sales: 13,
      total_average_price: 0.20579247301377154,
      one_day_average_price: 0,
      seven_day_average_price: 0.00795,
      thirty_day_average_price: 0.009583846153846153,
    },
    contracts: [
      {
        contract_address: "0x2e541cec5cb41e7678ac3c8e91acb3fc1db0da07",
      },
    ],
    id: 112,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:11:26.309Z",
    key: "pastel-cronies",
    name: "Pastel Cronies",
    description:
      "\nPastel Cronies is a community driver project with the main aim of raising funds for the SPCA, an organization who prevent cruelty, promote kindness and alleviate the suffering of animals. https://nspca.co.za/fundraise/\nThe Pastel Cronies NFT collection is published on the ERC-721A NFT token standard and live in the Ethereum network. The ERC-721A smart contract is used due to its extremely low gas fees, you will pay lower gas fees compared to traditional smart contract collections.\nPastel Crony owners also stand a chance to win monthly prizes paid out in ETH.\n\nhttps://pastelcronies.com/index.html\n\nPublic Mint: https://pastelcronies.com/public_mint.html\n\netherscan.io: https://etherscan.io/address/0x9bcFF7AC9e7ce3d274d7e77b4039E92a814133F7\n\n",
    exchange_url: "https://opensea.io/collection/pastel-cronies",
    external_url: "https://pastelcronies.com/index.html",
    banner_image_url:
      "https://i.seadn.io/gae/lotaMncCcuVcipnlgJXNnmKh5NOEKTOQBtlGdQWoTOlUJGatRm5o3IEsQ1Yz1Obl9kcqCQhbBhnOseHugzXQjrnNCLP125jnihFS?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/T4tNyWKIHd7NQ0o2sRN6b59CWPi_0qroKrRqptJJrNSfmJNcUfY12S94BswUljP-KL2ZvhA6uC8ONQAeOfQUXLbBnbFfNhVQB0CvKso?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/T4tNyWKIHd7NQ0o2sRN6b59CWPi_0qroKrRqptJJrNSfmJNcUfY12S94BswUljP-KL2ZvhA6uC8ONQAeOfQUXLbBnbFfNhVQB0CvKso?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/T4tNyWKIHd7NQ0o2sRN6b59CWPi_0qroKrRqptJJrNSfmJNcUfY12S94BswUljP-KL2ZvhA6uC8ONQAeOfQUXLbBnbFfNhVQB0CvKso?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/2vTagZxWEb",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "pastelcronies/",
    stats: {
      market_cap: 0,
      num_owners: 1524,
      floor_price: 0.04,
      floor_price_symbol: "ETH",
      total_minted: 1524,
      total_supply: null,
      total_volume: 0.06380500000000001,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 20,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.003190250000000001,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x9bcff7ac9e7ce3d274d7e77b4039e92a814133f7",
      },
    ],
    id: 113,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:11:01.552Z",
    key: "lacedameon",
    name: "Lacedameon",
    description:
      "<p> \n\n[Rarity](https://rarity.tools/Lacedameon) || [Twitter](https://twitter.com/officialmandox) || [Website](https://www.officialmandox.com) || [Merch](https://mandoxmilitia.company.site/)\n\n</p>\n\nMandox LLC presents our 1k of 10,000 NFT Drop, “The Lacedameon”\n \nThe Mandox will take you on a journey where you will\nencounter ten different tribes; each through a separate NFT drop.\n\nMandox LLC will bridge the gap between the world of cryptocurrency and the new up and coming wave of NFTs. With each purchase of the NFT collection, you will be making an investment into the company with at least 50% of profits going straight back into $Mandox to help\nfund marketing, developement and the Future of Mandox.\n\nIn addition to this and Amazing passionate art, community and team. Holding these NFTs from all collections will have future benefit and use in the MandoxPLAY P2E Block Chain game as well as MandoxCREATE, our Full purpose and use NFT market Place for Buying, Selling and Creating.",
    exchange_url: "https://opensea.io/collection/lacedameon",
    external_url: "https://www.mandoxglobal.com",
    banner_image_url:
      "https://i.seadn.io/gae/ZqFg9oJXjVhgriZiUPtjfpoOxTxxcQOzSTIhCZuNV67nyT6k3CaxIitbARA5SEdHx5_kboRpx6ST7cum2mdrxJgvDfCeGtM36prHPlU?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/mdeqKfe0L6Qk9q4fsFxvZtvgFGxNLaCxlUcEZifMjnh2ArOMWerh_tb56efgoVuKbVQe5zLbhcTNa_sEBiVGIlKZmfRechwq0uxISg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/mdeqKfe0L6Qk9q4fsFxvZtvgFGxNLaCxlUcEZifMjnh2ArOMWerh_tb56efgoVuKbVQe5zLbhcTNa_sEBiVGIlKZmfRechwq0uxISg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/e6eEKdgIWR1CKiaJH2i0ojxbPLF41Xf-gnM788kRVLjkP_fhmOrVaUAcA0bRzHTLPNdASelO0OWtRquakiZAth4b8HD2SdQo3WLShA?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/Mandox",
    telegram_url: "https://t.me/officialmandox",
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 325,
      floor_price: 0.00898940004000001,
      floor_price_symbol: "ETH",
      total_minted: 325,
      total_supply: null,
      total_volume: 37.188998400039964,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.00898940004000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 387,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.09609560310087846,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.00898940004000001,
    },
    contracts: [
      {
        contract_address: "0xc637a16482f7bd03d8ad8990a3c778c25bb11e0b",
      },
    ],
    id: 114,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:10:56.112Z",
    key: "dreamscapes-by-xander-steenbrugge",
    name: "DreamScapes by Xander Steenbrugge",
    description: null,
    exchange_url:
      "https://opensea.io/collection/dreamscapes-by-xander-steenbrugge",
    external_url: "https://braindrops.cloud/",
    banner_image_url:
      "https://i.seadn.io/gae/t0_woEGvWyRRM9HyYnqd7oz--41yerZYave9nd2TmaECc0mdPZa2K12MvMlUsrouaVjV9kSSQPlUn7yhZ0AfzW2kSxdVUmmsiVaESg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/rkc_FDAryMrxRxLHA63eqq-NY2mTha-qAL3myuSPwxEIuw4osmjiCsPht-orYeDOcQ3QFYvBYBrafBiR-e-SN7d8PGbfHZDK_KLCIg?w=500&auto=format",
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/rkc_FDAryMrxRxLHA63eqq-NY2mTha-qAL3myuSPwxEIuw4osmjiCsPht-orYeDOcQ3QFYvBYBrafBiR-e-SN7d8PGbfHZDK_KLCIg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 295,
      floor_price: 0.09685,
      floor_price_symbol: "ETH",
      total_minted: 295,
      total_supply: null,
      total_volume: 589.9622450276884,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.1075,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 987,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 2,
      total_average_price: 0.597732771051356,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.05375,
    },
    contracts: [
      {
        contract_address: "0xdfde78d2baec499fe18f2be74b6c287eed9511d7",
      },
    ],
    id: 115,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:10:48.731Z",
    key: "beach-freeze-by-oni-balogun-1",
    name: "Beach Freeze by Oni Balogun",
    description:
      'You\'re at the beach, ice cream in hand, basking in sunny bliss when suddenly it hits you- the rhythmic ebb and flow of the waves draw you into an introspective riptide, reflecting on all things big and small. This is the essence of "Beach Freeze" by Oni Balogun, a collection of four NFTs that encapsulates these moments of seaside meditation through bold, “Afro-cubist” forms filtered through a sunny color palette. Each artwork visually anchors viewers in a memory, capturing the fleeting beauty of personal reflections set against the perpetual motion of the ocean, and of course, time. Let’s hit the beach!',
    exchange_url: "https://opensea.io/collection/beach-freeze-by-oni-balogun-1",
    external_url: "https://orangehare.io/",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/09cb59341a1548bee6d4d5d492d97224.gif?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/09cb59341a1548bee6d4d5d492d97224.gif?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/735bdca175a1bb684d8686a708ec310a.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/e4TGPjYqw4",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 93,
      floor_price: 0.004,
      floor_price_symbol: "ETH",
      total_minted: 93,
      total_supply: null,
      total_volume: 0.009499999999999998,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 2,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.004749999999999999,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x8487c35c7137c353460a9771884b0a4700d04650",
      },
    ],
    id: 116,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:10:45.074Z",
    key: "monkerunners-official",
    name: "Monkerunners Official",
    description:
      "𝟞,𝟞𝟞𝟞 𝕊𝕥𝕣𝕠𝕟𝕘 𝕔𝕠𝕞𝕚𝕟𝕘 𝕥𝕠𝕘𝕖𝕥𝕙𝕖𝕣 𝕥𝕠 𝕡𝕣𝕠𝕥𝕖𝕔𝕥 𝕠𝕟𝕖 𝕒𝕟𝕠𝕥𝕙𝕖𝕣. 𝔻𝕠𝕟'𝕥 𝕗𝕒𝕝𝕝 𝕗𝕣𝕠𝕞 𝕥𝕙𝕖 𝕓𝕣𝕒𝕟𝕔𝕙 𝕠𝕣 𝕖𝕝𝕤𝕖. ",
    exchange_url: "https://opensea.io/collection/monkerunners-official",
    external_url: "http://monkerunners.xyz",
    banner_image_url:
      "https://i.seadn.io/gcs/files/59560fd23aad5d77e08bdfee34e3dd30.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/4220ef2d068dcee204c970f0530d796c.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/4220ef2d068dcee204c970f0530d796c.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/Gae5yRegkOqNUQkxQ5axPkGYE0yw-idYVvJw2rc4iztgOwskBgE4iEH4ADcK7Z6v5WjKbr4c2EXE3Q_w1n8LNrDA5d2D8MkSO5W8?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 2259,
      floor_price: 0.0045,
      floor_price_symbol: "ETH",
      total_minted: 2259,
      total_supply: null,
      total_volume: 184.65377457684957,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 8894,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.02076161171316051,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x23e449da6e242d7b94c6d35806f2c5cc9b950ddb",
      },
    ],
    id: 117,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:12:49.878Z",
    key: "boredaiclub",
    name: "BoredAIClub",
    description:
      "Bored AI Club is a collection of 10,000 AI-generated apes, each corresponding to its original version.\n\nAdoption of AI art is inevitable, and here is your chance to become a part of it by joining in the very early stage with the most desirable project!\n\nNo roadmap. No utility. Only art.",
    exchange_url: "https://opensea.io/collection/boredaiclub",
    external_url: "http://boredaiclub.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/dc70124e7a8d105ae926d733c860ec5c.jpg?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/d69c46222354b054d1c5ef61e78b9350.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 2282,
      floor_price: 0.00098,
      floor_price_symbol: "ETH",
      total_minted: 2282,
      total_supply: null,
      total_volume: 63.19954274410022,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 4308,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.014670274545984267,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xbb53dfe73a4fe50cbe2fc436a1667beb5c22956e",
      },
    ],
    id: 118,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:12:49.469Z",
    key: "beacon-book",
    name: "Beacon Book Series",
    description:
      "The Beacon Book is a multimedia project by Stateful Works, featuring written perspectives on the Beacon Chain from 46 contributors. \r\n\r\nIt also features 7 two-page illustrations, which could be minted as NFTs of varying rarity when the project launched. Only 10 full Genesis Edition sets (NFTs 1-7) can be assembled. All ETH proceeds go to a split contract with the book contributors.",
    exchange_url: "https://opensea.io/collection/beacon-book",
    external_url: "https://stateful.mirror.xyz/",
    banner_image_url:
      "https://i.seadn.io/gae/STcO-txd3oc8x8zauk5LAnfK8E_-4fXwWjg4p5eyzB6vZI7CCIUqWgh2_U0R5L0k5HGvW0KVecFH_Cz5Iw-y01gAlknabCC-BEOE?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/9zx19sT0NN2mDs11sVz9TTRkz60DaknwAaP4VrcQtt2qN9NvrAiGo-Oaow06jmBV-pMLBi411opkbu4IcivK463NbSqF8sYsJstj_kY?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/9zx19sT0NN2mDs11sVz9TTRkz60DaknwAaP4VrcQtt2qN9NvrAiGo-Oaow06jmBV-pMLBi411opkbu4IcivK463NbSqF8sYsJstj_kY?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/zZ5volPPURufjHA2-qyIy1o9FDkuSdaE68TiV5P1kstwdGOQkVbjJ4wSbiBJzRNW-GrRuLWf3VZUTWS2T3bl0-ZvkKXL8LX9Wpdb?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/dQftW5bNQy",
    telegram_url: null,
    twitter_username: "StatefulWorks",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 671,
      floor_price: 2.5,
      floor_price_symbol: "ETH",
      total_minted: 671,
      total_supply: null,
      total_volume: 28.175899553528648,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 143,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.19703426261208845,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x3725ca6034bcdbc3c9ada649d49df68527661175",
      },
    ],
    id: 119,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:13:11.983Z",
    key: "rtfkt-punk-project-gen1",
    name: "RTFKT PUNK PROJECT GEN 1",
    description: null,
    exchange_url: "https://opensea.io/collection/rtfkt-punk-project-gen1",
    external_url: "https://rtfkt.com/",
    banner_image_url:
      "https://i.seadn.io/gae/Z6d_prfpuybVigOXhuO8gt4ZTRTvhBayZXgrG419eZq2Ex6ptuodet4TCg8DLyc-E3otjIEatALGFGuuEje7CVreT4BbIPZjE0lKDw?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/ohMHQyczzcytYl9PybKJHZ3nWxJZdphYzaFdg3l3EQM-NZ1hzb5LnK3NBuASkHSfPpgMvLoS755djRwpCHHzVQyC7PsBwd9GACUE0w?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/ohMHQyczzcytYl9PybKJHZ3nWxJZdphYzaFdg3l3EQM-NZ1hzb5LnK3NBuASkHSfPpgMvLoS755djRwpCHHzVQyC7PsBwd9GACUE0w?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/ohMHQyczzcytYl9PybKJHZ3nWxJZdphYzaFdg3l3EQM-NZ1hzb5LnK3NBuASkHSfPpgMvLoS755djRwpCHHzVQyC7PsBwd9GACUE0w?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/rtfkt",
    telegram_url: null,
    twitter_username: "RTFKTStudios",
    wiki_url: null,
    instagram_username: "RTFKTStudios",
    stats: {
      market_cap: 0,
      num_owners: 256,
      floor_price: 0.019799,
      floor_price_symbol: "ETH",
      total_minted: 256,
      total_supply: null,
      total_volume: 2154.235655600238,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 400,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 5.3855891390005945,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xae3d8d68b4f6c3ee784b2b0669885a315ba77c08",
      },
    ],
    id: 120,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:13:11.589Z",
    key: "riotbulls",
    name: "RiotBulls",
    description:
      "RiotBull$: 1/1 Collection\nStrength, Power, and Innovation\nRiotBull$ is a movement redefining NFTs, gaming, and decentralized economies.\nCOMMUNITY COIN (ERB$) – EXCLUSIVE FOR HOLDERS:\nhttps://app.mintable.com/c/0x67294074d0530f150a662a5c3114b210587c0c02\nLaunch Timeline:\nFull Mint: 01.09.25\nOfficial 2D Version - Base:\nhttps://opensea.io/collection/riotbullsbase/overview\nMemecoin: https://www.pink.meme/token/ethereum/0x4704d5a44e01673071fba3a798fb1f978da38584\nPlay-to-Earn Game: Immersive multiplayer experience. Coming Soon.\nStore: Exclusive blockchain-integrated items. Coming Soon.\nAllocation Breakdown:\n2%: Game development.\n2%: Monthly draws for holders and community investments\nRiotBull$ – Where strength meets exclusivity. Be part of the revolution.",
    exchange_url: "https://opensea.io/collection/riotbulls",
    external_url: "https://riotbulls.io",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/67c2c8a8a14cba8d45b10069aaa8e1ba.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/67c2c8a8a14cba8d45b10069aaa8e1ba.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/77d95b2c415d74f1a85025784d465e6f.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/VTWDJ4RCx3",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 5.602955273437487,
      num_owners: 1222,
      floor_price: 0.0016,
      floor_price_symbol: "ETH",
      total_minted: 1222,
      total_supply: null,
      total_volume: 2.4099103899989816,
      one_day_volume: 0.13309999999999972,
      seven_day_volume: 0.14344999999999966,
      thirty_day_volume: 1.1190081099999913,
      one_day_volume_change: 0.13309999999999972,
      seven_day_volume_change: 226,
      thirty_day_volume_change: -210,
      total_sales: 1354,
      one_day_sales: 247,
      seven_day_sales: 256,
      thirty_day_sales: 572,
      total_average_price: 0.001779845192022882,
      one_day_average_price: 0.000538866396761132,
      seven_day_average_price: 0.000560351562499999,
      thirty_day_average_price: 0.001956307884615369,
    },
    contracts: [
      {
        contract_address: "0x67294074d0530f150a662a5c3114b210587c0c02",
      },
    ],
    id: 121,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:12:42.109Z",
    key: "beanstalker",
    name: "Beanstalker",
    description:
      "Beanstalker is a fairy tale rewrite by Tale Tinker based on Jack and the Beanstalk. \n \nPlant the bean and watch it grows into a massive, towering beanstalk reaching up into the clouds. Climb the beanstalk to reach to the Giant’s castle. Loot his treasure but DON’T wake him up!",
    exchange_url: "https://opensea.io/collection/beanstalker",
    external_url: "https://beanstalker.xyz/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/75fda3e51e0be6ef5db33ac0be89e2fa.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/ecb45543542c73fbdd4f2b4f6cfb309f.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/ecb45543542c73fbdd4f2b4f6cfb309f.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/05fe52a104571aac2bff044fdfd25739.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/taletinker",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1515,
      floor_price: 0.003,
      floor_price_symbol: "ETH",
      total_minted: 1515,
      total_supply: null,
      total_volume: 93.6935588632225,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 6530,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.014348171341994257,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xa75689d2a5329acfc70dc6f8f2de7ddfbb4eadb9",
      },
    ],
    id: 122,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:12:38.027Z",
    key: "cryptobabyteddies",
    name: "CryptoBabyTeddies",
    description:
      "The CryptoBabyTeddies are the first larger collection besides the main/genesis Collection CryptoTeddies (https://opensea.io/collection/cryptoteddies). They are first and foremost handdrawn pieces of pixel art by the renowned artist numo. It has always been about art first with his collections and this is also true for the CBT. It is hugely inspired by the project CryptoBabyPunks and of course CryptoPunks. The CryptoBabyTeddies are sweet little teddies with different well-known traits. It is on-chain and it is CC0. The CryptoBabyTeddies are part of the whole CryptoTeddies ecosystem and will play a role in future iterations of it.",
    exchange_url: "https://opensea.io/collection/cryptobabyteddies",
    external_url: "https://cryptoteddies.xyz",
    banner_image_url:
      "https://i.seadn.io/gae/ST_nt4mgwhyg_vFmR9NwvZdfDyaMvL9HGg5B7WvLr8QbkW8X7eGBPzwfYK9qVJdJYRBjr_n_c0uHNQJaLIi_Ubg9YlkI7VBoo835g2A?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/a539a80245aa019128a63c4c1d65667a.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/a539a80245aa019128a63c4c1d65667a.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/_mQS4r55jeXQoKT1a_Zbz4KUQCVDB9cLo6V9cWgc8Pe-ccsNwWU0WDwFimmDL1IMYnya_21x60pgqlYCI852HLPKZhSBiec3mZ-f?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/cryptoteddies-official",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 561,
      floor_price: 0.007884,
      floor_price_symbol: "ETH",
      total_minted: 561,
      total_supply: null,
      total_volume: 21.062137989999968,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0354,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 723,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 3,
      total_average_price: 0.02913158781466109,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0118,
    },
    contracts: [
      {
        contract_address: "0x3b84502df3d36ef2e5318bce5a988460cf349304",
      },
    ],
    id: 123,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:12:33.808Z",
    key: "the-power-of-ass",
    name: "The power of ass",
    description:
      "The Power of Ass is an original and unique \nSS1 of 202 asses and SS2 of 303 asses total 505 ass !! \ncreated by Mr. Ass from Assgard.  \nShow your appreciation for ass by joining our community and becoming a true ass lover.  \n\nJoin our [Discord](https://discord.gg/dSx3N45n94). \n\nHere is the link to our other collections and characters:\n[Made in Assgard](https://opensea.io/collection/made-in-ass-town) and \n[Mr.Ass Universe Tour](https://opensea.io/collection/mr-ass-1)",
    exchange_url: "https://opensea.io/collection/the-power-of-ass",
    external_url: "https://thepowerofass.art/",
    banner_image_url:
      "https://i.seadn.io/gae/Pe0-vvrMf8AlftHTdgng8Jr4d0fFgTwclBAlz1d-HQ2quiU9OXuaOwyiX6VaZh6wDii2SRc8BJAwA4vG6ioMMONSND08tDkC-ddZTQ?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/Pe0-vvrMf8AlftHTdgng8Jr4d0fFgTwclBAlz1d-HQ2quiU9OXuaOwyiX6VaZh6wDii2SRc8BJAwA4vG6ioMMONSND08tDkC-ddZTQ?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/Pe0-vvrMf8AlftHTdgng8Jr4d0fFgTwclBAlz1d-HQ2quiU9OXuaOwyiX6VaZh6wDii2SRc8BJAwA4vG6ioMMONSND08tDkC-ddZTQ?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/jy8lHQLm8js8cQBJIQJMjg7JhK2q4mKJQLUCrqglc8TEgvzCRmlHn4hwWwJwZr3pCAvpZ97KtRyq551iqttEUV7rlbe0v2FOXN_hsg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/dSx3N45n94",
    telegram_url: null,
    twitter_username: "Thepowerofass",
    wiki_url: null,
    instagram_username: "assgard_official/",
    stats: {
      market_cap: 0,
      num_owners: 276,
      floor_price: 0.0398,
      floor_price_symbol: "ETH",
      total_minted: 276,
      total_supply: null,
      total_volume: 68.2471848257153,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0036,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 851,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 2,
      total_average_price: 0.08019645690448331,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0018,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 124,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:12:22.589Z",
    key: "jnglnft",
    name: "JNGL",
    description: "A required token for staking in Jungle Labz ecosystem.\n",
    exchange_url: "https://opensea.io/collection/jnglnft",
    external_url: "http://supremekong.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/25434136d722f5e4c6b2580b98f63bf0.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/dfd22f466096a74c6d08b3be1f669a02.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/dfd22f466096a74c6d08b3be1f669a02.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/59101aedda00ecc51c49c97e1c82e4a3.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/supremekong",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 870.3346212533335,
      num_owners: 651,
      floor_price: 0.00789899,
      floor_price_symbol: "ETH",
      total_minted: 651,
      total_supply: null,
      total_volume: 547.5602394700061,
      one_day_volume: 0.28,
      seven_day_volume: 0.29589799000000006,
      thirty_day_volume: 0.8498668900000002,
      one_day_volume_change: 0.28,
      seven_day_volume_change: -21,
      thirty_day_volume_change: -5,
      total_sales: 9024,
      one_day_sales: 1,
      seven_day_sales: 3,
      thirty_day_sales: 45,
      total_average_price: 0.06067821802637479,
      one_day_average_price: 0,
      seven_day_average_price: 0.09863266333333336,
      thirty_day_average_price: 0.018885930888888892,
    },
    contracts: [
      {
        contract_address: "0x54fec6309b53a31e65593f196b4c58f7a704a361",
      },
    ],
    id: 125,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:12:07.934Z",
    key: "drp-lushsux",
    name: "LushSux.io",
    description:
      "35 countries, 15 years, 12 exhibitions, 4444 posts. Collect & hold your part of internet's first meme artist. Get exclusive access to community, artwork, and @lushsux's future projects.\n\nService guarantees citizenship.\n\n",
    exchange_url: "https://opensea.io/collection/drp-lushsux",
    external_url: "https://drp.io/drops/lushsux",
    banner_image_url:
      "https://i.seadn.io/gae/HnSwuXyraUZmidICY17uytF_iADnsc6oG7zsPfme-2HgF2z-otnB3vznNEX05mHlnhFyP3glfgaiCs_sFphvXbKnByX9MiEhhpx_-A?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/BgTLlOVRO0IrMxtuxqbwvuI9hStYGVOn0Hgj506mdamQ9cx7avzVwxBKu5oSaC9TZEX1Q6WUgo6UkWIhXTMGetl83BpQRcsrzjyf8IQ?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/BgTLlOVRO0IrMxtuxqbwvuI9hStYGVOn0Hgj506mdamQ9cx7avzVwxBKu5oSaC9TZEX1Q6WUgo6UkWIhXTMGetl83BpQRcsrzjyf8IQ?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/5YWQrQ8TH3XcMJcWeuihxK63osTVBeDsdRxyzS4JtRYoypl8-djpiPpK1gCbe6SQct5MCmAZafQqU9MJ1js6nbKHHBY8YRNNn9Vt4A?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/drp-io",
    telegram_url: null,
    twitter_username: "drp_io",
    wiki_url: null,
    instagram_username: "drp.io",
    stats: {
      market_cap: 32.29278000000001,
      num_owners: 1848,
      floor_price: 0.0144,
      floor_price_symbol: "ETH",
      total_minted: 1848,
      total_supply: null,
      total_volume: 208.6694634308232,
      one_day_volume: 0.01,
      seven_day_volume: 0.07410000000000001,
      thirty_day_volume: 0.07410000000000001,
      one_day_volume_change: -0.004,
      seven_day_volume_change: 10,
      thirty_day_volume_change: 3,
      total_sales: 2508,
      one_day_sales: 2,
      seven_day_sales: 10,
      thirty_day_sales: 10,
      total_average_price: 0.08320154044291196,
      one_day_average_price: 0.005,
      seven_day_average_price: 0.007410000000000001,
      thirty_day_average_price: 0.007410000000000001,
    },
    contracts: [
      {
        contract_address: "0x0b15727723690295a7981f12cf49b706a3eb555f",
      },
    ],
    id: 126,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:11:48.727Z",
    key: "chrysalism-dna",
    name: "CHRYSALISM: DNA",
    description:
      "An awe-inspiring revelation lies ahead, a mere particle hanging in a ray of light. Unveil the door to an alternate universe with CHRYSALISM DNA. Embark on the adventure and claim your entry to the Chrysalism lab through our official website and create your personalized larva. \n\nhttps://opensea.io/collection/chrysalism-insect",
    exchange_url: "https://opensea.io/collection/chrysalism-dna",
    external_url: "https://chrysalism.xyz/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/000e4616d2c195ed80e6bcdccf3cfce2.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/3feb1cb1c02253d05deb3a55f58ce874.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/3feb1cb1c02253d05deb3a55f58ce874.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/primary-drop-files/chrysalism/logo.png",
    chat_url: null,
    discord_url: "https://discord.gg/chrysalism",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 990,
      floor_price: 0.0089,
      floor_price_symbol: "ETH",
      total_minted: 990,
      total_supply: null,
      total_volume: 377.8364171002798,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0016,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 5772,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.0654602247228482,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0016,
    },
    contracts: [
      {
        contract_address: "0x7c729bf7f93ad88686e3a4bb2854b7cffb7dfcb9",
      },
    ],
    id: 127,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:11:41.234Z",
    key: "bassies",
    name: "BASTARD WASSIES (aka BASSIES)",
    description:
      "BASSIES (BASTARD WASSIES) are a peculiar crossbreed that first emerged following a cataclysmic event in the blockchain universe around the year 2023. Their genesis is traced back to an accidental intertwining of the digital DNA of two distinct entities: the Wassies and the BASTARD GAN PUNKS. This odd fusion led to a species that is a curious amalgamation of traits from its two parent species, making BASSIES a fascinating study in generative adversarial biology.\n\nCONSTANTLY WANTS TO MAKE THE WORLD BEAUTIFUL\nCONSTANTLY WANTS TO MAKE THE WORLD BEAUTIFUL\nCONSTANTLY WANTS TO MAKE THE WORLD BEAUTIFUL\nCONSTANTLY WANTS TO MAKE THE WORLD BEAUTIFUL\nCONSTANTLY WANTS TO MAKE THE WORLD BEAUTIFUL\nCONSTANTLY WANTS TO MAKE THE WORLD BEAUTIFUL\nCONSTANTLY WANTS TO MAKE THE WORLD BEAUTIFUL\nCONSTANTLY WANTS TO MAKE THE WORLD BEAUTIFUL\nCONSTANTLY WANTS TO MAKE THE WORLD BEAUTIFUL\nCONSTANTLY WANTS TO MAKE THE WORLD BEAUTIFUL\n\nby\nxbastard.eth - crazymotherfuckingbastard \nberk.eth - guerrillapimpminionbastard",
    exchange_url: "https://opensea.io/collection/bassies",
    external_url: "https://bassies.wtf/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/5341b64aea268bbcbf613a0787e0208e.jpg?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/db7cf16e148fabba40bb12bf2aac4fef.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/bganpunks",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 122,
      floor_price: 0.00848,
      floor_price_symbol: "ETH",
      total_minted: 122,
      total_supply: null,
      total_volume: 2.026699999999999,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 21,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.09650952380952377,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x61a010418ee55dfe4a0152908b971aad2e2af088",
      },
    ],
    id: 128,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:10:41.032Z",
    key: "rare-pepe-curated",
    name: "Rare Pepe (2016 - 2018)",
    description:
      "Rare Pepes is a historic NFT collection of 1,774 unique cards with varying designs and rarities that were minted from 2016 to 2018. The collection was created using the Counterparty protocol on the Bitcoin blockchain and is the first decentralized community art project in the history of NFTs. More than 300 artists submitted cards that were approved by the Rare Pepe Scientists, who curated the completion of 36 series of 50 cards each (Series 36 ended with 24 cards). This collection is curated by Emblem Vault.",
    exchange_url: "https://opensea.io/collection/rare-pepe-curated",
    external_url: "https://emblem.vision/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/e3f46f74afc2df8875585f511edd940a.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/b36c8411036867ffedd8d85c54079785.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/b36c8411036867ffedd8d85c54079785.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/b36c8411036867ffedd8d85c54079785.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/bcy5B4NU5r",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 62.1575850865778,
      num_owners: 5842,
      floor_price: 0.003,
      floor_price_symbol: "ETH",
      total_minted: 5842,
      total_supply: null,
      total_volume: 2516.9600708311837,
      one_day_volume: 1.1697418999999696,
      seven_day_volume: 9.890390475635442,
      thirty_day_volume: 85.41350149234205,
      one_day_volume_change: 10,
      seven_day_volume_change: 179,
      thirty_day_volume_change: -469,
      total_sales: 10544,
      one_day_sales: 80,
      seven_day_sales: 267,
      thirty_day_sales: 654,
      total_average_price: 0.23871017363725186,
      one_day_average_price: 0.01462177374999962,
      seven_day_average_price: 0.037042660957436115,
      thirty_day_average_price: 0.13060168423905513,
    },
    contracts: [
      {
        contract_address: "0x7e6027a6a84fc1f6db6782c523efe62c923e46ff",
      },
    ],
    id: 129,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:10:37.147Z",
    key: "moonswingers",
    name: "Moonswingers",
    description:
      "𝚆𝚑𝚢 𝚋𝚎 𝚒𝚗 𝚝𝚑𝚎 𝚓𝚞𝚗𝚐𝚕𝚎 𝚠𝚑𝚎𝚗 𝚢𝚘𝚞 𝚌𝚊𝚗 𝚜𝚠𝚒𝚗𝚐 𝚘𝚗 𝚝𝚑𝚎 𝚖𝚘𝚘𝚗? 𝚌𝚌𝟶 𝚙𝚛𝚘𝚓𝚎𝚌𝚝.",
    exchange_url: "https://opensea.io/collection/moonswingers",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/fdbf91b0fe07f9180f1f20a527831a63.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/b38f765eeef5888ec98338ca353e056d.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/b38f765eeef5888ec98338ca353e056d.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/84b9a13ecd85ade9bcab8f43ccc1e293.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1599,
      floor_price: 0.008,
      floor_price_symbol: "ETH",
      total_minted: 1599,
      total_supply: null,
      total_volume: 22.675971592728995,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 2572,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.00881647418068779,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x34f63158111ee06d854d441c0305ef9038e76509",
      },
    ],
    id: 130,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:10:22.871Z",
    key: "day-dreamerz",
    name: "Day Dreamerz",
    description:
      "Dive with us into a world of 555 Dreamz, where the boundaries between reality and imagination collide, opening up a realm of infinite possibilities.\n\nFor more detailed information, please check out our [whitepaper](https://whitepaper.daydreamerz.io).",
    exchange_url: "https://opensea.io/collection/day-dreamerz",
    external_url: "https://daydreamerz.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/aac910044a60a882cbf14f2bd385c38c.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/b5b88628674eb45c198f116ec220e04e.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/b5b88628674eb45c198f116ec220e04e.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/2912a45d732cfc342f20f5b5093f939c.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/daydreamerz",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 360,
      floor_price: 0.03,
      floor_price_symbol: "ETH",
      total_minted: 360,
      total_supply: null,
      total_volume: 0.7019710000000001,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 52,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.01349944230769231,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x922e21b11b7f6d3e2fb45634fdb095fab6037d9a",
      },
    ],
    id: 131,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:09:34.626Z",
    key: "boulder-art-pendants",
    name: "Boulder Art Pendants",
    description: null,
    exchange_url: "https://opensea.io/collection/boulder-art-pendants",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/s/raw/files/0a770a76c54528febb2b5b07f687c714.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 0.11,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x0ce191d6ef2d353ac916577a9afec866101edd20",
      },
    ],
    id: 132,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:09:02.828Z",
    key: "waifusion",
    name: "Waifusion",
    description:
      "Waifusion is a digital Waifu collection. There are 16,384 guaranteed-unique Waifusion NFTs. They’re just like you; a beautiful work of art, but 2-D and therefore, superior, Anon-kun. Each Waifu is wholly unique and yours forever... unless you sell them... Baka.",
    exchange_url: "https://opensea.io/collection/waifusion",
    external_url: "https://waifusion.io",
    banner_image_url:
      "https://i.seadn.io/gae/sI83M7RYdE27-tw42gtcVC-4BPwi-0Rp-4vmuqVfkRKbIB0U-twHaA0-IXU487mX1BLcHzXK3KTBE09A3SGzyhqy4CK0qLNqKqeg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/o93386L-fvk98ozt0VHxAPABav90JNDJiiBigE5AUICIvKg_hou8YCJXD1dteV9OiiNBu8LvZc3jxPc_HjRcnqdinIojs6al1KVa?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/o93386L-fvk98ozt0VHxAPABav90JNDJiiBigE5AUICIvKg_hou8YCJXD1dteV9OiiNBu8LvZc3jxPc_HjRcnqdinIojs6al1KVa?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/TrltscwBLgNJMM_jgHDU9f1GMR5xEfvC2SNwyqest2_3yN6icrtWQIvQTJRTA1WyGKP3qkOskrHMGyKDiXclLC0BWTB77mD0BWQ5xg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/CaR7RhfDZ6",
    telegram_url: null,
    twitter_username: "waifusion",
    wiki_url: null,
    instagram_username: "waifusionnft",
    stats: {
      market_cap: 174.09665109090915,
      num_owners: 2203,
      floor_price: 0.011147,
      floor_price_symbol: "ETH",
      total_minted: 2203,
      total_supply: null,
      total_volume: 3060.1419770858183,
      one_day_volume: 0,
      seven_day_volume: 0.23385800000000007,
      thirty_day_volume: 0.8168959999999996,
      one_day_volume_change: 0,
      seven_day_volume_change: -54,
      thirty_day_volume_change: 89,
      total_sales: 10438,
      one_day_sales: 0,
      seven_day_sales: 22,
      thirty_day_sales: 114,
      total_average_price: 0.29317321106397953,
      one_day_average_price: 0,
      seven_day_average_price: 0.010629909090909094,
      thirty_day_average_price: 0.007165754385964909,
    },
    contracts: [
      {
        contract_address: "0x2216d47494e516d8206b70fca8585820ed3c4946",
      },
    ],
    id: 133,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:08:58.767Z",
    key: "memeasf-mint-pass",
    name: "MEMEASF Mint Pass",
    description: null,
    exchange_url: "https://opensea.io/collection/memeasf-mint-pass",
    external_url: "http://fakememedirectory.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/18913af4682ef1ad5be03aed706430c7.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/c985bfccf4809be640f9ace7744f3cc6.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/c985bfccf4809be640f9ace7744f3cc6.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/0ef462510d313967fe8edf4b559f8dd8.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/fakes",
    telegram_url: "https://t.me/officialfakememes",
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 536,
      floor_price: 0.01,
      floor_price_symbol: "ETH",
      total_minted: 536,
      total_supply: null,
      total_volume: 33.89784198999995,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 627,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.054063543843700074,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xaaf62976da022ed936b5401653e4a4f4ce345b77",
      },
    ],
    id: 134,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:08:25.646Z",
    key: "xloot",
    name: "Extension Loot (for Adventurers)",
    description:
      "Extension Loot is second set of Loot, a randomized adventurer gear generated and stored on chain. It uses the same algo as Loot, Extension Loot is just more Loot. Stats, images, and other functionality are intentionally omitted for others to interpret. Feel free to use Exension Loot in any way you want.",
    exchange_url: "https://opensea.io/collection/xloot",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gae/SCyNKmiY2kw5hhn5b2W1wGDxYuaDR2FyQLdoQUpgy2Tmy3sIX6HgQQREKO4agClcUP9YYQiAl8v6qTAjT98h6YZbTSlFFuzTYi5PhQ?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/jrDIXHP7qyc5itCnyDgk4kA8Yjw89FjW1bFga_4lNpetLmJtl83ugVeK_QFcFaLBb2-qtDjGGQiJem_aVC8V0uUjDhrLyJwwdJjAwg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/CmySBzxpmp",
    telegram_url: null,
    twitter_username: "xLootProject",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 7.18518,
      num_owners: 2185,
      floor_price: 0.0059,
      floor_price_symbol: "ETH",
      total_minted: 2185,
      total_supply: null,
      total_volume: 3411.7210742132934,
      one_day_volume: 0,
      seven_day_volume: 0.00279,
      thirty_day_volume: 0.00279,
      one_day_volume_change: 0,
      seven_day_volume_change: 3,
      thirty_day_volume_change: -17,
      total_sales: 7731,
      one_day_sales: 0,
      seven_day_sales: 3,
      thirty_day_sales: 3,
      total_average_price: 0.44130398062518345,
      one_day_average_price: 0,
      seven_day_average_price: 0.00093,
      thirty_day_average_price: 0.00093,
    },
    contracts: [
      {
        contract_address: "0x8bf2f876e2dcd2cae9c3d272f325776c82da366d",
      },
    ],
    id: 135,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:08:15.091Z",
    key: "gatekeepersv2",
    name: "The Gatekeepers by Anon V2",
    description:
      '"We control our own destiny." ☑️\n\nGatekeepers were reserved for those who believed the earliest. Gatekeepers minted the Blank Checks by Anon Open Edition before any promises were made, or any scripts revealed. \n\nThe Gatekeepers will guard the Blank Checks. \n\nTo burn Blank Checks, one must become a Gatekeeper.',
    exchange_url: "https://opensea.io/collection/gatekeepersv2",
    external_url: null,
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/gcs/files/268a060d49133fc39c0da38f6dd42097.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/268a060d49133fc39c0da38f6dd42097.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/268a060d49133fc39c0da38f6dd42097.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/anonarts",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 609,
      floor_price: 0.008399,
      floor_price_symbol: "ETH",
      total_minted: 609,
      total_supply: null,
      total_volume: 49.788615709226356,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 704,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.07072246549606016,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xd387b00bc58cf23d00433a0031adce3d8d34e9d2",
      },
    ],
    id: 136,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:08:14.705Z",
    key: "cryptocities-suburbs",
    name: "CryptoCities: Suburbs",
    description:
      "CryptoCities: Suburbs is an extension of the CryptoCities universe.",
    exchange_url: "https://opensea.io/collection/cryptocities-suburbs",
    external_url: "http://cryptocities.world",
    banner_image_url:
      "https://i.seadn.io/gcs/files/687dca8d8a9ff56d0600506ac883154b.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/687dca8d8a9ff56d0600506ac883154b.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/687dca8d8a9ff56d0600506ac883154b.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/b4802aea312eb57eb4642fefc0f49cf2.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/cryptocities",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 179,
      floor_price: 0.03607400040184437,
      floor_price_symbol: "ETH",
      total_minted: 179,
      total_supply: null,
      total_volume: 43.20081699999999,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.08100000000000002,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 4,
      total_sales: 183,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 4,
      total_average_price: 0.23607003825136605,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.020250000000000004,
    },
    contracts: [
      {
        contract_address: "0x55d53d855323da475fe696ca007b34f55cc702f3",
      },
    ],
    id: 137,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:08:04.244Z",
    key: "icxn-by-xcopy",
    name: "ICXN",
    description: "500 icxns",
    exchange_url: "https://opensea.io/collection/icxn-by-xcopy",
    external_url: "https://xcopy.art",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/fe42f1594ed11201f558f156a075c6a4.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/fe42f1594ed11201f558f156a075c6a4.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/ba29396902a41bbfa63327e0e7466a20.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 660,
      num_owners: 338,
      floor_price: 1.619999,
      floor_price_symbol: "ETH",
      total_minted: 338,
      total_supply: null,
      total_volume: 425.4462669999999,
      one_day_volume: 0,
      seven_day_volume: 2.64,
      thirty_day_volume: 11.26,
      one_day_volume_change: 0,
      seven_day_volume_change: 2,
      thirty_day_volume_change: -4,
      total_sales: 180,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 7,
      total_average_price: 2.363590372222222,
      one_day_average_price: 0,
      seven_day_average_price: 1.32,
      thirty_day_average_price: 1.6085714285714285,
    },
    contracts: [
      {
        contract_address: "0xc04e0000726ed7c5b9f0045bc0c4806321bc6c65",
      },
    ],
    id: 138,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:14:32.766Z",
    key: "genesis-tiimy",
    name: "Genesis Tiimy [Migrating]",
    description:
      "Tiimy is migrating to Ternoa Blockchain to enhance utility - Join our discord to learn about the Burn 2 Claim process.\nThe Genesis Tiimy is an NFT collection of 2000 Tiimy hanging around Ternoa ecosystem, helping Tiime Engine community to earn $CAPS and Tokens doing various socials interactions and playing with Ternoa Blockchain features.",
    exchange_url: "https://opensea.io/collection/genesis-tiimy",
    external_url: "https://www.tiime-engine.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/ccf005a110c8b811021d7a69620d7405.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/59988f110e206ca912f9677ce4a086f6.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/59988f110e206ca912f9677ce4a086f6.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/59988f110e206ca912f9677ce4a086f6.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/2rGuvmEhWD",
    telegram_url: "https://t.me/TiimeEngineEN",
    twitter_username: null,
    wiki_url: null,
    instagram_username: "tiimeengine",
    stats: {
      market_cap: 0,
      num_owners: 225,
      floor_price: 0.009899,
      floor_price_symbol: "ETH",
      total_minted: 225,
      total_supply: null,
      total_volume: 110.10792800000006,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 742,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.14839343396226423,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x4dee84fc94cea12c85bb986c1d68aef85c36bfe1",
      },
    ],
    id: 139,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:14:29.072Z",
    key: "miladmaker",
    name: "Milad Maker",
    description:
      "Milad Maker is a collection of 10k neochibi hellions inspired by Milady Maker and the Remilia ecosystem.",
    exchange_url: "https://opensea.io/collection/miladmaker",
    external_url: "https://discord.gg/BhXSZs5Sv3",
    banner_image_url:
      "https://i.seadn.io/gcs/files/bad4ef6603dafce1d4f01343d8465a76.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/48b426fe2cd79203d73e34d199df0e28.gif?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/48b426fe2cd79203d73e34d199df0e28.gif?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/c96f7b3fe48adb894a86b353bebcd8ed.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 35.107200000000006,
      num_owners: 2270,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 2270,
      total_supply: null,
      total_volume: 474.4601829830281,
      one_day_volume: 0.0093,
      seven_day_volume: 0.0396,
      thirty_day_volume: 0.4831139,
      one_day_volume_change: -0.0005,
      seven_day_volume_change: -1,
      thirty_day_volume_change: 16,
      total_sales: 17727,
      one_day_sales: 3,
      seven_day_sales: 11,
      thirty_day_sales: 74,
      total_average_price: 0.026764832345181257,
      one_day_average_price: 0.0031,
      seven_day_average_price: 0.0036,
      thirty_day_average_price: 0.006528566216216216,
    },
    contracts: [
      {
        contract_address: "0x61628d84d0871a38f102d5f16f4e69ee91d6cdd9",
      },
    ],
    id: 140,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:14:25.156Z",
    key: "the-ancient-secrets",
    name: "The Ancient Secrets",
    description:
      "Buried beneath the sands of ancient Egypt, 100 unique NFTs unveil a lost world where pharaohs, extraterrestrials, and celestial beings once coexisted. The pyramids are not merely grand monuments but gateways to other realms, encoded with golden hieroglyphs that conceal forbidden truths.\n\nEach NFT in this collection tells a story: pharaohs clad in radiant golden armor, sacred sculptures pulsing with divine energy, and mysterious artifacts lost in time. In the shadows, enigmatic extraterrestrials guard the temple of knowledge, protecting the secrets of a forgotten civilization. The full moon bathes the sacred architecture in light, casting shadows that seem to come alive, revealing clues about the hidden connection between humanity and the stars.\n\nThis is more than just an NFT collection, it is a gateway to a forbidden past, where myths conceal cosmic truths, and history has been rewritten by those who were never meant to be seen.",
    exchange_url: "https://opensea.io/collection/the-ancient-secrets",
    external_url: null,
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/8593a2b9688582be491f623652146258.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/8593a2b9688582be491f623652146258.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/3e1091b2f4c9605be2e7c8896946378f.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 95,
      floor_price: 0.004,
      floor_price_symbol: "ETH",
      total_minted: 95,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x9d3c227705850b651bb697f7179c3fb00bc98feb",
      },
    ],
    id: 141,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:14:03.296Z",
    key: "mintify-official",
    name: "Mintify Lifetime Membership",
    description:
      "RETIRED COLLECTION - DO NOT BUY\n\nThis collection has been retired on 07/31/23. ",
    exchange_url: "https://opensea.io/collection/mintify-official",
    external_url: "https://www.mintify.xyz",
    banner_image_url:
      "https://i.seadn.io/gcs/files/da3a76acb5aa02cc44fa789ded5f5710.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/ea409c8be3fbaa5082e9382ed1ac2916.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/ea409c8be3fbaa5082e9382ed1ac2916.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/80qkrkOorr15eIteads9jQcX3F2E62s0Q-kJive_USsV9j8tcyMw7RsndvB7mLOsoqLsarcqonOcPi-6AxsFAsAQpew6SeUN588T?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/mintify",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "mintifyme",
    stats: {
      market_cap: 0,
      num_owners: 262,
      floor_price: 0.093299,
      floor_price_symbol: "ETH",
      total_minted: 262,
      total_supply: null,
      total_volume: 208.90929082699995,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 979,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.21339049114096012,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x6712545a0d1d8595d1045ea18f2f386ffca7ca90",
      },
    ],
    id: 142,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:15:12.350Z",
    key: "archive-of-feelings-by-mika-tajima",
    name: "Archive of Feelings by Mika Tajima",
    description:
      "Archive of Feelings is the first-ever solo NFT project from multidisciplinary artist Mika Tajima, produced by PROOF x Pace Verso.\r\n\r\nThe project is based on Tajima’s existing Human Synth series of large-scale installations that use a custom sentiment analysis algorithm to process text-based social media data and forecast collective emotions. With Archive of Feelings, Tajima brings Human Synth into the world of web3, using the same sentiment analysis program to visualize the averaged emotional data across 12 US regions on January 1, 2023.\r\n\r\nEach Archive of Feelings NFT will provide access to exclusive in-person events with Pace Gallery and private tours hosted by PROOF and Pace Verso. See [terms of sale](https://www.proof.xyz/pdfs/archive_of_feelings_terms.pdf) for more information",
    exchange_url:
      "https://opensea.io/collection/archive-of-feelings-by-mika-tajima",
    external_url: "https://www.proof.xyz/collaborations/archive-of-feelings",
    banner_image_url:
      "https://i.seadn.io/gcs/files/634a026a03416a9c161d622d740da54f.webp?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/5f5c262804d32edd307ac5bfa0f2458c.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 12.534616666666667,
      num_owners: 836,
      floor_price: 0.018799,
      floor_price_symbol: "ETH",
      total_minted: 836,
      total_supply: null,
      total_volume: 82.82255538998447,
      one_day_volume: 0,
      seven_day_volume: 0.065398,
      thirty_day_volume: 0.065398,
      one_day_volume_change: 0,
      seven_day_volume_change: 6,
      thirty_day_volume_change: -6,
      total_sales: 685,
      one_day_sales: 0,
      seven_day_sales: 6,
      thirty_day_sales: 6,
      total_average_price: 0.1209088399853788,
      one_day_average_price: 0,
      seven_day_average_price: 0.010899666666666665,
      thirty_day_average_price: 0.010899666666666665,
    },
    contracts: [
      {
        contract_address: "0x24607c7602e52ce6b1ab4ae7b5196e9ae4c13762",
      },
    ],
    id: 143,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:15:08.191Z",
    key: "more-loot",
    name: "More Loot",
    description: null,
    exchange_url: "https://opensea.io/collection/more-loot",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url: null,
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 25338,
      floor_price: 0.000898,
      floor_price_symbol: "ETH",
      total_minted: 25338,
      total_supply: null,
      total_volume: 550.9105412103194,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.002,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 6576,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.08377593388234783,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.002,
    },
    contracts: [
      {
        contract_address: "0x1dfe7ca09e99d10835bf73044a23b73fc20623df",
      },
    ],
    id: 144,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:15:03.467Z",
    key: "mintable-gasless-store",
    name: "Mintable Gasless Store",
    description:
      "Mintable gasless store. Any NFT can be minted for free, without a transaction, using the Mintable gasless store.",
    exchange_url: "https://opensea.io/collection/mintable-gasless-store",
    external_url: "https://mintable.app",
    banner_image_url:
      "https://i.seadn.io/gae/ziqI3WNB-j0ntLdC245swPLoIhCosL992h8UiP369nqMIca_-7zlI1RNMx74O8tOPQXu1fFjOlm_AdR3Fdieu89RWc-be1qwPU6upQ?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/q_YaCQ09XvyorweQ9jF4mpN5iEVhUQ7IKCRKPE1gTf01e6-Y-NCeOLbC5hGq9wYGo4Cl9c7QP1fO4bx-9fDuULxTcvJjySnKXiWf?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: "mintable_app",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 2646,
      floor_price: 0.007,
      floor_price_symbol: "ETH",
      total_minted: 2646,
      total_supply: null,
      total_volume: 150.28659752083888,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 193,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.77868703378673,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x8c5acf6dbd24c66e6fd44d4a4c3d7a2d955aaad2",
      },
    ],
    id: 145,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:15:03.013Z",
    key: "nickelodeon-eth",
    name: "Nickelodeon NFTs (ETH)",
    description:
      "The Splat Factory is back—this time with a twist! 12 characters from *Invader Zim* and *AAAHH!!! Real Monsters* will join *Rugrats* and *Hey Arnold!* characters in the official Nickelodeon collection. \n\n**Starting November 8th at 2pm ET**, it’ll be time for you to collect a new set of 12 classic characters in the upcoming public sale on Nickelodeon.xyz. [Register now](https://nickelodeon.xyz/signup/) to be ready. Collect multiple characters to earn enough slime so you can redeem a highly coveted *Invader Zim* and *AAAHH!!! Real Monsters* mashup character.\n\n---\n\n[Nickelodeon NFTs (MATIC) OpenSea Collection](https://opensea.io/collection/nickelodeon-polygon)\n\n[Nickelodeon.xyz Marketplace](https://nickelodeon.xyz/marketplace)\n\nTo open a sealed Nickelodeon TV pack, you'll need to [send it to your RECUR account](https://nickelodeon.xyz/signup) first.",
    exchange_url: "https://opensea.io/collection/nickelodeon-eth",
    external_url: "https://nickelodeon.xyz/marketplace",
    banner_image_url:
      "https://i.seadn.io/gcs/files/e8cdbba7dfed75c40a94a5d2a5979a22.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/7ae6d3aaa799ff4c2d8fe08a0f6788cf.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/7ae6d3aaa799ff4c2d8fe08a0f6788cf.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/14300f780a017ba9573caf5a012cc0e9.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/recur",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 18.251688,
      num_owners: 2384,
      floor_price: 0.017466,
      floor_price_symbol: "ETH",
      total_minted: 2384,
      total_supply: null,
      total_volume: 2397.7055511094068,
      one_day_volume: 0.00001,
      seven_day_volume: 0.017810000000000003,
      thirty_day_volume: 0.02571,
      one_day_volume_change: 1,
      seven_day_volume_change: 4,
      thirty_day_volume_change: -6,
      total_sales: 11708,
      one_day_sales: 1,
      seven_day_sales: 5,
      thirty_day_sales: 8,
      total_average_price: 0.20479206961986735,
      one_day_average_price: 0.00001,
      seven_day_average_price: 0.003562000000000001,
      thirty_day_average_price: 0.00321375,
    },
    contracts: [
      {
        contract_address: "0x223e16c52436cab2ca9fe37087c79986a288fffa",
      },
    ],
    id: 146,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:15:56.685Z",
    key: "sorare-unique",
    name: "Sorare",
    description:
      "Collect, play and win officially licensed digital cards featuring the world's best global football players.\n\n",
    exchange_url: "https://opensea.io/collection/sorare-unique",
    external_url: "https://sorare.com/",
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/s/raw/files/a5b9129e20360fc598164c7f620718d1.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 3,
      floor_price: 14.5,
      floor_price_symbol: "ETH",
      total_minted: 3,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 6,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x68cb61ca6466a4c397c45aac24fa00bc2bd7ea83",
      },
    ],
    id: 147,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:15:56.283Z",
    key: "knownorigin-5",
    name: "KnownOrigin",
    description: null,
    exchange_url: "https://opensea.io/collection/knownorigin-5",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/s/raw/files/603ad6cc69ee44bfea782ad725a89243.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 5,
      floor_price: 6.9,
      floor_price_symbol: "ETH",
      total_minted: 5,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 5,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x416127b77feb6f7837dc31ab074abdb9f23bfbc2",
      },
    ],
    id: 148,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:15:55.826Z",
    key: "terraforms",
    name: "Terraforms by Mathcastles",
    description:
      "Onchain land art from a dynamically generated onchain 3D world.",
    exchange_url: "https://opensea.io/collection/terraforms",
    external_url: "http://mathcastles.xyz",
    banner_image_url:
      "https://i.seadn.io/gae/hoEkfQECzheZeOBJ09dXg6ZGax3TCsCoYp34N3Xg4xztQz9nOK4eGezI3jXZ4eFK8lGmxV_o_NjkGX1YoySyBTVW3lN7U2IYjpBY?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/8987b795655076fdf8183a7daee3754a.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/mathcastles",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 4635.555445342104,
      num_owners: 2013,
      floor_price: 0.476999,
      floor_price_symbol: "ETH",
      total_minted: 2013,
      total_supply: null,
      total_volume: 33419.9453161779,
      one_day_volume: 5.375608,
      seven_day_volume: 17.773292999999995,
      thirty_day_volume: 102.17159898010007,
      one_day_volume_change: 0.4316110000000002,
      seven_day_volume_change: 13,
      thirty_day_volume_change: 19,
      total_sales: 27071,
      one_day_sales: 11,
      seven_day_sales: 38,
      thirty_day_sales: 182,
      total_average_price: 1.234529397369063,
      one_day_average_price: 0.48869163636363633,
      seven_day_average_price: 0.4677182368421051,
      thirty_day_average_price: 0.5613824119785719,
    },
    contracts: [
      {
        contract_address: "0x4e1f41613c9084fdb9e34e11fae9412427480e56",
      },
    ],
    id: 149,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:15:41.009Z",
    key: "melissa-wiederrecht-cosmic-rays-verse",
    name: "Melissa Wiederrecht - Cosmic Rays (Verse)",
    description:
      "This is an entirely generative piece that was created using p5.js and GLSL. Each iteration is an artist's rendition of what could possibly have been happening in some random corner of the universe while it was being formed.",
    exchange_url:
      "https://opensea.io/collection/melissa-wiederrecht-cosmic-rays-verse",
    external_url:
      "https://verse.works/exhibitions/odysseys-melissa-wiederrecht",
    banner_image_url:
      "https://i.seadn.io/gcs/files/33e4ea4016ca2c84c5868d6ccfe12f28.jpg?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/042b68d0698a8a1bfa7a7a4178911add.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 9.3833,
      num_owners: 305,
      floor_price: 0.022999,
      floor_price_symbol: "ETH",
      total_minted: 305,
      total_supply: null,
      total_volume: 38.2148950794976,
      one_day_volume: 0,
      seven_day_volume: 0.0103,
      thirty_day_volume: 0.0103,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: -9,
      total_sales: 230,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 1,
      total_average_price: 0.1661517177369461,
      one_day_average_price: 0,
      seven_day_average_price: 0.0103,
      thirty_day_average_price: 0.0103,
    },
    contracts: [
      {
        contract_address: "0x361e2654cf7f51a58e74f97b2bd663591da42a88",
      },
    ],
    id: 150,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:18:11.772Z",
    key: "plq",
    name: "Meebugs",
    description: null,
    exchange_url: "https://opensea.io/collection/plq",
    external_url: "https://opensea.io/collection/plq",
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url: null,
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 139,
      floor_price: 0.0025,
      floor_price_symbol: "ETH",
      total_minted: 139,
      total_supply: null,
      total_volume: 0.7528989999999999,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 23,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.03273473913043478,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x3b400259b6e8d003c9973a79fb9828fba9fb87a0",
      },
    ],
    id: 151,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:18:33.389Z",
    key: "legionnaires",
    name: "Satoshiverse - Satoshi's Legions - The Legionnaires",
    description:
      'The original avatar collection for the Satoshiverse and Legions 2029 game!\n\nHolding a Legionnaire grants you perks within the Legions 2029 game such as additional "Luck" and the ability to passively accumulate Satoshi\'s Crystals by opting in.\n\nTo learn more about Legions and the Satoshiverse please visit the links below.\n\nSatoshiverse Website: https://www.satoshiverse.io\n\nLegions 2029 Website: https://www.legions2029.com/\n\nTwitter: https://twitter.com/Satoshiverse_io\n\nDiscord: https://discord.gg/Satoshiverse',
    exchange_url: "https://opensea.io/collection/legionnaires",
    external_url: "https://www.satoshiverse.io/launch",
    banner_image_url:
      "https://i.seadn.io/gcs/files/b3dfb11570e71fd6f6dea2345b0c5891.gif?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/yS1oVe9y1FqlKYK33GCuzQUBwuIZtwVMLU1pRvHN8t7adZl-ro3hhWpfW2P-wXj6tXb8WBznV9EnK0Bd8zpJ6ERWQQcr4S7Z6M3z?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/yS1oVe9y1FqlKYK33GCuzQUBwuIZtwVMLU1pRvHN8t7adZl-ro3hhWpfW2P-wXj6tXb8WBznV9EnK0Bd8zpJ6ERWQQcr4S7Z6M3z?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/Y7iS6mbyvnItzi5pktWrcyTboLaxofwcSB5qvOgy3q1IJGJ1OxWM2ORiUxONI0iJLkw10WgCoR26_ptOSB8hMyVHdPbr947cRx3LRzA?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/satoshiverse",
    telegram_url: null,
    twitter_username: "satoshiverse_io",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 206.31999199999998,
      num_owners: 1211,
      floor_price: 0.007799,
      floor_price_symbol: "ETH",
      total_minted: 1211,
      total_supply: null,
      total_volume: 394.8990868584681,
      one_day_volume: 0.022888,
      seven_day_volume: 0.22288799999999998,
      thirty_day_volume: 0.344466,
      one_day_volume_change: -0.177112,
      seven_day_volume_change: 3,
      thirty_day_volume_change: -1,
      total_sales: 2649,
      one_day_sales: 3,
      seven_day_sales: 6,
      thirty_day_sales: 14,
      total_average_price: 0.14907477797601665,
      one_day_average_price: 0.007629333333333333,
      seven_day_average_price: 0.037147999999999994,
      thirty_day_average_price: 0.024604714285714285,
    },
    contracts: [
      {
        contract_address: "0x5041a99684d38e280e4b0b356185bf18c991f88b",
      },
    ],
    id: 152,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:21:07.890Z",
    key: "borpacasso",
    name: "Borpacasso",
    description:
      'The Modern Museum of Borpa presents, "Picasso x Borpa." This innovative NFT art series seamlessly blends the iconic styles of Pablo Picasso with the playful and irreverent spirit of the Borpa meme, resulting in a truly one-of-a-kind art experience. By combining elements of fine art and crypto culture, the MoMB challenges traditional art forms and pushes the boundaries of what is considered "art." Through the lens of Picasso\'s avant-garde cubism, the Borpa meme is elevated to new heights, showcasing the power of internet-generated art forms. The Borpacasso collection offers art enthusiasts the opportunity to own a piece of history, as the lines between fine art and meme culture continue to blur.\n\nSalvador Borpi: https://opensea.io/collection/salvador-borpi\n \nAndy Borphol: https://opensea.io/collection/andy-borphol\n\nVincent Van Borp: https://opensea.io/collection/vincent-van-borp ',
    exchange_url: "https://opensea.io/collection/borpacasso",
    external_url: "https://borpa.art/",
    banner_image_url:
      "https://i.seadn.io/gae/cPgU4DR8XW-ljHmBvJKPuhfuBAgW-vpysUlH90Sw8rAPJY6HUk29C4AcR9X3chlmhrIdZeLYZr3eu7V9mZ3z6qrWwTtLayoqipU0Mg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/IVnu5HJoa7buI1gmbFe_XVAClsJ-iyZ5XYy_ndHAAAxH6OkBfEUL_VADGBvFH7_CcczqjRA3dUnGZuombhsvdG2A1yuFVnD9kpSLLA?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/IVnu5HJoa7buI1gmbFe_XVAClsJ-iyZ5XYy_ndHAAAxH6OkBfEUL_VADGBvFH7_CcczqjRA3dUnGZuombhsvdG2A1yuFVnD9kpSLLA?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/IVnu5HJoa7buI1gmbFe_XVAClsJ-iyZ5XYy_ndHAAAxH6OkBfEUL_VADGBvFH7_CcczqjRA3dUnGZuombhsvdG2A1yuFVnD9kpSLLA?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/ekKw5Ay23j",
    telegram_url: null,
    twitter_username: "MoMBGallery",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 21.4214,
      num_owners: 1099,
      floor_price: 0.009348,
      floor_price_symbol: "ETH",
      total_minted: 1099,
      total_supply: null,
      total_volume: 1952.4273083018893,
      one_day_volume: 0.0286,
      seven_day_volume: 0.0286,
      thirty_day_volume: 0.032299999999999995,
      one_day_volume_change: 0.0286,
      seven_day_volume_change: 2,
      thirty_day_volume_change: -13,
      total_sales: 4651,
      one_day_sales: 3,
      seven_day_sales: 3,
      thirty_day_sales: 4,
      total_average_price: 0.4197865638146397,
      one_day_average_price: 0.009533333333333333,
      seven_day_average_price: 0.009533333333333333,
      thirty_day_average_price: 0.008074999999999999,
    },
    contracts: [
      {
        contract_address: "0x370108cf39555e561353b20ecf1eaae89beb72ce",
      },
    ],
    id: 153,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:20:41.498Z",
    key: "revenants-by-alethea-ai",
    name: "Revenants by Alethea AI",
    description:
      "The Revenants are the world's first Intelligent Collectibles.\r\n\r\nOne hundred intelligent NFTs (iNFTs), depicting historical and cultural icons, reborn. From Nikola Tesla to Napoleon to Cleopatra, the world’s greatest minds are now brought to life as Intelligent NFTs. iNFTs are a powerful new medium that not only seek to advance the utilities of NFTs but also unlock new economic, creative, and social possibilities. The Revenants are the first iNFTs on Noah’s Ark, an Intelligent Metaverse created by Alethea AI.\r\n\r\nTOS: https://alethea.ai/revenants",
    exchange_url: "https://opensea.io/collection/revenants-by-alethea-ai",
    external_url: "https://alethea.ai/",
    banner_image_url:
      "https://i.seadn.io/gae/J74rBgSDQI0bKibliYKGoX7nTYgeRPMIPVxYilUTBOj8aaShSmFRHPYmk-UfbtCG4s49HCpxx5UPWW3w7YPwpWkDJDhYo0uh_T65?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/kblpDV-4HBZNwbLyzAfl0lbotAjBLy1hRLpnbI9ijDGpVFA-adAcVXvD1jPLVkdVmZS97ZegA3nqEMnZ83b7RmoCsl21iSIvTiwM8Q?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/kblpDV-4HBZNwbLyzAfl0lbotAjBLy1hRLpnbI9ijDGpVFA-adAcVXvD1jPLVkdVmZS97ZegA3nqEMnZ83b7RmoCsl21iSIvTiwM8Q?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/l83Ga13cRv53TOuLzPji49oyCQ2SZW4e2e7gp4CNC2R0w82Y3JoYS6JvkKMe4TJnLdWCkydZrNoXTyUH05iN39M7grHnJSGbDXLVKwQ?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/aletheaai",
    telegram_url: "https://t.me/alethea_ai",
    twitter_username: "real_alethea",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 52,
      num_owners: 70,
      floor_price: 0.88795,
      floor_price_symbol: "ETH",
      total_minted: 70,
      total_supply: null,
      total_volume: 2898.8839231746074,
      one_day_volume: 0,
      seven_day_volume: 0.52,
      thirty_day_volume: 1.54,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: -3,
      total_sales: 147,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 2,
      total_average_price: 19.72029879710617,
      one_day_average_price: 0,
      seven_day_average_price: 0.52,
      thirty_day_average_price: 0.77,
    },
    contracts: [
      {
        contract_address: "0xc2d6b32e533e7a8da404abb13790a5a2f606ad75",
      },
    ],
    id: 154,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:20:35.409Z",
    key: "clementmor1-oe",
    name: "Clementmor1 OE",
    description: null,
    exchange_url: "https://opensea.io/collection/clementmor1-oe",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url: null,
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 327,
      floor_price: 0.01664940004000001,
      floor_price_symbol: "ETH",
      total_minted: 327,
      total_supply: null,
      total_volume: 4.801099999999999,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 62,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.07743709677419354,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x996cbac199217a1212fc7b4591a1d8956ca8ab17",
      },
    ],
    id: 155,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:20:27.939Z",
    key: "pursuit-by-per-kristian-stoveland",
    name: "Pursuit by Per Kristian Stoveland",
    description: null,
    exchange_url:
      "https://opensea.io/collection/pursuit-by-per-kristian-stoveland",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/646c90f900c8a98c6201e38db605db7a.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/0c6c2ee5d63fab9b0a3921872b9eaa6b.png?w=500&auto=format",
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/0c6c2ee5d63fab9b0a3921872b9eaa6b.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/aoicommunity",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 35.1,
      num_owners: 116,
      floor_price: 0.23985820000000005,
      floor_price_symbol: "ETH",
      total_minted: 116,
      total_supply: null,
      total_volume: 356.6060585449992,
      one_day_volume: 0.175,
      seven_day_volume: 0.351,
      thirty_day_volume: 1.5700787999999999,
      one_day_volume_change: -0.001000000000000001,
      seven_day_volume_change: -2,
      thirty_day_volume_change: -2,
      total_sales: 372,
      one_day_sales: 1,
      seven_day_sales: 2,
      thirty_day_sales: 8,
      total_average_price: 0.9586184369489226,
      one_day_average_price: 0,
      seven_day_average_price: 0.1755,
      thirty_day_average_price: 0.19625984999999999,
    },
    contracts: [
      {
        contract_address: "0x8cdbd7010bd197848e95c1fd7f6e870aac9b0d3c",
      },
    ],
    id: 156,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:19:55.229Z",
    key: "digi-dorkz-1",
    name: "Digi Dorkz",
    description: "by dorkz, for dorkz. 🤓 ",
    exchange_url: "https://opensea.io/collection/digi-dorkz-1",
    external_url: "http://www.dorkz.xyz",
    banner_image_url:
      "https://i.seadn.io/s/raw/files/44de59d485097f09ecc3287fa3d74019.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/3dbedb58916a5dfbf9a5073bd1673566.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/3dbedb58916a5dfbf9a5073bd1673566.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/2a6a50aecb73d5dd45f2a56ec5f6295f.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/5mJEh9Ngz6",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 728,
      floor_price: 0.0001,
      floor_price_symbol: "ETH",
      total_minted: 728,
      total_supply: null,
      total_volume: 15.73402379777998,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 1617,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.009730379590463809,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x99a14fa2a0e0bd22dd224dd746cfc4ed56ad66b4",
      },
    ],
    id: 157,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:19:35.210Z",
    key: "nth-culture-by-fingacode",
    name: "nth culture by fingacode",
    description: null,
    exchange_url: "https://opensea.io/collection/nth-culture-by-fingacode",
    external_url: "https://brightmoments.io/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/e83b4bb1dd28e9c328e5e5ea4b9141b0.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/OsEZgUvLUT0fmAauN8j_BXEQtlyS8nN0vbectmxFLma0WEI9K2z4kqdb0QG5DarW3HoJ2M65zcMW_SgQ6XhWU-TKca8mTcAO1IYU66k?w=500&auto=format",
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/OsEZgUvLUT0fmAauN8j_BXEQtlyS8nN0vbectmxFLma0WEI9K2z4kqdb0QG5DarW3HoJ2M65zcMW_SgQ6XhWU-TKca8mTcAO1IYU66k?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 48,
      floor_price: 0.171,
      floor_price_symbol: "ETH",
      total_minted: 48,
      total_supply: null,
      total_volume: 74.05110000000002,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 49,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 1.5112469387755105,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x0a1bbd57033f57e7b6743621b79fcb9eb2ce3676",
      },
    ],
    id: 158,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:22:20.268Z",
    key: "karma-llamacatacorn",
    name: "Karma-Llamacatacorn",
    description: null,
    exchange_url: "https://opensea.io/collection/karma-llamacatacorn",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url: null,
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 0.02,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x5732225daf8dc6dcdabed2e0ce6796128a2958e0",
      },
    ],
    id: 159,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:22:59.473Z",
    key: "7sclub",
    name: "7sClub Official",
    description:
      "7sClub is an Artist Founded project that plans to push the limits of an irl brand with monthly limited edition clothing drops, irl pop up shops, mystery boxes, and a lot more. Each one unique from the next on the ETH blockchain.",
    exchange_url: "https://opensea.io/collection/7sclub",
    external_url: "https://www.7sclub.io/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/a14b6a92d78de30072ead4317f882caa.jpg?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/bd1ed94a9dab6637df87e4408f04ace0.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/7sClubNFT",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 811,
      floor_price: 0.00547,
      floor_price_symbol: "ETH",
      total_minted: 811,
      total_supply: null,
      total_volume: 67.40689099999702,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 1802,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.037406709766923986,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x0d51e692be786b8dfd0620b0286e1f45e75b4d28",
      },
    ],
    id: 160,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:23:36.249Z",
    key: "torquesquad",
    name: "Torque Squad",
    description:
      "Torque Squad is a collection of 8,888 racing avatars by Animoca Brands, which act as the entry point to the Motorverse ecosystem. This is your personal mark, your fingerprint and your race license.\r\n\r\nThe 'Torqies' offer true utility across multiple areas in both the ‘real and virtual worlds.’ Holders gain access to exclusive events, streetwear, games, future drops and more.\r\n\r\nTorqies... start your engines!",
    exchange_url: "https://opensea.io/collection/torquesquad",
    external_url: "http://torquesquad.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/912a5780deeef3a1d201dcb179bafc81.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/Q8Jb3nSUygz7WQYk4qhDUQCkKNbh4HV5Slk-fsvTpE0XrFQVyYF88JpI1icTHgowWIkKvC_lug1Uxqhg33ubY1ER1YEwfYTUn7FtGgQ?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/Q8Jb3nSUygz7WQYk4qhDUQCkKNbh4HV5Slk-fsvTpE0XrFQVyYF88JpI1icTHgowWIkKvC_lug1Uxqhg33ubY1ER1YEwfYTUn7FtGgQ?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/134edeff396521c3510f5471b494e03d.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/4kThHKuGvF",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "torquesquad.eth",
    stats: {
      market_cap: 109.7668,
      num_owners: 940,
      floor_price: 0.019952,
      floor_price_symbol: "ETH",
      total_minted: 940,
      total_supply: null,
      total_volume: 121.19009064211662,
      one_day_volume: 0,
      seven_day_volume: 0.0247,
      thirty_day_volume: 0.277861,
      one_day_volume_change: 0,
      seven_day_volume_change: -9,
      thirty_day_volume_change: 12,
      total_sales: 1833,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 20,
      total_average_price: 0.06611570684239859,
      one_day_average_price: 0,
      seven_day_average_price: 0.01235,
      thirty_day_average_price: 0.01389305,
    },
    contracts: [
      {
        contract_address: "0xfa17e965a740ade5a58224072e236899bb453bd0",
      },
    ],
    id: 161,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:23:48.371Z",
    key: "thealcabones",
    name: "Al Cabones",
    description:
      "Al Cabones, a network of organized crime groups based in the blockchain. The collection consists of 10,000 wanted skeleton mobsters each carrying their own history of ruthless crime. Following their escape, they chose to enter and hide away in the blockchain where they plan to create even more chaos. \nIt’s about time the Mayhem has come to the Metaverse, right?",
    exchange_url: "https://opensea.io/collection/thealcabones",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/719e0d939796375574433aed2f44b912.png?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/b05616447a381430027704730d941ce9.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/y4ZbyVP4tm",
    telegram_url: null,
    twitter_username: "alcabonesNFT",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 146.41733333333332,
      num_owners: 3587,
      floor_price: 0.0054,
      floor_price_symbol: "ETH",
      total_minted: 3587,
      total_supply: null,
      total_volume: 6073.537382026614,
      one_day_volume: 0,
      seven_day_volume: 0.044,
      thirty_day_volume: 0.049499999999999995,
      one_day_volume_change: 0,
      seven_day_volume_change: 3,
      thirty_day_volume_change: 2,
      total_sales: 16862,
      one_day_sales: 0,
      seven_day_sales: 3,
      thirty_day_sales: 4,
      total_average_price: 0.3601908066674543,
      one_day_average_price: 0,
      seven_day_average_price: 0.014666666666666666,
      thirty_day_average_price: 0.012374999999999999,
    },
    contracts: [
      {
        contract_address: "0x8ca5209d8cce34b0de91c2c4b4b14f20aff8ba23",
      },
    ],
    id: 162,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:24:03.849Z",
    key: "jogadores-futebol-2025",
    name: "Jogadores Futebol 2025",
    description:
      "Acolhedora e cálida, assim nos recebe, Com produtos de excelência, que a todos comove. Diversidade e qualidade, sempre em harmonia, Transformam cada visita numa grata alegria.",
    exchange_url: "https://opensea.io/collection/jogadores-futebol-2025",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/s/raw/files/0488079cfc5662b197470a4cb9ad5c04.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 100,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x506d774cf5743c4e3d3bc8dd0571ef8362db7b52",
      },
    ],
    id: 163,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:24:03.455Z",
    key: "og-baby-moose",
    name: "OG Baby Moose",
    description:
      "OG Baby Moose is a 677 collection by DoYouMoose. These OG Baby Moose have taken a detour from Moxie Meadows to pursue new adventures.",
    exchange_url: "https://opensea.io/collection/og-baby-moose",
    external_url: "https://doyoumoose.com/",
    banner_image_url:
      "https://i.seadn.io/s/raw/files/49329648f36ade74bfa2942941ed7e88.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/af2d391a4285987ef83c8ca1e8315282.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/af2d391a4285987ef83c8ca1e8315282.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/8ae6a5388613f5eb5b00b3e9dfbec07b.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/pwRmhydE5x",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 8.018442857142857,
      num_owners: 208,
      floor_price: 0.043898,
      floor_price_symbol: "ETH",
      total_minted: 208,
      total_supply: null,
      total_volume: 5.09213648241206,
      one_day_volume: 0,
      seven_day_volume: 0.0839,
      thirty_day_volume: 0.0839,
      one_day_volume_change: 0,
      seven_day_volume_change: 7,
      thirty_day_volume_change: 4,
      total_sales: 55,
      one_day_sales: 0,
      seven_day_sales: 7,
      thirty_day_sales: 7,
      total_average_price: 0.09258429968021926,
      one_day_average_price: 0,
      seven_day_average_price: 0.011985714285714285,
      thirty_day_average_price: 0.011985714285714285,
    },
    contracts: [
      {
        contract_address: "0xfe2a59eeb6829bd316d358786a02324d3e8ba903",
      },
    ],
    id: 164,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:24:23.053Z",
    key: "dimensionx",
    name: "Dimension X",
    description:
      "**Arenas are here!** There is no entry fee on these Arenas! Compete for power tokens/crafting mats! Experience new heroes **TOTALLY FREE!**",
    exchange_url: "https://opensea.io/collection/dimensionx",
    external_url: "https://dimensionxnft.com/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/3cc47ef545e3ee3f33a476bf19a9f08a.gif?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/28280dd8c26f0e75722de682928eedb1.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/28280dd8c26f0e75722de682928eedb1.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/abab7bd6771be121e9036b09af2ae6cb.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/dimensionx",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 80.04782322580648,
      num_owners: 1898,
      floor_price: 0.0015,
      floor_price_symbol: "ETH",
      total_minted: 1898,
      total_supply: null,
      total_volume: 475.9403095079292,
      one_day_volume: 0.003,
      seven_day_volume: 0.13404000000000005,
      thirty_day_volume: 0.2408900000000001,
      one_day_volume_change: -0.0093,
      seven_day_volume_change: -2,
      thirty_day_volume_change: -8,
      total_sales: 12139,
      one_day_sales: 1,
      seven_day_sales: 31,
      thirty_day_sales: 86,
      total_average_price: 0.039207538471696946,
      one_day_average_price: 0,
      seven_day_average_price: 0.004323870967741937,
      thirty_day_average_price: 0.002801046511627908,
    },
    contracts: [
      {
        contract_address: "0x8918ba30e2e76b503e83d55eb08936b0f979eec4",
      },
    ],
    id: 165,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:24:22.669Z",
    key: "rings-genesis-by-nick-kuder",
    name: "Rings Genesis by Nick Kuder",
    description:
      "The Collection that Inspired a Movement.\n\nThis iconic collection, by art professor and graphic artist Nick Kuder, is an ongoing series of artworks. It was initially created in February 2019 using a system-generating-system to create unique glyphs.\n\nThe collection is influenced by cattle brands, hobo signs, and other glyph systems. Other influences include cellular automata and biological morphologies.\n\nThe maximum number of pieces across all Series will not exceed 200.\n\nThe works and associated metadata are stored on both Arweave and IPFS.",
    exchange_url: "https://opensea.io/collection/rings-genesis-by-nick-kuder",
    external_url: "https://www.ringsgenesis.com",
    banner_image_url:
      "https://i.seadn.io/gae/xONPHkU39HRfqTDCAbk-DFJSmP26oP_CoqyjDN0FgeVOq923N7nsb2sQ2zth0TFDvLFbCVJNxdM4NgvBg63lPnHS-5xSFDTzIpuYVw4?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/dWBU_VLsQjDs7xEzEXBSVDL_7U7OFeFiAb-9NV-CPJYa40zcwKTa_JPzzGMdj2S8_xMQdOAWA81XrodP39TN5p2kLf45va_bfTa8BA?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/dWBU_VLsQjDs7xEzEXBSVDL_7U7OFeFiAb-9NV-CPJYa40zcwKTa_JPzzGMdj2S8_xMQdOAWA81XrodP39TN5p2kLf45va_bfTa8BA?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/py1h2S0NkDzkpTfbqugz3YgP4UG-vKDNrKwQ3V5gXkH1rqwyOkpL3NiT1EFjll33KZ3h0DBnkwyv9inUbv1xAPJUuyWO8SRJzeLGtXs?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: "ringsgenesis",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 47,
      floor_price: 1.39295,
      floor_price_symbol: "ETH",
      total_minted: 47,
      total_supply: null,
      total_volume: 789.8038054612617,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 96,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 8.22712297355481,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x4426391e8d7d191d867ae19842a74464c0f22afc",
      },
    ],
    id: 166,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:24:18.554Z",
    key: "brawler-bearz",
    name: "Brawler Bearz",
    description:
      "The Brawler Bearz (4,169 supply / 72% staked) is an animated pixel NFT. It is the 1st on-chain dynamic NFT (dNFT) w/ equipable ERC1155 items. The platform utility includes staking for $CREDIT, training for XP, questing for item drops, and battles. Each aspect of utility leverages and changes the Bearz metadata. \n\nEquip your Bear with Items from Max's Shop: https://opensea.io/collection/brawler-bearz-shop\n",
    exchange_url: "https://opensea.io/collection/brawler-bearz",
    external_url: "https://brawlerbearz.club/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/7b8f9ef0367cbb8acca79f790d6c3949.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/13a4376a67ad6b020e239b3852f193c7.gif?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/13a4376a67ad6b020e239b3852f193c7.gif?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/0c60facb88a0601a07de92a59a23ba9a.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/brawlerbearz",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 21.737776097560978,
      num_owners: 1351,
      floor_price: 0.004679,
      floor_price_symbol: "ETH",
      total_minted: 1351,
      total_supply: null,
      total_volume: 457.1547993901577,
      one_day_volume: 0.0138,
      seven_day_volume: 0.21378000000000003,
      thirty_day_volume: 10.679640999999998,
      one_day_volume_change: 0.01,
      seven_day_volume_change: -395,
      thirty_day_volume_change: 400,
      total_sales: 11081,
      one_day_sales: 3,
      seven_day_sales: 41,
      thirty_day_sales: 715,
      total_average_price: 0.04125573498692877,
      one_day_average_price: 0.0046,
      seven_day_average_price: 0.005214146341463415,
      thirty_day_average_price: 0.014936560839160838,
    },
    contracts: [
      {
        contract_address: "0x556697ca91476b811f37a851dd2e53ae4c6024db",
      },
    ],
    id: 167,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:25:56.215Z",
    key: "milady-aura2-after-death",
    name: "MILADY AURA2 AFTER DEATH",
    description:
      "In twilight's hush, Milady once bloomed,\nAmidst whispered tales, her presence loomed.\nYet fate's cruel whisper stole her breath away,\nHer essence soared beyond night's astral fray.\n\nIn whispered sighs, her name still rings,\nA ghostly dance where memory sings.\nShe morphed into an ethereal sight,\nAn aura of grace, a celestial light.\n\nHer laughter echoes in the cosmic breeze,\nAmongst stardust and celestial seas.\nShe floats, an essence pure and free,\nIn the boundless embrace of eternity.\n\nGone from sight, but not from soul's embrace,\nMilady, an aura, in infinite space.\nA mystic tale of beauty's flight,\nHer essence now a starry night.",
    exchange_url: "https://opensea.io/collection/milady-aura2-after-death",
    external_url: null,
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/28dfbd00b0329a34cbed22d99239b4e7.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/28dfbd00b0329a34cbed22d99239b4e7.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/5edee5ac2fd05e1915ab4c28553b0446.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 297,
      floor_price: 0.018933600160614093,
      floor_price_symbol: "ETH",
      total_minted: 297,
      total_supply: null,
      total_volume: 5.170105199516981,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 269,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.019219721931289895,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x30f9efa712dde239a13a5fef1a8c7a6ac530a26d",
      },
    ],
    id: 168,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:25:48.396Z",
    key: "riptcgs",
    name: "RIP TCG VAULTS",
    description:
      "RIP TCG is a digital trading card game in early development at DFZ LABS. A fast, brutal evolution of the digital TCG experience & web3 enabled gaming.",
    exchange_url: "https://opensea.io/collection/riptcgs",
    external_url: "https://riptcg.deadfellaz.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/ac203565de67b1d46906daf8dcee23c5.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/ac203565de67b1d46906daf8dcee23c5.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/ac203565de67b1d46906daf8dcee23c5.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/2248aaaef63ccd433f8975810ecda18d.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 13.849422631578948,
      num_owners: 911,
      floor_price: 0.01,
      floor_price_symbol: "ETH",
      total_minted: 911,
      total_supply: null,
      total_volume: 6.406556599982723,
      one_day_volume: 0,
      seven_day_volume: 0.059066,
      thirty_day_volume: 0.09228900000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 17,
      thirty_day_volume_change: 16,
      total_sales: 444,
      one_day_sales: 0,
      seven_day_sales: 19,
      thirty_day_sales: 25,
      total_average_price: 0.01442918153149262,
      one_day_average_price: 0,
      seven_day_average_price: 0.003108736842105263,
      thirty_day_average_price: 0.00369156,
    },
    contracts: [
      {
        contract_address: "0xf39e0064942cb5ba0623381dda3056fede56df55",
      },
    ],
    id: 169,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:25:44.228Z",
    key: "wrapped-cryptopunks",
    name: "Wrapped Cryptopunks",
    description:
      "Wrapped Punks are ERC721 Tokens, each one backed 1:1 by an original Cryptopunk by Larvalabs.\r\n\r\nBuy an original Cryptopunk at https://larvalabs.com/cryptopunks\r\n\r\nTurn your Original Cryptopunk into an ERC721 at https://wrappedpunks.com/\r\n\r\nCryptoPunks launched as a fixed set of 10,000 items in mid-2017 and became one of the inspirations for the ERC-721 standard.",
    exchange_url: "https://opensea.io/collection/wrapped-cryptopunks",
    external_url: "https://wrappedpunks.com/",
    banner_image_url:
      "https://storage.googleapis.com/opensea-prod.appspot.com/static/banners/wrapped-banner2.png",
    featured_image_url:
      "https://i.seadn.io/gae/pGU54BaIe5k4I_zsAt7j3mZaLLPDbRHzPqjPDOubQc_hyHw7T7lnGb8x3ce0O9NX3qYYD887BMZ3uvrbL1JJQU2g3Q?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/pGU54BaIe5k4I_zsAt7j3mZaLLPDbRHzPqjPDOubQc_hyHw7T7lnGb8x3ce0O9NX3qYYD887BMZ3uvrbL1JJQU2g3Q?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/e0972d771af4d633e70e00338aa38e34.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/Bvf5m9k",
    telegram_url: "",
    twitter_username: "arkgalleryDAO",
    wiki_url: "",
    instagram_username: "",
    stats: {
      market_cap: 0,
      num_owners: 139,
      floor_price: 43,
      floor_price_symbol: "ETH",
      total_minted: 139,
      total_supply: null,
      total_volume: 355442.41445183725,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 192.17000000000002,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 7523,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 5,
      total_average_price: 47.247429808831214,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 38.434000000000005,
    },
    contracts: [
      {
        contract_address: "0xb7f7f6c52f2e2fdb1963eab30438024864c313f6",
      },
    ],
    id: 170,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:25:42.611Z",
    key: "cryptopunks",
    name: "CryptoPunks",
    description:
      "CryptoPunks launched as a fixed set of 10,000 items in mid-2017 and became one of the inspirations for the ERC-721 standard. They have been featured in places like The New York Times, Christie’s of London, Art|Basel Miami, and The PBS NewsHour.",
    exchange_url: "https://opensea.io/collection/cryptopunks",
    external_url: "https://cryptopunks.app/",
    banner_image_url:
      "https://i.seadn.io/s/primary-drops/0xb47e3cd837ddf8e4c57f05d70ab865de6e193bbb/2563:about:media:70594573-20b8-4f3d-b535-716084978052.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/0xb47e3cd837ddf8e4c57f05d70ab865de6e193bbb-featured-1556589448.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/QB2kKuQEw04X02V9EoC2BNYZV652LYuewUv9ZdR7KJfI9Jocwmd28jIfsGg0umSCr2bOMV8O9UpLAkoaqfYwvwmC?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/BdxvLseXcfl57BiuQcQYdJ64v-aI8din7WPk0Pgo3qQFhAUH-B6i-dCqqc_mCkRIzULmwzwecnohLhrcH8A9mpWIZqA7ygc52Sr81hE?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/tQp4pSE",
    telegram_url: "",
    twitter_username: "cryptopunksnfts",
    wiki_url: "",
    instagram_username: "",
    stats: {
      market_cap: 443960.6455090909,
      num_owners: 3866,
      floor_price: 0,
      floor_price_symbol: null,
      total_minted: 3866,
      total_supply: null,
      total_volume: 1332579.6168893138,
      one_day_volume: 160.4749,
      seven_day_volume: 977.2998,
      thirty_day_volume: 8100.454900099997,
      one_day_volume_change: -1,
      seven_day_volume_change: -23,
      thirty_day_volume_change: 40,
      total_sales: 25985,
      one_day_sales: 4,
      seven_day_sales: 22,
      thirty_day_sales: 169,
      total_average_price: 51.2826483313186,
      one_day_average_price: 40.118725,
      seven_day_average_price: 44.42271818181818,
      thirty_day_average_price: 47.931685799408264,
    },
    contracts: [
      {
        contract_address: "0xb47e3cd837ddf8e4c57f05d70ab865de6e193bbb",
      },
    ],
    id: 171,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:25:27.491Z",
    key: "sadgirlsbar",
    name: "Sad Girls Bar",
    description:
      "[Skeletongues](https://opensea.io/collection/skeletongues) | [The Sad Cats](https://opensea.io/collection/thesadcats) | [Collabs](https://opensea.io/collection/sadgirlsbar-collabs)\n\nHand-drawn, monochrome, and stylish Sad Girls were created by female artist Glam Beckett.\n10000 gently curated ERC721 NFT worthy to fall in love.\n\nOfficial Sad Girl’s companions: [Skeletongues](https://opensea.io/collection/skeletongues)",
    exchange_url: "https://opensea.io/collection/sadgirlsbar",
    external_url: "https://sadgirlsbar.io",
    banner_image_url:
      "https://i.seadn.io/gae/pWkki76UOGU7lxTYxRthRFcjWuFPdGzniOLiDQfuvSeUJcneQLaF0rvfI6TXiNDrmV9F2RbKrviwat276Z258dqOyHTWRMUrtlCm8g?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/Ci3KZAOXGlIo7m6vjCNfUaBh1vLwBjWl08AQVga39QCBtRYysxfH19P7DqVYi3E5cS7cTk8w7qvUSI1zTvqs_Z2PGedzt_d_rwp2Cg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/Ci3KZAOXGlIo7m6vjCNfUaBh1vLwBjWl08AQVga39QCBtRYysxfH19P7DqVYi3E5cS7cTk8w7qvUSI1zTvqs_Z2PGedzt_d_rwp2Cg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/tDq_9Vqull9yDeWdotD818etAFEIJo8r893K-rEg_ZFTnBQGzzGAjk6SkMjrpADnmo7t0RKUE53j-uQnB72buAP0PgAB9tH6GIV9?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/aA467bQRDj",
    telegram_url: null,
    twitter_username: "sad_girls_bar",
    wiki_url: null,
    instagram_username: "sadgirlsbar",
    stats: {
      market_cap: 50.267700000000005,
      num_owners: 4612,
      floor_price: 0.0069,
      floor_price_symbol: "ETH",
      total_minted: 4612,
      total_supply: null,
      total_volume: 2464.2832561697483,
      one_day_volume: 0,
      seven_day_volume: 0.0553,
      thirty_day_volume: 0.16059700000000005,
      one_day_volume_change: 0,
      seven_day_volume_change: 8,
      thirty_day_volume_change: -56,
      total_sales: 15423,
      one_day_sales: 0,
      seven_day_sales: 11,
      thirty_day_sales: 24,
      total_average_price: 0.15977976114697195,
      one_day_average_price: 0,
      seven_day_average_price: 0.005027272727272727,
      thirty_day_average_price: 0.006691541666666669,
    },
    contracts: [
      {
        contract_address: "0x335eeef8e93a7a757d9e7912044d9cd264e2b2d8",
      },
    ],
    id: 172,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:25:23.650Z",
    key: "888innercircle",
    name: "888 inner circle",
    description:
      "8888 Editions of the Genesis NFT from 888 to celebrate the milestone of 88.8K followers on Twitter.\r\nHolding this token will give the owner Airdrops, early access to all 888 drops, early access to curated drops and various other benefits\r\n\r\nOfficial Drop Collection\r\nhttps://opensea.io/collection/888innercirclethedrops",
    exchange_url: "https://opensea.io/collection/888innercircle",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gae/ZiOyFYFSAgA-q9b6CtK9qJ-Z2shwldKyKzDAjopUNAL0aB5TKyVynjeptsybUx59t7D3yd7JvMTXXHatDybQb0WbF4BXdTPgweqTNyM?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/pnJeSudJAfhAinecDqcM4-VJ-u4LbdIXeoJdZ-y0PqtDzvNF7qDK8aUXn9duCUyMGLtgS_J04D9-wLlqgZKei931ZdQ59bbJMPZpcg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/pnJeSudJAfhAinecDqcM4-VJ-u4LbdIXeoJdZ-y0PqtDzvNF7qDK8aUXn9duCUyMGLtgS_J04D9-wLlqgZKei931ZdQ59bbJMPZpcg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/pnJeSudJAfhAinecDqcM4-VJ-u4LbdIXeoJdZ-y0PqtDzvNF7qDK8aUXn9duCUyMGLtgS_J04D9-wLlqgZKei931ZdQ59bbJMPZpcg?w=500&auto=format",
    chat_url: null,
    discord_url: "http://discord.gg/888ic",
    telegram_url: null,
    twitter_username: "crypto888crypto",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0.003188888888888889,
      num_owners: 2032,
      floor_price: 0.0098,
      floor_price_symbol: "ETH",
      total_minted: 2032,
      total_supply: null,
      total_volume: 20710.089060043374,
      one_day_volume: 0,
      seven_day_volume: 0.028700000000000003,
      thirty_day_volume: 0.17790000000000003,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 14,
      total_sales: 19236,
      one_day_sales: 0,
      seven_day_sales: 9,
      thirty_day_sales: 22,
      total_average_price: 1.0766317872761164,
      one_day_average_price: 0,
      seven_day_average_price: 0.003188888888888889,
      thirty_day_average_price: 0.008086363636363638,
    },
    contracts: [
      {
        contract_address: "0x36d30b3b85255473d27dd0f7fd8f35e36a9d6f06",
      },
    ],
    id: 173,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:25:19.445Z",
    key: "real-nobody-xyz",
    name: "Nobody",
    description: "Every nobody is somebody.",
    exchange_url: "https://opensea.io/collection/real-nobody-xyz",
    external_url: "https://nobody.xyz",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/7933da435b972021a3c6b59a4265e96f.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/7933da435b972021a3c6b59a4265e96f.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/3fed00c1e0cbba036be3c8654e3abb46.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/nobodyxyz",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 491.0345454545455,
      num_owners: 2918,
      floor_price: 0.050046,
      floor_price_symbol: "ETH",
      total_minted: 2918,
      total_supply: null,
      total_volume: 16937.93036333946,
      one_day_volume: 0.101,
      seven_day_volume: 1.080276,
      thirty_day_volume: 16.387657989999965,
      one_day_volume_change: -0.09087799999999999,
      seven_day_volume_change: -98,
      thirty_day_volume_change: 120,
      total_sales: 36969,
      one_day_sales: 2,
      seven_day_sales: 22,
      thirty_day_sales: 257,
      total_average_price: 0.45816577033026207,
      one_day_average_price: 0.0505,
      seven_day_average_price: 0.04910345454545455,
      thirty_day_average_price: 0.0637652061867703,
    },
    contracts: [
      {
        contract_address: "0xa28d6a8eb65a41f3958f1de62cbfca20b817e66a",
      },
    ],
    id: 174,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:27:04.834Z",
    key: "zenapenft",
    name: "ZenApe",
    description:
      "Wisdom, virtue and mindfulness. The home of innovators who want to make the world a better place - becoming a ZenApe unlocks exclusive benefits. More than a NFT project, owning a ZenApe unlocks access to:\r\nZenTask.xyz \r\nWellness, Self-Development & Education resources\r\nFull access to the ZenApes community \r\nAnd much more\r\n\r\nOfficial Links: https://linktr.ee/zenape\r\nCreators of professional & social networking DAPP: https://zentask.xyz/ !Oohm",
    exchange_url: "https://opensea.io/collection/zenapenft",
    external_url: "https://linktr.ee/zenapenft",
    banner_image_url:
      "https://i.seadn.io/gae/oQa_Zl4rWgZN6D5BqKcdouFpfRBGvEr_iAmfCfRp1bWZVsodNZE_R1SIN_kKInyPnXSgYqPuYOVFN4AyPie0AB4p9S12jLyMe-cKAg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/oHl4g2JSiVAez047AmYFkhG3CMFYFzRdvrdIptFfs_YlcbluSUzpWd8pNAjzWN1QnUg4j2pTUOg_n5JeoAeB0UC0q2CQZvHEcTTy?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/oHl4g2JSiVAez047AmYFkhG3CMFYFzRdvrdIptFfs_YlcbluSUzpWd8pNAjzWN1QnUg4j2pTUOg_n5JeoAeB0UC0q2CQZvHEcTTy?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/nQoqkJdwxQMxFeA9bcSS6xzCLkliYmd_-0SUwtiNobA8RknKCFTMQsZFyOQvbmfAnNroy2MuwzJKSWS6nUIv8UYgIMRgiP4Qm6r2wok?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/7Su2yMuzzG",
    telegram_url: null,
    twitter_username: "ZenApeNFT",
    wiki_url: null,
    instagram_username: "ZenApeNFT",
    stats: {
      market_cap: 21.840367894736843,
      num_owners: 2166,
      floor_price: 0.0045,
      floor_price_symbol: "ETH",
      total_minted: 2166,
      total_supply: null,
      total_volume: 3008.6194045671928,
      one_day_volume: 0.0184,
      seven_day_volume: 0.08301,
      thirty_day_volume: 0.15348799999999999,
      one_day_volume_change: -0.019219,
      seven_day_volume_change: 12,
      thirty_day_volume_change: 11,
      total_sales: 11998,
      one_day_sales: 4,
      seven_day_sales: 19,
      thirty_day_sales: 32,
      total_average_price: 0.2507600770601094,
      one_day_average_price: 0.0046,
      seven_day_average_price: 0.004368947368421053,
      thirty_day_average_price: 0.0047965,
    },
    contracts: [
      {
        contract_address: "0x838804a3dd7c717396a68f94e736eaf76b911632",
      },
    ],
    id: 175,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:27:00.709Z",
    key: "boardrooms",
    name: "BoardRooms",
    description:
      "After a successful Nifty Gateway drop last December, RareBoards is back with BoardRooms - new dArtboards and dArts PLUS each open edition dArtboard unlocks an artist designed RareRoom to play the games and show off your Nifties. This time they teamed up with three of the most iconic artists in these still early days of NFTs - Alotta Money, Jon Burgerman and Trippyogi.",
    exchange_url: "https://opensea.io/collection/boardrooms",
    external_url: "https://niftygateway.com/collections/boardroomsopens",
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/_xtSxaA6efXpWchLxcU0_dcbJluLF8653G1dDYJuZR_Nb5FWgLH19XBpUSEl68-y3jY69XweMq2ghCGmqku8_7Qyg57zzgQNG4Qg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 172,
      floor_price: 0.013,
      floor_price_symbol: "ETH",
      total_minted: 172,
      total_supply: null,
      total_volume: 5.951000000000001,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 33,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.18033333333333337,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xf91b673aaf37242257618bf8b467d20adcea13ce",
      },
    ],
    id: 176,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:26:29.540Z",
    key: "cosmiclabs",
    name: "Cosmic Labs(Genesis)",
    description:
      "Website: https://chimbastudios.com/cosmic-labs\nOfficial Discord : https://discord.com/invite/chimbastudios\n\nCosmic Genesis is dedicated to fostering an art-driven community,\ncelebrating creativity and exceptional design. With its collection of\n1,000 Galactic Ducks, the project aims to inspire and unite\nindividuals who value the power of fun and unique art.\n\n",
    exchange_url: "https://opensea.io/collection/cosmiclabs",
    external_url: "https://cosmic-labs.io",
    banner_image_url:
      "https://i.seadn.io/gae/DVBKTdXX1fQlY_ubmPzAf9EJCTfifF24lI0pcPfnvx14RaPrfr8NJqO_u1SC3hXbAq2Kv2gk_UVOliFnMIoDFI9lWU-tgcB6HleSHA?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/DVBKTdXX1fQlY_ubmPzAf9EJCTfifF24lI0pcPfnvx14RaPrfr8NJqO_u1SC3hXbAq2Kv2gk_UVOliFnMIoDFI9lWU-tgcB6HleSHA?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/DVBKTdXX1fQlY_ubmPzAf9EJCTfifF24lI0pcPfnvx14RaPrfr8NJqO_u1SC3hXbAq2Kv2gk_UVOliFnMIoDFI9lWU-tgcB6HleSHA?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/gAaIagdJbMTjsh9skRwqWq_G1TQfPEMY-UNMJNnOqij6rl_EvNuEyv-B2w_dalr9smeOavXIA_DrSUa4vzFQwHBJOwLSU8hWvPS1-Q?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/cosmiclabsnft",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 497,
      floor_price: 0.04,
      floor_price_symbol: "ETH",
      total_minted: 497,
      total_supply: null,
      total_volume: 1798.0416009571327,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 2041,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.8809610979701777,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x96316355c44be69414756d6706c61e61aecbd5f3",
      },
    ],
    id: 177,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:26:21.875Z",
    key: "dope-shibas",
    name: "Dope Shibas",
    description:
      "**Dope Shibas** is a cool degenerative collection on Ethereum Mainnet and a tribute to [Cool Cats](https://opensea.io/collection/cool-cats-nft). The collection consists of 10,000 randomly generated Shibas that are assembled from 180 different items layered on top of each other",
    exchange_url: "https://opensea.io/collection/dope-shibas",
    external_url: "http://dopeshibas.fun",
    banner_image_url:
      "https://i.seadn.io/gae/15sN-z3nq5ZtZCqPImxG_NBZnD8ixgOSEyO6LqJAxCBbf74tiss80mqpKBpttC5nwDkQhgdizb4ks8LrA2NbJm4ck6L4RZaD0lDQdw?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/EaEvjLXumtfSjRi3McJrp278PnMCeTPh0io8zeMZJFpm_HnFSioLjTr1bqmvA3Eijjvd2UrmeaYetvSvOUE6gi6dOj1kkeSCFwbZ?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/EaEvjLXumtfSjRi3McJrp278PnMCeTPh0io8zeMZJFpm_HnFSioLjTr1bqmvA3Eijjvd2UrmeaYetvSvOUE6gi6dOj1kkeSCFwbZ?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/m5Uqb0aI1HUANtBIhvcQJwDxu6jM_FP1JNG5kVUVMt-PaY-pH5s1COR3EGuOYR-u2wZQi9a_mRluvyp_FuirdWdykOybFbl-JB7eNw?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/6k5uQdKgqA",
    telegram_url: null,
    twitter_username: "dopeshibas",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 9.839000000000006,
      num_owners: 4032,
      floor_price: 0.004,
      floor_price_symbol: "ETH",
      total_minted: 4032,
      total_supply: null,
      total_volume: 1663.7598182638278,
      one_day_volume: 0,
      seven_day_volume: 0.01800000000000001,
      thirty_day_volume: 0.01900000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 17,
      thirty_day_volume_change: 17,
      total_sales: 12376,
      one_day_sales: 0,
      seven_day_sales: 18,
      thirty_day_sales: 19,
      total_average_price: 0.13443437445570683,
      one_day_average_price: 0,
      seven_day_average_price: 0.001000000000000001,
      thirty_day_average_price: 0.001000000000000001,
    },
    contracts: [
      {
        contract_address: "0x763864f1a74d748015f45f7c1181b60e62e40804",
      },
    ],
    id: 178,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:27:53.155Z",
    key: "cryptodickbuttss4",
    name: "Gooch Island Passport",
    description:
      "It's all over forever it's a new dawn. Keep away from children.",
    exchange_url: "https://opensea.io/collection/cryptodickbuttss4",
    external_url: "http://cryptodickbutts.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/3704c2260d4bcea269801be0b723da17.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/eb26bdd40f47861ad97a70aacaa52aa8.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/eb26bdd40f47861ad97a70aacaa52aa8.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/9ba06b1b6fccab7c9c092be2e9e12efc.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 529,
      floor_price: 0.03843280008020401,
      floor_price_symbol: "ETH",
      total_minted: 529,
      total_supply: null,
      total_volume: 55.98121294406646,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.32320000000000004,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -73,
      total_sales: 1151,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 27,
      total_average_price: 0.048637022540457396,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.011970370370370373,
    },
    contracts: [
      {
        contract_address: "0x8de765d95c83a790714c53ed8a820168cab9123c",
      },
    ],
    id: 179,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:27:48.739Z",
    key: "swirlbridge1",
    name: "SwirlBridge1",
    description: null,
    exchange_url: "https://opensea.io/collection/swirlbridge1",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url: null,
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 7,
      floor_price: 7.777,
      floor_price_symbol: "ETH",
      total_minted: 7,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x1d412b81b50407b49a09d203219de7077af4271f",
      },
    ],
    id: 180,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:27:20.069Z",
    key: "palioai-aura",
    name: "PalioAI Aura",
    description:
      "The PalioAI AURA NFT Collection presents a collection of 3,333 NFTs, each representing the revolutionary fusion of AI-enhanced productivity with the tenets of Web3 ownership. Holders are poised to immerse themselves in the rich tapestry of experiences offered by the PalioAI ecosystem, collaboratively shaping the future of the PalioAI brand.",
    exchange_url: "https://opensea.io/collection/palioai-aura",
    external_url: "https://www.palio.ai/",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/d3bdeb6fa079b6d5f217acad3b5738ca.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/d3bdeb6fa079b6d5f217acad3b5738ca.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/aa333a3cf64c8cef205108afdb4fe7cf.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 437.79480399014784,
      num_owners: 1022,
      floor_price: 0.108476,
      floor_price_symbol: "ETH",
      total_minted: 1022,
      total_supply: null,
      total_volume: 2244.186143640724,
      one_day_volume: 0.2791,
      seven_day_volume: 26.664370000000005,
      thirty_day_volume: 95.05377000000004,
      one_day_volume_change: -1.3933980000000004,
      seven_day_volume_change: 117,
      thirty_day_volume_change: -377,
      total_sales: 8092,
      one_day_sales: 3,
      seven_day_sales: 203,
      thirty_day_sales: 544,
      total_average_price: 0.2773339277855566,
      one_day_average_price: 0.09303333333333334,
      seven_day_average_price: 0.13135157635467984,
      thirty_day_average_price: 0.17473119485294125,
    },
    contracts: [
      {
        contract_address: "0x7b563a232c197bae03089852a9cfd65395232861",
      },
    ],
    id: 181,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:28:56.930Z",
    key: "nexus-tools-pass",
    name: "Nexus Tools Pass",
    description:
      "The absolute best tool in your arsenal for monitoring mints in real-time, getting the analytics you need and minting from multiple wallets. In addition, all holders get access to a FREE node and portfolio manager\n\n**Supports Desktop and Mobile**\n\n[Docs](https://docs.nexustools.io/) | [App](https://beta.nexustools.io/)",
    exchange_url: "https://opensea.io/collection/nexus-tools-pass",
    external_url: "https://docs.nexustools.io/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/13ae261c58fa265040cf932b8feea470.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/a9c7dc0f1568ff49fe9949dad96a851a.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/a9c7dc0f1568ff49fe9949dad96a851a.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/3e0f8cfcdc4b34caaf9440e6f2862252.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/aPBRwBYJUP",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 10,
      num_owners: 679,
      floor_price: 0.013299,
      floor_price_symbol: "ETH",
      total_minted: 679,
      total_supply: null,
      total_volume: 85.93069461136082,
      one_day_volume: 0,
      seven_day_volume: 0.01,
      thirty_day_volume: 0.22506000000000007,
      one_day_volume_change: 0,
      seven_day_volume_change: -13,
      thirty_day_volume_change: -92,
      total_sales: 1980,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 18,
      total_average_price: 0.043399340712808494,
      one_day_average_price: 0,
      seven_day_average_price: 0.01,
      thirty_day_average_price: 0.012503333333333337,
    },
    contracts: [
      {
        contract_address: "0xe2736a83bc9afe23db1313355dad1ceaf5399bb6",
      },
    ],
    id: 182,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:28:56.552Z",
    key: "colosseumio",
    name: "Colosseum",
    description:
      "Colosseum is an NFT-based game project centered around gladiatorial combat in a vibrant and interactive Metaverse. Our platform allows users to own, train, and compete with Gladiator NFTs, each endowed with unique powers that determine their capabilities and earnings in the Arena.",
    exchange_url: "https://opensea.io/collection/colosseumio",
    external_url: null,
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/c3c9121dc57fc1d630c3c361ddcaa844.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/c3c9121dc57fc1d630c3c361ddcaa844.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/ef083e4de2ae05b216e09b498fdd5485.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 151,
      floor_price: 0.00065940004000001,
      floor_price_symbol: "ETH",
      total_minted: 151,
      total_supply: null,
      total_volume: 2.8332451989999985,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 136,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.020832685286764695,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x2471a7d2c629775899fa4333ac051237f8846def",
      },
    ],
    id: 183,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:28:44.820Z",
    key: "emoe",
    name: "Eclectic Method : Open Editions",
    description: "Video Remix NFTs ",
    exchange_url: "https://opensea.io/collection/emoe",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/8abaaa7a4bd8eba7b7f0337479a4fbf2.gif?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/8abaaa7a4bd8eba7b7f0337479a4fbf2.gif?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/8abaaa7a4bd8eba7b7f0337479a4fbf2.gif?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/8abaaa7a4bd8eba7b7f0337479a4fbf2.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 2207,
      floor_price: 0.002,
      floor_price_symbol: "ETH",
      total_minted: 2207,
      total_supply: null,
      total_volume: 5.246839579799982,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 816,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.006429950465441154,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x724739ceb3945b8ca946cc692f6ee58096f1634b",
      },
    ],
    id: 184,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:29:56.660Z",
    key: "circles-of-devotion",
    name: "Circles of Devotion",
    description:
      "In the Mithila region of Eastern India, nestled along the Nepal border, a group of remote villages steadfastly preserves ancient artistic traditions. The villagers practice Madhubani art, known for its complex patterns and profound symbolism, handed down across generations. Today, three up-and-coming artists from these communities are ushering this age-old craft into the digital era. Their NFT collection, 'Circles of Devotion,' melds tradition with modernity, providing a unique passage from the rich cultural depths of India to the contemporary global stage.",
    exchange_url: "https://opensea.io/collection/circles-of-devotion",
    external_url: "https://orangehare.io/",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/9b0a77a36f59aaf10bbf331f1e735bb4.gif?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/9b0a77a36f59aaf10bbf331f1e735bb4.gif?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/47c23dc59c84ea63f879a0bbe8c40b96.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/r9u2tmd25j",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 158,
      floor_price: 0.00299,
      floor_price_symbol: "ETH",
      total_minted: 158,
      total_supply: null,
      total_volume: 0.0462,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0127,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 5,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 2,
      total_average_price: 0.00924,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.00635,
    },
    contracts: [
      {
        contract_address: "0x858e9b4403099da6a90ba552e9bc4090af0e6d06",
      },
    ],
    id: 185,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:29:52.297Z",
    key: "renga-black-box",
    name: "RENGA Black Box",
    description:
      "The Black Box contains the data needed to understand the past, present, and future of stories within RENGA. Each box is a portal to a random archetype from worlds unknown across space and time. \n\nUse this box to open the portal and bring forth your character.",
    exchange_url: "https://opensea.io/collection/renga-black-box",
    external_url: "https://www.renga.app",
    banner_image_url:
      "https://i.seadn.io/s/raw/files/5c95b3b7571cb5cc1b5c0fd6c6161687.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/0d6ea6d36500f5316d8224fdfee91ad8.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/0d6ea6d36500f5316d8224fdfee91ad8.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/4216b57628ccd772526611ed019311b7.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/renga",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "renga.factory",
    stats: {
      market_cap: 322.4914,
      num_owners: 417,
      floor_price: 0.369998,
      floor_price_symbol: "ETH",
      total_minted: 417,
      total_supply: null,
      total_volume: 13200.91148099249,
      one_day_volume: 0,
      seven_day_volume: 0.37499,
      thirty_day_volume: 5.259590050000002,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 3,
      total_sales: 10942,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 13,
      total_average_price: 1.2064441126843803,
      one_day_average_price: 0,
      seven_day_average_price: 0.37499,
      thirty_day_average_price: 0.40458385000000013,
    },
    contracts: [
      {
        contract_address: "0x64ad353bc90a04361c4810ae7b3701f3beb48d7e",
      },
    ],
    id: 186,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:31:00.599Z",
    key: "dr-grordborts-rayguns",
    name: "Dr. Grordborts: Rayguns",
    description:
      "Introducing Dr. Grordborts Infallible Aether Oscillators (rayguns for short), available in an exclusive collaboration between [Wētā Workshop](https://www.wetaworkshop.com/) and [FLUF World](https://opensea.io/collection/fluf-world/).\r\n\r\nPeruse the collection and add some punch to your personal armoury. You’ll never know when these things will come in handy!\r\n\r\nPew pew.",
    exchange_url: "https://opensea.io/collection/dr-grordborts-rayguns",
    external_url: "https://www.fluf.world/",
    banner_image_url:
      "https://i.seadn.io/gae/nedWWpnBtO6bHuKmcS9WeFONohV42A_6UFPKFxEkOd5StDRaPI7KUjm888jU9oArvYjO2ttqtrVXpPUIeA6ARszq4I_hILWKd_FMCA?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/tpjfaquN05B0PtnFke1nzcyKUgee8SVGiUhcZORL8lmEvWmvhvtHHCWI9VkERTWmch72pMVkUfwnoxBHpPo4nm0OC0WPhkWxCvncXw?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/tpjfaquN05B0PtnFke1nzcyKUgee8SVGiUhcZORL8lmEvWmvhvtHHCWI9VkERTWmch72pMVkUfwnoxBHpPo4nm0OC0WPhkWxCvncXw?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/9dd9ce905fd397937995ea6b7748c6f3.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/futureverse",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "flufworld",
    stats: {
      market_cap: 40.0292,
      num_owners: 1647,
      floor_price: 0.022799,
      floor_price_symbol: "ETH",
      total_minted: 1647,
      total_supply: null,
      total_volume: 489.56892310993817,
      one_day_volume: 0,
      seven_day_volume: 0.0437,
      thirty_day_volume: 0.1316,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: -35,
      total_sales: 1931,
      one_day_sales: 0,
      seven_day_sales: 3,
      thirty_day_sales: 7,
      total_average_price: 0.2535312910978447,
      one_day_average_price: 0,
      seven_day_average_price: 0.014566666666666669,
      thirty_day_average_price: 0.018799999999999997,
    },
    contracts: [
      {
        contract_address: "0xe176a13b59a6ee59348a417607f2881baad402ea",
      },
    ],
    id: 187,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:30:44.794Z",
    key: "banksyapeclub",
    name: "Banksy Apes",
    description:
      'This project pays homage to BAYC and Banksy, we are not affiliated with any of them.\n\nLimited Editions\n\nRewards* : Collect 5+ Different Banksy Apes and get 5% of the money you spent "Daily" \n',
    exchange_url: "https://opensea.io/collection/banksyapeclub",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gae/iux3DtSFXIEtbdw89TDlvbc65GcUcZ0WFipZ_lW93GsZDkkGKQy1SYMZqXiI_Ngcmdn_kgEI6A4R8T-ptXQpEMU2NzAecZHAEs2rWw?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/hyIDp1PPyeo6HKG2Siuxw7sAG9AgRMfxYMyjxFnMNG_sKuvpFxHJCmcsgMjqbCcYF4OMaDxKabcgz93C_cXlNvVkA8BJ6snaepW83F4?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 66,
      floor_price: 0.18,
      floor_price_symbol: "ETH",
      total_minted: 66,
      total_supply: null,
      total_volume: 6.380000000000001,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 44,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.14500000000000002,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 188,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:30:27.890Z",
    key: "social-masking-by-buddybuddy",
    name: "Social Masking by BuddyBuddy",
    description:
      'How many "hats" do you wear in a day? From the diligent worker and the cheerful friend to the devoted lover and the stealthy online moderator, every role is a unique performance. For “Buddybuddy,” this dance of the self is captured through “Social Masking,” a mesmerizing collection of artworks where faces transform, masks tumble, and personalities whisper secrets in each other’s ears. This collection of four NFTs embodies the essence of our daily social shifts—from professional to personal, public to private—unveiling the vibrant and authentic selves hidden beneath our everyday disguises. In doing so, it also reveals the artist’s own double life: an office drone by day and a fervent painter by night, Buddybuddy’s studio becomes a sanctuary where the true self speaks through artistic expression, and all masks fall away.',
    exchange_url: "https://opensea.io/collection/social-masking-by-buddybuddy",
    external_url: "https://orangehare.io/",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/cb62a4ec4b06a39a3b82d17b666062cd.gif?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/cb62a4ec4b06a39a3b82d17b666062cd.gif?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/c8260386860ce664f3e8f3968e6aa3e3.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/r9u2tmd25j",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 130,
      floor_price: 0.0089,
      floor_price_symbol: "ETH",
      total_minted: 130,
      total_supply: null,
      total_volume: 0.063,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.005,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 7,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.009,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.005,
    },
    contracts: [
      {
        contract_address: "0xf33388b15a95727998d1037674780d0e78cdd941",
      },
    ],
    id: 189,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:30:15.901Z",
    key: "the-sneakerheadz-society",
    name: "The SneakerHeadz Society",
    description:
      "The Sneakerheadz Society (TSS) is a members-only club of 4444 hypebeasts living on the Ethereum blockchain. Completely unique NFT's that define themselves by how they flex, and believe what they ‘re rocking is supremely superior to what you are. The newest and rarest kicks, accessories, clothes and locations. Stunt on your neighbor.",
    exchange_url: "https://opensea.io/collection/the-sneakerheadz-society",
    external_url: "https://tssnft.com",
    banner_image_url:
      "https://i.seadn.io/gae/Epo3f0jOmfhzZsjo7Y66n5fvSsTE-ZY0bKADIZ22ZrlRsTA8XasQFKciNnYltB9guLQLuZzMjlyCYPWiVZYbkvlDULs24uiaDC2I6A?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/yHht_hvhDtkGOql3WszT1qWTLXUZGRNkNCos1jyUn286DOuQIAJ9-cMpH0EsblW7PZAeGs4Q8NT-23pNsNFcBqj3XZpdP2pF0tl3NkE?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/yHht_hvhDtkGOql3WszT1qWTLXUZGRNkNCos1jyUn286DOuQIAJ9-cMpH0EsblW7PZAeGs4Q8NT-23pNsNFcBqj3XZpdP2pF0tl3NkE?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/7NOGq4BV_X2xQB1zFMD7tStj6pz7OZm0_hn_-YGXWfQahLaRuG0m2XG4J5E7kNgB3MJQn_PPSIu_75cF3kHxLtEnr3pLnRV_fWSnVA?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/HttaEx5teE",
    telegram_url: null,
    twitter_username: "TSSNft",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 7.0832,
      num_owners: 1279,
      floor_price: 0.018632,
      floor_price_symbol: "ETH",
      total_minted: 1279,
      total_supply: null,
      total_volume: 285.338199874471,
      one_day_volume: 0,
      seven_day_volume: 0.0016,
      thirty_day_volume: 0.0033,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -2,
      total_sales: 3071,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 2,
      total_average_price: 0.09291377397410322,
      one_day_average_price: 0,
      seven_day_average_price: 0.0016,
      thirty_day_average_price: 0.00165,
    },
    contracts: [
      {
        contract_address: "0x197fc873b3e498b7ca8fac410f466515ceec600b",
      },
    ],
    id: 190,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:32:08.079Z",
    key: "wavelengthbykalebjohnston",
    name: "Wavelength by Kaleb Johnston",
    description:
      "Wavelength by Kaleb Johnston. A code inspired by the brain's electrical activity and how a thought can spark millions of connections within our neural pathway.",
    exchange_url: "https://opensea.io/collection/wavelengthbykalebjohnston",
    external_url: "https://www.wavelengthbykaleb.com/",
    banner_image_url:
      "https://i.seadn.io/gae/F8OrmSba0-U_92crnrIvm4xc6oNO6_u75vkx_URvcps6GJEHx7yFYhzGGn7YJgcNi_nDyKbZ7Onvogv8hDWugzKzFS2Pk_ZDzuiNyA?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/fUdOAUY_Y0a7BvkFkP-5aENWRsR3uJOVfPagm0Q7zM0y6PGJmXCS-OVRAoeuOQ8-XhtcSWJCtfnRCFvS8TFAL37ef1ZSI-P2NE3F?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/fUdOAUY_Y0a7BvkFkP-5aENWRsR3uJOVfPagm0Q7zM0y6PGJmXCS-OVRAoeuOQ8-XhtcSWJCtfnRCFvS8TFAL37ef1ZSI-P2NE3F?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/62a7a1adc52c036014ac2a78cfbfd576.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: "kalebscode",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 652,
      floor_price: 0.068795,
      floor_price_symbol: "ETH",
      total_minted: 652,
      total_supply: null,
      total_volume: 2528.7906252288612,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.30819899999999995,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 2328,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 10,
      total_average_price: 1.0862502685690985,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.030819899999999994,
    },
    contracts: [
      {
        contract_address: "0x68930072647a0d79e601d5ee3914833ae9148247",
      },
    ],
    id: 191,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:31:44.580Z",
    key: "xanders",
    name: "Xanders Pass",
    description:
      "The Xanders Pass is a premium and exclusive membership providing access to the Xanders ecosystem where holders receive exclusive drops, investment strategies, trading tools, community events and more. \r\n\r\nFilter the traits for the Xanders Pass to purchase directly. Alternatively you can purchase 3 Utility Tokens and burn them to create a new Xanders Pass.",
    exchange_url: "https://opensea.io/collection/xanders",
    external_url: "https://side.xyz/xanders",
    banner_image_url:
      "https://i.seadn.io/gcs/files/93b12ceffdda9428f1d18c612c84120c.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/51574377c5b1404442a32381e76c8a44.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/51574377c5b1404442a32381e76c8a44.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/51574377c5b1404442a32381e76c8a44.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/xanders",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 33.459966666666666,
      num_owners: 380,
      floor_price: 0.035482,
      floor_price_symbol: "ETH",
      total_minted: 380,
      total_supply: null,
      total_volume: 208.0160096494448,
      one_day_volume: 0,
      seven_day_volume: 0.2329,
      thirty_day_volume: 0.5233000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 4,
      thirty_day_volume_change: -25,
      total_sales: 3751,
      one_day_sales: 0,
      seven_day_sales: 6,
      thirty_day_sales: 11,
      total_average_price: 0.05545614760049182,
      one_day_average_price: 0,
      seven_day_average_price: 0.038816666666666666,
      thirty_day_average_price: 0.04757272727272728,
    },
    contracts: [
      {
        contract_address: "0xf9713c11780151f142e3d1089efaec0646bcc314",
      },
    ],
    id: 192,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:31:40.274Z",
    key: "parallel-battlepass-cards",
    name: "Parallel Battle Pass Cards",
    description: "Parallel TCG's Battle Pass Cards",
    exchange_url: "https://opensea.io/collection/parallel-battlepass-cards",
    external_url: "http://www.parallel.life/",
    banner_image_url:
      "https://i.seadn.io/s/raw/files/c5fe621607527c8fc9ce16046fe8f0f1.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/93d9d6c15b41903ed124d673e2b5b651.png?w=500&auto=format",
    large_image_url: null,
    image_url:
      "https://i.seadn.io/s/raw/files/93d9d6c15b41903ed124d673e2b5b651.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/paralleltcg",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0.09323999999999999,
      num_owners: 1633,
      floor_price: 0.00099,
      floor_price_symbol: "ETH",
      total_minted: 1633,
      total_supply: null,
      total_volume: 109.40415358565893,
      one_day_volume: 0,
      seven_day_volume: 0.05179999999999999,
      thirty_day_volume: 0.3006,
      one_day_volume_change: 0,
      seven_day_volume_change: 4,
      thirty_day_volume_change: 13,
      total_sales: 3777,
      one_day_sales: 0,
      seven_day_sales: 15,
      thirty_day_sales: 40,
      total_average_price: 0.028965886572851186,
      one_day_average_price: 0,
      seven_day_average_price: 0.003453333333333333,
      thirty_day_average_price: 0.007514999999999999,
    },
    contracts: [
      {
        contract_address: "0x9d764bcf1affd83554b7626f22eab2ffc60590c7",
      },
    ],
    id: 193,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:31:23.612Z",
    key: "10ktf-stockroom",
    name: "Stockroom by 10KTF",
    description:
      "10KTF Stockroom is a collection of the finest Tools and Materials held by the esteemed customers of 10KTF for use in future endeavors.\r\n\r\nVisit 10ktf.com for more details.",
    exchange_url: "https://opensea.io/collection/10ktf-stockroom",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/25fe1d023cdda4ac9ab37bd8754235a3.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/7ef815238fb96304c8f4fad921b11a30.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/7ef815238fb96304c8f4fad921b11a30.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/cd1043190fc2ee3677ee2d99dc0fe59d.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0.05383333333333334,
      num_owners: 4086,
      floor_price: 0.005,
      floor_price_symbol: "ETH",
      total_minted: 4086,
      total_supply: null,
      total_volume: 22868.46262673469,
      one_day_volume: 0.0019,
      seven_day_volume: 0.0085,
      thirty_day_volume: 0.0654,
      one_day_volume_change: 0.0019,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -35,
      total_sales: 49076,
      one_day_sales: 1,
      seven_day_sales: 3,
      thirty_day_sales: 10,
      total_average_price: 0.4659805735335946,
      one_day_average_price: 0,
      seven_day_average_price: 0.002833333333333334,
      thirty_day_average_price: 0.00654,
    },
    contracts: [
      {
        contract_address: "0x7daec605e9e2a1717326eedfd660601e2753a057",
      },
    ],
    id: 194,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:33:10.971Z",
    key: "yakuza-elite",
    name: "Yakuza Elite",
    description:
      "A collection of 333 Unique Yakuza Elites consisting of only the strongest Yakuzas. Generating Massive amounts of TEMPURA and providing massive amounts of utility to their holders.\r\n\r\n**MIGRATED COLLECTION**",
    exchange_url: "https://opensea.io/collection/yakuza-elite",
    external_url: "https://www.yakuzainc.io/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/12d45a7fa8c654f3a0c580585c144ace.gif?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/19759384c26407e30ad78b6d09d5befd.gif?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/19759384c26407e30ad78b6d09d5befd.gif?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/19759384c26407e30ad78b6d09d5befd.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/yakuza-inc",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 211,
      floor_price: 0.010459001406970514,
      floor_price_symbol: "ETH",
      total_minted: 211,
      total_supply: null,
      total_volume: 8.749299999999996,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.015,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -3,
      total_sales: 55,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.15907818181818176,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.015,
    },
    contracts: [
      {
        contract_address: "0xe2c430d0c0b6b690facf54ca26d7620237aa62a4",
      },
    ],
    id: 195,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:32:35.614Z",
    key: "archive-bust",
    name: "archive bust",
    description: null,
    exchange_url: "https://opensea.io/collection/archive-bust",
    external_url: "https://linktr.ee/bongdoe",
    banner_image_url:
      "https://i.seadn.io/gcs/files/7b15990bfe00947dcc7909d9da7da1c6.gif?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/401a011c0e06604f3cc857ab6839ff85.gif?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/401a011c0e06604f3cc857ab6839ff85.gif?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/43c37c8ea67f0b0d6efa126b19a1135b.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/bongdoearchive",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 399,
      floor_price: 0.019,
      floor_price_symbol: "ETH",
      total_minted: 399,
      total_supply: null,
      total_volume: 27.42747158888953,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 519,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.05284676606722453,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x6c5407d1c272436a66ecbc6a8110f790d5821606",
      },
    ],
    id: 196,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:32:19.531Z",
    key: "elmonx-skull-of-a-skeleton-with-burning-cigarette",
    name: "Skull of a Skeleton with Burning Cigarette",
    description:
      "Skull of a Skeleton with Burning Cigarette, c.1886 (oil on canvas) by Vincent van Gogh is one of his most unusual and striking works, depicting a skeleton smoking a cigarette. It’s thought to be either an anatomy study or a satirical take on mortality. Despite its small size, this painting has become famous for its dark humor and is often referenced in popular culture, standing out as a unique piece in Van Gogh's diverse portfolio.",
    exchange_url:
      "https://opensea.io/collection/elmonx-skull-of-a-skeleton-with-burning-cigarette",
    external_url: "https://ElmonX.com",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/c6ed0a4d464e1ce92b1642823b8c4058.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/c6ed0a4d464e1ce92b1642823b8c4058.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/667ce8a891c5feb660ef1f9b2d994575.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/elmonx",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 108,
      floor_price: 0.075,
      floor_price_symbol: "ETH",
      total_minted: 108,
      total_supply: null,
      total_volume: 0.5848000000000002,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 17,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.034400000000000014,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x47e6bc519f0137f2a5597a58ee5b02f094295bc0",
      },
    ],
    id: 197,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:34:49.817Z",
    key: "cachorros-de-pan",
    name: "Cachorros de Pan",
    description:
      "animales protegidos por Pan, el dios griego de los pastores, los rebaños y los animales salvajes. ",
    exchange_url: "https://opensea.io/collection/cachorros-de-pan",
    external_url: null,
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/161364ec3451e75c23d550d32bf164ec.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/161364ec3451e75c23d550d32bf164ec.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/48733f948bd84139f115015938c4313c.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 0.7,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xc12a1ce3526edfdfc4ea0a8cbc8b59e2632582f7",
      },
    ],
    id: 198,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:34:45.456Z",
    key: "golden-state-warriors-legacy-collection",
    name: "Golden State Warriors Legacy Collection",
    description:
      "The Golden State Warriors are the first pro sports team to release an official NFT collection. Commemorating their 6x NBA championships & their most iconic games in history, the collection is minted on the blockchain in limited supply. A portion of proceeds from the auction will go to the Warriors Community Foundation\r\n\r\nChampionship Ring NFTs\r\n- 1947 Championship Ring (25 Editions)\r\n- 1956 Championship Ring (25 Editions) \r\n- 1975 Championship Ring (25 Editions) \r\n- 2015 Championship Ring (50 Editions)\r\n- 2017 Championship Ring (50 Editions)\r\n- 2018 Championship Ring (50 Editions)\r\n- 1-of-1 Six-Time NBA Championship Ring  \r\n\r\nTicket Stub NFTs (Editions of 10 per game) \r\n- 1947 - First Ever NBA Championship\r\n- 1956 - Second Championship\r\n- 1975 - Third Championship\r\n- 2007 - We Believe Upset\r\n- 2015 - Fourth Championship\r\n- 2016 - Single Season Wins Record\r\n- 2017 - Fourth Championship\r\n- 2018 - Fifth Championship\r\n- 2019 - Finale at Oracle Arena\r\n- 2020 - First Game at Chase Center\r\n- 1-of-1 - Golden Ticket",
    exchange_url:
      "https://opensea.io/collection/golden-state-warriors-legacy-collection",
    external_url: "https://www.nba.com/warriors/",
    banner_image_url:
      "https://i.seadn.io/gae/GkfeK6hFSVLcsZpkGJRkIZCaciC_XnxuaffbImtRX1jgTwCOPDWTNyjqOArsrUbuEWioc2rL4720rui_rmRWXehmBKnaYHqskdfsZQ?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/QqqzafLtIFD4FkTjjtEpApSIByW4U2s7G5f_J7ihKnnLxfHZMGaqH3V-b7K4a6TdVNA7GqCfcXkTuNiEgkgaUVt4cDqB00ex03m6bw?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: "warriors",
    wiki_url: null,
    instagram_username: "warriors",
    stats: {
      market_cap: 0,
      num_owners: 100,
      floor_price: 0.3,
      floor_price_symbol: "ETH",
      total_minted: 100,
      total_supply: null,
      total_volume: 748.1300900611946,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 412,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 1.8158497331582393,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 199,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:35:49.881Z",
    key: "open-mind-15",
    name: "Open mind",
    description: null,
    exchange_url: "https://opensea.io/collection/open-mind-15",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url: null,
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 0.03,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x8e38516ccf980078e43cd280b2db64dd5fac2a09",
      },
    ],
    id: 200,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:35:45.865Z",
    key: "intimita",
    name: "Intimita: By Stefano Contiero",
    description: null,
    exchange_url: "https://opensea.io/collection/intimita",
    external_url: "https://tonic.xyz/collection/intimita/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/2e190fdfae47bf01988cdba534eacd6f.png?w=500&auto=format",
    featured_image_url: null,
    large_image_url:
      "https://i.seadn.io/gcs/files/592b7544ed36ea5cac1d24e01df46505.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/3b74eec255ae249026a971731f12dcef.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 210,
      floor_price: 0.0077,
      floor_price_symbol: "ETH",
      total_minted: 210,
      total_supply: null,
      total_volume: 62.05928090000002,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.12060000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -12,
      total_sales: 292,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 3,
      total_average_price: 0.21253178390410965,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.04020000000000001,
    },
    contracts: [
      {
        contract_address: "0xfcab9c24303a7b7680680249effcf8ce18699526",
      },
    ],
    id: 201,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:35:45.468Z",
    key: "rectangles-for-herbert-by-jeff-davis",
    name: "Rectangles (for Herbert) by Jeff Davis",
    description:
      "Art Blocks Collection: Presents\n\nHeritage Art Blocks Collection: Playground\n\nProject Description: Revisiting one of my first algorithms on the occasion of the Tribute to Herbert W. Franke. All artist proceeds from minting will be directed to *art meet science – Foundation Herbert W. Franke* to support the preservation of Herbert's legacy with ZKM Karlsruhe and technology education through RÜTGERS Foundation.",
    exchange_url:
      "https://opensea.io/collection/rectangles-for-herbert-by-jeff-davis",
    external_url: "https://artblocks.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/6a0193895d5538c3e04da84ec9ec4f76.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/Bl8qT1wM_0RxFkk3oSumGRc4IX-WNZxPzx18H55Df9ZFseKBQL7bycjJ_wjawNPbyLvp9YuH9-rNlDmpW4lR91qVexkAhSw36p0S6Gs?w=500&auto=format",
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/Bl8qT1wM_0RxFkk3oSumGRc4IX-WNZxPzx18H55Df9ZFseKBQL7bycjJ_wjawNPbyLvp9YuH9-rNlDmpW4lR91qVexkAhSw36p0S6Gs?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 236,
      floor_price: 0.072,
      floor_price_symbol: "ETH",
      total_minted: 236,
      total_supply: null,
      total_volume: 132.69300278900025,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 715,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.18558461928531503,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xa7d8d9ef8d8ce8992df33d8b8cf4aebabd5bd270",
      },
    ],
    id: 202,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:35:45.072Z",
    key: "neckville",
    name: "NeckVille",
    description:
      "NeckVille is home to 5,555 different inhabitants known as NeckVillians who go about their lives working, playing, and exploring the first living town within the MetaVerse. \r\nNeckVillians are stored as ERC-721 tokens on the Ethereum blockchain and hosted on IPFS.",
    exchange_url: "https://opensea.io/collection/neckville",
    external_url: "https://www.neckville.io/",
    banner_image_url:
      "https://i.seadn.io/gae/2Tt1UEKRvQgp7BzLCasC7BNrF853GyS7IwkC7LEqb6GF1MMS2ZqlFWc3QCnyvIX5t8jVbkuz56eCGtIrQyxb2VIUccRhG_kibS07UjY?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/YHS_2Ts1QPNm2szWQ6Z-173CDU0H-ssIwPU3imdRhuyd8RLS6PMZd9lf0jvxTTLnPnM2Gu7Oro04DbmoPBvjh2wb1JYmVMyD2JAt?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/YHS_2Ts1QPNm2szWQ6Z-173CDU0H-ssIwPU3imdRhuyd8RLS6PMZd9lf0jvxTTLnPnM2Gu7Oro04DbmoPBvjh2wb1JYmVMyD2JAt?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/hZ1OAas2cz0gFTAuVnc9XaQsPysWRd3tVnAT8txFMQpgZ8Dt9ne-lJLZjXRB8aSrPyGYWk9CDok321cYH3SdxIahCG1mmnI-E22JJ6g?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/skUhFDTPmz",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "neckvillenft",
    stats: {
      market_cap: 11.092,
      num_owners: 2222,
      floor_price: 0.0084,
      floor_price_symbol: "ETH",
      total_minted: 2222,
      total_supply: null,
      total_volume: 1615.7763869858316,
      one_day_volume: 0,
      seven_day_volume: 0.002,
      thirty_day_volume: 0.045782,
      one_day_volume_change: 0,
      seven_day_volume_change: -9,
      thirty_day_volume_change: 2,
      total_sales: 9117,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 13,
      total_average_price: 0.177226761762184,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003521692307692308,
    },
    contracts: [
      {
        contract_address: "0xffd287647f3f5ac7e5d613911b75023311712f93",
      },
    ],
    id: 203,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:35:33.098Z",
    key: "garbage-friends-main",
    name: "Garbage Friends",
    description:
      "A collection of Garbage Friends representing the final stage (Stage 4) in our upcycling journey.",
    exchange_url: "https://opensea.io/collection/garbage-friends-main",
    external_url: "https://www.typicalfriends.com/garbagefriends/",
    banner_image_url:
      "https://i.seadn.io/s/raw/files/c3b868d5217c562a54a55d1a2a9c24c6.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/fc0469b9c6663cccbcbe5ea01736308e.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/fc0469b9c6663cccbcbe5ea01736308e.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/d4ee60b36eeb6fccaf473dd1dbe375af.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 111.52270714283696,
      num_owners: 1816,
      floor_price: 0.017877,
      floor_price_symbol: "ETH",
      total_minted: 1816,
      total_supply: null,
      total_volume: 104.21903872999908,
      one_day_volume: 0.1481,
      seven_day_volume: 0.66297999999988,
      thirty_day_volume: 6.1187076999998755,
      one_day_volume_change: 0.037400000000120004,
      seven_day_volume_change: -12,
      thirty_day_volume_change: -350,
      total_sales: 2864,
      one_day_sales: 4,
      seven_day_sales: 28,
      thirty_day_sales: 227,
      total_average_price: 0.03638932916550247,
      one_day_average_price: 0.037025,
      seven_day_average_price: 0.023677857142852858,
      thirty_day_average_price: 0.02695465947136509,
    },
    contracts: [
      {
        contract_address: "0xef371a11e6adb9dc3d333dafcb1ff5afbcb6cdc8",
      },
    ],
    id: 204,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:36:36.577Z",
    key: "kondux",
    name: "Kondux kNFT Disclosure Collection",
    description:
      "The Disclosure kNFT Collection was designed to showcase a series of groundbreaking technology innovations with OpenUSD & NVIDIA Omniverse. It is the first kNFT collection to use our lightweight data exchange protocol using our Kondux DNA Sequence & USD file format. \n\nComposed of the ERC-721 token standard these dynamic NFT metadata containers are built for 3D asset management within interoperable NVIDIA Omniverse technology and visible using the GDN (Graphics Display Network).  \n\nThe Disclosure kNFT Collection is more than just creating high quality assets. It’s about creating the processes and pathways for advanced dynamic 3D asset design pipelines secured by blockchain technology. This mint paves the way to bringing partners into our ecosystem and using our tech stack to build a secure and transparent 3D future.",
    exchange_url: "https://opensea.io/collection/kondux",
    external_url: null,
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/2642411769c7fa2b7296f2cc1eefc56c.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/2642411769c7fa2b7296f2cc1eefc56c.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/4f8a2b546703f74e47e6f811a1933f29.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 175,
      floor_price: 0.04,
      floor_price_symbol: "ETH",
      total_minted: 175,
      total_supply: null,
      total_volume: 3.10456,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 41,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.0757209756097561,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x5ad180df8619ce4f888190c3a926111a723632ce",
      },
    ],
    id: 205,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:38:13.544Z",
    key: "nft3-2022",
    name: "NFT3 2022",
    description:
      "AWARDS GALA - MUSIC FESTIVAL - EXHIBITION - FASHION SHOW - ART GALLERY\n\nNFT3 TICKETS GET YOU ACCESS TO NFT EXPOVERSE AFTER PARTY JULY 29th & 30th\n\nNFT3 TICKETS GET YOU A COMP TICKET TO NFT LV AUG 26th-28th\n\nNFT3 TICKETS GET YOU ACCESS TO NFT3 IN LA FALL OF 2022\n\nABOUT NFT3 \nNFT3 brings you the first first-ever 3-day/4-night NFT Music Festival along with a first-of-its-kind red carpet NFT Awards Gala, at the original home of the Academy Awards, Exhibition, Fashion show, NFT Art Gallery, and more.\n\nNFT3 is the must-attend event of the year!\n\nFor ticket information, ticket levels and rarity, please go to nft3awards.io/mint",
    exchange_url: "https://opensea.io/collection/nft3-2022",
    external_url: "https://nft3awards.io/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/e4456d612afb5fc4a55a07d643bdc398.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/cac60769c6b90e663e409d80c74b3ffc.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/cac60769c6b90e663e409d80c74b3ffc.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/82c7a5066172da0d4ad32837dadba051.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/NFT3",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 353,
      floor_price: 0.08,
      floor_price_symbol: "ETH",
      total_minted: 353,
      total_supply: null,
      total_volume: 103.39215279770433,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 1126,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.09182251580613172,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x9909fd545b000c7333eed69b1b749caa235b9f16",
      },
    ],
    id: 206,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:38:08.917Z",
    key: "apes-in-space-nft",
    name: "Apes In Space NFT",
    description:
      "Home of the Apes in Space NFT project launched by Takeoff, 1/3 of the award-winning group Migos.",
    exchange_url: "https://opensea.io/collection/apes-in-space-nft",
    external_url: "https://apesinspace.io/",
    banner_image_url:
      "https://i.seadn.io/gae/EJ6SmmllcjAUyNtXdSOwJDcXPjK8CQ9q2jOlZNxDbiRzutbaVbiVP0Gu_QRyZGUKDsd-0uoy_yLfeV-N8GJK2DQjbDoRZ78VVfne?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/cd4Z3Q5-XqwxJrPd92jrFAdcVXmyPnmA6XHYHkqmh8gKByANEr1c0hNhQBI779zGBSI6JPZ2O0urUQtKSWGOnaOMwSxkZiBwMQdL?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/cd4Z3Q5-XqwxJrPd92jrFAdcVXmyPnmA6XHYHkqmh8gKByANEr1c0hNhQBI779zGBSI6JPZ2O0urUQtKSWGOnaOMwSxkZiBwMQdL?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/qwB8U_rzY2DmHAhuEKSr5WemDIyBLuptgJ-RgYeQ0nBAYVw641R2GzgZ8lEIK4k6F-6e9JWByC010KgT0ob5p_u66iqdMSRnPZcTqg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/apesinspace",
    telegram_url: null,
    twitter_username: "ApesinSpaceNFT",
    wiki_url: null,
    instagram_username: "apesinspace.io/",
    stats: {
      market_cap: 33.983,
      num_owners: 6459,
      floor_price: 0.003084,
      floor_price_symbol: "ETH",
      total_minted: 6459,
      total_supply: null,
      total_volume: 1850.458496194865,
      one_day_volume: 0,
      seven_day_volume: 0.0034,
      thirty_day_volume: 0.020600000000000004,
      one_day_volume_change: 0,
      seven_day_volume_change: -4,
      thirty_day_volume_change: -18,
      total_sales: 8034,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 7,
      total_average_price: 0.2303284162552732,
      one_day_average_price: 0,
      seven_day_average_price: 0.0034,
      thirty_day_average_price: 0.002942857142857143,
    },
    contracts: [
      {
        contract_address: "0x7a3b97a7400e44dadd929431a3640e4fc47daebd",
      },
    ],
    id: 207,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:38:03.722Z",
    key: "elmonx-nympheas-1907-original",
    name: "ElmonX Nymphéas 1907 Original",
    description:
      "Nymphéas, 1907, an exquisite oil on canvas by Claude Monet (1840–1926), the master of Impressionism, captures the enchanting beauty of morning and afternoon scenes with open lily blossoms. This acclaimed series drew comparisons to Cubist experiments in 1909, leaving a lasting impact on the art world.\r\n\r\nRecently, Nymphéas, 1907 was sold for an impressive $56,495,000 in May 2022, further solidifying Monet’s enduring artistic legacy.",
    exchange_url: "https://opensea.io/collection/elmonx-nympheas-1907-original",
    external_url: "http://ElmonX.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/308c2467441772f321ad19674f9dedbc.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/425e0260d76f6dfad6927be056733c01.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/425e0260d76f6dfad6927be056733c01.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/f7fc9f8fa254124427928e4a964048c6.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 13.303,
      num_owners: 320,
      floor_price: 0.024998,
      floor_price_symbol: "ETH",
      total_minted: 320,
      total_supply: null,
      total_volume: 6.709690000000002,
      one_day_volume: 0,
      seven_day_volume: 0.0502,
      thirty_day_volume: 0.07200000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 2,
      thirty_day_volume_change: -3,
      total_sales: 98,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 4,
      total_average_price: 0.06846622448979593,
      one_day_average_price: 0,
      seven_day_average_price: 0.0251,
      thirty_day_average_price: 0.018000000000000002,
    },
    contracts: [
      {
        contract_address: "0x29081a6f42dba17c93a12436c141803612308bdd",
      },
    ],
    id: 208,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:38:03.257Z",
    key: "baby-doge-3d",
    name: "Baby Doge Army 3D",
    description:
      "Welcome to the home of Baby Doge 3D on OpenSea. Discover the best items in this collection.\n\nOfficial 3D collection of [BabyDogeArmy](https://opensea.io/collection/babydogearmy)",
    exchange_url: "https://opensea.io/collection/baby-doge-3d",
    external_url: "http://babydogenft.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/f61378207ccb2ac7b7ca707aa377a13b.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/e182d1757eaf6a5813730447239bd0d5.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/e182d1757eaf6a5813730447239bd0d5.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/a3d81b8fd0770a9708e0e0ba90a463bf.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: "https://t.me/babydogearmy",
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 130.5675518888889,
      num_owners: 1342,
      floor_price: 0.012439,
      floor_price_symbol: "ETH",
      total_minted: 1342,
      total_supply: null,
      total_volume: 109.30664612293867,
      one_day_volume: 0,
      seven_day_volume: 0.173141,
      thirty_day_volume: 0.7428102001200003,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -15,
      total_sales: 2287,
      one_day_sales: 0,
      seven_day_sales: 9,
      thirty_day_sales: 37,
      total_average_price: 0.047794773118906286,
      one_day_average_price: 0,
      seven_day_average_price: 0.019237888888888888,
      thirty_day_average_price: 0.020075951354594602,
    },
    contracts: [
      {
        contract_address: "0xd260c7ae9c8e425f02354e799ca2eb276410570a",
      },
    ],
    id: 209,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:37:44.094Z",
    key: "yurei-pass",
    name: "Yurei Pass",
    description:
      "Yurei is a Decentralized Investment Organization which provides early-stage investment opportunities to its NFT holders.",
    exchange_url: "https://opensea.io/collection/yurei-pass",
    external_url: "https://yurei.fund",
    banner_image_url:
      "https://i.seadn.io/gcs/files/eb6babaf69fd360f3e1e42fb2a9dd871.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/f83bc7ae80e9b3a0fcfb86dc594c3a17.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/f83bc7ae80e9b3a0fcfb86dc594c3a17.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/08b479c8da853858fe807aea67a989fa.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/spectre-955281929438122024",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 96.26404391988807,
      num_owners: 1375,
      floor_price: 0.059996,
      floor_price_symbol: "ETH",
      total_minted: 1375,
      total_supply: null,
      total_volume: 1319.9868572362147,
      one_day_volume: 0,
      seven_day_volume: 0.09631220001989801,
      thirty_day_volume: 1.780812200019898,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -11,
      total_sales: 1991,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 19,
      total_average_price: 0.6629768243275815,
      one_day_average_price: 0,
      seven_day_average_price: 0.04815610000994901,
      thirty_day_average_price: 0.09372695789578411,
    },
    contracts: [
      {
        contract_address: "0x495b01c1bc3b9203fde4362d9913c692fb661f3f",
      },
    ],
    id: 210,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:37:35.702Z",
    key: "rebelsociety",
    name: "Rebel Society",
    description:
      "[Luchadoras]( https://opensea.io/collection/luchadoras) | [Good Rebels]( https://opensea.io/collection/good-rebels) | [Iconic Rebels of Music]( https://opensea.io/collection/iconic-rebels-of-music-by-rebel-society) | [RS Collabs]( https://opensea.io/collection/rebel-society-collabs) | [RS Collabs 2]( https://opensea.io/collection/rs-collabs-season-2) | [RS Collabs 3]( https://opensea.io/collection/rs-collabs-season-3) | [Website](https://www.rebelsociety.io)\n\nRebel Society is a NFT limited edition collection of 7000 female characters created from hand-drawn elements in celebration of all inspiring badass women. \n\n",
    exchange_url: "https://opensea.io/collection/rebelsociety",
    external_url: "https://www.rebelsociety.io/",
    banner_image_url:
      "https://i.seadn.io/gae/xVhSk_WfZRlv1tK4UeH4v7Qw0R_97rbL_rn8YFA6zOCztKfYKVX2mo-7N5C_MSmKbCCFm0B5lCQss23NZ9fn2iARf8plGIfP3lsU?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/iVQZiHEKEPHGaR5Dw_utTYSQUpAUD-I8vSY7T4V7DQNp5jr4i_t-Jx74ycOEug1HFG-c53muVaUIruKN0m70fMCOxhnsglh-NBIkGw?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/iVQZiHEKEPHGaR5Dw_utTYSQUpAUD-I8vSY7T4V7DQNp5jr4i_t-Jx74ycOEug1HFG-c53muVaUIruKN0m70fMCOxhnsglh-NBIkGw?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/gGjMsiQ5gp57zdiSrYEI-m3CUWH81rtrTqaMV0jE1WKvkGt9mxA-EyB950WvFxIWSZtPWg5ma85nPvvg6mej25AEcgXnaqL6zNsyoA?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/BGehAVEBwN",
    telegram_url: null,
    twitter_username: "RebelSocietyNFT",
    wiki_url: null,
    instagram_username: "RebelSocietyNFT",
    stats: {
      market_cap: 13.996,
      num_owners: 3833,
      floor_price: 0.005487,
      floor_price_symbol: "ETH",
      total_minted: 3833,
      total_supply: null,
      total_volume: 2150.5174661317915,
      one_day_volume: 0.004,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.0101,
      one_day_volume_change: 0.004,
      seven_day_volume_change: 1,
      thirty_day_volume_change: -10,
      total_sales: 13825,
      one_day_sales: 2,
      seven_day_sales: 2,
      thirty_day_sales: 5,
      total_average_price: 0.15555280044352923,
      one_day_average_price: 0.002,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.00202,
    },
    contracts: [
      {
        contract_address: "0x8cd3cea52a45f30ed7c93a63fb2b5c13b453d5a1",
      },
    ],
    id: 211,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:40:02.555Z",
    key: "ape-bond-bonds",
    name: "Ape.bond Bonds",
    description: null,
    exchange_url: "https://opensea.io/collection/ape-bond-bonds",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url: null,
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1321,
      floor_price: 0.068,
      floor_price_symbol: "ETH",
      total_minted: 1321,
      total_supply: null,
      total_volume: 0.0002,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 1,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.0002,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x499b654b0a7f9979cc315190c09ca2633809b8df",
      },
    ],
    id: 212,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:39:31.501Z",
    key: "cyborg-mercenaries-cm",
    name: "Cyborg Mercenaries CM",
    description:
      "Cyborg Mercenaries CM is a collection of NFTs battling the most difficult challenges in the E-Gaming and Web 3 space.",
    exchange_url: "https://opensea.io/collection/cyborg-mercenaries-cm",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/3ac3770b5d1e2d17a105ea22fe7f7d6f.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/4b452bc024619b7cf3fafb0274f87797.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/4b452bc024619b7cf3fafb0274f87797.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/a3927131460eda77ab167de4c1d750f0.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/wtVgDywmQE",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 2080,
      floor_price: 0.0099,
      floor_price_symbol: "ETH",
      total_minted: 2080,
      total_supply: null,
      total_volume: 159.2586557677673,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 1780,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.08947115492571196,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x61fce80d72363b731425c3a2a46a1a5fed9814b2",
      },
    ],
    id: 213,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:39:31.118Z",
    key: "nonfungiblealiens",
    name: "Non-Fungible Aliens",
    description:
      "Non-Fungible Aliens (NFA) is an exclusive collection of 4000 NFT Aliens with\nincredible utility...\nAliens are stored as ERC-721 tokens on the Ethereum blockchain and hosted on IPFS.\n\nWith a hundred designated quality 3D elements, your Alien will be yours, it will be unique\nand come straight from space to give you an amazing opportunity that you can't miss.\n\nVisit www.NonFungibleAliens.com to discover how to use your NFA.",
    exchange_url: "https://opensea.io/collection/nonfungiblealiens",
    external_url: "https://nonfungiblealiens.com",
    banner_image_url:
      "https://i.seadn.io/gae/RYT16jUhfXH1N52kGD8yf7NAhfiRG_lEF0QXWuhgjSW5yCi7vm69Y0PxrIAZX6MyjK4WfPp6qs3QF86gMECwkasgLFmewb3SiLJzJhk?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/ieRNPtxz7szpSGkuuJ5XJ_GTjTCXpqumt-Y8HfAPXwb3TWDfk-uf_NRVTCymuNtsUZtMvPjR0o3uTLR0gnRS7iaOPFJ_6-EfUmsFfkY?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/ieRNPtxz7szpSGkuuJ5XJ_GTjTCXpqumt-Y8HfAPXwb3TWDfk-uf_NRVTCymuNtsUZtMvPjR0o3uTLR0gnRS7iaOPFJ_6-EfUmsFfkY?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/DXq4BBClXBuJR_rO6z5TOlYdK0M8GVlqyd1DD9sZUG28lL01P6uCglfDctEHsNo6-SIoS_Xt3zRPAI0iVxjQc7IOqXS8KA7ypkRszA?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/NFA",
    telegram_url: null,
    twitter_username: "NFAliens",
    wiki_url: null,
    instagram_username: "NonFungibleAliens",
    stats: {
      market_cap: 0,
      num_owners: 2136,
      floor_price: 0.015,
      floor_price_symbol: "ETH",
      total_minted: 2136,
      total_supply: null,
      total_volume: 247.24964252606875,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 1642,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.15057834502196635,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x17a3770e1c07f246c89b8b54b40d0a883d734fb9",
      },
    ],
    id: 214,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:39:26.932Z",
    key: "cyberpunk-267",
    name: "Cyberpunk",
    description: "This is cyberpunk",
    exchange_url: "https://opensea.io/collection/cyberpunk-267",
    external_url: null,
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/92fb06eafee4de66a308b84b3b3d18eb.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/92fb06eafee4de66a308b84b3b3d18eb.jpg?w=500&auto=format",
    image_url: null,
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 0,
      floor_price_symbol: null,
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x0cb404779f798d41c942319deb7a8c08357118dc",
      },
    ],
    id: 215,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:39:26.515Z",
    key: "m4v3r1ck-collection",
    name: "m4v3r1ck Collection",
    description: null,
    exchange_url: "https://opensea.io/collection/m4v3r1ck-collection",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url: null,
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 0,
      floor_price_symbol: null,
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 216,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:39:22.411Z",
    key: "frankmillersincity",
    name: "Frank Miller: Sin City 30th Anniversary",
    description:
      "In celebration of [30 years of Sin City](https://frankmiller.io), Frank Miller has teamed up with gaming art studio Concept Art House and industry-leading blockchain gaming platform Gala Games to produce a set of non-fungible token (NFT) collectibles based on the Sin City franchise.\r\n\r\nVisit https://frankmiller.io for more information.",
    exchange_url: "https://opensea.io/collection/frankmillersincity",
    external_url: "https://frankmiller.io/",
    banner_image_url:
      "https://i.seadn.io/gae/G0GhUEBty0fVft5U_jBxh0Lf0dOV_QpjSN5LjS5m4LZaqai_s4XAxuSDbJwGj6qOmZbv4Z9kd0I4PsbNYNH0oGRPnBBDFGBjEvsYbw?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/bzsfD95oIHDvEUyr0cGh-yItkUGlvndezj-U4nhj7PT3Iih7_coPJ6D3cK6yJI7v1tB7Jz5nRtdODNVgvh40i-oPUuWogKQU89YJYQ?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/bzsfD95oIHDvEUyr0cGh-yItkUGlvndezj-U4nhj7PT3Iih7_coPJ6D3cK6yJI7v1tB7Jz5nRtdODNVgvh40i-oPUuWogKQU89YJYQ?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/05JFJpdX8UOAdBd9xSLoGp816X6OWgFDLTOHHXhFyTJIZopuVtMeA8khlwTuhRXZwL3-ayS2T-7hMBQoZpJVeTahFHztObYvVhV0fCk?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/gogalagames",
    telegram_url: null,
    twitter_username: "gogalagames",
    wiki_url: null,
    instagram_username: "gogalagames",
    stats: {
      market_cap: 33.345,
      num_owners: 954,
      floor_price: 0.019,
      floor_price_symbol: "ETH",
      total_minted: 954,
      total_supply: null,
      total_volume: 667.7003051775982,
      one_day_volume: 0,
      seven_day_volume: 0.019,
      thirty_day_volume: 0.019,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 1,
      total_sales: 783,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 1,
      total_average_price: 0.8527462390518497,
      one_day_average_price: 0,
      seven_day_average_price: 0.019,
      thirty_day_average_price: 0.019,
    },
    contracts: [
      {
        contract_address: "0x178b3f41c1496ffa41bc86e9e59e825a246e2b76",
      },
    ],
    id: 217,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:39:22.000Z",
    key: "8megs",
    name: "8megs",
    description:
      "Sun-Min + David are the co-creators of Uglydoll, Bossy Bear, and millions of books, toys and consumer goods produced since 2001.\nTheir art has been featured everywhere from the MoMA store in NYC and Tower Records Shibuya to Giant Robot and \nSun-Min + David have minted 2500+ works on OpenSea and Foundation since March of 2021.\nTheir blockchain based art presents a historical opportunity to offer original works of digital art.\nAll digital art by Sun-Min + David lives on blockchains which use several times less energy than Netflix.\n(And Netflix doesn’t use that much.)\n\n",
    exchange_url: "https://opensea.io/collection/8megs",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gae/JPZ_SBn-rV7tRXn321ULtI6TkaySjMGkFEaZwYNh-dvF0JWcxZI-f0RIIi4juUeME-Ho78GtDcWuaGZOu0W11vnqd0pXN5OQxrkKfQ?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/7QivfwLd1Hdfnw918KBr-suWP_-ep1Uujh5Ywu18OJenTp6RldiZJKKFH4siB0zW0CePRc9DSWULaCP6q9ke97Y5MuTHWlzijppiSQ?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/7QivfwLd1Hdfnw918KBr-suWP_-ep1Uujh5Ywu18OJenTp6RldiZJKKFH4siB0zW0CePRc9DSWULaCP6q9ke97Y5MuTHWlzijppiSQ?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/xbc9lJAHssdyR5U3Br2_izhgPVAzwBY5mdkqUJSuv_kjhgc1aVaS1qck1R5UIWeIFEV58tSYG9DPLRtTj_Mg0L17-1jJTVMKMFhJC7s?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 90,
      floor_price: 0.075,
      floor_price_symbol: "ETH",
      total_minted: 90,
      total_supply: null,
      total_volume: 45.40125550401745,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 288,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.15764324827783838,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 218,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:39:21.581Z",
    key: "co-r-ral-by-phaust",
    name: "Co(r)ral by Phaust",
    description: null,
    exchange_url: "https://opensea.io/collection/co-r-ral-by-phaust",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/5665af8ef04110bda8abab4f0d3e0044.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/WqDOzpF6gJ5lzm1bGGyLDiqLK7j128PYtattkhAruFbG7kfCj6X4bwfS3NcUyPck37icbB9nSR0bM-yUHT6JgWxdy5FqD5t7gZ0Gpg?w=500&auto=format",
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/WqDOzpF6gJ5lzm1bGGyLDiqLK7j128PYtattkhAruFbG7kfCj6X4bwfS3NcUyPck37icbB9nSR0bM-yUHT6JgWxdy5FqD5t7gZ0Gpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 52,
      floor_price: 0.09,
      floor_price_symbol: "ETH",
      total_minted: 52,
      total_supply: null,
      total_volume: 14.786859999999999,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 62,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.23849774193548384,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xbb5471c292065d3b01b2e81e299267221ae9a250",
      },
    ],
    id: 219,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:39:21.038Z",
    key: "thankyoux",
    name: "ThankYouX",
    description:
      "ThankYouX is inspired by the pop tropes and bright colors of the NYC graffiti scene as well as tech innovation. He graduated from LA street stencils to paintings and sculpture exhibitions in London, LA, Miami, NYC and Hong Kong. Now using his street style in a more unique way, he has gained world wide attention for his geometric cube paintings and large scale abstract works. In 2020 he made the leap into the NFT space and now ThankYouX is bringing the physical and digital worlds together a unique collection of original paintings and NFTs. Welcome to CONVERGENCE.",
    exchange_url: "https://opensea.io/collection/thankyoux",
    external_url: "https://www.phillips.com/auctions/auction/NY090321",
    banner_image_url:
      "https://i.seadn.io/gae/8-XQ6R2SmGw_LkgooJx0D5q3jKBgH0veZDwy03XXl3nsGsrvLpuJusfzyXa1K2BnFwHyA7z0bGAQyEjb03xP_kKDlQByhsLvVWmKfg?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/2M67rG7rI1yc-FzFI8PgCr8exVE5gJpvjsHqRp_31KOeIKyYVYIRZADpjpCJmopyjJ1mQRfCx1vo56AXDyO21FHHiyxM1C3TkqHfng?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: "THANKYOUX",
    wiki_url: null,
    instagram_username: "THANKYOUX",
    stats: {
      market_cap: 0,
      num_owners: 226,
      floor_price: 0.3,
      floor_price_symbol: "ETH",
      total_minted: 226,
      total_supply: null,
      total_volume: 24.774699999999996,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 121,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.20474958677685948,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xee03ec62ddfa8b3eff3ffe40201652f1a953f70c",
      },
    ],
    id: 220,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:41:01.901Z",
    key: "kroma-guardian-house",
    name: "Kroma Guardian House",
    description:
      "Kroma Guardian House (KGH) is a collection of NFTs indicating Kroma Guardians who support validators to make Kroma Network more secure and stable. KGH is the first attempts to enabling that any people can participate Kroma’s network validation, which reflect Kroma’s vision to the security",
    exchange_url: "https://opensea.io/collection/kroma-guardian-house",
    external_url: null,
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/ae3318407a3cdc1384f6c9799f1e9207.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/ae3318407a3cdc1384f6c9799f1e9207.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/30e697fc191ad56159b52a283a907f7a.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 586,
      floor_price: 0.0689,
      floor_price_symbol: "ETH",
      total_minted: 586,
      total_supply: null,
      total_volume: 0.47443749999999996,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.12190000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -1,
      total_sales: 10,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 3,
      total_average_price: 0.04744374999999999,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.040633333333333334,
    },
    contracts: [
      {
        contract_address: "0xaca91c74748090f861e25d142b6fcb265c6171c8",
      },
    ],
    id: 221,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:40:41.195Z",
    key: "pol-the-paradox",
    name: "POL by Harto",
    description:
      "We want to build the world's largest emotional NFT initiative, transforming community livestream sentiments into perpetually on-chain recorded geometric artworks.",
    exchange_url: "https://opensea.io/collection/pol-the-paradox",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/758d5f2cd386be81682f4a36330f1413.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/758d5f2cd386be81682f4a36330f1413.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/758d5f2cd386be81682f4a36330f1413.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/3b05b5291c513aa400e35a5baedd031b.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 368,
      floor_price: 0.08498940004000001,
      floor_price_symbol: "ETH",
      total_minted: 368,
      total_supply: null,
      total_volume: 120.38520905899915,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.06,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -14,
      total_sales: 883,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.1363365901007918,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.06,
    },
    contracts: [
      {
        contract_address: "0x4e214429d55697200f6c5213b6c6fd2f471c9ca4",
      },
    ],
    id: 222,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:40:34.334Z",
    key: "mutant-apewives",
    name: "Mutant ApeWives",
    description:
      "Project has been revived by new Leadership and is growing quickly! Please join Discord for updated info and Road Map      \n\nThe mutant ape wives project is a collection of 3333 NFTs with a backstory. This project was acquired by the community after the original anonymous owners decided they couldn’t carry on.\n\nAs a community we are bound by the love of the art, the blockchain and the continuous additions of utility that are added every time someone new purchases a maw and joins our growing community.\n\nView our MAWney Token here: https://opensea.io/collection/mawney",
    exchange_url: "https://opensea.io/collection/mutant-apewives",
    external_url: "https://mutantapewivesnft.webflow.io/",
    banner_image_url:
      "https://i.seadn.io/gae/l3Mr_8FrAbBzoh4H_OYKApClWtpSbK_OBs2iwjgLFCq8gtWt3CIkPLtRskJygCVYiiJ-29ubgvS7zzbyLfHGZkmJDKccRQ324OY4?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/m_QjNJExBMrJLR4j_lORmJKTNadRBgrokzS3Lk9NzA5m5QQN33vp7Mkw-55rh91I4dDmPTvzBxHHoGH1fwF1fsRUYnRhvnwQQCR5EI4?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: "MutantApeWives",
    wiki_url: null,
    instagram_username: "mutantapewive/",
    stats: {
      market_cap: 0,
      num_owners: 1301,
      floor_price: 0.005999,
      floor_price_symbol: "ETH",
      total_minted: 1301,
      total_supply: null,
      total_volume: 67.59318604821402,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 1974,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.03424173558673456,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x0a7fd3cef7f30ebeab3e9f0fbe4af90eac671cf1",
      },
    ],
    id: 223,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:40:18.959Z",
    key: "rug-radio-membership-pass",
    name: "Rug Radio Membership Pass",
    description:
      "Rug Radio Membership pass is your key to accessing value as a participant in the Rug Radio ecosystem.\r\nKey utility includes:\r\n\r\n- Vote & participate before you hold DAO ownership.\r\n- Most importantly, it’s how you are able to gain all kinds of benefit from participating in the community. \r\n\r\nIn addition to the Membership Pass Rug Radio has a Genesis NFT collection. The Genesis NFT allows you to earn our $RUG utility token which can earn you entry into the DAO.  You can see that collection here: https://opensea.io/collection/ruggenesis-nft",
    exchange_url: "https://opensea.io/collection/rug-radio-membership-pass",
    external_url: "https://www.rug.fm/",
    banner_image_url:
      "https://i.seadn.io/gae/e7k5z8bajMs_siuo_Y3pw0xmWPboGTOi5PHikzn_k00izWoFmqY1KM5ZSMItE336lx-QqXlnJdZtal8g4eoUq_sFW_UJOEmInkA48io?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/I4Jd-ET3UY7eKLYeC7WxrmJTsyxrsXHG0Zg_Yqif0vpFhO9oA6fMdzHX6ze0g4nzSFsjP7RZSyDMPUdeuJxDCjPx9moPzPJkqeVBeco?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 46.42586666666667,
      num_owners: 13441,
      floor_price: 0.00298999,
      floor_price_symbol: "ETH",
      total_minted: 13441,
      total_supply: null,
      total_volume: 3087.0252948689504,
      one_day_volume: 0.0088,
      seven_day_volume: 0.041800000000000004,
      thirty_day_volume: 0.22976799999999994,
      one_day_volume_change: -0.0038,
      seven_day_volume_change: 12,
      thirty_day_volume_change: -362,
      total_sales: 26520,
      one_day_sales: 4,
      seven_day_sales: 18,
      thirty_day_sales: 80,
      total_average_price: 0.11640366873563161,
      one_day_average_price: 0.0022,
      seven_day_average_price: 0.002322222222222222,
      thirty_day_average_price: 0.002872099999999999,
    },
    contracts: [
      {
        contract_address: "0xd1d411d2da363144248b98adab453aa3b19ccf04",
      },
    ],
    id: 224,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:40:18.298Z",
    key: "genesisbubblebots",
    name: "Genesis Bubble Bots",
    description:
      "Airdropped to you if you minted the Netherthorne Pass via peanutgames.com/mint. \n\nBubble Bots serves as a cool & fun PFP in our gaming ecosystem. In addition, it will play a crucial role in receiving the STAGE 1 community rewards. \n\nEssentially, the rewards will be dropped to you by simply holding a Bot. \n\nTo stay up to date, join our community.",
    exchange_url: "https://opensea.io/collection/genesisbubblebots",
    external_url: "https://peanutgames.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/efd397338831f22c6557c62f2649ccd6.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/8b4640f4fe183988ec90029d01de9a32.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/8b4640f4fe183988ec90029d01de9a32.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/8418aaa364a7c5e0dbe6f94b0f4f2921.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 55,
      floor_price: 0.00558459996000001,
      floor_price_symbol: "ETH",
      total_minted: 55,
      total_supply: null,
      total_volume: 21.05909778000001,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 125,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.16847278224000006,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xed02082bd33be0d2953d1430a130c5ea9b17f871",
      },
    ],
    id: 225,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:42:11.042Z",
    key: "hyper-drive-a-side-by-ryan-bell",
    name: "Hyper Drive: A-Side by Ryan Bell",
    description:
      "Art Blocks Collection: Presents\n\nProject Description: Hyper Drive is based on the mathematics of recursion. Scale symmetry is used to create patterns that repeat at ever-smaller intervals, creating the illusion of infinite depth and complexity.\n\nThe rule for the recursive loop is incredibly simple. A box is drawn, then a snapshot of the full canvas is resized to cover the boundary. As this process is repeated, small variations in position create endless fractals.\n\nThis project is an experimental cross-chain collection, with a fully-generative A-side published via Art Blocks on Ethereum and an AI-based image composition B-side published via fxhash on Tezos. The artwork symbolizes the great divides we must cross, the connections we make along the way, and the disconnections we feel. We move through the world as the world moves through us.",
    exchange_url:
      "https://opensea.io/collection/hyper-drive-a-side-by-ryan-bell",
    external_url: "https://artblocks.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/e6216e17265481b01b1e62690588a169.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/3af465a64ebed5aa0fbf6ed6a53ffa18.png?w=500&auto=format",
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/3af465a64ebed5aa0fbf6ed6a53ffa18.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 13.930000000000001,
      num_owners: 123,
      floor_price: 0.084,
      floor_price_symbol: "ETH",
      total_minted: 123,
      total_supply: null,
      total_volume: 196.50428490009992,
      one_day_volume: 0,
      seven_day_volume: 0.21000000000000002,
      thirty_day_volume: 0.21000000000000002,
      one_day_volume_change: 0,
      seven_day_volume_change: 3,
      thirty_day_volume_change: 1,
      total_sales: 226,
      one_day_sales: 0,
      seven_day_sales: 3,
      thirty_day_sales: 3,
      total_average_price: 0.869487986283628,
      one_day_average_price: 0,
      seven_day_average_price: 0.07,
      thirty_day_average_price: 0.07,
    },
    contracts: [
      {
        contract_address: "0x99a9b7c1116f9ceeb1652de04d5969cce509b069",
      },
    ],
    id: 226,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:42:02.914Z",
    key: "thecryptomasksproject",
    name: "The Cryptomasks Project",
    description:
      "The Cryptomasks is a collection of 555 randomly generated NFTs on the Ethereum blockchain created by [The Cryptomath](https://twitter.com/TheCryptomath).\nEach Cryptomasks is uniquely generated from 24 different rarity traits hand-drawn by [8th Project](https://opensea.io/8thproject).\n\nMonthly Airdrops for holders!\nThe backgrounds will determine the ranks:\nCommon gives you 1 chance per airdrop to win. Rare gives you 2 chances. Epic gives you 3 chances. Legendary gives you 5 chances. Mythic gives you 10 chances.\n\nFor each NFT of the collection there is a unique physical copy, signed by the artist with its certificate of authenticity on the blockchain. This copy can only be claimed once.\nTo check if the physical copy of a Cryptomasks has already been claimed, you can click [here](https://claim.thecryptomasks.xyz/check-physical) and fill in the ID of the Cryptomasks (the claim period is in January of each year).\n\nVisit www.thecryptomasks.xyz for more details.",
    exchange_url: "https://opensea.io/collection/thecryptomasksproject",
    external_url: "https://thecryptomasks.xyz/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/ad86e1a4a0032c20f88f4f63a378bd7d.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/GQNUkKcl3n0oO-GM-C-zZTXrUGAhq7eli2O_9tVsBMfe86jJ0Ok-TvK1EaXI4XoLGvlDUDzWaPY-HENMKL6-hFoukpPeO2GTj4LOrg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/GQNUkKcl3n0oO-GM-C-zZTXrUGAhq7eli2O_9tVsBMfe86jJ0Ok-TvK1EaXI4XoLGvlDUDzWaPY-HENMKL6-hFoukpPeO2GTj4LOrg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/85ac62393aae07e7329a27e382d65d58.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/thecryptomasks",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 396,
      floor_price: 0.14438940004,
      floor_price_symbol: "ETH",
      total_minted: 396,
      total_supply: null,
      total_volume: 141.60611392799993,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.2744,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -9,
      total_sales: 434,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 3,
      total_average_price: 0.3262813684976957,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.09146666666666665,
    },
    contracts: [
      {
        contract_address: "0xb45d21dc0c1cf275f790b668c3ae09ac5677b740",
      },
    ],
    id: 227,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:41:58.736Z",
    key: "temporale",
    name: "Temporale",
    description:
      "Temporale are Tapestries of Time. A digital-analog video-photo series by artist Sarah Zucker / [@thesarahshow](http://twitter.com/thesarahshow). \n\nEach Temporale is a fixed vantage point from which to see the fourth dimension. When you view a Temporale, you are witnessing Time’s flow interwoven with itself and captured in a still image.\n\nThese works begin as videos of luminous fabrics and materials rotating through space.\n\nThe seed videos are then subjected to a series of time displacements in an analog video ecosystem and then digitally slit-scanned, registering myriad timelines of the same moving object into a single still image.\n\nThe aim of this work is to evoke the non-linear experience of Time when moving between the physical and virtual worlds of the early 21st century.\n\nDue to their fluid nature, Temporale may be displayed vertically, horizontally or cropped at the viewer’s preference – each viewpoint allows for new facets to emerge.\n\nTemporale is an edition of 1/1/250.",
    exchange_url: "https://opensea.io/collection/temporale",
    external_url:
      "https://superrare.com/0x802f48de163cafb073dd00f582d3365112ee181b",
    banner_image_url:
      "https://i.seadn.io/gcs/files/37589f4d795e75f2fafebeb4a0ce2e14.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/cf7ecd92e238ee75abda52e75dd603d6.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/cf7ecd92e238ee75abda52e75dd603d6.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/9de603d010a875869e8e9979cd69aab9.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/VhatQjEcDw",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 194,
      floor_price: 0.22895,
      floor_price_symbol: "ETH",
      total_minted: 194,
      total_supply: null,
      total_volume: 37.355639999999994,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0784,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 60,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.6225939999999999,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0784,
    },
    contracts: [
      {
        contract_address: "0x802f48de163cafb073dd00f582d3365112ee181b",
      },
    ],
    id: 228,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:41:33.758Z",
    key: "financeapeclub-genesis",
    name: "FinanceApeClub-Genesis",
    description:
      "A burgeoning financial contract project specializing in offering secure and flexible over-the-counter (OTC) trading mode, while also supporting equity blockchain projects. What sets this project apart is its allocation of a portion of platform revenue to holders of FinanceApeClub-Genesis NFTs, providing them with an additional source of income.",
    exchange_url: "https://opensea.io/collection/financeapeclub-genesis",
    external_url: "https://www.financeapeclub.com/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/a964ea36881ada6afbb83ea8c78ef304.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/8de095568e1cb4cefeb2df8ae824c80a.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/8de095568e1cb4cefeb2df8ae824c80a.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/8de095568e1cb4cefeb2df8ae824c80a.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 159,
      floor_price: 0.0593,
      floor_price_symbol: "ETH",
      total_minted: 159,
      total_supply: null,
      total_volume: 2429.935616151004,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 52.779300000000035,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -178,
      total_sales: 1387,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 107,
      total_average_price: 1.7519362769653959,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.49326448598130873,
    },
    contracts: [
      {
        contract_address: "0x7c2053cf89f89a6bf183abc9414283315b9992a5",
      },
    ],
    id: 229,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:42:31.957Z",
    key: "miragem-by-third-vision",
    name: "Miragem by Third Vision",
    description:
      "Art Blocks Collection: Presents\n\nProject Description: Computation is one of the most powerful tools for our age. It opens up a whole world of possibilities. Some people use its power to solve the mysteries of our universe through science. I’m using it to explore our relationship with beauty and perception.\n\n“Miragem” *(Mirage in Portuguese)* is a generative project that requires your slow attention. It’s an exploration of rhythm, balance, and texture. Just simple elements in a coordinated dance, ruled by math and randomness.\n\n**It’s an invitation for the eyes and mind to wander.**\n\n\n >>  ‎  \n>> ## “Beauty is the mystery of life. It is not in the eye, it is in my mind. In our minds there is awareness of perfection.”\n>> Agnes Martin\n\n ‎\n*Please check the project website to know more about the composition and features.*",
    exchange_url: "https://opensea.io/collection/miragem-by-third-vision",
    external_url: "https://artblocks.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/27cc228ea2cab06caff52bab1058b320.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/d6c70170e2c6eedda4e73d1444eae0ba.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/d6c70170e2c6eedda4e73d1444eae0ba.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/d6c70170e2c6eedda4e73d1444eae0ba.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 165,
      floor_price: 0.015,
      floor_price_symbol: "ETH",
      total_minted: 165,
      total_supply: null,
      total_volume: 119.20998500000003,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 335,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.3558507014925374,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x99a9b7c1116f9ceeb1652de04d5969cce509b069",
      },
    ],
    id: 230,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:43:54.934Z",
    key: "unstable-objects-of-the-artificial-ceremony",
    name: "Unstable Objects of the Artificial Ceremony",
    description: null,
    exchange_url:
      "https://opensea.io/collection/unstable-objects-of-the-artificial-ceremony",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url: null,
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 3.2,
      num_owners: 208,
      floor_price: 0.07495,
      floor_price_symbol: "ETH",
      total_minted: 208,
      total_supply: null,
      total_volume: 3.868099000000001,
      one_day_volume: 0,
      seven_day_volume: 0.0128,
      thirty_day_volume: 0.0128,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 1,
      total_sales: 27,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 1,
      total_average_price: 0.14326292592592596,
      one_day_average_price: 0,
      seven_day_average_price: 0.0128,
      thirty_day_average_price: 0.0128,
    },
    contracts: [
      {
        contract_address: "0xe418c30ca2ecd3c046122ea0faf95a6b9da97191",
      },
    ],
    id: 231,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:43:51.153Z",
    key: "daopunksnft",
    name: "DAOpunks",
    description:
      "The DAOpunks is a collection of 1,111 unique NFTs. The DAOpunks’s mission is to enable humans to liberate themselves from the soul-sucking drudgery of default world work and lead them to the rewarding, expansive freedom found in meaningful DAO work. DAOpunk public goods grant, unique 1/1 claimable merch, massive DAO to DAO collaborations, and more! Visit www.daopunks.io for more details.",
    exchange_url: "https://opensea.io/collection/daopunksnft",
    external_url: "https://daopunks.io",
    banner_image_url:
      "https://i.seadn.io/gae/b1zjOmGiJrCNjeuoA1l3aWmWCqHUSLAmS79PZjh6zcI0zMtKXDoAjlZdOQg0Qknxp1zVxxV29jQIFbUYi9v2JUC8teviTmfFQXE2?w=500&auto=format",
    featured_image_url: null,
    large_image_url:
      "https://i.seadn.io/gae/QLgU7rg7RtGbv_Di1K671LD87QNnZXpXzHTfMxYYCYYB85zQA6DfMewMPgc8EzSCzBZLdN65PQxMRM_TmGUVRHC4tsgLbWiSRPt6Pg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/fpyFlFiwfJTe2_lD00907R-X9ZheiUcw4Pyuyz9vrDfLXHEIFBS3qP18DqfoWZIOkJl95FZw9nsR7vfN3xXJkJBLO9ZZZVRwJWSJ?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/daopunks",
    telegram_url: null,
    twitter_username: "DAOpunksNFT",
    wiki_url: null,
    instagram_username: "daopunks",
    stats: {
      market_cap: 0,
      num_owners: 636,
      floor_price: 0.03877940004000001,
      floor_price_symbol: "ETH",
      total_minted: 636,
      total_supply: null,
      total_volume: 190.602401975659,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 448,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.42545179012423884,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x700f045de43fce6d2c25df0288b41669b7566bbe",
      },
    ],
    id: 232,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:43:50.755Z",
    key: "jakeshotmess",
    name: "HOT MESS",
    description:
      "hot mess is a reward collection for degen token holders - https://opensea.io/assets/0xa3f226d6633ca531c1f8e26cfbf724b1eee9202e/9\n \nairdrop dates are released in advance and no snapshot will take place. the owners of the degen token at the time of each airdrop will receive (1) for each token held.",
    exchange_url: "https://opensea.io/collection/jakeshotmess",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gae/6gB75zlhBE58LzlHV4Mp2a8uV_H7QWm6YHQnZ7uPm8n-m_fGWw3hDWm90iU11QEBW2Mf4lnXUxYYVPeCaWo6XyE6Sw-XzN2xWiGD?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/shfGxjUeEqnqYPGq4OssInKZ2f3Jc-THTKoaI-tsm50VajAAHvkb-ZV8ULsTRK5DrtUaR8zXM1N6zwjkExOK_dv4LD3JDiRBwDct-A?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/shfGxjUeEqnqYPGq4OssInKZ2f3Jc-THTKoaI-tsm50VajAAHvkb-ZV8ULsTRK5DrtUaR8zXM1N6zwjkExOK_dv4LD3JDiRBwDct-A?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/shfGxjUeEqnqYPGq4OssInKZ2f3Jc-THTKoaI-tsm50VajAAHvkb-ZV8ULsTRK5DrtUaR8zXM1N6zwjkExOK_dv4LD3JDiRBwDct-A?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 509,
      floor_price: 0.01892940004000001,
      floor_price_symbol: "ETH",
      total_minted: 509,
      total_supply: null,
      total_volume: 310.3260152998501,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0175,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -11,
      total_sales: 1546,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 3,
      total_average_price: 0.2007283410736417,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.005833333333333334,
    },
    contracts: [
      {
        contract_address: "0x8c335a5e0cf05eca62ca1e49afa48531b694824e",
      },
    ],
    id: 233,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:43:47.095Z",
    key: "master-key-nft",
    name: "Master Key NFT",
    description:
      "Descubre la exclusividad con Master Key. Únete a una comunidad selecta donde los beneficios y oportunidades no tienen límites. \nPor Francisco Nicolás.\n\n## Artistas:\nJenifer Labarra (artista princial):\nhttps://www.instagram.com/jenifer.labarram/\n\nArtista secundario (alteraciones de los diseños de la artista principal para generar los diseños personalizados): \nhttps://www.instagram.com/limparfait.official/",
    exchange_url: "https://opensea.io/collection/master-key-nft",
    external_url: "https://masterkeynft.com/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/31f72542833030dc585a8841ce1ec686.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/e9ab89c1f3cb0ae65c670b38fe21125d.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/e9ab89c1f3cb0ae65c670b38fe21125d.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/56de24a5f6fbdb4f6dbdf3d1078ca1f7.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: "https://t.me/masterkeynft",
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 529,
      floor_price: 0.00997940004000001,
      floor_price_symbol: "ETH",
      total_minted: 529,
      total_supply: null,
      total_volume: 4.0173393939392,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0043,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -1,
      total_sales: 44,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.09130316804407274,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0043,
    },
    contracts: [
      {
        contract_address: "0xc7c82a0be062ab70cd5b0a09f920b74fa11fb2c8",
      },
    ],
    id: 234,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:43:46.622Z",
    key: "rektguy",
    name: "rektguy",
    description: "Down bad but never dead. https://rektguy.com",
    exchange_url: "https://opensea.io/collection/rektguy",
    external_url: "https://rektguy.com",
    banner_image_url:
      "https://i.seadn.io/gae/Xx-V2z1k3CQyMScCmrrpEgxAVxN6gDGbydc40TzmJVoST44qD1Ssc_augREsu3aLeRmKg5rOPz0XynD5cegToVvaNv1FIWON3laGqA?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/yF5IFTazZAfM2CjAGBZa_XyFA-lt1cZTOna3PDyami5Tmhv6m_rm4oXwDWwpnxQu9lZ5NMqRhHNbix5jrzzj2U772XhaFgsJiL1f?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/yF5IFTazZAfM2CjAGBZa_XyFA-lt1cZTOna3PDyami5Tmhv6m_rm4oXwDWwpnxQu9lZ5NMqRhHNbix5jrzzj2U772XhaFgsJiL1f?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/0d5f1b200a067938f507cbe12bbbabc2.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/rektguynft",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 2802.8827029044573,
      num_owners: 3342,
      floor_price: 0.333255,
      floor_price_symbol: "ETH",
      total_minted: 3342,
      total_supply: null,
      total_volume: 38937.57729989856,
      one_day_volume: 10.249796000000003,
      seven_day_volume: 49.93221199999998,
      thirty_day_volume: 138.85491697999947,
      one_day_volume_change: 13,
      seven_day_volume_change: 100,
      thirty_day_volume_change: 30,
      total_sales: 43652,
      one_day_sales: 31,
      seven_day_sales: 157,
      thirty_day_sales: 384,
      total_average_price: 0.8919998465110089,
      one_day_average_price: 0.3306385806451614,
      seven_day_average_price: 0.3180395668789808,
      thirty_day_average_price: 0.36160134630208196,
    },
    contracts: [
      {
        contract_address: "0xb852c6b5892256c264cc2c888ea462189154d8d7",
      },
    ],
    id: 235,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:45:03.643Z",
    key: "time-after-vessels-by-sofia-crespo",
    name: "Time after vessels by Sofia Crespo",
    description: null,
    exchange_url:
      "https://opensea.io/collection/time-after-vessels-by-sofia-crespo",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/8acfdd2ff1d58ea00b7c9cb0b90ed31d.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/9fa459fef03485e38de3ba3214992a23.png?w=500&auto=format",
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/9fa459fef03485e38de3ba3214992a23.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 81,
      floor_price: 0.35,
      floor_price_symbol: "ETH",
      total_minted: 81,
      total_supply: null,
      total_volume: 12.757999,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.25,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 23,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.5546956086956522,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.25,
    },
    contracts: [
      {
        contract_address: "0x7c3ea2b7b3befa1115ab51c09f0c9f245c500b18",
      },
    ],
    id: 236,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:45:03.199Z",
    key: "elemental-fang-lijun",
    name: "Elemental by Fang Lijun",
    description:
      "Fang Lijun’s latest NFT conveys the intense collision, fission and possibility of material elements when they converge, and how it activates human perception and the unknown.\r\n\r\nElemental is also Outland Art's MINTPASS for all future projects that are larger than 2022 editions.\r\n\r\nOutland Art is fostering critical conversations around emerging digital technologies + their connections to contemporary art.\r\n\r\nSee more information on our website: [https://outland.art/fang-lijun/](https://outland.art/fang-lijun/)",
    exchange_url: "https://opensea.io/collection/elemental-fang-lijun",
    external_url: "https://outland.art/fang-lijun/",
    banner_image_url:
      "https://i.seadn.io/gae/hyAY2_hS0x5YjCkEv009-yTfxw-c0TZvGHqOor6aqrPUhgz78bET1d8CBr-mtgAqiQR5Edyf_4n220jtImRFNpfixN93GYh0tdXqxA?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/TfiuyJTYBonvuXeNFCkK8UTOhzf9Z64g0f2besckC-oDX-tdro6_zCenIgMJadPvgKtLa36_Ti7CsCg_q0jhx31CdtlwOXk6V70CB8Q?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/TfiuyJTYBonvuXeNFCkK8UTOhzf9Z64g0f2besckC-oDX-tdro6_zCenIgMJadPvgKtLa36_Ti7CsCg_q0jhx31CdtlwOXk6V70CB8Q?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/hbe_-yi5K_UjPXiGj8IlxsR6ZMOy9AZs17vcCLIEbvS5Q7VaPCM7JwYmAioddCJ71rnEu_b11Dcyn2JXzhetqloLgHgnSrtJ3sRP?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/outland",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "outland_art",
    stats: {
      market_cap: 0,
      num_owners: 936,
      floor_price: 0.114191,
      floor_price_symbol: "ETH",
      total_minted: 936,
      total_supply: null,
      total_volume: 9621.149593799191,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.2474,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -9,
      total_sales: 6522,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 4,
      total_average_price: 1.4751839303586616,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.06185,
    },
    contracts: [
      {
        contract_address: "0xc9677cd8e9652f1b1aadd3429769b0ef8d7a0425",
      },
    ],
    id: 237,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:44:54.617Z",
    key: "animetas",
    name: "Animetas",
    description:
      "Animetas is a generative collection of 10101 unique 1/1 NFTs that live on the Ethereum Blockchain. The collection was designed by Gustavo Viselner and generated by cyberh49. Besides being residents of the Animetaverse, and members of the best community in the NFT space, Animetas owners can participate in unprecedented exclusive community events and challenges. Animetas owners will be granted access to our future Animetas-themed arcade world. For more info about Animetas, visit - www.animetas.io",
    exchange_url: "https://opensea.io/collection/animetas",
    external_url: "https://animetaverse.club/",
    banner_image_url:
      "https://i.seadn.io/gae/u1dksMCnfzcbRfUtFaOzxWAzZTV434isRUhLFgpMirRUkdT4qhP5WliqKb3jtX1-Xm52BFjntxaMBND2cJVGhI4DihtePrAPsojR86g?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/E8Jp3aUZFSKdZu7RdLHGfXzF1S29Ga7c5LV3aM0uDud9zbzgVInMgJknokGwEdBgDS567TG6gHekTkK5K6mlZJMR1sWlWT1K3lCX?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/r2ncCRzkck",
    telegram_url: null,
    twitter_username: "Animetas1",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 62.589000000000006,
      num_owners: 3831,
      floor_price: 0.006617,
      floor_price_symbol: "ETH",
      total_minted: 3831,
      total_supply: null,
      total_volume: 11121.67533185128,
      one_day_volume: 0.0044,
      seven_day_volume: 0.037200000000000004,
      thirty_day_volume: 0.35969500000000004,
      one_day_volume_change: -0.004599999999999999,
      seven_day_volume_change: 1,
      thirty_day_volume_change: -99,
      total_sales: 22383,
      one_day_sales: 1,
      seven_day_sales: 6,
      thirty_day_sales: 50,
      total_average_price: 0.49688045980660683,
      one_day_average_price: 0,
      seven_day_average_price: 0.006200000000000001,
      thirty_day_average_price: 0.007193900000000001,
    },
    contracts: [
      {
        contract_address: "0x18df6c571f6fe9283b87f910e41dc5c8b77b7da5",
      },
    ],
    id: 238,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:44:35.035Z",
    key: "million-dollars-painting",
    name: "Million Dollars Painting",
    description: null,
    exchange_url: "https://opensea.io/collection/million-dollars-painting",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/s/raw/files/ef1d04812251651ee5fff385f8ef1863.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 371,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x16ecdca760e2545720b554385f17588b36d6e673",
      },
    ],
    id: 239,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:44:20.517Z",
    key: "avastar",
    name: "Avastars",
    description:
      "Avastars (est. in Feb. 2020) are generative characters for the metaverse. Each one is unique and has their art and metadata stored on-chain. Avastars come licensed for use commercially by their owners. Collect Avastar Primes to make Replicants with their trait copies. IMPORTANT: When someone uses/burns a trait copy from an Avastar Prime, OpenSea shows “-Burned” after the trait name. ALWAYS CLICK ON A TRAIT TO SEE IF IT’S COPY IS BURNED BEFORE PURCHASE IF THIS IS IMPORTANT TO YOU. There is also a “MINT CONDITION” trait. All Avastars #0-25,199 are Avastar Primes. #25,200+ are Avastar Replicants. You cannot make a Replicant with another Replicant’s traits, and no 2 Avastar Primes or Replicants can ever be the same. You can also see whether an Avastar is a Prime or a Replicant under the “Wave” category. For more info, visit the Avastars Discord.",
    exchange_url: "https://opensea.io/collection/avastar",
    external_url: "https://avastars.io/",
    banner_image_url:
      "https://i.seadn.io/gae/iycBgTAdxv8wr2BcJoAvwXmzjzX6t_x56fVsv2XW98VldWXAsPnEAaF7REdvEk5gJ6FyG_hvs059dQfV3WD1Bh_k1kEXHoUZpKz2?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/static/featured/avastars-featured.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/nqAH3M0pky9XgNVA5p2rCplmpNX-K3F2aH1CMQ9i30ILpTklFW-lAhbMMXdDOQvLynbQqh883ivRwAjbz7_-59Jo?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/nqAH3M0pky9XgNVA5p2rCplmpNX-K3F2aH1CMQ9i30ILpTklFW-lAhbMMXdDOQvLynbQqh883ivRwAjbz7_-59Jo?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/avastars",
    telegram_url: null,
    twitter_username: "AvastarsNFT",
    wiki_url: null,
    instagram_username: "AvastarsNFT",
    stats: {
      market_cap: 252.28283036111108,
      num_owners: 5070,
      floor_price: 0.011759,
      floor_price_symbol: "ETH",
      total_minted: 5070,
      total_supply: null,
      total_volume: 4382.74770265159,
      one_day_volume: 0.029400000000000003,
      seven_day_volume: 0.34191099999999996,
      thirty_day_volume: 0.7353660000000002,
      one_day_volume_change: 1,
      seven_day_volume_change: 36,
      thirty_day_volume_change: 26,
      total_sales: 15036,
      one_day_sales: 3,
      seven_day_sales: 36,
      thirty_day_sales: 77,
      total_average_price: 0.2914836194899967,
      one_day_average_price: 0.009800000000000001,
      seven_day_average_price: 0.009497527777777777,
      thirty_day_average_price: 0.009550207792207796,
    },
    contracts: [
      {
        contract_address: "0xf3e778f839934fc819cfa1040aabacecba01e049",
      },
    ],
    id: 240,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:46:13.835Z",
    key: "hytopia-genesis-avatars",
    name: "HYTOPIA Avatars: Genesis",
    description:
      "An official [HYTOPIA](https://opensea.io/collection/topia-worlds) collection.\n\n15,000 Genesis Avatars. Playable characters within the [HYTOPIA](https://opensea.io/collection/topia-worlds) ecosystem. Owning a Genesis Avatar gives access to a unique fully playable character, exclusive in-game item airdrops, $TOPIA staking, rare in-game titles and more.",
    exchange_url: "https://opensea.io/collection/hytopia-genesis-avatars",
    external_url: "https://nftworlds.com/avatars",
    banner_image_url:
      "https://i.seadn.io/gae/L7iYSoz45NKbt42-SCRv4ECELtQAxjN2mtHNcPLRRtu1mrTFFSUTKVC3QGC9XvEVA9aKdcsCfkkdzlK3iasDPz4rS_ETcSogV7zK?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/f80345a3aaf9bae37214fa7c151bf5b4.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/f80345a3aaf9bae37214fa7c151bf5b4.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/z2xHmmGG46kp6xOtFc604xPgxT886qvyhKKvAFjNABfi2WcNlYgkyI6n50lAwEwu74O4Q67T9jRnWLVllg6aW5oUFLL0ngvkm4cf?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 519.6196408380954,
      num_owners: 2245,
      floor_price: 0.030546,
      floor_price_symbol: "ETH",
      total_minted: 2245,
      total_supply: null,
      total_volume: 1671.3020775411364,
      one_day_volume: 0,
      seven_day_volume: 0.9158214400000002,
      thirty_day_volume: 4.57032682888889,
      one_day_volume_change: 0,
      seven_day_volume_change: -31,
      thirty_day_volume_change: -31,
      total_sales: 10604,
      one_day_sales: 0,
      seven_day_sales: 21,
      thirty_day_sales: 135,
      total_average_price: 0.1576105316428835,
      one_day_average_price: 0,
      seven_day_average_price: 0.04361054476190477,
      thirty_day_average_price: 0.033854272806584366,
    },
    contracts: [
      {
        contract_address: "0x05745e72fb8b4a9b51118a168d956760e4a36444",
      },
    ],
    id: 241,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:45:51.298Z",
    key: "fishyfam",
    name: "FishyFam",
    description:
      "Hey Fam!\n\nFishy Fam is an NFT collection on the Ethereum blockchain consisting of 9,999 collectible Fishy’s, who are leaving their Great Reef to go on an ocean adventure. Fishy holders receive access to exclusive drops, experiences, and more. Visit [fishyfam](https://fishyfam.io) for more info.\n\nCheck out our other collections: [Deep Sea Creatures](https://opensea.io/collection/deepseacreaturesnft) | [Fishy Collabs](https://opensea.io/collection/fishycollabs) | [ Mind of Zam](https://opensea.io/collection/mindofzam)",
    exchange_url: "https://opensea.io/collection/fishyfam",
    external_url: "http://fishyfam.io",
    banner_image_url:
      "https://openseauserdata.com/files/ea966ae72cc97c49e4abcc11212198a3.svg",
    featured_image_url:
      "https://i.seadn.io/gcs/files/1679790e201002a6d52ddee8702a10b0.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/1679790e201002a6d52ddee8702a10b0.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/80bfaa3696480b38a864fffc0a0e832a.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/r7aj9HvcYS",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "fishyfamNFT",
    stats: {
      market_cap: 23.88950945454545,
      num_owners: 5248,
      floor_price: 0.004399,
      floor_price_symbol: "ETH",
      total_minted: 5248,
      total_supply: null,
      total_volume: 8778.958567350122,
      one_day_volume: 0.0021,
      seven_day_volume: 0.05259899999999999,
      thirty_day_volume: 0.21349799999999994,
      one_day_volume_change: -0.006,
      seven_day_volume_change: 7,
      thirty_day_volume_change: 16,
      total_sales: 23461,
      one_day_sales: 1,
      seven_day_sales: 22,
      thirty_day_sales: 50,
      total_average_price: 0.37419370731640267,
      one_day_average_price: 0,
      seven_day_average_price: 0.002390863636363636,
      thirty_day_average_price: 0.004269959999999999,
    },
    contracts: [
      {
        contract_address: "0x63fa29fec10c997851ccd2466dad20e51b17c8af",
      },
    ],
    id: 242,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:45:15.995Z",
    key: "meta-monopoly",
    name: "Meta Monopoly",
    description:
      "NFT Storytelling: Experience a unique collection of animated memes where characters come to life through captivating animations! Each week, we unveil new videos that bring fresh stories to your screen. Dive into a world of creative NFT storytelling where imagination knows no bounds.\n\nNote: We are not affiliated with Hasbro, Inc. The character and/or “mascot” for the original Monopoly is not trademarked or owned by any individual or company.",
    exchange_url: "https://opensea.io/collection/meta-monopoly",
    external_url: "http://metamonopoly.org",
    banner_image_url:
      "https://i.seadn.io/gcs/files/b748ed667d5e748ea72d3ecfb4adc202.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/0a4934ba84a8615749bf41712ca8c5a3.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/0a4934ba84a8615749bf41712ca8c5a3.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/08a487a2e82bb49fc62fe84eec1ab2ea.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/cFFqPA7gxQ",
    telegram_url: "https://t.me/metamonopolyofficial",
    twitter_username: null,
    wiki_url: null,
    instagram_username: "meta.monopoly",
    stats: {
      market_cap: 124.40921785714283,
      num_owners: 320,
      floor_price: 0.09758,
      floor_price_symbol: "ETH",
      total_minted: 320,
      total_supply: null,
      total_volume: 2453.9249990899034,
      one_day_volume: 0.608,
      seven_day_volume: 3.5948999999999995,
      thirty_day_volume: 61.958320000000015,
      one_day_volume_change: 0.608,
      seven_day_volume_change: -61,
      thirty_day_volume_change: 239,
      total_sales: 2087,
      one_day_sales: 5,
      seven_day_sales: 28,
      thirty_day_sales: 323,
      total_average_price: 1.175814565927122,
      one_day_average_price: 0.1216,
      seven_day_average_price: 0.1283892857142857,
      thirty_day_average_price: 0.19182142414860687,
    },
    contracts: [
      {
        contract_address: "0xe47e5dcde8e14e874d2711e786bb34ae6980bef8",
      },
    ],
    id: 243,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:47:06.442Z",
    key: "hpprs-collection",
    name: "HPPRS Collection",
    description:
      "HPPRS is a 8000 piece generative collection by @shakkablood. The HPPRS are an infamous gang of rabbits who participate in mischievous and heinous activities. Each HPPR is completely unique, masking their identity in various forms/combinations.\n\n[WEBSITE](https://www.hpprs.io/)\n\n[PCKR Drones](https://opensea.io/collection/pckr-drones)\n\n[HPPRS Hall Pass](https://opensea.io/collection/hppr-hall-passes)\n\n[HPPRS PLUS (1/1s)](https://opensea.io/collection/hpprs-plus)",
    exchange_url: "https://opensea.io/collection/hpprs-collection",
    external_url: "https://hoppersnft.xyz",
    banner_image_url:
      "https://i.seadn.io/gcs/files/507176320c2620a2faa2124bb587621e.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/d1c8485265515273cc1fb3cb6eee332d.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/d1c8485265515273cc1fb3cb6eee332d.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/1d06066d0e4927d43b80d7cba274f0e3.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/exaCw5tGXY",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 35.51127003846154,
      num_owners: 2684,
      floor_price: 0.005199,
      floor_price_symbol: "ETH",
      total_minted: 2684,
      total_supply: null,
      total_volume: 616.7250851313263,
      one_day_volume: 0,
      seven_day_volume: 0.13619900000000001,
      thirty_day_volume: 0.18129000000000003,
      one_day_volume_change: 0,
      seven_day_volume_change: 14,
      thirty_day_volume_change: -47,
      total_sales: 5937,
      one_day_sales: 0,
      seven_day_sales: 26,
      thirty_day_sales: 40,
      total_average_price: 0.10387823566301604,
      one_day_average_price: 0,
      seven_day_average_price: 0.005238423076923077,
      thirty_day_average_price: 0.004532250000000001,
    },
    contracts: [
      {
        contract_address: "0xe2609354791bf57e54b3f7f9a26b2dacbed61da1",
      },
    ],
    id: 244,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:46:32.407Z",
    key: "bitemares",
    name: "Bitemares",
    description:
      "[MINT IS LIVE](https://www.chompiesnft.com/mint) \nBitemares is a continuation of their mother project Chompies NFT. \nBringing the fun and games of web3 to the masses! \n\nFREE mobile game! Real World Assets! Dental Health! Autism Appreciation! ",
    exchange_url: "https://opensea.io/collection/bitemares",
    external_url: null,
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/5d144dd347d0b14ac353fc3d5ea2e107.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/5d144dd347d0b14ac353fc3d5ea2e107.png?w=500&auto=format",
    image_url: null,
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 9.96,
      num_owners: 144,
      floor_price: 0.011,
      floor_price_symbol: "ETH",
      total_minted: 144,
      total_supply: null,
      total_volume: 0.0529,
      one_day_volume: 0,
      seven_day_volume: 0.02,
      thirty_day_volume: 0.0419,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 4,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 3,
      total_average_price: 0.013225,
      one_day_average_price: 0,
      seven_day_average_price: 0.02,
      thirty_day_average_price: 0.013966666666666667,
    },
    contracts: [
      {
        contract_address: "0xafc0e66f11494afa85755d06d73a9ba1ebfdb3f3",
      },
    ],
    id: 245,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:47:55.698Z",
    key: "mr-floppys-diary",
    name: "Mr Floppy's Diary",
    description:
      "Hi, I'm Mr. Floppy. I was born in the 1960s. This is my diary that shows my life that you might not have noticed. I see the modern world changing in a fast pace driven by technology.  One thing that remains constant is that I'm still here to save your file, your work, your memory and your dream...",
    exchange_url: "https://opensea.io/collection/mr-floppys-diary",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gae/g97A-jIsTQ5Tf3mAUf8Pxy6Y_8J3jnPrU2ngToPy9GPbgFJ9AgV1VpXtpmlP8_Qy29LGlKXs_GFN9C2f6XD8XDQwEROPAiax57mj?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/udLm_JT7AKfO4jFS5vGwM4WtrHHwx5qg7veYSwEpQ4LfdCMuwddcmspVnRTitBkotjGcC39SlEAFVJtg1kloKCWZSGXD9WX_r6XIWQ?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/udLm_JT7AKfO4jFS5vGwM4WtrHHwx5qg7veYSwEpQ4LfdCMuwddcmspVnRTitBkotjGcC39SlEAFVJtg1kloKCWZSGXD9WX_r6XIWQ?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/KLCcYxd1DEiBELum9WY4lCfu18gmGWvliLHqkEOv-QOgqVNv6LdCaIpQM9f_ivqnr2Im_VtWrcU5CW2ScmF38BZb3tbXxaiBI_j3Ww?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 0.5,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 246,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:47:55.237Z",
    key: "angry-dynomites-lab-fire-dynos",
    name: "Angry Dynomites Lab - Fire Dynos",
    description:
      "🔥 The Genesis Fire Dyno collection is the first of four collections, followed by 💧[Water Dynos](https://opensea.io/collection/angry-dynomites-lab-water-dynos), 🌱 Earth, and 💨 Air\n\n\nVisit https://www.angrydynomiteslab.com for more details.\n\nAngry Dynomites Lab is the world's first massive co-op multiplayer game on the blockchain. Players need to unite to build artifacts to help the poor Dynomites survive. Many materials are required to create these so-called Masterpieces, making it impossible to build them for a single player alone. Therefore, the community needs to collaborate to establish a flourishing, decentralized economy powered by tokens living on the blockchain. Players need to craft materials, set up production lines, trade with each other, and optimize their production empire to keep our clumsy Dynomites alive.",
    exchange_url:
      "https://opensea.io/collection/angry-dynomites-lab-fire-dynos",
    external_url:
      "https://www.angrydynomiteslab.com/?utm_source=Opensea&utm_medium=FireDynoCollection",
    banner_image_url:
      "https://i.seadn.io/gae/rTeG-sFHA_9pOGCFTpTAytKfMTP0N5IEenlZFc-wi74IH6A6KViCwyALLKAIi9Ph3XQKc4Ky6L9Vit3CKS5z5HzOfyDFJ9yJqQInlyQ?w=500&auto=format",
    featured_image_url: null,
    large_image_url:
      "https://i.seadn.io/gae/_a-BeVg5MQOA7g6tMFknTsk_Nm_D3Q0AKJaCnHgpp_XP0odkjJGqm9lkzqN-FtFnYJcAlEn2-ynLC_fG9D12mrR0UMehciyKqrWJET4?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/5gWyKjmi-iPVhcJBvrqJNcLfTpj5_UtJSe4uN-ELsBOTy2cEKBfnAOumXCYm0n-S0Xnw-AoEp8uNf9ie99z0CW2jzt4WHrkI_SFX4w?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/AngryDynomites",
    telegram_url: "https://t.me/AngryDynomitesLab",
    twitter_username: null,
    wiki_url: null,
    instagram_username: "angrydynomiteslab",
    stats: {
      market_cap: 0,
      num_owners: 193,
      floor_price: 0.24849,
      floor_price_symbol: "ETH",
      total_minted: 193,
      total_supply: null,
      total_volume: 248.25894464877678,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.563,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 939,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 2,
      total_average_price: 0.264386522522659,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.2815,
    },
    contracts: [
      {
        contract_address: "0xee85b6ce11276b50c72b2504776f8faa36f29931",
      },
    ],
    id: 247,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:49:05.361Z",
    key: "toolsofrock",
    name: "Tools Of Rock",
    description:
      "Tools of Rock is a collection of 8,500 unique and generative collectable NFTs rocking on the Ethereum blockchain. ~170 generative traits, each hand crafted and researched to capture the spirit and energy that defined the greatest generations in Rock & Roll.",
    exchange_url: "https://opensea.io/collection/toolsofrock",
    external_url: "https://www.toolsofrock.com/",
    banner_image_url:
      "https://i.seadn.io/gae/iJlwI5FCnt01pwsMGAVYfozUOi22rsfCo5ZbixXlRw1QLjjMr28DvnZOcy9Prz4RF27wRwMvtBuclGWYXnAc2gM5HTYkhoHbBuOG?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/tuGP6k_O1eZhzBaiHOD0zGJKLPwXq8oDiqFpWuDYC_UNfI87YmRRhPq1lFG98kutfaBE3oVXXelQB7Zc5n8XIwyokrYY6zOvfXTuh2c?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/tuGP6k_O1eZhzBaiHOD0zGJKLPwXq8oDiqFpWuDYC_UNfI87YmRRhPq1lFG98kutfaBE3oVXXelQB7Zc5n8XIwyokrYY6zOvfXTuh2c?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/unH5gENY8NavBvtvPt21ANq9WjoAFpy_7YrAhVmZowr5bgCLkfCXB646qkSdLcIPmRLLA7q461-BZ9ni712cUaurlfwwCYZpjK-9Lw?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/torofficial",
    telegram_url: null,
    twitter_username: "ToolsOfRockNFT",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 2060,
      floor_price: 0.003,
      floor_price_symbol: "ETH",
      total_minted: 2060,
      total_supply: null,
      total_volume: 1832.327827094187,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 8282,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.2212421911487789,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xc2f05fd9fe4cfe8f7395ddb220c84d3ef240cf3d",
      },
    ],
    id: 248,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:48:54.815Z",
    key: "nimteens-by-bryan-brinkman",
    name: "NimTeens by Bryan Brinkman",
    description:
      "Art Blocks Collection: Presents\n\nProject Description: A collection of on-chain, generative cumulonimbus teenagers, ready for their class photo. A fun follow-up to NimBuds (Art Blocks Project #10). \n\nCreated using vanilla javascript, each unique NimTeen features random hair, colors, eyes, mouths, acne, bodies,backdrops and more. Each with its own personality.",
    exchange_url: "https://opensea.io/collection/nimteens-by-bryan-brinkman",
    external_url: "https://artblocks.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/ad00eeaa0f581615db3a4b623c4f3b38.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/e4cc9d15ac2327af35160e011bef785e.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/e4cc9d15ac2327af35160e011bef785e.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/5de8df72ea825067115d47a2d6fb3619.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 9.46,
      num_owners: 275,
      floor_price: 0.0449,
      floor_price_symbol: "ETH",
      total_minted: 275,
      total_supply: null,
      total_volume: 165.06650393633333,
      one_day_volume: 0.0123,
      seven_day_volume: 0.0473,
      thirty_day_volume: 0.2309,
      one_day_volume_change: 0.0123,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 0,
      total_sales: 432,
      one_day_sales: 1,
      seven_day_sales: 2,
      thirty_day_sales: 4,
      total_average_price: 0.38209838874151236,
      one_day_average_price: 0,
      seven_day_average_price: 0.02365,
      thirty_day_average_price: 0.057725,
    },
    contracts: [
      {
        contract_address: "0x99a9b7c1116f9ceeb1652de04d5969cce509b069",
      },
    ],
    id: 249,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:48:41.499Z",
    key: "waytogods",
    name: "Way To Gods",
    description:
      "If immortality is what you seek, this is the Way.\nFrom T&B Media Global, join Mo Ke and Min - two travelers seeking immortality within the Mittaria Universe.",
    exchange_url: "https://opensea.io/collection/waytogods",
    external_url: "https://waytogods.mittaria.io/",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/26759cc2cd5a6e59ee78daf81f8da56f.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/26759cc2cd5a6e59ee78daf81f8da56f.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/780adc5e6d50dc05be3ad7da314dcd91.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/Mittaria",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 76.46387402777778,
      num_owners: 2344,
      floor_price: 0.0118,
      floor_price_symbol: "ETH",
      total_minted: 2344,
      total_supply: null,
      total_volume: 246.67732136559084,
      one_day_volume: 0.065884,
      seven_day_volume: 0.399695,
      thirty_day_volume: 1.7760661300000005,
      one_day_volume_change: -0.001573000000000005,
      seven_day_volume_change: 4,
      thirty_day_volume_change: 25,
      total_sales: 6713,
      one_day_sales: 6,
      seven_day_sales: 36,
      thirty_day_sales: 165,
      total_average_price: 0.03674621203122164,
      one_day_average_price: 0.010980666666666666,
      seven_day_average_price: 0.01110263888888889,
      thirty_day_average_price: 0.010764037151515153,
    },
    contracts: [
      {
        contract_address: "0x98954e8e24772ecea85710f0987eb50d223cba95",
      },
    ],
    id: 250,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:48:29.280Z",
    key: "maa-kheru",
    name: "Maa Kheru",
    description: null,
    exchange_url: "https://opensea.io/collection/maa-kheru",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://raw.seadn.io/files/447d324b57403be0ee49bb2fb83cc90c.svg",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 421,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x18678aba3bb2cb5b3430db7001f1a93fc5f31976",
      },
    ],
    id: 251,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:48:14.058Z",
    key: "superspacedefenders",
    name: "Super Space Defenders",
    description:
      " - **Super Space Defenders** is an upcoming NFT Collection consisting of 4,444 cloned individuals with different personalities, political affinities and styles, living in a reality where the human species is only a memory in the history books. The solar system is now inhabited by the Aurora Sapiens, biological duplicates with synthetic additives from Subject #4,444 Aurora, the only human whose genetic code managed to be replicated.\n - They’re mainly divided in two groups: The Elites and The Citizens. The Elites are a group of wealthy Families that govern the galaxy, while the Citizens are the workforce of the galaxy, living under the Elite’s rules. But... it's time for some changes, isn't it?!\n - Will you join the Rebels' growing force fighting for justice, or will you keep feeding the Elites' power and greed?\n - [Super Space Defenders](https://www.ssdefenders.io)",
    exchange_url: "https://opensea.io/collection/superspacedefenders",
    external_url: "http://ssdefenders.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/38c839cfeb772daa7b95899a125e0963.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/5b7bdd7790b9c52622735840578bc753.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/5b7bdd7790b9c52622735840578bc753.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/ecd8893491ac82c38a6e349675b1c853.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/ssdefenders",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 17.521517870097778,
      num_owners: 384,
      floor_price: 0.031899,
      floor_price_symbol: "ETH",
      total_minted: 384,
      total_supply: null,
      total_volume: 16.995331000103878,
      one_day_volume: 0,
      seven_day_volume: 0.40853280008,
      thirty_day_volume: 0.5994670001040222,
      one_day_volume_change: 0,
      seven_day_volume_change: 35,
      thirty_day_volume_change: 38,
      total_sales: 615,
      one_day_sales: 0,
      seven_day_sales: 36,
      thirty_day_sales: 48,
      total_average_price: 0.027634684553014436,
      one_day_average_price: 0,
      seven_day_average_price: 0.011348133335555555,
      thirty_day_average_price: 0.012488895835500464,
    },
    contracts: [
      {
        contract_address: "0x6ea26ecde564df85d4c631e041ff7630296b08b8",
      },
    ],
    id: 252,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:49:56.953Z",
    key: "nobodyeth",
    name: "Nobody .",
    description:
      "Clickable/Interactive NFTs - Collection of 3210 Nobody NFTs\r\n\r\nEach NFT has 2 sets of discoverable animations.\r\nSometimes we can relieve energy in lower consistent amounts or sometimes hold it thinking we're fine and then blow up positively and/or negatively.  We just need to refresh ourselves from time to time.",
    exchange_url: "https://opensea.io/collection/nobodyeth",
    external_url: "https://nobodyeth.art",
    banner_image_url:
      "https://i.seadn.io/gae/2CCDW0nBBOuWcybSjDwDuutpoZ6cJUmpcTKwmibeGjpscZrIHO_yi6cfUwpg0pusD2t8ro7FcTgBrPbHCfmhLUx9V1tmFa1xVMzj?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/FS4rR2LfTHEqF3dW2LGxcNp3ktxhx2Xs8z0OCrA8ZadPXwJEvKsJPtEcBUH4fnBKTu1HnyV7s1xnfDPX0FNLCU5hWN-lqeROkjOXkg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/FS4rR2LfTHEqF3dW2LGxcNp3ktxhx2Xs8z0OCrA8ZadPXwJEvKsJPtEcBUH4fnBKTu1HnyV7s1xnfDPX0FNLCU5hWN-lqeROkjOXkg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/yWHGj4iy-0gS8HW9SdRvcATn91F9m1L58BAJLhtlOBQ30EHX6kKQARNuXCz-3fxJcV7MlSxy3WyiHul7P7HWXb4HHNQ_VM8L_-9Nmg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: "Nobodyeth",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 10.686499999999999,
      num_owners: 1209,
      floor_price: 0.0047,
      floor_price_symbol: "ETH",
      total_minted: 1209,
      total_supply: null,
      total_volume: 615.1239397475183,
      one_day_volume: 0.0019,
      seven_day_volume: 0.006699999999999999,
      thirty_day_volume: 0.006699999999999999,
      one_day_volume_change: -0.0029,
      seven_day_volume_change: 2,
      thirty_day_volume_change: 0,
      total_sales: 4300,
      one_day_sales: 1,
      seven_day_sales: 2,
      thirty_day_sales: 2,
      total_average_price: 0.14305207901105077,
      one_day_average_price: 0,
      seven_day_average_price: 0.00335,
      thirty_day_average_price: 0.00335,
    },
    contracts: [
      {
        contract_address: "0x219463d0675c3fa01c1edf537ec5dc693b6410ae",
      },
    ],
    id: 253,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:49:56.483Z",
    key: "nexus-chronicles",
    name: "Nexus Chronicles",
    description: null,
    exchange_url: "https://opensea.io/collection/nexus-chronicles",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/s/raw/files/c493f1e3543f88e7aa40559e48ba2af3.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 0.05,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xc7415509f2b0b16bd4c7a9e4b21906d832187ae2",
      },
    ],
    id: 254,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:49:44.459Z",
    key: "linageenamewrapper",
    name: "Linagee Name Registrar (LNR)",
    description:
      "By Linagee, from the first NFT contract on Ethereum, launched August 8, 2015.  \n  \nDisclaimer:  \nPlease use the bytecode to confirm any names. The categories act as a guide but we cannot guarantee the accuracy of every name.",
    exchange_url: "https://opensea.io/collection/linageenamewrapper",
    external_url: "https://linagee.vision/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/e93a7eee826c9b0c6d47f12bb379baf2.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/2ee1ddd211f39d39a4732433af1e75d4.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/2ee1ddd211f39d39a4732433af1e75d4.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/240ac5920778f5ae0de8a3f6176b4d3c.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/DAKRWGfMyx",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 6.9284,
      num_owners: 15150,
      floor_price: 0.0005,
      floor_price_symbol: "ETH",
      total_minted: 15150,
      total_supply: null,
      total_volume: 1076.0435611319078,
      one_day_volume: 0,
      seven_day_volume: 0.0004,
      thirty_day_volume: 0.0004,
      one_day_volume_change: 0,
      seven_day_volume_change: 4,
      thirty_day_volume_change: -1,
      total_sales: 20970,
      one_day_sales: 0,
      seven_day_sales: 4,
      thirty_day_sales: 4,
      total_average_price: 0.05131347454134038,
      one_day_average_price: 0,
      seven_day_average_price: 0.0001,
      thirty_day_average_price: 0.0001,
    },
    contracts: [
      {
        contract_address: "0x2cc8342d7c8bff5a213eb2cde39de9a59b3461a7",
      },
    ],
    id: 255,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:51:49.461Z",
    key: "krapopolis-krap-chickens",
    name: "Krapopolis Krap Chickens",
    description:
      "Discover KRAPOPOLIS Krap Chickens, a one-of-a-kind digital collectible from FOX. From Dan Harmon, co-creator of ‘Rick and Morty', KRAPOPOLIS features voices by Emmy-Award winner Hannah Waddingham, Richard Ayoade, Matt Berry, Pam Murphy, and Duncan Trussell.\r\n\r\nWatch Krapopolis Sundays at 8:30/7:30c on FOX, next day Hulu. \r\n\r\nJoin the Krapopolis community and immerse yourself in this mythological adventure with your very own Krap Chicken. Learn more at Krapopolis.com",
    exchange_url: "https://opensea.io/collection/krapopolis-krap-chickens",
    external_url: "https://www.krapopolis.com",
    banner_image_url:
      "https://i.seadn.io/s/raw/files/02171a4b20d334b610127e30d65a77d9.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/6f7616aa1a7ce21074d8a643846693d7.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/6f7616aa1a7ce21074d8a643846693d7.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/eff9f792f1dfd9c23e035cf65f4811ce.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.krapopolis.com/",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "anidom/?hl=en",
    stats: {
      market_cap: 43.079416666666674,
      num_owners: 1351,
      floor_price: 0.008786,
      floor_price_symbol: "ETH",
      total_minted: 1351,
      total_supply: null,
      total_volume: 554.2945724259853,
      one_day_volume: 0.0097,
      seven_day_volume: 0.06470000000000001,
      thirty_day_volume: 0.12149999999999998,
      one_day_volume_change: 0.0097,
      seven_day_volume_change: 4,
      thirty_day_volume_change: 5,
      total_sales: 4689,
      one_day_sales: 1,
      seven_day_sales: 6,
      thirty_day_sales: 17,
      total_average_price: 0.11821168104627539,
      one_day_average_price: 0,
      seven_day_average_price: 0.010783333333333336,
      thirty_day_average_price: 0.007147058823529411,
    },
    contracts: [
      {
        contract_address: "0x5a57ed460bd0368bfcf48dd3dd246a56b4bbb891",
      },
    ],
    id: 256,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:51:37.639Z",
    key: "blvckgenesis",
    name: "Blvck Genesis",
    description:
      "Blvck Genesis is a collection of 9,999 Blvck avatar NFTs living on the Ethereum blockchain. With hundreds of artistic elements, high fashion traits and monochrome aesthetics, each graphic is crafted by Julian O'hayon, French designer and founder of global lifestyle brand, Blvck Paris. By owning a Blvck Genesis avatar, you will immediately have membership access to exclusive events, lifestyle products and rewards. Join the Blvck movement.",
    exchange_url: "https://opensea.io/collection/blvckgenesis",
    external_url: "https://blvck.com",
    banner_image_url:
      "https://i.seadn.io/gae/NJFGq4Vl7L1181M9k9xBegagd97sMWOz8hi2z4uBfVoxgvhFHpiD36uMkSkyLBIUROtdUOfORktms5PS5EKTkiLEYpzOjnJg98s_rjY?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/cQ0Z5z5CyFz9umUar2HEg-p3_z0E4U9tOmsBzslqwkRRF36_vBLl76xHbOyiRUKq0Yg4bXUPRbR6DfaLa8jyG5I32JE9m9HEhUWU7A?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/cQ0Z5z5CyFz9umUar2HEg-p3_z0E4U9tOmsBzslqwkRRF36_vBLl76xHbOyiRUKq0Yg4bXUPRbR6DfaLa8jyG5I32JE9m9HEhUWU7A?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/CuIyk9FayPXFXHondh5EsVBK-k5IpsqXe-wSeo0sTXGnNHs0qXs_euw7gadS4fXJRcv_rySDaU6mso_Z1Oq271U5mPt4TR0nfDlY?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/blvckparis",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "black",
    stats: {
      market_cap: 127.20482823085716,
      num_owners: 4802,
      floor_price: 0.009389,
      floor_price_symbol: "ETH",
      total_minted: 4802,
      total_supply: null,
      total_volume: 2403.9883682040527,
      one_day_volume: 0.038502,
      seven_day_volume: 0.44530596000000006,
      thirty_day_volume: 0.8500599599999998,
      one_day_volume_change: 0.004902000000000004,
      seven_day_volume_change: 15,
      thirty_day_volume_change: 8,
      total_sales: 16194,
      one_day_sales: 4,
      seven_day_sales: 35,
      thirty_day_sales: 79,
      total_average_price: 0.14844932494776167,
      one_day_average_price: 0.0096255,
      seven_day_average_price: 0.01272302742857143,
      thirty_day_average_price: 0.010760252658227845,
    },
    contracts: [
      {
        contract_address: "0x83b070e842adba2397113c4bca70c00d7df00729",
      },
    ],
    id: 257,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:51:33.739Z",
    key: "exverse-pass",
    name: "Exverse Genesis Pass",
    description:
      "The Exverse Genesis Pass\n\nThe genesis of everything at Exverse, and its most valuable asset.\nAt a collection size of 1000, players who hold the Exverse pass will gain lifetime benefits and access to holders-only events both in and outside the game.",
    exchange_url: "https://opensea.io/collection/exverse-pass",
    external_url: "https://exverse.io/",
    banner_image_url:
      "https://i.seadn.io/gae/I1lhbESN59PugTzMDuQwx4xsddDTa8tmvvSnbBodJrBt95j6BNXcwhsylif4rTwNM0vu0rw6y7f9TnjbaoJDbRkPt0TgN3-zEo-G?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/d32a9f333fae27031fe89c131e5616a5.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/d32a9f333fae27031fe89c131e5616a5.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/b5373f55116480c7087656dd3c3acf8c.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/exverse",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "exverse_io",
    stats: {
      market_cap: 5.729850000000001,
      num_owners: 255,
      floor_price: 0.0248,
      floor_price_symbol: "ETH",
      total_minted: 255,
      total_supply: null,
      total_volume: 32.8443959332572,
      one_day_volume: 0.007,
      seven_day_volume: 0.06420000000000001,
      thirty_day_volume: 0.1261,
      one_day_volume_change: 0.007,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 5,
      total_sales: 254,
      one_day_sales: 1,
      seven_day_sales: 4,
      thirty_day_sales: 9,
      total_average_price: 0.12930864540652443,
      one_day_average_price: 0,
      seven_day_average_price: 0.016050000000000002,
      thirty_day_average_price: 0.01401111111111111,
    },
    contracts: [
      {
        contract_address: "0x5428a611192c4fce14ef56eff8ee7dab93b8de86",
      },
    ],
    id: 258,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:51:23.018Z",
    key: "superyeti",
    name: "Super Yeti",
    description:
      "SuperYeti is a 3D collection of randomized characters created through a standard ERC-721 contract and backed by IPFS file storage and registered on the Ethereum Blockchain.  You can learn more at www.superyeti.co",
    exchange_url: "https://opensea.io/collection/superyeti",
    external_url: "http://superyeti.co",
    banner_image_url:
      "https://i.seadn.io/gcs/files/7702d0aaac5118f7675555efde7cf3ba.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/594eb9b712c56837eb0ac531a140b0b4.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/594eb9b712c56837eb0ac531a140b0b4.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/6c8fc7e11d889468b633589e6ad78b53.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/dw9htFCCju",
    telegram_url: null,
    twitter_username: "super_yeti",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 112.79629999999999,
      num_owners: 4149,
      floor_price: 0.00977940004000001,
      floor_price_symbol: "ETH",
      total_minted: 4149,
      total_supply: null,
      total_volume: 1884.8667147409355,
      one_day_volume: 0,
      seven_day_volume: 0.022699999999999998,
      thirty_day_volume: 0.40707900000000014,
      one_day_volume_change: 0,
      seven_day_volume_change: -5,
      thirty_day_volume_change: -26,
      total_sales: 16471,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 41,
      total_average_price: 0.1144354753652441,
      one_day_average_price: 0,
      seven_day_average_price: 0.011349999999999999,
      thirty_day_average_price: 0.009928756097560979,
    },
    contracts: [
      {
        contract_address: "0x3f0785095a660fee131eebcd5aa243e529c21786",
      },
    ],
    id: 259,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:51:19.242Z",
    key: "biginc-letters",
    name: "BiG iNC Letters of Acceptance",
    description:
      "Dear Serious Investors: These letters have been written to indicate that BiG iNC is interested in employing you, whoever you are. In order to confirm your desire to enter into indenture at BiG iNC, you will be prompted to burn these letters in accordance with Letter Combustion Instruction Form 1183923-F no sooner than (a date to be announced shortly). Congratulations, and welcome.",
    exchange_url: "https://opensea.io/collection/biginc-letters",
    external_url: "https://biginc.business/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/a5b3e86a45a9c92fb698f910552ee45f.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/a5b3e86a45a9c92fb698f910552ee45f.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/a5b3e86a45a9c92fb698f910552ee45f.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/581d3cda94c903c446847a6d5a3b9161.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0.042249999999999996,
      num_owners: 1313,
      floor_price: 0.0148,
      floor_price_symbol: "ETH",
      total_minted: 1313,
      total_supply: null,
      total_volume: 223.24130868768708,
      one_day_volume: 0,
      seven_day_volume: 0.0169,
      thirty_day_volume: 0.0169,
      one_day_volume_change: 0,
      seven_day_volume_change: 2,
      thirty_day_volume_change: -11,
      total_sales: 6126,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 2,
      total_average_price: 0.0364416109513038,
      one_day_average_price: 0,
      seven_day_average_price: 0.00845,
      thirty_day_average_price: 0.00845,
    },
    contracts: [
      {
        contract_address: "0x7b390a46c868ccebf2730121faf777129b47c97c",
      },
    ],
    id: 260,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:52:56.061Z",
    key: "p1aeditions",
    name: "P1A Editions",
    description: "Editions of P1A ",
    exchange_url: "https://opensea.io/collection/p1aeditions",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/4484ce4ed63edd9809a99a2622797abe.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/564ae00b7570054b9875d62f213c13a7.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/564ae00b7570054b9875d62f213c13a7.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/4484ce4ed63edd9809a99a2622797abe.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0.0216,
      num_owners: 250,
      floor_price: 0.0297,
      floor_price_symbol: "ETH",
      total_minted: 250,
      total_supply: null,
      total_volume: 10.679686899990003,
      one_day_volume: 0,
      seven_day_volume: 0.0024,
      thirty_day_volume: 0.0024,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 1,
      total_sales: 97,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 1,
      total_average_price: 0.11009986494835054,
      one_day_average_price: 0,
      seven_day_average_price: 0.0024,
      thirty_day_average_price: 0.0024,
    },
    contracts: [
      {
        contract_address: "0xc82ae21402eea321a0ccdbf19796147a9bdc07f9",
      },
    ],
    id: 261,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:52:48.619Z",
    key: "never-fear-truth",
    name: "LIT Collaboration One: Never Fear Truth",
    description:
      "I'm not sure. It's pretty subtle, but this appears to be an NFT. It was mysteriously dropped to Degenaissance holders. It claims to be a LIT Collaboration. But with who or what? I better hold and find out. I don't want to miss anything. \r\n\r\n\"I think now is a very good time to embrace the fear.\"\r\n\r\nhttps://discord.gg/neverfeartruth\r\n\r\nNote that by entering this Discord, you entering a space run by another team that is not affiliated with LIT. One we believe you’ll be very excited to meet. However, do all necessary due diligence. And know that you’re early.\r\n\r\n*Proceeds have been earmarked for two specific charities, which will be announced after the reveal.*",
    exchange_url: "https://opensea.io/collection/never-fear-truth",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gae/3zEzeywf-9Q-aTbisByzXaHdOIWhfZpjB0ZhrCI19iFnKgT-xUybkOeXZn1ZGwtNlJ1qNkCzFdIiCW0zCuo8BBubgywV0yg5M5iI?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/tqU9jCXFn8URBxqQV70pza-cXLNVITt-BLkNQTG3nLP5Kwh7TmojvJzkKDjSWzzcLq_8RWJKeD8jQ3zTz5YqFXJk9KGk7zlVvv1ENw?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0.008,
      num_owners: 2136,
      floor_price: 0.0499,
      floor_price_symbol: "ETH",
      total_minted: 2136,
      total_supply: null,
      total_volume: 848.2027789000026,
      one_day_volume: 0,
      seven_day_volume: 0.016,
      thirty_day_volume: 0.016,
      one_day_volume_change: 0,
      seven_day_volume_change: 2,
      thirty_day_volume_change: 2,
      total_sales: 1510,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 2,
      total_average_price: 0.5617236946357633,
      one_day_average_price: 0,
      seven_day_average_price: 0.008,
      thirty_day_average_price: 0.008,
    },
    contracts: [
      {
        contract_address: "0x399bd363426dfdd7f84fe8b917e1a3525b039309",
      },
    ],
    id: 262,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:52:36.727Z",
    key: "the-divine-nft",
    name: "The Divine NFT",
    description:
      "The Divine is a collection of 4,477 hand-drawn, cosmic, angelic warriors that protect and nurture all that is good in the observable universe of their realm.\n\nThey are guided and created by the omnivalent Arc and reside in The Heavens. From The Fire, the dark world below The Heavens, demonic spawns arose to fight and overtake The Arc. Ultimately, The Fire failed, but this left a tainted mark on The Arc and The Heavens; that wouldn't be the last fight.\n\nEach Divine NFT holder will be a part of this fight as we prepare for the next Eradication.\n\nVisit https://divinenft.io website for more details or our Discord.",
    exchange_url: "https://opensea.io/collection/the-divine-nft",
    external_url: "https://divinenft.io/",
    banner_image_url:
      "https://i.seadn.io/gae/Vyykb21sO3em-bBdtaDab5uq0t2xBbx--MSfobvscQgmCfkXEPwiIphw3UfrbO5BPREvI4TeHepnz3QDXjTLTPUP0kWsUo0fSGZE?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/mD7RAzIlqeLy1viFuyiVJ_2dIUZSbRu512QqurYqIJZHd5zpxADyF_Yt24ELvbXkdDHIP9lv5PSC9gHMZSSNjLLgkOZYKTjEoJ8KHNQ?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/mD7RAzIlqeLy1viFuyiVJ_2dIUZSbRu512QqurYqIJZHd5zpxADyF_Yt24ELvbXkdDHIP9lv5PSC9gHMZSSNjLLgkOZYKTjEoJ8KHNQ?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/ZiWopZDlqc7tn-hBgULDv-oMGHGF83DPv5zAyk_pIw2XE_MqoNSJE5KqU9udn6TwtCGNFcOZWry7rAzMOWcNK0h94wSGK_4KjP-W?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/the-divine",
    telegram_url: null,
    twitter_username: "thedivinenft",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1846,
      floor_price: 0.0074,
      floor_price_symbol: "ETH",
      total_minted: 1846,
      total_supply: null,
      total_volume: 255.8771337767992,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0015,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 2234,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.11453766059838819,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0015,
    },
    contracts: [
      {
        contract_address: "0xa3c2e31ad437742173706578748a223dda95f019",
      },
    ],
    id: 263,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:52:32.935Z",
    key: "pokergo-genesis-nft-collection",
    name: "PokerGO Genesis NFT Collection",
    description:
      "PokerGO, the world’s largest provider of poker content including World Series of Poker, High Stakes Poker, Super High Roller Bowl, and many more, is providing a unique Web3 experience available for up to 1,326 poker fans!\r\n\r\nThe PokerGO Genesis NFT Collection features 1,326 unique, stylized NFTs representing every possible starting hand combination in Texas Hold’em. \r\n\r\nAll PokerGO Genesis NFT holders are eligible for a VIP PokerGO subscription, gaining complimentary access to PokerGO content, and have opportunities to win digital collectibles from the biggest poker events on earth with PGT Major Moments (https://opensea.io/collection/pgt-major-moments)\r\n\r\nFrom chances to participate in live studio events at the PokerGO Studio in Las Vegas to online freerolls for PokerGO merch, gift cards, and other prizes, the PokerGO NFT community is the place to be for any poker fan.",
    exchange_url:
      "https://opensea.io/collection/pokergo-genesis-nft-collection",
    external_url: "https://www.nftstadium.io/",
    banner_image_url:
      "https://i.seadn.io/gae/QRH2L1ab3WsVsDhrQ-kzkWcbJ58VmVml0Jm4ZjWAM6JF0qNrJDlRihZ-2E7hsKf2WZxEwoTlIw2EXLfgxKoz26Lxc95DKhUOdWXX-A?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/QRH2L1ab3WsVsDhrQ-kzkWcbJ58VmVml0Jm4ZjWAM6JF0qNrJDlRihZ-2E7hsKf2WZxEwoTlIw2EXLfgxKoz26Lxc95DKhUOdWXX-A?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/QRH2L1ab3WsVsDhrQ-kzkWcbJ58VmVml0Jm4ZjWAM6JF0qNrJDlRihZ-2E7hsKf2WZxEwoTlIw2EXLfgxKoz26Lxc95DKhUOdWXX-A?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/BeHAJ9tsiuGwv4ah_Goy-vVJHIha2waJiMPsZQ6PemTvmqhFBZkQZacZN5jBKnjfu-_fXWt4mXFFCx-NC10p93DqJhE8--IgZZFjevw?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/zc8yTFsrCT",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 557,
      floor_price: 0.064977,
      floor_price_symbol: "ETH",
      total_minted: 557,
      total_supply: null,
      total_volume: 65.59286369,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.31270000000000003,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 4,
      total_sales: 580,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 6,
      total_average_price: 0.11309114429310345,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.05211666666666667,
    },
    contracts: [
      {
        contract_address: "0xbe6338f94920faefc59c76041689808be5fed6b7",
      },
    ],
    id: 264,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:52:32.518Z",
    key: "tiffatronn-editions",
    name: "tiffatronn editions",
    description: "Editions by tiffatronn.  \n♡ ♡ ♡  ",
    exchange_url: "https://opensea.io/collection/tiffatronn-editions",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/75990903e6844a5408ed8f9518275a67.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/a808e3c4cd43092cd7d4f020e533213a.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/a808e3c4cd43092cd7d4f020e533213a.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/ed88130f2bdc2d7b5538015e576de198.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 369,
      floor_price: 0.05499940004000001,
      floor_price_symbol: "ETH",
      total_minted: 369,
      total_supply: null,
      total_volume: 128.782756254697,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.16288939999894,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -1,
      total_sales: 658,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 4,
      total_average_price: 0.19571847455121125,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.040722349999735,
    },
    contracts: [
      {
        contract_address: "0x7831729a089df41d7c5bcbd5cebb9d7d131addd3",
      },
    ],
    id: 265,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:52:21.777Z",
    key: "abasho",
    name: "Abasho",
    description:
      "Colección de 250 abrazos en formato NFT, generados aleatoriamente por el equipo de [chaucha.art](https://chaucha.art/abasho)\r\n\r\n0% royalties, 100% opensource\r\n\r\n[https://github.com/proyecto-chaucha/abasho/](https://github.com/proyecto-chaucha/abasho/)",
    exchange_url: "https://opensea.io/collection/abasho",
    external_url: "https://chaucha.art/",
    banner_image_url:
      "https://i.seadn.io/gae/DqbvujBPHszcei4NPujOteLiNnuc8XQb7OU-tWH3t6f0ZyyC59ruRH50FmC7xFX8RnMgKnjAE5nEp7GNkFhmdxhaPAVtOZK7Gf1Xcw?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/VpUhTIaQwz7UUFbm8ZzamdaZSkIgWMAMMs_cLYusJIVGHCiHpTpJkgSkgxv8F_xAwyRLp0xY3LAi5Bl_dcKypJmNhynu4wVDM6Sz?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/VpUhTIaQwz7UUFbm8ZzamdaZSkIgWMAMMs_cLYusJIVGHCiHpTpJkgSkgxv8F_xAwyRLp0xY3LAi5Bl_dcKypJmNhynu4wVDM6Sz?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/zS9B1WAZd-vxmW5ijP6XfxWjAlQKN-c8_QJRWvbvwM262A46V7tRD7l_rXibj8monugrccmKQmP7rN98XFicu_hbMWiAzWGPLh3KlQ?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/ju7vst8Vmw",
    telegram_url: null,
    twitter_username: "cvasqxz",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 294.91666666666663,
      num_owners: 206,
      floor_price: 1.7,
      floor_price_symbol: "ETH",
      total_minted: 206,
      total_supply: null,
      total_volume: 440.7738123470898,
      one_day_volume: 1.399,
      seven_day_volume: 3.5389999999999997,
      thirty_day_volume: 21.238799999999998,
      one_day_volume_change: 1.399,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 14,
      total_sales: 866,
      one_day_sales: 1,
      seven_day_sales: 3,
      thirty_day_sales: 18,
      total_average_price: 0.5089766886225056,
      one_day_average_price: 0,
      seven_day_average_price: 1.1796666666666666,
      thirty_day_average_price: 1.1799333333333333,
    },
    contracts: [
      {
        contract_address: "0xe9c79b33c3a06f5ae7369599f5a1e2ff886e17f0",
      },
    ],
    id: 266,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:52:14.438Z",
    key: "sougen-builder-pioneer-pass",
    name: "Sougen Builder Pioneer Pass",
    description:
      "The limited-edition NFT to access exclusive features of the most advanced Web Metaverse editor.\n\nUnlock private Microverses, paid access, vanity URL, and also premiere access to all our new builder features.\nThis pass allows you to build the most immersive and accessible Metaverse experience for your community and fans in just a few clicks.",
    exchange_url: "https://opensea.io/collection/sougen-builder-pioneer-pass",
    external_url: "https://pioneer-pass.sougen.co/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/c3c5cc91be023b1dd8a71b9d77d66a3c.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/9d18a99bea9a970d86e7a32f34b67398.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/9d18a99bea9a970d86e7a32f34b67398.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/ea99be7adcac657ae116e0f3f6baffcc.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/tFrVHtzRMq",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "sougenmetaverse/",
    stats: {
      market_cap: 0,
      num_owners: 467,
      floor_price: 0.007805800281229233,
      floor_price_symbol: "ETH",
      total_minted: 467,
      total_supply: null,
      total_volume: 231.24482107796695,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0298,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 1060,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 4,
      total_average_price: 0.2181554915829877,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.00745,
    },
    contracts: [
      {
        contract_address: "0xdf44545c815fbea9da95f1f83b4a6d87d46c2f7f",
      },
    ],
    id: 267,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:54:13.882Z",
    key: "the4001project",
    name: "Exoplanets: The 4001 Project.",
    description:
      "To date, thousands of exoplanets have been discovered and are confirmed. However, there are thousands of other candidates. The 4001 Project is a community-driven universe, which utilizes specific data from NASA’s Exoplanet Exploration Program in order to randomly generate Exoplanets that could be possibly found beyond our solar system.\r\nThe collection consists of 4001 unique digital exoplanets. We invite you to explore above and beyond.",
    exchange_url: "https://opensea.io/collection/the4001project",
    external_url: "https://www.the4001project.com/",
    banner_image_url:
      "https://i.seadn.io/gae/lVeYKn4NaSdRGgohpvchx3p_LYJ3El1keWsqomqOgT-7ggFnVKLYQwxFLalf4S5wPBs0VYgvmOR1OAWGiZbQf44-mQdUD2iLHjGZ1CI?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/yjsYdHP9dMaLL2iabmT0YFH5oXej9Vv1TRbQr9cVLC2wc09ipMkwxf5ox8fUtaKsu2zA6uMIzsPBfpS6D4Z4i2yDwJ_Y3Z2wzfcB?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/yjsYdHP9dMaLL2iabmT0YFH5oXej9Vv1TRbQr9cVLC2wc09ipMkwxf5ox8fUtaKsu2zA6uMIzsPBfpS6D4Z4i2yDwJ_Y3Z2wzfcB?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/VuMldI73X-echB6jfSvq1RsqWvpyZVEi6ynSu7h5bTG7iKEuFeDj0K7RpubTheC-xH_6gwB4fe46NMDqjDR_WzjoRJzSotIsVhYByA?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/5eu34uu6RY/",
    telegram_url: null,
    twitter_username: "4001P",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 835,
      floor_price: 0.0492,
      floor_price_symbol: "ETH",
      total_minted: 835,
      total_supply: null,
      total_volume: 200.08830934923077,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.07439999999999998,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 10,
      total_sales: 3219,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 10,
      total_average_price: 0.062158530397400054,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.007439999999999998,
    },
    contracts: [
      {
        contract_address: "0x4530ed5907ceb4e14b0550a28e7d300cc773b92e",
      },
    ],
    id: 268,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:54:02.778Z",
    key: "og-crystals",
    name: "OG:Crystals",
    description:
      '[About](https://ogcrystals.com/) | [OG.Art](https://og.art/) | [Deck](https://deck.ogcrystals.com/) | [OnCyber](https://oncyber.io/myshli) | [Twitter](https://twitter.com/ogdotart)\n\nA collection of 10,301 unique NFT collectibles launched on October 16, 2021. Each OG:Crystal transformed and grew every time it was purchased from another collector. The facets and contours of each piece were generated algorithmically, according to each owner\'s crypto wallet history. \n\nAfter all the crystals were "locked" into their permanent form, the project entered the final and most ambitious road map stage. 3D Crystals will soon evolve into Crystal REEF — a massive physical sculpture that will be shown in highly respected museums and galleries worldwide. \n\nOG:CR is a collaboration between artists Michael Joo (ASomatica) and Danil Krivoruchko (Myshli) with the technical support of Snark.art. \nThe collection inspired an even more ambitious and large-scale art project — [OG.Art platform](https://og.art)',
    exchange_url: "https://opensea.io/collection/og-crystals",
    external_url: "https://ogcrystals.com/",
    banner_image_url:
      "https://i.seadn.io/gae/FTvidq-UOBQB_bk-12V51WBsKBaFFun0wsD0seZPIhDZNFilhQea_kIHoqZMILXbX_cSNoqyxJ1nxD7e3NUwl4WcWYsJrWV5V-c_Ug?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/INGrcMFjLrBqs4uW-ZaYHslw0pWMyqwQVnECxpV5HZpbJSgCzRI2CIUZ-is4kuDhBit1DYFxZ09DFuk_JDe6ueEGRBjQl0z9ivtBpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/INGrcMFjLrBqs4uW-ZaYHslw0pWMyqwQVnECxpV5HZpbJSgCzRI2CIUZ-is4kuDhBit1DYFxZ09DFuk_JDe6ueEGRBjQl0z9ivtBpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/PaM_tFDNK4SBoo73VtX2mjqtb5pG1jbcioMW2CUntcFbY8aA1l1vhAKOn7jYlykkuk7JLCZFvPo7vbiN7xotzQUYab18i4tl1Wk3_A?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/ERYY5qH8pf",
    telegram_url: "https://t.me/ogdotart",
    twitter_username: "ogdotart",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 47.26555555555556,
      num_owners: 3442,
      floor_price: 0.01,
      floor_price_symbol: "ETH",
      total_minted: 3442,
      total_supply: null,
      total_volume: 3315.0303559852146,
      one_day_volume: 0,
      seven_day_volume: 0.0413,
      thirty_day_volume: 0.15239999999999998,
      one_day_volume_change: 0,
      seven_day_volume_change: -2,
      thirty_day_volume_change: 39,
      total_sales: 26617,
      one_day_sales: 0,
      seven_day_sales: 9,
      thirty_day_sales: 44,
      total_average_price: 0.12454560453789738,
      one_day_average_price: 0,
      seven_day_average_price: 0.004588888888888889,
      thirty_day_average_price: 0.003463636363636363,
    },
    contracts: [
      {
        contract_address: "0x368ad4a7a7f49b8fa8f34476be0fc4d04ce622f5",
      },
    ],
    id: 269,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:53:51.463Z",
    key: "mal-pets",
    name: "Moon Ape Pets",
    description:
      "Welcome to the Pet Incubator! Moon Pets can now be burned in the Mad Exchange for $MAD tokens. You will need 50 $MAD per Moon Capsule - Moon Capsules contain 3D wearables for your Genesis & Deku Avatars. \n\nHowever: By collecting all 8 types of Moon Pets are qualified to acquire a limited edition Aku Aku 3D wearable - absolutely free!\n\nMake sure you DON'T burn your set of 8 - remember to keep one of each in your wallet",
    exchange_url: "https://opensea.io/collection/mal-pets",
    external_url: "https://moonapelab.io",
    banner_image_url:
      "https://i.seadn.io/gae/b-YLYx2bwHG5r1bsXSONJGWxysWXKpnv8GOAqE53iGT2m8AZPUrWBwQ0ppVQm66QlUMOwWMImX7TuIzYtFwiZyv94cZLj9iBbHlwGes?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/b-YLYx2bwHG5r1bsXSONJGWxysWXKpnv8GOAqE53iGT2m8AZPUrWBwQ0ppVQm66QlUMOwWMImX7TuIzYtFwiZyv94cZLj9iBbHlwGes?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/b-YLYx2bwHG5r1bsXSONJGWxysWXKpnv8GOAqE53iGT2m8AZPUrWBwQ0ppVQm66QlUMOwWMImX7TuIzYtFwiZyv94cZLj9iBbHlwGes?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/BZjkNyR-s0etUyzdsK4xpiE531zW_QifXNtnzreMgSRTLnrHyYLeYNMQk7300U5bOxeWObM6bJv-RQiuHs-3wV6GJEfy_ZDxoxOgLw?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/moonapelab",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "moonapelab.io",
    stats: {
      market_cap: 0,
      num_owners: 399,
      floor_price: 0.0099,
      floor_price_symbol: "ETH",
      total_minted: 399,
      total_supply: null,
      total_volume: 112.7749801959001,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0057,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 2,
      total_sales: 3497,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 3,
      total_average_price: 0.03224906496880186,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0019,
    },
    contracts: [
      {
        contract_address: "0x8c11c7b0256a6014be1ed51a66ecefa35c4924e6",
      },
    ],
    id: 270,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:55:10.700Z",
    key: "techno-mystic",
    name: "Techno Mystic",
    description: null,
    exchange_url: "https://opensea.io/collection/techno-mystic",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url: null,
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 0.09,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x10a68c2af2ce6b47812318b4a853d14551b70083",
      },
    ],
    id: 271,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:56:11.063Z",
    key: "cube-x-official",
    name: "CubeX Official NFTs",
    description:
      'PLEASE BE AWARE THAT THIS COLLECTION IS MORPHED INTO A "NEW ERA" COLLECTION: https://opensea.io/collection/cubexofficialtoken',
    exchange_url: "https://opensea.io/collection/cube-x-official",
    external_url: "https://www.cube-x.gg/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/75c3f48d5858944618122c1e9e7583fe.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/162a6b90cd2f800e9f3e8cb7eaf49eaa.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/162a6b90cd2f800e9f3e8cb7eaf49eaa.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/a1b0c5cefb12979bda981f2ee4ae1070.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/cubex",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1878,
      floor_price: 0.0045,
      floor_price_symbol: "ETH",
      total_minted: 1878,
      total_supply: null,
      total_volume: 2225.909557531015,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.044989999999999974,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 17,
      total_sales: 12304,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 20,
      total_average_price: 0.18090942437670796,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.002249499999999999,
    },
    contracts: [
      {
        contract_address: "0x92c93fafc20fe882a448f86e594d9667259c42c8",
      },
    ],
    id: 272,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:56:10.660Z",
    key: "hiddeninnoise",
    name: "HIDDEN IN NOISE",
    description:
      "1024 algorithmically generated audiovisual NFTs. Created by 404.zero.\r\n\r\nNoise is another form of perception. It’s one of the most abstract of the visual and auditory forms. Both simple and complex generators were used to produce the Hidden in Noise collection: gradients, perlin and white noises, and a number of custom made generators.\r\n\r\nThe outputs of the generators combine in multiple ways in random orders with random math operations. That’s the order of Chaos.",
    exchange_url: "https://opensea.io/collection/hiddeninnoise",
    external_url: "http://hiddeninnoise.com",
    banner_image_url:
      "https://i.seadn.io/gae/xWg14UQ9fPkbPALyaUuAz_eprJSgq5_LTnxkwpppNY3h4T-jFAM4fZ0ollkaErZ_HQNDSj-U96EsP-d_VXz3axZWruBnkYUDcoiV?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/iiSYQRMFWgmFJDi6w1MtRavklUHfCqu-F4bln0EdHPa7PTBKpgFEnH-WqookLuwl3kHNis2ByzZ2XnoA0ArBeU4eGpqolL4X1zvc84k?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/iiSYQRMFWgmFJDi6w1MtRavklUHfCqu-F4bln0EdHPa7PTBKpgFEnH-WqookLuwl3kHNis2ByzZ2XnoA0ArBeU4eGpqolL4X1zvc84k?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/ooVb87Y2-PKHx8uJjUUzDZCZaVQwvEcc0rJrqdsKIcem9lBQXQuGSQRwMwDHz-mzpYGlL2nupNFr-6CLWyA9w2VUxELAwWorQHQ05w?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: "hiddeninoise",
    wiki_url: null,
    instagram_username: "hiddeninnoise",
    stats: {
      market_cap: 9.386666666666665,
      num_owners: 531,
      floor_price: 0.021699,
      floor_price_symbol: "ETH",
      total_minted: 531,
      total_supply: null,
      total_volume: 1579.7243899943646,
      one_day_volume: 0,
      seven_day_volume: 0.027499999999999997,
      thirty_day_volume: 0.088,
      one_day_volume_change: 0,
      seven_day_volume_change: 3,
      thirty_day_volume_change: -1,
      total_sales: 1882,
      one_day_sales: 0,
      seven_day_sales: 3,
      thirty_day_sales: 8,
      total_average_price: 0.8393859670533287,
      one_day_average_price: 0,
      seven_day_average_price: 0.009166666666666667,
      thirty_day_average_price: 0.011,
    },
    contracts: [
      {
        contract_address: "0xf55dd62034b534e71cb17ef6e2bb112e93d6131a",
      },
    ],
    id: 273,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:55:59.377Z",
    key: "sleepy-sloth-society-by-zzz-labs",
    name: "Sleepy Sloth Society by Zzz Labs",
    description:
      "Welcome to the **Sleepy Sloth Society** , a project composed of 2,222 unique pieces. The collection focuses on creating an ecosystem that bridges the gap between culture, education and cryptonomics. Come nap with us on Web3.\n\nRead our [White Paper](https://sleepy-sloth-society.gitbook.io/sleepy-sloth-society-whitepaper/)\n\n [Sleepy House Key](https://opensea.io/collection/sleepy-house-keys) \n\nUpcoming **Outcast of the Society** through the  [The Sleepy  Serums](https://opensea.io/collection/sleepy-serums)\n\nFor more information visit our [Website](https://sleepyslothsociety.io/)\n\n\n**If you are a holder join** [Discord](https://discord.gg/sleepyslothsociety) and verify your role.\n\nVisit all our official links [LinkTree](https://linktr.ee/Sleepyslothsociety)\n                                                                                             \n                                                                                                            \n\n",
    exchange_url:
      "https://opensea.io/collection/sleepy-sloth-society-by-zzz-labs",
    external_url: "https://sleepyslothsociety.io/",
    banner_image_url:
      "https://i.seadn.io/gae/tiea6Sbvt-Txa4Xj2FqUbqB_rFLscIRQTMBNy0nAm6n4wJPMvvw8knwKk5RLEBbuXZwfIz03bGHcEuULb4Noc-w75QG7vkwpOt2tEg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/YYVHgo9vCWWwF11M0ggqHb_OOU5lzw4IOMRfvj72Jur1GZ1l69ONoL7eibTI_xyBYRW68k2iubqa2Zj-7VwMzKSITVHmuZzFaQU_sA?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/YYVHgo9vCWWwF11M0ggqHb_OOU5lzw4IOMRfvj72Jur1GZ1l69ONoL7eibTI_xyBYRW68k2iubqa2Zj-7VwMzKSITVHmuZzFaQU_sA?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/heuqYphUq9kAPjdN1_EIig669XspxJ6A1miGRzeThSqjEdWIeK4Oy4CwVI2fYgsPdd88nTk8LZSN0MqhYHEJ0kM5gYBpsmasgrtRRA?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/ZzzLabs",
    telegram_url: null,
    twitter_username: "sleepyslothsc",
    wiki_url: null,
    instagram_username: "sleepyslothsociety",
    stats: {
      market_cap: 0,
      num_owners: 786,
      floor_price: 0.0128,
      floor_price_symbol: "ETH",
      total_minted: 786,
      total_supply: null,
      total_volume: 125.79631495769888,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0018,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 1385,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.09082766422938547,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0018,
    },
    contracts: [
      {
        contract_address: "0x1889b8d0860884c3595776419814168d07550cc1",
      },
    ],
    id: 274,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:55:58.886Z",
    key: "narrated-monologue-by-korbinian-vogt",
    name: "Narrated Monologue by Korbinian Vogt",
    description:
      "Narrated Monologue is a captivating project by Korbinian Vogt that explores the intricate connection between humans and nature. With a focus on capturing this connection in some of the most remote wilderness areas, Vogt has been working on this project for several years.\r\n\r\nNarrated Monologue is Vogt's personal revision of his long-term work on human nature, and through the lens of his camera, he offers a final view of this concept. Through his photographic works, he provides a unique and thought-provoking perspective on the relationship between humans and nature.\r\n\r\nNarrated Monologue is not just a collection of photographs but also a journey that takes viewers through Vogt's experiences and insights. It is a powerful reminder of the beauty and importance of the natural world and how humans are an integral part of it. As you view one of the images, Vogt's work invites you to explore your own connection with nature and how it shapes your life.",
    exchange_url:
      "https://opensea.io/collection/narrated-monologue-by-korbinian-vogt",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/9e6a9352983823774bf629a4599c4582.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/67619e9d4a4567d6daa70c8c6cd781ee.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/67619e9d4a4567d6daa70c8c6cd781ee.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/67619e9d4a4567d6daa70c8c6cd781ee.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 9,
      floor_price: 0.69,
      floor_price_symbol: "ETH",
      total_minted: 9,
      total_supply: null,
      total_volume: 0.5495700003400003,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 69,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.007964782613623192,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xba7b898f17e47edb39d73530e408490cecb42dc0",
      },
    ],
    id: 275,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:56:58.806Z",
    key: "bang-by-cybersea",
    name: "BANG! by CyberSea",
    description:
      "BANG! is a vibrant art project inspired by the nostalgic hours spent immersed in old comic books. It evokes the iconic color palettes associated with beloved heroes & stories, while paying homage to pop art legends like Lichtenstein and Warhol. With a canvas divided into cells reminiscent of a comic strip, each piece captures the essence of classic comic art. The project combines colors, iconic elements, and hand-drawn contours to create an captivating experience for fans of the genre.",
    exchange_url: "https://opensea.io/collection/bang-by-cybersea",
    external_url: "https://www.alba.art/projects/bang",
    banner_image_url:
      "https://i.seadn.io/gcs/files/d1ddd54743d8e245cb7a3c5ab6b2cb95.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/079c541bdde9f4f5852975e9bb7fdc33.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/079c541bdde9f4f5852975e9bb7fdc33.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/3365b124eabe136ab161c77e5094b447.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 159,
      floor_price: 0.030999,
      floor_price_symbol: "ETH",
      total_minted: 159,
      total_supply: null,
      total_volume: 15.394913121209994,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.09110000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 229,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 4,
      total_average_price: 0.06722669485244538,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.022775000000000004,
    },
    contracts: [
      {
        contract_address: "0xaf200928568391bf8bd4d845df46329ae6801e0a",
      },
    ],
    id: 276,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:58:51.807Z",
    key: "moon-ape-lab-3d",
    name: "Moon Ape Lab 3D",
    description:
      "MINT IS LIVE: https://3dmint.moonapelab.io \n\nCollect your fully rigged 3d blender files here: https://thestudio.moonapelab.io\n\nAre you ready to unleash your digital alter ego?\n\nThe entire Moon Ape Lab ecosystem is designed by, and for, holders, and when we build we look to provide long-term opportunity for all investors\n\nBy giving you full intellectual property rights to your avatar, you are free to find the 3d Moon Ape that tells your story, represents your vibe or just looks cool af. Whichever you choose, it becomes yours and you are free to use it without restriction\n\nWith a diverse range of traits, originating from the 2d Genesis collection, the sky is the limit. Re-imagine yourself, create your brand and then explore what it truly means to have creative freedom\n\nYou're not just minting an NFT - you're minting you! \n\nJoin the us as we head into the metaverse - we have a lot to show you. We ARE Moon Apes and this is just the beginning!",
    exchange_url: "https://opensea.io/collection/moon-ape-lab-3d",
    external_url: null,
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/16d1337a459275a7f430cd6f1540e36c.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/16d1337a459275a7f430cd6f1540e36c.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/1c054a7247707a303a6acb777477115f.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/moonapelab",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 56.977199999999996,
      num_owners: 248,
      floor_price: 0.1069,
      floor_price_symbol: "ETH",
      total_minted: 248,
      total_supply: null,
      total_volume: 2.1958001002201084,
      one_day_volume: 0,
      seven_day_volume: 0.0399,
      thirty_day_volume: 0.059899999999999995,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -17,
      total_sales: 47,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 2,
      total_average_price: 0.046719151068512946,
      one_day_average_price: 0,
      seven_day_average_price: 0.0399,
      thirty_day_average_price: 0.029949999999999997,
    },
    contracts: [
      {
        contract_address: "0x1334c7bcac271e247f6d78d201d3afeb883b19bb",
      },
    ],
    id: 277,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:58:44.561Z",
    key: "spectrumpepes",
    name: "Spectrum Pepes",
    description:
      "Spectrum Pepes is the most [redacted] Pepe NFT collection in existence, born out of the infamous $AUTISM experiment, crafted as a memetic resistance to NPC culture and mainstream norms.\n\nCreated by 1Lucky1 (anon), each Pepe carries the legacy of internet’s untamed history—an unfiltered symbol of rebellion feared by NPCs, social engineers, and heads of state.\n\nMore than just PFPs, they’re symbols of defiance against the normie world, crafted for those who see beyond the veil.\n[Twitter](https://twitter.com/spectrumpepes)・[Telegram](https://t.me/spectrumpepes)",
    exchange_url: "https://opensea.io/collection/spectrumpepes",
    external_url:
      "https://mirror.xyz/community.spectrumpepes.eth/K0O__IEqvMV6OjcZBfDPv1QIet5hr-i4HpuEesU0aGw",
    banner_image_url:
      "https://i.seadn.io/gcs/files/1710603393ed964074b771a677c8e185.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/538ecf6e1470bfcc0147117c3fd91c52.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/538ecf6e1470bfcc0147117c3fd91c52.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/1b9bebb3e1e76a0d1c079191e67d7352.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/ncxbWjV7vF",
    telegram_url: "https://t.me/spectrumpepes",
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 9.30735,
      num_owners: 672,
      floor_price: 0.009072200522459507,
      floor_price_symbol: "ETH",
      total_minted: 672,
      total_supply: null,
      total_volume: 58.83313556166834,
      one_day_volume: 0,
      seven_day_volume: 0.0037,
      thirty_day_volume: 0.36320000000000013,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -19,
      total_sales: 2769,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 39,
      total_average_price: 0.021247069541953174,
      one_day_average_price: 0,
      seven_day_average_price: 0.00185,
      thirty_day_average_price: 0.009312820512820516,
    },
    contracts: [
      {
        contract_address: "0xecafeba408dd65fdc94030ec5aa99f3bd15c842c",
      },
    ],
    id: 278,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:58:35.289Z",
    key: "end-transmissions-by-justin-mezzell",
    name: "End Transmissions by Justin Mezzell",
    description: null,
    exchange_url:
      "https://opensea.io/collection/end-transmissions-by-justin-mezzell",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/4640c87362c2fbd619be9e2efe78a833.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/8112572568f2ce1477ff187eddf79f0f.gif?w=500&auto=format",
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/8112572568f2ce1477ff187eddf79f0f.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 340,
      floor_price: 0.01197940004000001,
      floor_price_symbol: "ETH",
      total_minted: 340,
      total_supply: null,
      total_volume: 7.827189999989995,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.08420000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 7,
      total_sales: 82,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 8,
      total_average_price: 0.09545353658524384,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.010525000000000001,
    },
    contracts: [
      {
        contract_address: "0x68d0f6d1d99bb830e17ffaa8adb5bbed9d6eec2e",
      },
    ],
    id: 279,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:58:28.354Z",
    key: "nft-ocs-collection-4-yurudorashiru",
    name: "NFT OCS Collection #4 Yurudorashiru",
    description: null,
    exchange_url:
      "https://opensea.io/collection/nft-ocs-collection-4-yurudorashiru",
    external_url: "https://otaku-culture-studio.com/yurudorashiru/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/c3432bff3553b0b8201e4288816dbddb.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/c399b64c3a74a96f1fd38d552c350838.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/c399b64c3a74a96f1fd38d552c350838.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/36a94230cac29d7ba49ced6d27dd797b.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 134,
      floor_price: 0.008,
      floor_price_symbol: "ETH",
      total_minted: 134,
      total_supply: null,
      total_volume: 0.00398,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -0.00398,
      total_sales: 1,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.00398,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x371fbda16a96751f48afaac61f949cdc3ca6934f",
      },
    ],
    id: 280,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:58:27.880Z",
    key: "convergence-pepe",
    name: "Convergence Pepe",
    description: null,
    exchange_url: "https://opensea.io/collection/convergence-pepe",
    external_url: "https://twitter.com/Convergence_fi",
    banner_image_url:
      "https://i.seadn.io/gcs/files/9fb49665fe8a28a93f15378ec003b31a.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/183c2ab8bf814563f22dfeed16dd1877.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/183c2ab8bf814563f22dfeed16dd1877.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/002b775c5b9a6e02a36594a0db65ab61.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 85,
      floor_price: 0.07535,
      floor_price_symbol: "ETH",
      total_minted: 85,
      total_supply: null,
      total_volume: 66.40138536470364,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0174,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 2,
      total_sales: 158,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 2,
      total_average_price: 0.4202619326879977,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0087,
    },
    contracts: [
      {
        contract_address: "0x822ee3715e2c15372e45a4a62376bf786ff45511",
      },
    ],
    id: 281,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-15T23:59:55.325Z",
    key: "doumei",
    name: "Doumei",
    description:
      "【Doumei's world of character art】\nWelcome to Doumei's animal character art world.\nWe have unique animals centered around owl and whale characters.\nIn addition, I am conscious of the color of the work, so please pay attention to it.\nWe hope you will enjoy this illustration.\n\n【Doumeiのキャラクターアートの世界】\nDoumeiの動物達のキャラクターアートへようこそ。。。\nフクロウやクジラのキャラクター達を中心に個性的な動物達が揃っています。\nさらに作品の色彩も意識して描いていますので注目して見て下さい。\nイラストを楽しんで頂けたら幸いです。",
    exchange_url: "https://opensea.io/collection/doumei",
    external_url: "https://doumei-art-livedoor.blog.jp",
    banner_image_url:
      "https://i.seadn.io/gae/On459GAmBZDr_LdLm081VPKx1h---eG_LKdKfzGaqBVsxeX7cJ-wdM3KX_nADP3wasvGmaxtNKj1B0rduwkOxyJZo8qyD7QMWMNYnA?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/VVlKNFrzzAxg0wJmOaWPfeId9n_dwwb-_W4QzpuvBY1f1WTMb8rQXEAsviVfWSu8kAoSAjQaqTenyf_jHxyddi3Ai1-2L8za4pZ-Rw?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/VVlKNFrzzAxg0wJmOaWPfeId9n_dwwb-_W4QzpuvBY1f1WTMb8rQXEAsviVfWSu8kAoSAjQaqTenyf_jHxyddi3Ai1-2L8za4pZ-Rw?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/Zf6R0v-CfSZGL871pA9xCZUKQBuhIcT7kYj-In9RKoEqsT9NAxkDavH5lDL59rZpemx2BtbofRJoGESLfCwbWkEPHgX4ZBmahBVn?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: "@CyakiZengo",
    wiki_url: null,
    instagram_username: "kititora620",
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 0.1,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 282,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:01:12.989Z",
    key: "arityclub",
    name: "Arity Club",
    description:
      "Arity is decentralizing the opportunities and experiences found in the precious minerals and luxury world, revealing a distorted and cryptic reality.\r\n\r\nWe are a community-focused lifestyle brand. Our purpose is to help you achieve your highest POTENTIAL.\r\n\r\nArity is the way of gemstones and precious minerals into the Metaverse.\r\n\r\nOfficial Website: https://arity.club/\r\n\r\nOfficial Twitter: https://twitter.com/Arityclub",
    exchange_url: "https://opensea.io/collection/arityclub",
    external_url: "https://arity.club/",
    banner_image_url:
      "https://i.seadn.io/gae/OEgSPvF_LOKh2T30VfOOmCWDqnOOLMyYbRUzG8VBv-WYXf_iYRnRF07NM7tkDbpoattYnCDAS-xx03ZSRD3ZBVzf3ebfc98mtDQlJms?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/Uq9KQXCBUlxhf1k-SknzYpYDRDzufFk9iLhN2tZ2X5PDDX832m7Eu6S1imroDydb1t2deN0v_I3vGWE_6CNSUGhULqFetMU2xiGQ9IY?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/Uq9KQXCBUlxhf1k-SknzYpYDRDzufFk9iLhN2tZ2X5PDDX832m7Eu6S1imroDydb1t2deN0v_I3vGWE_6CNSUGhULqFetMU2xiGQ9IY?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/34AQe5bGmYMiov03bvABXvAh622tnAZsaCZlTLCoCp-f6v2vg7ovurTvcLisxfOVdi3o1yMPgKAEsFrwDtDHtKbHr41fW6Oixic?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/arity",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 118,
      floor_price: 0.011899,
      floor_price_symbol: "ETH",
      total_minted: 118,
      total_supply: null,
      total_volume: 89.26647000000007,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 135,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.6612331111111116,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xf26a035eb240de3624cf2d4071387e5be5f57f77",
      },
    ],
    id: 283,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:01:09.295Z",
    key: "the-real-milady",
    name: "The Real Milady",
    description:
      "The Real Milady for the Culture\n\nqueen Milady\nhttps://opensea.io/collection/queen-milady-s",
    exchange_url: "https://opensea.io/collection/the-real-milady",
    external_url: "https://bit.ly/46MC89h",
    banner_image_url:
      "https://i.seadn.io/s/raw/files/9802f0ae33424d3fbcccd1cd181b70b6.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/4d4f42333cffff978be8bfd98225ca69.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/4d4f42333cffff978be8bfd98225ca69.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/372132a5803ff8be15871a60d629a9e2.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 133,
      floor_price: 0.005,
      floor_price_symbol: "ETH",
      total_minted: 133,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x8644f35380c9b56274cd8e12cf4920214710151e",
      },
    ],
    id: 284,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:00:45.064Z",
    key: "sakura-pop",
    name: "Sakura pop! | Sitone",
    description:
      "桜×ポップをテーマにした和服少女の作品です。\nIt is a work of a kimono girl with the theme of cherry blossoms x pop.",
    exchange_url: "https://opensea.io/collection/sakura-pop",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/c391935b94a04850c2396d2f77294d1c.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/0df12a93f340b152460854355fa18aa1.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/0df12a93f340b152460854355fa18aa1.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/fddaaa7646f2f7ee2cab1f8e545dd651.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 104,
      floor_price: 0.02,
      floor_price_symbol: "ETH",
      total_minted: 104,
      total_supply: null,
      total_volume: 2.28597343083333,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.001,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 143,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.015985828187645663,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.001,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 285,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:00:44.639Z",
    key: "yooldo-treasure-chest-1",
    name: "Yooldo Treasure Chest",
    description:
      "Yooldo Treasure Chest is a unique NFT with only 888 available.\r\nHolders can be eligible for airdrops when $YOOL tokens are officially launched and will receive direct benefits from various payment contents within Yooldo.\r\n\r\nBoasting an impressive track record, the team has won more than 10 prestigious hackathons, including Coinbase, Aptos, BNB, Oasys, and Klaytn, as well as the Google Game Festival and Unity Game Awards. In 2023 Yooldo team successfully completed the investment round with a value of $13M, further solidifying its position in the industry. As a member of the Consensys Scale program, Yooldo benefits from the continuous support from Consensys.",
    exchange_url: "https://opensea.io/collection/yooldo-treasure-chest-1",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url:
      "https://i.seadn.io/s/raw/files/0840cd581ac8aa83fe5c0962521c60c1.gif?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/0840cd581ac8aa83fe5c0962521c60c1.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 819,
      floor_price: 0.139998,
      floor_price_symbol: "ETH",
      total_minted: 819,
      total_supply: null,
      total_volume: 3.6360899999999994,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 65,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.055939846153846146,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xe6541adbf2629f84222606eed028cc624f37f9a6",
      },
    ],
    id: 286,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:00:34.900Z",
    key: "gallery-304",
    name: "gallery 304",
    description: "A small  art gallery  in Tokyo",
    exchange_url: "https://opensea.io/collection/gallery-304",
    external_url: "http://orange.zero.jp/zbk23056.boat/304.html",
    banner_image_url:
      "https://i.seadn.io/gae/bsvzc1csk2IKD-OicqWewmbJen4wXglB5C5vo65Oz0KycIafRgK-3FCVHv5qy290t1ZzJk5WxPtyTr3sX_u0lSUbbMXx0pnBxumz?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/bsvzc1csk2IKD-OicqWewmbJen4wXglB5C5vo65Oz0KycIafRgK-3FCVHv5qy290t1ZzJk5WxPtyTr3sX_u0lSUbbMXx0pnBxumz?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/bsvzc1csk2IKD-OicqWewmbJen4wXglB5C5vo65Oz0KycIafRgK-3FCVHv5qy290t1ZzJk5WxPtyTr3sX_u0lSUbbMXx0pnBxumz?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/QD4BIZkJxMqSkdQ7Pcnin7ukga784TG4pxNq8d4l_ZvkioaGUT8Fi8PHYpU_fLQH-fkhI8UckJVIQyPYfigkvSldJUCESOO5ynCMxew?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 0.001,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 287,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:01:47.647Z",
    key: "sketchy-degens",
    name: "Sketchy Degens",
    description:
      "Sketchy Degens is a group collaboration of 10 artists from the Hashlips - Sketchy Labs community. Collectors will be included in future community projects.",
    exchange_url: "https://opensea.io/collection/sketchy-degens",
    external_url: "https://sketchyplayground.com/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/8f0f5c94f05dcf83f0fd72ffd60b1642.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/84009f62cdf5160f3a24af4d6a462833.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/84009f62cdf5160f3a24af4d6a462833.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/efb62289677c4d0e525253b531e7005f.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/SketchyLabs",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 324,
      floor_price: 0.004,
      floor_price_symbol: "ETH",
      total_minted: 324,
      total_supply: null,
      total_volume: 2.4957639999999994,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 242,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.010313074380165287,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xa35600d9b0e6c4e6f629d8cf452d4cf8a629cc69",
      },
    ],
    id: 288,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:01:33.905Z",
    key: "mutated-moon-ape",
    name: "Mutated Moon Apes",
    description:
      "Mutated Moon Apes are in-game, rewards miners\n\nSoft staking and $MAD mining coming in Q2, 2024\n\nEarn or burn for Lab currency, hunt the alpha, reap the rewards",
    exchange_url: "https://opensea.io/collection/mutated-moon-ape",
    external_url: "https://moonapelab.io",
    banner_image_url:
      "https://i.seadn.io/gae/RJ2FRCCNXfhubtxZRPr9SFE3n5S4F_K0B8DSdJ6qAIl0rb-3Q1zbBRj773ov6im-IDLW67APxlZjacnq5GoNjdXedu7vWAJlfqj6smU?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/RJ2FRCCNXfhubtxZRPr9SFE3n5S4F_K0B8DSdJ6qAIl0rb-3Q1zbBRj773ov6im-IDLW67APxlZjacnq5GoNjdXedu7vWAJlfqj6smU?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/RJ2FRCCNXfhubtxZRPr9SFE3n5S4F_K0B8DSdJ6qAIl0rb-3Q1zbBRj773ov6im-IDLW67APxlZjacnq5GoNjdXedu7vWAJlfqj6smU?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/BoJ2RK2bGnpsGVYIoQTwehuqbCKtwTSre-vP140IT1WAomWirz9wydj9x-tUiQ0PWXYpOBSWHIUOUyxETX1RwFaLcK6U4CSTzw4n8yU?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/moonapelab",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "moonapelab.io",
    stats: {
      market_cap: 23.920899999999996,
      num_owners: 1392,
      floor_price: 0.003856,
      floor_price_symbol: "ETH",
      total_minted: 1392,
      total_supply: null,
      total_volume: 29.33676685950005,
      one_day_volume: 0,
      seven_day_volume: 0.012899999999999998,
      thirty_day_volume: 0.0166,
      one_day_volume_change: 0,
      seven_day_volume_change: 4,
      thirty_day_volume_change: 0,
      total_sales: 1870,
      one_day_sales: 0,
      seven_day_sales: 6,
      thirty_day_sales: 8,
      total_average_price: 0.015688110620053503,
      one_day_average_price: 0,
      seven_day_average_price: 0.00215,
      thirty_day_average_price: 0.002075,
    },
    contracts: [
      {
        contract_address: "0x19f918b5352fe3316564f5245942c57d78d6cf9d",
      },
    ],
    id: 289,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:01:30.068Z",
    key: "fvck-avatar-essence",
    name: "ESSENCE//",
    description:
      "ESSENCE// is the redeem token for the [FVCK_AVATAR//](https://opensea.io/collection/lvcidiaavatars) collection created by [FVCKRENDER](https://twitter.com/fvckrender).\nThere is no time limit to burn your ESSENCE//, but there will be no other utility to ESSENCE// other than claiming the FVCK_AVATAR// collectibles.\n\nVisit our [website](https://avatar.fvckrender.xyz/) for redemption or for more information.",
    exchange_url: "https://opensea.io/collection/fvck-avatar-essence",
    external_url: "https://avatar.fvckrender.xyz/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/a27b6e9822e99d70b054ae85071998fd.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/8b380f148808d6e78681db688f14932c.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/8b380f148808d6e78681db688f14932c.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/ePiw_GozPKduVcOOFo984j4Z8PnOi4arZjLOWWymRdelQ1EZ3n7ZCLmy8L613abEvosM3_qX5vuAtDHLNhjckzW-1XyvnXIMc-xT?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/lvcidia",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "lvcidia.xyz",
    stats: {
      market_cap: 0.0047,
      num_owners: 1150,
      floor_price: 0.01398940004000001,
      floor_price_symbol: "ETH",
      total_minted: 1150,
      total_supply: null,
      total_volume: 4554.079590437296,
      one_day_volume: 0.0047,
      seven_day_volume: 0.0047,
      thirty_day_volume: 0.035500000000000004,
      one_day_volume_change: 0.0047,
      seven_day_volume_change: 1,
      thirty_day_volume_change: -5,
      total_sales: 7541,
      one_day_sales: 1,
      seven_day_sales: 1,
      thirty_day_sales: 5,
      total_average_price: 0.6039092415378989,
      one_day_average_price: 0,
      seven_day_average_price: 0.0047,
      thirty_day_average_price: 0.007100000000000001,
    },
    contracts: [
      {
        contract_address: "0xddb149ae8e6635df01a530da1e46921bd78dc385",
      },
    ],
    id: 290,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:02:49.885Z",
    key: "legendary-lions-by-tecate-pal-norte",
    name: "Legendary Lions by Tecate Pal Norte",
    description:
      "The Legendary Lions collection, celebrating Tecate Pal Norte’s 10th anniversary, gives its loyal fans the opportunity of a life-time to belong to our exclusive group.\n\nEach NFT that you collect comes with exclusive benefits in the real and digital world. We have included unique experiences within the collection through a unique dynamic. Some of the life-time experiences include: Backstage dressing room for you and 5 friends, “Hospitality” access, Tecate Pa'l Norte tickets and other experiences that will be announced on our official social networks and Discord . Visit nft.tecatepalnorte.com",
    exchange_url:
      "https://opensea.io/collection/legendary-lions-by-tecate-pal-norte",
    external_url: "http://nft.tecatepalnorte.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/c5a5b58d3c099075532ee97a17bc41d4.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/14312d5449186abff45b55ecfa412fb4.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/14312d5449186abff45b55ecfa412fb4.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/HUqg8Q2dYzjieOmmSkve37gobdt-yoLYJBLj62OzcOnzG7qyqZxQpekuxM4e-vaPsSyYquY1dlIxIK9urJGd3To3Vvqw0hpIAjm4950?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/bXdAfWkrKc",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "tecatepalnorte",
    stats: {
      market_cap: 0,
      num_owners: 460,
      floor_price: 0.013899,
      floor_price_symbol: "ETH",
      total_minted: 460,
      total_supply: null,
      total_volume: 192.53370672746087,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.71343,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 906,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 3,
      total_average_price: 0.21250961007446012,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.23781,
    },
    contracts: [
      {
        contract_address: "0x3b19ae1888cf876340d4c7a5d77a33d68cc6cf5d",
      },
    ],
    id: 291,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:02:45.962Z",
    key: "degas-nft",
    name: "Artwork by Edgar Degas NFT powered by GPDHost",
    description:
      "Edgar Degas was a French Impressionist of the 19th century. One of the main themes of his work was ballet. GPD Host presents a drawing by Degas (charcoal and pastel on paper, 21 × 21 cm) as an NFT token.\n\nA high-quality digital copy of the artwork has been created and divided into a 21 × 21 grid, resulting in 441 unique individual items, available in a limited edition.\n\nAt the moment, 369 items have been minted. The remaining 72 items are reserved by the creators and will be released in 2025. The price of the items is fixed.",
    exchange_url: "https://opensea.io/collection/degas-nft",
    external_url: "https://gpdhost.com/nft/edgar-degas/",
    banner_image_url:
      "https://i.seadn.io/gae/XuoykfNHSgNQXQ3FXTcKxz0hjPdxQwIQUoexo8Ylm7yB4T3lH-KevG6qFqZcjPLQfcdbhh7bHJiRb5sKm-rfWIZKGSETV847Q45iWw?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/cLcrwSqqM9ujUbWEWYA7ZDsPHG5bnnZOV6_KXKKBxpdHwstoy4m9Yyj-otvaL2LY_GO_RRjJ7tLQvrHzk5z_rt410PhGXVWlZ5hv?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/cLcrwSqqM9ujUbWEWYA7ZDsPHG5bnnZOV6_KXKKBxpdHwstoy4m9Yyj-otvaL2LY_GO_RRjJ7tLQvrHzk5z_rt410PhGXVWlZ5hv?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/bYrtB2Ocmag62TkNig0h8qDFwowF3nfsGZ13NHDl54ogkUEvCCkNVBFnAzYxDqbiCafNEpV6flD1CKI5UT-HB5WK8bIv46t83N6sfQ?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 6,
      floor_price: 0.09,
      floor_price_symbol: "ETH",
      total_minted: 6,
      total_supply: null,
      total_volume: 0.315,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 4,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.07875,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 292,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:02:42.372Z",
    key: "thesearemad",
    name: "My Abstract Dreams by Mart Biemans",
    description:
      "My Abstract Dreams is a collection of experimental art by Mart Biemans. \n\nOut of pure passion to create and experiment, the collection has grown into my biggest personal project to date. \n\nThe primary goal of it being to learn new techniques and develop myself as an artist. \n\nBeing an artist can be a struggle, I have experienced this myself. A percentage of the profits will be directly invested into upcoming NFT artists.",
    exchange_url: "https://opensea.io/collection/thesearemad",
    external_url: "http://thesearemad.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/ee8ece57cc726ac3bcf9831a005bc5ef.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/7U-OrrM0EFoRBOeyj6WTxqd9EWFxH5dNYNSqy_LH8PUVOuw73X4VQJ1xZwjzjMJ0H9ZWR1GANsHnkLVuVyLZPpK3fZqwb4UtyMKE0w?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/7U-OrrM0EFoRBOeyj6WTxqd9EWFxH5dNYNSqy_LH8PUVOuw73X4VQJ1xZwjzjMJ0H9ZWR1GANsHnkLVuVyLZPpK3fZqwb4UtyMKE0w?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/oKIGcwBayz5Z61Rwm0bioPsmBWOnAYlaeAA-mWF2D_uGO411JfKw5f7dXD84GWfT9EIxhtb_6GVn5-zXcY9eoIVBUDIBP_AXVG6f?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0.208,
      num_owners: 77,
      floor_price: 0.0328,
      floor_price_symbol: "ETH",
      total_minted: 77,
      total_supply: null,
      total_volume: 9.306999999999983,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.004,
      one_day_volume_change: 0,
      seven_day_volume_change: 2,
      thirty_day_volume_change: 0,
      total_sales: 129,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 2,
      total_average_price: 0.07214728682170529,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.002,
    },
    contracts: [
      {
        contract_address: "0x5eac8f5f8cb522f1fd946542667feaef96724787",
      },
    ],
    id: 293,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:02:37.882Z",
    key: "living-on-the-internet",
    name: "Living on the Internet",
    description:
      "LOTI is a Premium membership club. A community of like-minded individuals that have strengths as traders, collectors, and degens. Members have access to exclusive resources and tools. Each NFT represents a perk in our ecosystem.\n\nIf you have any questions please check out our discord for FAQs or our Medium page.\n\n[Medium](https://medium.com/@bitboyjay/pushing-boundaries-web3-meta-63f3f589ca26?source=social.tw) | [Discord](https://discord.gg/loti) | [Twitter](https://twitter.com/LOTI_NFT)",
    exchange_url: "https://opensea.io/collection/living-on-the-internet",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/7514238c12771d9c05af09e9bac19001.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/7da2e96841451d12a1e54fe8936352b9.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/7da2e96841451d12a1e54fe8936352b9.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/e51601c4737a34d652e5bc10e802122f.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0.0147,
      num_owners: 722,
      floor_price: 0.01977940004000001,
      floor_price_symbol: "ETH",
      total_minted: 722,
      total_supply: null,
      total_volume: 473.1558558206583,
      one_day_volume: 0,
      seven_day_volume: 0.0049,
      thirty_day_volume: 7.78439879997988,
      one_day_volume_change: 0,
      seven_day_volume_change: -4,
      thirty_day_volume_change: 2,
      total_sales: 2850,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 19,
      total_average_price: 0.16601959853356432,
      one_day_average_price: 0,
      seven_day_average_price: 0.0049,
      thirty_day_average_price: 0.40970519999894106,
    },
    contracts: [
      {
        contract_address: "0x78e1fdd193af5a8c091f3248ee4b906dff91fd40",
      },
    ],
    id: 294,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:02:30.344Z",
    key: "hoshiboshi-aries",
    name: "Hoshiboshi Aries",
    description:
      "HoshiBoshi 2,222 Star Club-Aries is a high-quality anime profile picture collection drawn by the prominent Japanese Artist Harimoji. The holders will be considered as Aries members who have the voting rights for the creation of the upcoming Vtuber Aries by Staroom.",
    exchange_url: "https://opensea.io/collection/hoshiboshi-aries",
    external_url: "https://hoshiboshi.io/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/5d19d6ab184b8fe076d237e457717660.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/5d19d6ab184b8fe076d237e457717660.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/5d19d6ab184b8fe076d237e457717660.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/3fe7db6e009071c897813977dbc04eeb.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1194,
      floor_price: 0.019,
      floor_price_symbol: "ETH",
      total_minted: 1194,
      total_supply: null,
      total_volume: 2893.3598616706818,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0245,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -7,
      total_sales: 4767,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.6069561278939966,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0245,
    },
    contracts: [
      {
        contract_address: "0x7614632d063fb1f335b36c612f8dfc52e5c62420",
      },
    ],
    id: 295,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:02:29.866Z",
    key: "multiversevm",
    name: "MultiverseVM",
    description:
      "Multiverse VM is a collection of 8000 NFTs living on the Ethereum blockchain.\nEach MVM has randomly generated outgoing links to other simulations, and through [Xeno Infinity](https://opensea.io/collection/xenoinfinity), users can instantly integrate the NFTs they own to use as their web3 identity.\nThe multiverse virtual machine contains mysterious technology, scientists suggest it seems to have the ability to create new realities.",
    exchange_url: "https://opensea.io/collection/multiversevm",
    external_url: "https://www.multiversevm.com/",
    banner_image_url:
      "https://i.seadn.io/gae/gyGE3NJO3Njl4zQkbSi7zDkkueGIsCmQvTbbzHPmk7Ef7w6DNVzNbohrV0TB6WgJcoxQVzbo60KdbTJyci2k815iWHQuu5HUO0-j?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/sJBqZcJittBcjkIY1F-V6DkJuIBYN0R0AaVjPIpnznaPTdPNCWoauHBNRGwgObGtp-zGailvnavs0uDitRaVoOEonGEjEieIq0-KLQ?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/b7ZcEKBEsu",
    telegram_url: null,
    twitter_username: "MultiverseVM",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 18.3632,
      num_owners: 1839,
      floor_price: 0.0094,
      floor_price_symbol: "ETH",
      total_minted: 1839,
      total_supply: null,
      total_volume: 3551.2674450333025,
      one_day_volume: 0,
      seven_day_volume: 0.0023,
      thirty_day_volume: 0.013999999999999999,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: -40,
      total_sales: 14828,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 3,
      total_average_price: 0.23949739985387797,
      one_day_average_price: 0,
      seven_day_average_price: 0.0023,
      thirty_day_average_price: 0.004666666666666666,
    },
    contracts: [
      {
        contract_address: "0xd5a73977e6effc252a7f1af4548ba11ff7187616",
      },
    ],
    id: 296,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:03:59.700Z",
    key: "element-pass-standard",
    name: "Element Pass Standard",
    description:
      "Element Pass Standard(EPS) is a standard collection(amount 20,000) in\r\nthe Element Pass Series. It is an equity asset anchored based on Element\r\nPass Genesis(EPG). Holders will have most of the similar rights and\r\ninterests as EPG. EPS is anchored by the long-term development of the\r\nElement platform and has a value from the moment of Mint. In the future,\r\nits price may fluctuate with the macro environment of the encryption\r\nmarket, user scale, and market sentiment.Element Pass Standard(EPS) is a standard collection(amount 20,000) in\r\nthe Element Pass Series. It is an equity asset anchored based on Element\r\nPass Genesis(EPG). Holders will have most of the similar rights and\r\ninterests as EPG. EPS is anchored by the long-term development of the\r\nElement platform and has a value from the moment of Mint. In the future,\r\nits price may fluctuate with the macro environment of the encryption\r\nmarket, user scale, and market sentiment.",
    exchange_url: "https://opensea.io/collection/element-pass-standard",
    external_url: "https://element.market",
    banner_image_url:
      "https://i.seadn.io/gcs/files/4cfa151e53daaf77276b4666dd6854dd.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/4cfa151e53daaf77276b4666dd6854dd.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/4cfa151e53daaf77276b4666dd6854dd.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/ee41c672ce156141bd1fbdbfde2f0dd6.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/elementmarket",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 91.68344978571427,
      num_owners: 6333,
      floor_price: 0.005468,
      floor_price_symbol: "ETH",
      total_minted: 6333,
      total_supply: null,
      total_volume: 34.27696628894183,
      one_day_volume: 0,
      seven_day_volume: 0.19255449999999996,
      thirty_day_volume: 0.6167185000000003,
      one_day_volume_change: 0,
      seven_day_volume_change: 31,
      thirty_day_volume_change: -119,
      total_sales: 1139,
      one_day_sales: 0,
      seven_day_sales: 42,
      thirty_day_sales: 90,
      total_average_price: 0.030093912457367717,
      one_day_average_price: 0,
      seven_day_average_price: 0.004584630952380951,
      thirty_day_average_price: 0.006852427777777781,
    },
    contracts: [
      {
        contract_address: "0x2675616c14eb3f56db556c1ff95aaf2a19c88bcb",
      },
    ],
    id: 297,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:03:45.621Z",
    key: "naka-chads",
    name: "NakaChads",
    description: "3333 NakaChads on the ethereum blockchain.",
    exchange_url: "https://opensea.io/collection/naka-chads",
    external_url: "https://bueno.art/flkljp9mo3b1zecrvpe9e/nakachads",
    banner_image_url:
      "https://i.seadn.io/gcs/files/0a2914dfdd6d1a114af58e5c7945155f.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/5494a5fd27b050eeb754912eef4561ad.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/5494a5fd27b050eeb754912eef4561ad.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/2f5364545c176a9ed8f8c0257e98d766.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 640,
      floor_price: 0.0495,
      floor_price_symbol: "ETH",
      total_minted: 640,
      total_supply: null,
      total_volume: 0.07644989999999999,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 12,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.006370824999999999,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x4b571cad08671ac5c17dde8ac3768759354cbd06",
      },
    ],
    id: 298,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:06:10.207Z",
    key: "monsieurabbit-genesis-collection",
    name: "MonsieuRabbit Genesis Collection",
    description:
      "La carte de membre Genesis VIR soutient la chaîne Youtube MonsieuRabbit et son écosystème.\n\nC'est également la première étape d'une aventure communautaire où je donnerai toujours mon maximum pour régaler les holders!\n\nAucune autre promesse, aucune road map mais attendez vous à des giveaways, white list, airdrop, event etc",
    exchange_url:
      "https://opensea.io/collection/monsieurabbit-genesis-collection",
    external_url: "https://www.youtube.com/monsieurabbit",
    banner_image_url:
      "https://i.seadn.io/gcs/files/aead6d18c4f942c8b051c7ddd17fd3db.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/b3526f464908ee49fd9fd605091f9dd9.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/b3526f464908ee49fd9fd605091f9dd9.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/b3526f464908ee49fd9fd605091f9dd9.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/rabbit-family-rf-810287253401763851",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0.0022,
      num_owners: 191,
      floor_price: 0.0249496,
      floor_price_symbol: "ETH",
      total_minted: 191,
      total_supply: null,
      total_volume: 2.7345000000000006,
      one_day_volume: 0.0022,
      seven_day_volume: 0.0022,
      thirty_day_volume: 0.0022,
      one_day_volume_change: 0.0022,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 0,
      total_sales: 68,
      one_day_sales: 1,
      seven_day_sales: 1,
      thirty_day_sales: 1,
      total_average_price: 0.040213235294117654,
      one_day_average_price: 0,
      seven_day_average_price: 0.0022,
      thirty_day_average_price: 0.0022,
    },
    contracts: [
      {
        contract_address: "0xe2a5bfbbd797689819067ed50348a0de8e1db018",
      },
    ],
    id: 299,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:06:09.801Z",
    key: "helix-founder-pass-official",
    name: "HELIX Founder Pass Official",
    description:
      "More than 70% OF PASSES STAKED: https://staking.helixmetaverse.com\r\n\r\nThe Founder Pass  is the best way to take full advantage of one of the most immersive Metaverse experiences on the Blockchain. The Founder Pass is 5000 NFTs that grant 3 months early access to play HELIX. Founder Pass holders will be entitled to exclusive airdrops, free land, exclusive designer clothes, supercars, and much more.\r\n\r\n\r\nOur EA pass holders will become HELIX’s tightly knit “alpha” community and be a pinnacle of the development of our game. Holders have the opportunity to be beta testers and take part in the most elite blockchain gaming community.",
    exchange_url: "https://opensea.io/collection/helix-founder-pass-official",
    external_url: "https://axium.co",
    banner_image_url:
      "https://i.seadn.io/gcs/files/b6e8b87c9e4fd8c49d0490749664eb60.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/f543cd8527f8252af58409745b2678c5.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/f543cd8527f8252af58409745b2678c5.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/f543cd8527f8252af58409745b2678c5.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/axium",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 107.71285714285713,
      num_owners: 839,
      floor_price: 0.021697,
      floor_price_symbol: "ETH",
      total_minted: 839,
      total_supply: null,
      total_volume: 4636.10359063581,
      one_day_volume: 0,
      seven_day_volume: 0.150798,
      thirty_day_volume: 0.379264,
      one_day_volume_change: 0,
      seven_day_volume_change: 4,
      thirty_day_volume_change: -19,
      total_sales: 15275,
      one_day_sales: 0,
      seven_day_sales: 7,
      thirty_day_sales: 18,
      total_average_price: 0.30350923670283536,
      one_day_average_price: 0,
      seven_day_average_price: 0.02154257142857143,
      thirty_day_average_price: 0.021070222222222223,
    },
    contracts: [
      {
        contract_address: "0x3df5c619a4926156f966a64e08f863385c21da0e",
      },
    ],
    id: 300,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:05:48.263Z",
    key: "shrapnel-operators-collection",
    name: "Shrapnel Operators Collection",
    description:
      "Operators represent the 5 characters in Shrapnel's upcoming comic book series based on the video game in development. Each character has their own story told in one of the comic books currently in production. Collect each Operator to get access to the comic for that character; collect all for additional benefits - in addition to . . .\r\n\r\n**Operators Utility:**  \r\n- Early access to video game  \r\n- Exclusive in-game assets  \r\n- Access to future token and NFT airdrops based on rarity level  \r\n- Access to future whitelists  \r\n- Digital Comic Book as NFT",
    exchange_url: "https://opensea.io/collection/shrapnel-operators-collection",
    external_url: "https://shrapnel.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/83962fe64af2be1f30f4703eeb8e23d4.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/0aefcaccc43a6998b3d6de2fe459e2b2.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/0aefcaccc43a6998b3d6de2fe459e2b2.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/N-0Ykz_InP31IMCnBV4gXAjPfXbkoOmENXGZjKRdK6mo2dO-hRcAHHPyQ-oBLcQMgWwzmh06GHeJ5U0yib3IDE9ekrvVc_-qlOWK?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/shrapnel",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 204.10728813559328,
      num_owners: 3303,
      floor_price: 0.02049,
      floor_price_symbol: "ETH",
      total_minted: 3303,
      total_supply: null,
      total_volume: 3554.212605360304,
      one_day_volume: 0.666434,
      seven_day_volume: 1.2042330000000003,
      thirty_day_volume: 2.242887839999998,
      one_day_volume_change: 0.6087739999999999,
      seven_day_volume_change: 46,
      thirty_day_volume_change: -189,
      total_sales: 24173,
      one_day_sales: 29,
      seven_day_sales: 59,
      thirty_day_sales: 121,
      total_average_price: 0.14703233381708122,
      one_day_average_price: 0.022980482758620687,
      seven_day_average_price: 0.020410728813559327,
      thirty_day_average_price: 0.018536263140495852,
    },
    contracts: [
      {
        contract_address: "0xfc8a98c22a9e32948ab028414d67c62c49b16864",
      },
    ],
    id: 301,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:05:41.082Z",
    key: "sattva-soul-supporters-generative",
    name: "SattvaSoulSupporters",
    description:
      "SattvaSoulSupporters is the collection based on the twelve signs of the Japanese zodiac drived CryptoNinja project.  \nThey are guardian of Sattva.  \nAfter undergoing rigorous training, They descended to earth to bestow Sattva's blessings on people!  \n\nSattvaSoulSupportersは、日本の十二支をモチーフとしたCryptoNinja派生のジェネラティブコレクションです。  \n彼らは天界に住むサットヴァ様にお仕えする護衛隊です。  \n厳しい修行を経てサットヴァ様の御加護を人々に与えるため、彼らは地上に降り立たちました！",
    exchange_url:
      "https://opensea.io/collection/sattva-soul-supporters-generative",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/0e5d815a50fedcaa7211efff92799205.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/559c72cfd2a36fcd5fd4a082d20ee0e9.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/559c72cfd2a36fcd5fd4a082d20ee0e9.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/bb265d7c8b78d07e8adfc5665ef47902.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 2439,
      floor_price: 0.001,
      floor_price_symbol: "ETH",
      total_minted: 2439,
      total_supply: null,
      total_volume: 7.759489439899962,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 1390,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.005582366503525153,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x08b349751cf5c5a30757358a02dc48b0be39c80c",
      },
    ],
    id: 302,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:05:33.183Z",
    key: "autoscope-by-erik-swahn",
    name: "Autoscope by Erik Swahn",
    description: "Solo exhibition with Verse, 2024.",
    exchange_url: "https://opensea.io/collection/autoscope-by-erik-swahn",
    external_url: "https://erikswahn.com",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/3e2c2ccae0fa225fd9fa40cef846cbc1.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/3e2c2ccae0fa225fd9fa40cef846cbc1.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/3e2c2ccae0fa225fd9fa40cef846cbc1.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 39.617999999999995,
      num_owners: 80,
      floor_price: 0.19397940004,
      floor_price_symbol: "ETH",
      total_minted: 80,
      total_supply: null,
      total_volume: 5.964037,
      one_day_volume: 0.0701,
      seven_day_volume: 0.2201,
      thirty_day_volume: 0.5645370000000001,
      one_day_volume_change: -0.0799,
      seven_day_volume_change: 2,
      thirty_day_volume_change: 2,
      total_sales: 29,
      one_day_sales: 1,
      seven_day_sales: 2,
      thirty_day_sales: 4,
      total_average_price: 0.20565644827586207,
      one_day_average_price: 0,
      seven_day_average_price: 0.11005,
      thirty_day_average_price: 0.14113425000000002,
    },
    contracts: [
      {
        contract_address: "0xe7ed54673455193f1d4448c88c6544fd93a237c0",
      },
    ],
    id: 303,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:05:15.860Z",
    key: "rotus",
    name: "ROTUS",
    description:
      "ROTUS (Rebels of the United States) introduces 369 unique skull characters, embodying the strength of the Red Lotus, a mystical flower given to them by their Ancestors (Rollindragons Series I), through the traits of this collection.\n\nHow you use the power of your Rotus, is upto you...",
    exchange_url: "https://opensea.io/collection/rotus",
    external_url: "http://linkr.bio/rollindragons",
    banner_image_url:
      "https://i.seadn.io/gcs/files/1f16844ba9ae742ebe961a30c64f2c0e.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/77d15f378af2ab64ede5bed100b9b82a.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/77d15f378af2ab64ede5bed100b9b82a.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/a549f45a9546cf11a825a18562988f70.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: "https://t.me/rollindragons",
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 107,
      floor_price: 0.012,
      floor_price_symbol: "ETH",
      total_minted: 107,
      total_supply: null,
      total_volume: 0.15850000000000003,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 13,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.012192307692307695,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x9e20f9434ac790c046da19ce642868354a547ee3",
      },
    ],
    id: 304,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:07:13.640Z",
    key: "takanotsume-dan-nft",
    name: "TAKANOTSUME-DAN-NFT",
    description:
      '*We allow holders to make commercial use of NFTs they own on a conditional basis.\n\nWe are TAKANOTSUME(aka Eagle Talon) , which is the greatest Japanese animation supervillain group in the world who suffer many ordinary problems such as a bothersome landlord and terrible allergies. Our mission is world domination!\n\nHelp us carry out our mission and we can dominate the world together! (in a fun way)\n\n本プロジェクトは、"だれもが幸せに生きられる世界を実現する"ために世界征服を目指す、心優しい悪の秘密結社鷹の爪団の一員になり、応援するためのデジタルアートNFTプロジェクトです。\n*ホルダーの方には条件付きで所有するNFTの商用利用を認めております。',
    exchange_url: "https://opensea.io/collection/takanotsume-dan-nft",
    external_url: "https://takanotsumedan.com/en/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/283f6775bb01f0a44253435b4d98d8ef.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/10e7592882670f01fc82814ad2f4fc00.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/10e7592882670f01fc82814ad2f4fc00.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/c0dcf0055c80494b7581932f32efb757.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/bANVjjc9Wr",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 395,
      floor_price: 0.007999,
      floor_price_symbol: "ETH",
      total_minted: 395,
      total_supply: null,
      total_volume: 44.72698865999898,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.016,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -6,
      total_sales: 750,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 2,
      total_average_price: 0.05963598487999864,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.008,
    },
    contracts: [
      {
        contract_address: "0x8b1ce0ab6f2b3b4e2b98f1b35ff986d9b8d481a2",
      },
    ],
    id: 305,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:07:06.062Z",
    key: "blootofficial",
    name: "Bloot (not for Weaks)",
    description: "It's basically worthless.\n\nNow under new management.",
    exchange_url: "https://opensea.io/collection/blootofficial",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gae/KHBDzGmftfOeZoFvbAbKHhv3-id1f58kMAldASP77AL8_UKSIEVMLTDycGWdQEGAwP3u_3YSqJZJAnPK2Mdb01rDnXaNZnogrvI8Nw?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/srjbORK3qPUaMDvBC1EfaMrr3KK1fIg0T6G69QFg-czyTS4wfMm-rP9stVwh4_HyA3QSqMvzc8Ry0NY0OgNClVTaR6dGl6iBTyGMDQ?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/srjbORK3qPUaMDvBC1EfaMrr3KK1fIg0T6G69QFg-czyTS4wfMm-rP9stVwh4_HyA3QSqMvzc8Ry0NY0OgNClVTaR6dGl6iBTyGMDQ?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/srjbORK3qPUaMDvBC1EfaMrr3KK1fIg0T6G69QFg-czyTS4wfMm-rP9stVwh4_HyA3QSqMvzc8Ry0NY0OgNClVTaR6dGl6iBTyGMDQ?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/Qdep8xgGqE",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 12.510152000000001,
      num_owners: 3695,
      floor_price: 0.0024,
      floor_price_symbol: "ETH",
      total_minted: 3695,
      total_supply: null,
      total_volume: 9032.032863208653,
      one_day_volume: 0.003,
      seven_day_volume: 0.01574,
      thirty_day_volume: 0.6067638999999997,
      one_day_volume_change: 0.003,
      seven_day_volume_change: -75,
      thirty_day_volume_change: 60,
      total_sales: 16982,
      one_day_sales: 1,
      seven_day_sales: 10,
      thirty_day_sales: 117,
      total_average_price: 0.5318591958078349,
      one_day_average_price: 0,
      seven_day_average_price: 0.001574,
      thirty_day_average_price: 0.005186016239316237,
    },
    contracts: [
      {
        contract_address: "0x4f8730e0b32b04beaa5757e5aea3aef970e5b613",
      },
    ],
    id: 306,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:07:02.261Z",
    key: "pigeons-of-new-york-phase-3",
    name: "PIGEONS OF NEW YORK: Phase3",
    description:
      "MUTANTS OF NEW YORK.  \n\nSold Out!! \n\nhttps://pigeonsofnewyork.io/",
    exchange_url: "https://opensea.io/collection/pigeons-of-new-york-phase-3",
    external_url: "https://pigeonsofnewyork.io/",
    banner_image_url:
      "https://i.seadn.io/s/raw/files/359363734f14185e60e6b489125fded7.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/79b621d6016f90b42a132bb29dc6856b.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/79b621d6016f90b42a132bb29dc6856b.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/9540ffbb96b4de1d6e584428f9cdc8af.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/HV4UEYY22t",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 5.61,
      num_owners: 228,
      floor_price: 0.01,
      floor_price_symbol: "ETH",
      total_minted: 228,
      total_supply: null,
      total_volume: 1.0996999800000005,
      one_day_volume: 0,
      seven_day_volume: 0.01,
      thirty_day_volume: 0.04,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 4,
      total_sales: 59,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 4,
      total_average_price: 0.018638982711864416,
      one_day_average_price: 0,
      seven_day_average_price: 0.01,
      thirty_day_average_price: 0.01,
    },
    contracts: [
      {
        contract_address: "0x6e3fd380a54ac11780857c88c868e6bb259cc5ac",
      },
    ],
    id: 307,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:06:31.221Z",
    key: "tcr-former",
    name: "former Team Cats and Rabbits(TCR)",
    description:
      "⚠️ ⚠️ 【重要】【IMPORTANT】⚠️ ⚠️\nNew URL\nhttps://rarible.com/cp-tcr",
    exchange_url: "https://opensea.io/collection/tcr-former",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/0eec5d2536528795b7bf3cfe2ef70b80.png?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/4b56292847b29963844687f5b0c5732d.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 192,
      floor_price: 0.01,
      floor_price_symbol: "ETH",
      total_minted: 192,
      total_supply: null,
      total_volume: 20.416879999999995,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 411,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.04967610705596106,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 308,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:08:12.622Z",
    key: "grandpaapechemistryclub",
    name: "Grandpa Ape Chemistry Club",
    description:
      "Grandpa Ape Chemistry Club consists of 5,000 Mutant Serums, to be airdropped to all Grandpa Apes. \n\nHandle with care.\n\nThe OG Grandpa Ape Collection: https://opensea.io/collection/grandpaapecountryclub\n\nMACC Collection: https://opensea.io/collection/mutantgrandpacountryclub\n\nGACC Toys: https://opensea.io/collection/gacc-toys-v1\n\nLunagems: https://opensea.io/collection/lunagems\n\nKitten Club: https://opensea.io/collection/grandpaapekittenclub",
    exchange_url: "https://opensea.io/collection/grandpaapechemistryclub",
    external_url: "http://www.grandpaapecountryclub.com/macc",
    banner_image_url:
      "https://i.seadn.io/gae/tDlON8dfP49TBvIEdahpiTtd9l8u5XF8bvA5n_39B88UHbJFQRxWw22Yx77PQAOn4w4RAsyJbFaubYbQeE-lGkaMhE_BnAZID4mWgw?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/tDlON8dfP49TBvIEdahpiTtd9l8u5XF8bvA5n_39B88UHbJFQRxWw22Yx77PQAOn4w4RAsyJbFaubYbQeE-lGkaMhE_BnAZID4mWgw?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/tDlON8dfP49TBvIEdahpiTtd9l8u5XF8bvA5n_39B88UHbJFQRxWw22Yx77PQAOn4w4RAsyJbFaubYbQeE-lGkaMhE_BnAZID4mWgw?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/we9wClWToKgrvmDPY3dpCnG4M-tJ1QlvHbqpvsWipitap_gipUilOhq1mcuw0htwrBlzc_elmg_xJLHV5ZvYJP0K4KL5HRu-5Jft?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/gacc",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0.03594970002,
      num_owners: 1117,
      floor_price: 0.007,
      floor_price_symbol: "ETH",
      total_minted: 1117,
      total_supply: null,
      total_volume: 997.5530148327905,
      one_day_volume: 0,
      seven_day_volume: 0.07189940004,
      thirty_day_volume: 0.13219940004000003,
      one_day_volume_change: 0,
      seven_day_volume_change: 5,
      thirty_day_volume_change: 5,
      total_sales: 3860,
      one_day_sales: 0,
      seven_day_sales: 6,
      thirty_day_sales: 14,
      total_average_price: 0.25843342353181104,
      one_day_average_price: 0,
      seven_day_average_price: 0.011983233340000001,
      thirty_day_average_price: 0.00944281428857143,
    },
    contracts: [
      {
        contract_address: "0xb9655f835418fb64b63f934acb745d12d810fedb",
      },
    ],
    id: 309,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:08:05.270Z",
    key: "shadow-wolves",
    name: "Shadow Wolves",
    description:
      'Shadow Wolves is a collection created by Cool Cats, compiled of 6,250 NFTs which offer mid-tier "Super Cool" membership into the Cool Cats ecosystem and access to the World of Cooltopia.\r\n\r\nShadow Wolves are druidic Viking-like creatures that have inhabited the Wandering Territory for thousands of years and are known for being aggressive, uncivilized adversaries, yet an integral part of the Cooltopian economy.',
    exchange_url: "https://opensea.io/collection/shadow-wolves",
    external_url: "https://coolcatsnft.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/cfff9971ae647745b67581f6890b0af4.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/956149196b12575538bb64d1779b3871.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/956149196b12575538bb64d1779b3871.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/dedaf5f76105701382212b10705bcb8e.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/coolcatsnft",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 246.52804878048778,
      num_owners: 3116,
      floor_price: 0.03498,
      floor_price_symbol: "ETH",
      total_minted: 3116,
      total_supply: null,
      total_volume: 388.1517130515116,
      one_day_volume: 0.2082,
      seven_day_volume: 1.6172239999999998,
      thirty_day_volume: 13.795269002999989,
      one_day_volume_change: 0.13300099999999998,
      seven_day_volume_change: 20,
      thirty_day_volume_change: -729,
      total_sales: 5119,
      one_day_sales: 6,
      seven_day_sales: 41,
      thirty_day_sales: 261,
      total_average_price: 0.07582569116067818,
      one_day_average_price: 0.0347,
      seven_day_average_price: 0.039444487804878046,
      thirty_day_average_price: 0.05285543679310341,
    },
    contracts: [
      {
        contract_address: "0x858df9f84c73e01c55a2dfb95825401242a65d64",
      },
    ],
    id: 310,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:07:58.269Z",
    key: "spectral-skellies",
    name: "Spectral Skellies",
    description:
      "A Limited Collection of Skeletal NFT companions. Destined to live on the Ethereum blockchain for all of eternity. Spectral Skellies are looking for a new home.\n\nOFFICIAL COMPANION COLLECTION: https://opensea.io/collection/spectralskelliecats",
    exchange_url: "https://opensea.io/collection/spectral-skellies",
    external_url: "http://Spectralskellies.io",
    banner_image_url:
      "https://i.seadn.io/gae/9jprOCOOxDxI8Zju5k3Q9aT-jvY4zgfDT5evupML7rd5TQfPXFZka37XCHFeDuxFe3FnVrL-4sMvlQ7vbk883pDREOFP_PdWfeXsNw?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/gielPdhpya3h3773JWokmtI2XPz6ghoFJ7CHKUNqvhLaUBU0W6i_whIGE-z1SB2TTLy4fv4bEx8o4dd6spR5LNbba2_OWEILDftx2ec?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/gielPdhpya3h3773JWokmtI2XPz6ghoFJ7CHKUNqvhLaUBU0W6i_whIGE-z1SB2TTLy4fv4bEx8o4dd6spR5LNbba2_OWEILDftx2ec?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/OD0zDtDr5A7TcITJxTlgu9NXsFfvjCuGuasXYOZNmN4TCYwfUoBfeBNhS-nhd7N3tgdmnBoPDkkGthhyHGMeHJop8dl4tiBVB0BzHg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/SpectralSkellies",
    telegram_url: null,
    twitter_username: "SpectralSkellie",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 13.052475,
      num_owners: 1142,
      floor_price: 0.007041,
      floor_price_symbol: "ETH",
      total_minted: 1142,
      total_supply: null,
      total_volume: 243.91122747975572,
      one_day_volume: 0,
      seven_day_volume: 0.0317,
      thirty_day_volume: 0.044399999999999995,
      one_day_volume_change: 0,
      seven_day_volume_change: 5,
      thirty_day_volume_change: 11,
      total_sales: 3263,
      one_day_sales: 0,
      seven_day_sales: 8,
      thirty_day_sales: 12,
      total_average_price: 0.07475060603118472,
      one_day_average_price: 0,
      seven_day_average_price: 0.0039625,
      thirty_day_average_price: 0.0037,
    },
    contracts: [
      {
        contract_address: "0x7a2e961c7adc05f8352818274687b3dda477dbaa",
      },
    ],
    id: 311,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:07:54.422Z",
    key: "space-girl-free-mint",
    name: "SPACE GIRL X NFT LIFE",
    description: "https://twitter.com/spacegirllab",
    exchange_url: "https://opensea.io/collection/space-girl-free-mint",
    external_url: "https://japannftmuseum.one/spacegirl",
    banner_image_url:
      "https://i.seadn.io/gcs/files/3e838ddf97fb5627a8b958084bdfb621.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/44c3869dc187f8b066d8291aa1c826bb.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/44c3869dc187f8b066d8291aa1c826bb.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/44c3869dc187f8b066d8291aa1c826bb.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/japandao",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1748,
      floor_price: 0.001,
      floor_price_symbol: "ETH",
      total_minted: 1748,
      total_supply: null,
      total_volume: 12.002573234899977,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 1427,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.0084110534231955,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x0c2ca73a5839d2d7f9291b44d38e03cf4f9195b3",
      },
    ],
    id: 312,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:07:27.749Z",
    key: "neo-baby-pass",
    name: "NEO BABY PASS",
    description:
      "NEO BABY GENESIS COLLECTION PASS\nhttps://japannftmuseum.one/neobaby",
    exchange_url: "https://opensea.io/collection/neo-baby-pass",
    external_url: "https://japannftmuseum.one/neobaby",
    banner_image_url:
      "https://i.seadn.io/gcs/files/ac8b90a4af9d885020b36b9c2ce3481f.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/9ce9c090d23cfe8830999173ed91deaf.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/9ce9c090d23cfe8830999173ed91deaf.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/604bf9fada4e0b615d96f5d62284ca1b.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/japandao",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 359,
      floor_price: 0.001,
      floor_price_symbol: "ETH",
      total_minted: 359,
      total_supply: null,
      total_volume: 3.4693719899999986,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 118,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.02940145754237287,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xbadd79eb199eaa8184f1c102aa273205158377f7",
      },
    ],
    id: 313,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:09:02.647Z",
    key: "nft-life-card",
    name: "NFT LIFE CARD",
    description: "APP https://www.nftlife.network/",
    exchange_url: "https://opensea.io/collection/nft-life-card",
    external_url: "https://www.nftlife.network/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/3235ef243e3962e80a4c06e3050d7e83.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/3235ef243e3962e80a4c06e3050d7e83.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/3235ef243e3962e80a4c06e3050d7e83.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/1d8f8a0b009d88473362cc32b8e38380.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 3534,
      floor_price: 0.001,
      floor_price_symbol: "ETH",
      total_minted: 3534,
      total_supply: null,
      total_volume: 3.2369473200283334,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 744,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.004350735645199373,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xf62c8d0cc458f2509736796ed916412cdd0ad1a8",
      },
    ],
    id: 314,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:08:44.568Z",
    key: "giftgoat-driftershoots",
    name: "VeeFriends Gift Goat x DrifterShoots: Where My Goats Go",
    description:
      "*Where My Goats Go* is a collection of 555 tokens comprising 37 editions. Each edition is a unique photograph taken by Drift during his helicopter flight with GaryVee. Prior to the flight, the duo, inspired by their respective creative backgrounds, drew on two pairs of Old Skool VANS. The helicopter then took a flight course above iconic NYC landscapes while they reimagined Drift’s signature style from his collection Where My Vans Go and photographed their feet hanging over the greatest city in the world. This was the 3rd NFT gifted to Gift Goats, and was airdropped on March 18th, 2022.",
    exchange_url: "https://opensea.io/collection/giftgoat-driftershoots",
    external_url: "https://veefriends.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/0938fbcfa188d1027d2e5fce2fef2828.jpg?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/5584b5b4c19d47c265b71e0c30bb6a60.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/veefriends",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 11.766,
      num_owners: 429,
      floor_price: 0.04678940004000001,
      floor_price_symbol: "ETH",
      total_minted: 429,
      total_supply: null,
      total_volume: 304.564884966866,
      one_day_volume: 0,
      seven_day_volume: 0.0424,
      thirty_day_volume: 0.0424,
      one_day_volume_change: 0,
      seven_day_volume_change: 2,
      thirty_day_volume_change: -2,
      total_sales: 219,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 2,
      total_average_price: 1.3907072372916254,
      one_day_average_price: 0,
      seven_day_average_price: 0.0212,
      thirty_day_average_price: 0.0212,
    },
    contracts: [
      {
        contract_address: "0x13927739076014913a3a7c207ef84c5be4780014",
      },
    ],
    id: 315,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:08:36.653Z",
    key: "muhammad-ali-thenextlegends-boxers",
    name: "Muhammad Ali | The Next Legends - Boxers",
    description:
      "Muhammad Ali — The Next Legends immerses you in the sport and culture of boxing as a coach and manager of your own artificially intelligent Boxer. Your strategic choices both in-gym and ringside will determine whether your one-of-a-kind AI Boxer becomes the next legend of the Open Metaverse. \n\nHead over to [The Locker Room](https://play.thenextlegends.xyz/boxers) now to begin customizing your Boxer and start your story. Get a [Gym Bag](https://opensea.io/collection/muhammad-ali-thenextlegends-gym-bags), train your Pro Boxer and fight your opponents to build your legacy.\n\nThe Next Legends is brought to you by [Altered State Machine](https://www.alteredstatemachine.xyz/) and [Futureverse](https://www.futureverse.com/) in partnership with ABG, IP rights holders of the Muhammad Ali Estate.\n\nVisit [thenextlegends.xyz](https://thenextlegends.xyz/) for more information.",
    exchange_url:
      "https://opensea.io/collection/muhammad-ali-thenextlegends-boxers",
    external_url: "https://thenextlegends.xyz/",
    banner_image_url:
      "https://i.seadn.io/s/raw/files/cb70147d9846519329d9d22b143d9cbb.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/cb70147d9846519329d9d22b143d9cbb.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/cb70147d9846519329d9d22b143d9cbb.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/cc52378dc19b17b6e28dfa871436f0dd.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/futureverse",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 22.4553,
      num_owners: 1823,
      floor_price: 0.003667,
      floor_price_symbol: "ETH",
      total_minted: 1823,
      total_supply: null,
      total_volume: 293.70872157925965,
      one_day_volume: 0,
      seven_day_volume: 0.0119,
      thirty_day_volume: 0.021,
      one_day_volume_change: 0,
      seven_day_volume_change: 2,
      thirty_day_volume_change: -3,
      total_sales: 3910,
      one_day_sales: 0,
      seven_day_sales: 3,
      thirty_day_sales: 5,
      total_average_price: 0.07511732009699736,
      one_day_average_price: 0,
      seven_day_average_price: 0.003966666666666667,
      thirty_day_average_price: 0.0042,
    },
    contracts: [
      {
        contract_address: "0x6bca6de2dbdc4e0d41f7273011785ea16ba47182",
      },
    ],
    id: 316,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:09:20.365Z",
    key: "unioverse-legendary-heroes",
    name: "UNIOVERSE LEGENDARY HEROES",
    description:
      "# Unio Coin hits exchanges! Start [here](https://medium.com/@unio_coin/unio-hits-exchanges-heres-how-to-use-it-and-what-s-coming-to-the-unioverse-99e723aa4f9f)\n\nThe Unioverse is a groundbreaking sci-fi franchise and game creation platform. Use **U**nioverse **H**eroes to play games like the Proving Grounds.",
    exchange_url: "https://opensea.io/collection/unioverse-legendary-heroes",
    external_url: "https://unioverse.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/0f1c15120fcba470deeb7d6948ff389c.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/787d058b27bf523548c4ea3be462a7e2.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/787d058b27bf523548c4ea3be462a7e2.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/336cd0691ce57bdafc720eccb9cdc17c.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/theunioverse",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 40.2164,
      num_owners: 169,
      floor_price: 0.026699,
      floor_price_symbol: "ETH",
      total_minted: 169,
      total_supply: null,
      total_volume: 40.899738199805505,
      one_day_volume: 0,
      seven_day_volume: 0.2968,
      thirty_day_volume: 0.34390000000000004,
      one_day_volume_change: 0,
      seven_day_volume_change: 2,
      thirty_day_volume_change: 3,
      total_sales: 210,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 5,
      total_average_price: 0.19476065809431192,
      one_day_average_price: 0,
      seven_day_average_price: 0.1484,
      thirty_day_average_price: 0.06878000000000001,
    },
    contracts: [
      {
        contract_address: "0x6a570bb15bc67968868c19b0ec7dcccdfd8ed089",
      },
    ],
    id: 317,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:11:05.171Z",
    key: "kitaroworld",
    name: "Kitaro World",
    description:
      'Kitaro World is a collaborative community storytelling experience.\n\nAs a web2 centric brand, Kitaro is staged for a global adventure - beginning with books, merch and more and seen across your everyday stores.\n\nIntroducing, the "Greenhouse Launchpad", a tool within the enchanted forest designed to help holders launch and/or license their IP.  Additionally, holders will have exclusive access to future drops, experiences and more!  \n\nVisit Purrr Pals collection: [Purrr Pals](https://opensea.io/collection/purrrpals)\n\nVisit World Scenes collection: [Kitaro World Scenes](https://opensea.io/collection/kitaroworldscenes)\n\nResources:\n[Website](https://kitaro.world) | [X](https://twitter.com/kitarostudios) | [Discord](https://discord.gg/kitaro) | [Presentation](https://drive.google.com/file/d/1ElyAjhjeil_lI8FAvPpiiIcibjIItvtB/view?usp=sharing)',
    exchange_url: "https://opensea.io/collection/kitaroworld",
    external_url: "https://kitaro.world",
    banner_image_url:
      "https://i.seadn.io/gcs/files/b1fe87d0ae23fd32ed79f623e7818fa7.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/b1fe87d0ae23fd32ed79f623e7818fa7.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/b1fe87d0ae23fd32ed79f623e7818fa7.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/495e3fc34c22c8e6e446ddcad5549cf7.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/kitaro",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 177.54487035949367,
      num_owners: 2453,
      floor_price: 0.023899,
      floor_price_symbol: "ETH",
      total_minted: 2453,
      total_supply: null,
      total_volume: 7466.3162555025065,
      one_day_volume: 0.2503989,
      seven_day_volume: 1.8037609,
      thirty_day_volume: 8.208654568649981,
      one_day_volume_change: 2,
      seven_day_volume_change: -36,
      thirty_day_volume_change: -134,
      total_sales: 46812,
      one_day_sales: 12,
      seven_day_sales: 79,
      thirty_day_sales: 291,
      total_average_price: 0.15949577577335952,
      one_day_average_price: 0.020866575,
      seven_day_average_price: 0.0228324164556962,
      thirty_day_average_price: 0.028208434943814368,
    },
    contracts: [
      {
        contract_address: "0x39d3230c84efcb5559d22f499151934476b5c16d",
      },
    ],
    id: 318,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:12:58.536Z",
    key: "nounish-punks-official",
    name: "Nounish Punks",
    description: null,
    exchange_url: "https://opensea.io/collection/nounish-punks-official",
    external_url: "https://nounishpunk.com/",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/089d6f67cf0fd9e2fe8c8d874edfe888.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/089d6f67cf0fd9e2fe8c8d874edfe888.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/842568a4040be16946f42b73b565a477.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/gF5wy4NaBe",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 61.15871066782609,
      num_owners: 633,
      floor_price: 0.00959999,
      floor_price_symbol: "ETH",
      total_minted: 633,
      total_supply: null,
      total_volume: 9.681929638999978,
      one_day_volume: 0,
      seven_day_volume: 0.62131199,
      thirty_day_volume: 0.9957696900000002,
      one_day_volume_change: 0,
      seven_day_volume_change: -19,
      thirty_day_volume_change: 42,
      total_sales: 822,
      one_day_sales: 0,
      seven_day_sales: 23,
      thirty_day_sales: 72,
      total_average_price: 0.011778503210462261,
      one_day_average_price: 0,
      seven_day_average_price: 0.027013564782608697,
      thirty_day_average_price: 0.013830134583333336,
    },
    contracts: [
      {
        contract_address: "0xa83edf3d52e930313640df79c4ea2fb2436bf853",
      },
    ],
    id: 319,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:12:43.933Z",
    key: "the-jims",
    name: "The Jims",
    description:
      "Jim Simons, the greatest investor of all time, reimagined.\r\n\r\nThe first Fingerprints DAO pfp project, created by DAO member Gremplin with a small bit of help from his friends.\r\n\r\nThis project is in the public domain. CC0. Feel free to use Jims in any way you want.\r\n\r\nThe Jims is not an investment. This is a fun, non-speculative profile picture project!",
    exchange_url: "https://opensea.io/collection/the-jims",
    external_url: "https://thejims.xyz",
    banner_image_url:
      "https://i.seadn.io/gae/Mk72Gynt-DyWLsw_gX8gtlnfcSirWCObYn8sHlLtfeiwJ4TJtJHRrPoGIjSlBzprqkyZOXbP--jnhTlYYGHbAICeWDxNS2E73pNHsQ?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/nC9n1Cv9uuTXbklbDChUWcywMcxR1n1686742CU8fbv9WUK1H1TzdsHIaKEk04eWiFY8xXgrrm_goNk7GgaDrQk_q6IBSU2IxWgP?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/nC9n1Cv9uuTXbklbDChUWcywMcxR1n1686742CU8fbv9WUK1H1TzdsHIaKEk04eWiFY8xXgrrm_goNk7GgaDrQk_q6IBSU2IxWgP?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/5BRd4ZVOYOgAfC3ah4YDMcZAMsbA19tKJFJa1sIvLUMa3pMcqG8QLDpwmfAjXG6USXtMcSeXmo_ro0eVXzC0R7lfRn_6IFyxYf4LKVs?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/5xTXtZXn2g",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 30.6584,
      num_owners: 846,
      floor_price: 0.024916,
      floor_price_symbol: "ETH",
      total_minted: 846,
      total_supply: null,
      total_volume: 1309.6188286214324,
      one_day_volume: 0,
      seven_day_volume: 0.0152,
      thirty_day_volume: 0.3637619999999999,
      one_day_volume_change: 0,
      seven_day_volume_change: -2,
      thirty_day_volume_change: 2,
      total_sales: 3325,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 15,
      total_average_price: 0.39387032439742325,
      one_day_average_price: 0,
      seven_day_average_price: 0.0152,
      thirty_day_average_price: 0.024250799999999996,
    },
    contracts: [
      {
        contract_address: "0xe7df058ee3f091b46ab14b79b8efc5a5e46b275f",
      },
    ],
    id: 320,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:12:43.436Z",
    key: "special-yacht-collection-2025",
    name: "Special Yacht Collection 2025",
    description: null,
    exchange_url: "https://opensea.io/collection/special-yacht-collection-2025",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/s/raw/files/95b1352ea462851cf1239353262e73ba.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 20,
      floor_price: 2,
      floor_price_symbol: "ETH",
      total_minted: 20,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x17cc83caac31d938ee9f14336a0fa568d8f70675",
      },
    ],
    id: 321,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:12:36.209Z",
    key: "sequels-by-joel-meyerowitz",
    name: "Sequels by Joel Meyerowitz",
    description:
      "One Image, Every Day, for a Decade\n\nSequels is Joel Meyerowitz's pioneering exploration of photography and blockchain technology, uniting six decades of his work into a decade-long narrative. This visual autobiography offers a unique window into Meyerowitz's diverse experiences across the USA, Europe, and Latin America.\n\nFor sequels, Meyerowitz brings together images from over 250,000 negatives, revealing connections between photographs and creating an ongoing, interactive exhibition. As he puts it, \"When you put a run of pictures together, you're making ideas, they become your language.\"\n\nSequels transcends the boundaries of traditional exhibits, promising a new image every day for ten years. Meyerowitz invites us into this evolving narrative, sparking anticipation and engagement with the question: \"What's he going to come up with next?\"",
    exchange_url: "https://opensea.io/collection/sequels-by-joel-meyerowitz",
    external_url: "https://sequels.fellowship.xyz",
    banner_image_url:
      "https://i.seadn.io/gcs/files/4136a3f9e7f3796331f4dba263caa6a9.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/4136a3f9e7f3796331f4dba263caa6a9.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/4136a3f9e7f3796331f4dba263caa6a9.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/1ac5c8f0da5a8ab111cce523587baf0c.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/fellowshiptrust",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 10,
      num_owners: 131,
      floor_price: 0.094999,
      floor_price_symbol: "ETH",
      total_minted: 131,
      total_supply: null,
      total_volume: 1.9220999999999997,
      one_day_volume: 0.02,
      seven_day_volume: 0.02,
      thirty_day_volume: 0.02,
      one_day_volume_change: 0.02,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 1,
      total_sales: 24,
      one_day_sales: 1,
      seven_day_sales: 1,
      thirty_day_sales: 1,
      total_average_price: 0.08008749999999999,
      one_day_average_price: 0,
      seven_day_average_price: 0.02,
      thirty_day_average_price: 0.02,
    },
    contracts: [
      {
        contract_address: "0x766edd602ce72fa5737a92e50d4a5e192b57aef4",
      },
    ],
    id: 322,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:12:28.259Z",
    key: "plushie-pals-4",
    name: "PLUSHIE PALS",
    description:
      "A collection of 3000 cute, cuddly, and off the charts Plushie Pals brought to you by The Bear and Bull NFT. Created in the style of the previous Phase Two collection, some traits will have been seen before, but this time, in a whole new way. Other traits are new and have never before been seen. There are plenty of 1 of 1s, and some are more rare than the others.",
    exchange_url: "https://opensea.io/collection/plushie-pals-4",
    external_url: "https://thebearandbullnft.com/",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/d1f43467c6306445eb910fd1b3547b09.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/d1f43467c6306445eb910fd1b3547b09.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/d1f43467c6306445eb910fd1b3547b09.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/HNX49gnkmU",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 88.08,
      num_owners: 197,
      floor_price: 0.1,
      floor_price_symbol: "ETH",
      total_minted: 197,
      total_supply: null,
      total_volume: 0.375,
      one_day_volume: 0.36,
      seven_day_volume: 0.36,
      thirty_day_volume: 0.375,
      one_day_volume_change: 3,
      seven_day_volume_change: 2,
      thirty_day_volume_change: 4,
      total_sales: 4,
      one_day_sales: 3,
      seven_day_sales: 3,
      thirty_day_sales: 4,
      total_average_price: 0.09375,
      one_day_average_price: 0.12,
      seven_day_average_price: 0.12,
      thirty_day_average_price: 0.09375,
    },
    contracts: [
      {
        contract_address: "0xff27073a1aa350188625e4c67e24ab8a2c764d90",
      },
    ],
    id: 323,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:14:05.953Z",
    key: "derage",
    name: "Derage",
    description:
      "A 4201 Derivate Degen Rage collection by Darkfarms1. CC0 \nDiscord: https://discord.gg/XzvGhuqxzv",
    exchange_url: "https://opensea.io/collection/derage",
    external_url: "http://darkfarms.net",
    banner_image_url:
      "https://i.seadn.io/gae/fTINfJGAQqIkgzNDfZnyjxraijU9bJuhTr04D4FC6kXhsO-Njf8_oUSOodGHOeRfTtfk6EEWWFdRbjiQ9OUwiVUEPq-YcC0EnL8mzQA?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/xKa2FOzh2_QYkhIg64WbeAfaFtxykoNvCTciKgqz9OnZP4jd-gS86o03UcTw6eir7B8mp_Zq9BLKUcW9vOoLRBxW5BxsE6lXHCuD?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/xKa2FOzh2_QYkhIg64WbeAfaFtxykoNvCTciKgqz9OnZP4jd-gS86o03UcTw6eir7B8mp_Zq9BLKUcW9vOoLRBxW5BxsE6lXHCuD?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/Bs2eUUmyvjM7RmU1CHA6dSKhpsQAsx6BNSShzvAW0AvBvOS_TuQdCcORmwKcBxxK1NwHdEO2eF67Fe76vtdXF_DiPAT_ca4sBpgh?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/XzvGhuqxzv",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 177.64239999999998,
      num_owners: 1103,
      floor_price: 0.051286,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 1265.105395068983,
      one_day_volume: 0.0598,
      seven_day_volume: 0.1798,
      thirty_day_volume: 1.6952779999999998,
      one_day_volume_change: 0.0598,
      seven_day_volume_change: -10,
      thirty_day_volume_change: -32,
      total_sales: 13154,
      one_day_sales: 1,
      seven_day_sales: 4,
      thirty_day_sales: 29,
      total_average_price: 0.09617647826280849,
      one_day_average_price: 0,
      seven_day_average_price: 0.04495,
      thirty_day_average_price: 0.05845786206896551,
    },
    contracts: [
      {
        contract_address: "0xbc8af167ffaa6b780aaeb522ccabd64c5933bf02",
      },
    ],
    id: 324,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:13:58.273Z",
    key: "ens",
    name: "ENS: Ethereum Name Service",
    description:
      "Ethereum Name Service (ENS) domains are secure domain names for the decentralized world. ENS domains provide a way for users to map human readable names to blockchain and non-blockchain resources, like Ethereum addresses, IPFS hashes, or website URLs. ENS domains can be bought and sold on secondary markets.",
    exchange_url: "https://opensea.io/collection/ens",
    external_url: "https://ens.domains",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/gae/BBj09xD7R4bBtg1lgnAAS9_TfoYXKwMtudlk-0fVljlURaK7BWcARCpkM-1LGNGTAcsGO6V1TgrtmQFvCo8uVYW_QEfASK-9j6Nr?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/BBj09xD7R4bBtg1lgnAAS9_TfoYXKwMtudlk-0fVljlURaK7BWcARCpkM-1LGNGTAcsGO6V1TgrtmQFvCo8uVYW_QEfASK-9j6Nr?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/0cOqWoYA7xL9CkUjGlxsjreSYBdrUBE0c6EO1COG4XE8UeP-Z30ckqUNiL872zHQHQU5MUNMNhfDpyXIP17hRSC5HQ?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: "ensdomains",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 36697.13180794474,
      num_owners: 1063251,
      floor_price: 0.00022,
      floor_price_symbol: "ETH",
      total_minted: 1063251,
      total_supply: null,
      total_volume: 98533.32576361927,
      one_day_volume: 0.6267763880000004,
      seven_day_volume: 11.394020614274986,
      thirty_day_volume: 139.4309903451054,
      one_day_volume_change: 61,
      seven_day_volume_change: 842,
      thirty_day_volume_change: 1040,
      total_sales: 392523,
      one_day_sales: 295,
      seven_day_sales: 1121,
      thirty_day_sales: 2054,
      total_average_price: 0.251025610635859,
      one_day_average_price: 0.002124665722033899,
      seven_day_average_price: 0.010164157550646731,
      thirty_day_average_price: 0.06788266326441354,
    },
    contracts: [
      {
        contract_address: "0x57f1887a8bf19b14fc0df6fd9b2acc9af147ea85",
      },
    ],
    id: 325,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:13:40.215Z",
    key: "spaceartdesign-collection",
    name: "Istanbul Collection",
    description:
      "Graphics interchange format images of Galata Tower, Tunel, Istiklal, Nisantasi and its surroundings in Istanbul and a feast of historical texture. ",
    exchange_url: "https://opensea.io/collection/spaceartdesign-collection",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/4ca1dff88b4e2f3f082cb79e77a8849e.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/4ca1dff88b4e2f3f082cb79e77a8849e.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/4ca1dff88b4e2f3f082cb79e77a8849e.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/4ca1dff88b4e2f3f082cb79e77a8849e.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 1,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 326,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:13:18.650Z",
    key: "vsamurai-genesis",
    name: "vSamurai Genesis",
    description:
      "vSamurai is a 2222 Supply Genesis Collection. \r\n\r\nVarying rarity-based tokenomics geared to provide the most value to vSamurai hodlers. \r\n\r\nStaking + $EDO Token + Alpha + Future P2E Access + Future Breeding + Future Seasonal Rotation System.",
    exchange_url: "https://opensea.io/collection/vsamurai-genesis",
    external_url: "https://vsamurai.io/",
    banner_image_url:
      "https://i.seadn.io/gae/umSWrS7RdsxCAdWUqxxNjMVtvLbj8zOdwILDoBTbmMTnALN2eekBiChg406sJU7JPmEXqQpVAcKCdvJzRry7sgx73ltVCeiHVhSWyw?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/x_xIVdyPU-WEwiCX9e-2gyNZVFRpzdYIt5zQJ5y4eTL_tL1aaZ07K086SJlaUjhmPX9wuCeMVwWMeGCXwmNRR7rFx6cv88dCPGHS?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/x_xIVdyPU-WEwiCX9e-2gyNZVFRpzdYIt5zQJ5y4eTL_tL1aaZ07K086SJlaUjhmPX9wuCeMVwWMeGCXwmNRR7rFx6cv88dCPGHS?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/eqo-1RyE-IR_IR4bw2cepAHGJrJUmfEDF63tnK47mLq__FgFSt8IajBoSDxFqbw9LUkmyRpF5STKSVsXaCpfVdSx0yE6WMAxA3_YPPc?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/6FZj6rJ52r",
    telegram_url: "https://t.me/cryptocurrencyboss",
    twitter_username: null,
    wiki_url: null,
    instagram_username: "cryptocurrency.boss",
    stats: {
      market_cap: 4.272,
      num_owners: 315,
      floor_price: 0.0439,
      floor_price_symbol: "ETH",
      total_minted: 315,
      total_supply: null,
      total_volume: 114.51460520569982,
      one_day_volume: 0.002,
      seven_day_volume: 0.002,
      thirty_day_volume: 0.002,
      one_day_volume_change: 0.002,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 1,
      total_sales: 3488,
      one_day_sales: 1,
      seven_day_sales: 1,
      thirty_day_sales: 1,
      total_average_price: 0.032831022134661644,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.002,
    },
    contracts: [
      {
        contract_address: "0x0b95b4f29d10f7a676f8c38c7c0692b29a396d1d",
      },
    ],
    id: 327,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:13:18.232Z",
    key: "netvrktransports",
    name: "Netvrk Transports",
    description:
      "Transports will be fully functional in the metaverse and can be used to traverse the land, transport multiple avatars, store items and receive increased staking rewards and even participate in select blockchain games.\r\n\r\nYou can stake your transport to receive a revenue share of Netvrk's Marketplace and NFT royalties.\r\n\r\nJoin the Netvrk community: https://netvrk.link/discord\r\n\r\nNetvrk NFT collections:\r\n\r\nhttps://opensea.io/collection/netvrkland\r\n\r\nhttps://opensea.io/collection/netvrktransports\r\n\r\nhttps://opensea.io/collection/netvrkbonuses\r\n\r\nhttps://opensea.io/collection/netvrkavatars",
    exchange_url: "https://opensea.io/collection/netvrktransports",
    external_url: "http://Netvrk.co",
    banner_image_url:
      "https://i.seadn.io/gae/mY6yJ90l6LK4st5h09yHXKAMgRKV64_zhlBqS_680qOpAmEef26cdHkG9ctXaPhk_Ra-tjUS0KFouro0-aiN-d_dGworE1G9T4FchQ?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/y9snj8roDcjFjFwuj5eQf2Wf6RFmbNOZKJ_h6H9sNHmQgMOopkQiZGe-j6TJQhRkH2qCby6b0qmQ5Ey1uAzpX-6uuJ6Y78CFcqndanM?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/y9snj8roDcjFjFwuj5eQf2Wf6RFmbNOZKJ_h6H9sNHmQgMOopkQiZGe-j6TJQhRkH2qCby6b0qmQ5Ey1uAzpX-6uuJ6Y78CFcqndanM?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/CEwS8Ch7B_yjWfM5kF_P8GvYqj4bVI3L0qlse4_8CyPBhiGkvFlQnBLVY30AHTA1pMXHKHOOcgg7wkiw2SIf3rZkafzJaZcvwUboRZM?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.com/invite/6aBuuqXN4y",
    telegram_url: "https://t.me/NetVRk_Official",
    twitter_username: null,
    wiki_url: null,
    instagram_username: "netvrkofficial",
    stats: {
      market_cap: 138.832881,
      num_owners: 1488,
      floor_price: 0.01269,
      floor_price_symbol: "ETH",
      total_minted: 1488,
      total_supply: null,
      total_volume: 600.1494184511182,
      one_day_volume: 0,
      seven_day_volume: 0.09661299999999999,
      thirty_day_volume: 0.9007200000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: -9,
      thirty_day_volume_change: -8,
      total_sales: 2313,
      one_day_sales: 0,
      seven_day_sales: 4,
      thirty_day_sales: 33,
      total_average_price: 0.25946797166066504,
      one_day_average_price: 0,
      seven_day_average_price: 0.024153249999999998,
      thirty_day_average_price: 0.027294545454545457,
    },
    contracts: [
      {
        contract_address: "0xb95abd5fa9e71f1981505c3d9a7800c369b0718c",
      },
    ],
    id: 328,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:14:45.387Z",
    key: "influence-crew",
    name: "Influence Crew",
    description:
      "[Influence](https://influenceth.io) is a space strategy MMO, set in a realistic asteroid belt in the Adalia system, after an ill-fated journey aboard the Arvad, a generational ship fleeing from a dying Earth.\n\n**NOTE**: Influence metadata is dynamic. Please be cautious when purchasing and do NOT trust metadata without also checking the source contracts.\n\n**NOTE**: This collection is migrating to the [Influence Crewmates](https://opensea.io/collection/influence-crewmates) collection. After bridging crewmates to L2 they will return to the new collection after bridging back.",
    exchange_url: "https://opensea.io/collection/influence-crew",
    external_url: "https://www.influenceth.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/5e4f9377fd635e426326d74215f344a9.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/5e4f9377fd635e426326d74215f344a9.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/5e4f9377fd635e426326d74215f344a9.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/5742ExtD_kaqBxjWdwFudDd30s7hGUki5Lod2vFpBeBvKvT00BcZQbZvcxKnqH8jcC2yWJGN267eMdp3jsdccPqOXyV_G--pFfosBw?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/influenceth",
    telegram_url: null,
    twitter_username: "influenceth",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 794,
      floor_price: 0.0142,
      floor_price_symbol: "ETH",
      total_minted: 794,
      total_supply: null,
      total_volume: 884.3235098815273,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.1003,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -4,
      total_sales: 5204,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 6,
      total_average_price: 0.16993149690267628,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.016716666666666668,
    },
    contracts: [
      {
        contract_address: "0x746db7b1728af413c4e2b98216c6171b2fc9d00e",
      },
    ],
    id: 329,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:15:45.856Z",
    key: "digidaigakudragonessences",
    name: "DigiDaigaku Dragon Essences",
    description:
      "This collection consists of Dragon Essences needed to create DigiDaigaku Adult Dragons. Please follow us on Twitter: https://twitter.com/DigiDaigaku or visit our website https://digidaigaku.com for more information.",
    exchange_url: "https://opensea.io/collection/digidaigakudragonessences",
    external_url: "http://digidaigaku.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/4d0dbdbcf9a6b090255ba7dd3c7a714a.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/382493dd2f487f05ee0289374ff8cd87.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/382493dd2f487f05ee0289374ff8cd87.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/4a1a7cb7e32c0e4c78b4688d516ddb25.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/qHqsDJMTha",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 521,
      floor_price: 0.049692,
      floor_price_symbol: "ETH",
      total_minted: 521,
      total_supply: null,
      total_volume: 224.2779522443133,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 2088,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.10741281237754469,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x5434e17e9f4aa9521f85e57932b884d45037f071",
      },
    ],
    id: 330,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:15:45.412Z",
    key: "cryptoarte",
    name: "CryptoArte",
    description:
      "A NFT and generative art collection from 2018, CryptoArte projects the Ethereum blockchain history into colorful, unique, and meaningful paintings. Each token represents a given painting and matches its hash on-chain. Token owners can download their painting's 8K resolution digital images and order signed, ready to hang prints at cryptoarte.io.",
    exchange_url: "https://opensea.io/collection/cryptoarte",
    external_url: "https://www.cryptoarte.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/f5422f6c666a498facccdd949f4089ae.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/H0GBuAjiFWYE7hHA6p66Q36iOcjuP0X22v22-jME1aBeYqCggNXcuOgOxAUbLi43o-OYv4eOSRwYpE8TTG5xGSjEh1tWxdrkmM2X?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/H0GBuAjiFWYE7hHA6p66Q36iOcjuP0X22v22-jME1aBeYqCggNXcuOgOxAUbLi43o-OYv4eOSRwYpE8TTG5xGSjEh1tWxdrkmM2X?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/JySahZaeN2tGy4aTvzfdbRGv9qizz8-7F-s3iJ_pbhUZ9KJceVnoW1c_V2IZq5dSK_9h_FgrTv_HF2MA2s8PXqg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/kwbRuwf",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 298.64590875,
      num_owners: 3399,
      floor_price: 0.0338,
      floor_price_symbol: "ETH",
      total_minted: 3399,
      total_supply: null,
      total_volume: 6319.357913046515,
      one_day_volume: 0.098994,
      seven_day_volume: 0.24198999999999998,
      thirty_day_volume: 5.849596000000003,
      one_day_volume_change: 0.098994,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 4,
      total_sales: 13382,
      one_day_sales: 3,
      seven_day_sales: 8,
      thirty_day_sales: 44,
      total_average_price: 0.47222821051012664,
      one_day_average_price: 0.032998,
      seven_day_average_price: 0.030248749999999998,
      thirty_day_average_price: 0.1329453636363637,
    },
    contracts: [
      {
        contract_address: "0xbace7e22f06554339911a03b8e0ae28203da9598",
      },
    ],
    id: 331,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:15:44.952Z",
    key: "paraverse",
    name: "PARAVERSE",
    description:
      "Enter the Augmented World. PARAVERSE Genesis AR Lands is a collection of Augmented Reality Lands NFTs. Your AR Land allows you to own a virtual parcel in PARAVERSE and make your imagination come true by merging both virtual and real worlds.\r\nBecome a pioneer and be among the first to participate in a Web3 revolution by building your own AR world.\r\nVisit www.paraverse.world for all details.",
    exchange_url: "https://opensea.io/collection/paraverse",
    external_url: "https://www.paraverse.world",
    banner_image_url:
      "https://i.seadn.io/gcs/files/fa406ddedab776132cc783deae76cd29.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/567c97441a62b7eaa1b645e384b55bd0.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/567c97441a62b7eaa1b645e384b55bd0.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/aab68af65a95213bedb29c669af27c73.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/paraverse",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 246,
      floor_price: 0.008997,
      floor_price_symbol: "ETH",
      total_minted: 246,
      total_supply: null,
      total_volume: 59.63005005795898,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.007750799960000009,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 570,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 3,
      total_average_price: 0.10461412290869997,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.00258359998666667,
    },
    contracts: [
      {
        contract_address: "0x4da36efb0fe676a6a4aa656fd5dedd7c8184c79e",
      },
    ],
    id: 332,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:15:41.029Z",
    key: "wol-kyushime",
    name: "World of Lunars Official",
    description:
      'First Collection to Challenge the World\n\nKyushime\'s first generative PFP collection, depicting the most popular artwork of Kyushime, "Lunars," in a more diverse range of situations and styles.',
    exchange_url: "https://opensea.io/collection/wol-kyushime",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/db2c092f649cf1008f4473e766b67a4e.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/db2c092f649cf1008f4473e766b67a4e.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/db2c092f649cf1008f4473e766b67a4e.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/056bae8e908c4d355334206a2a834f13.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/kyushime-family",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 4,
      num_owners: 711,
      floor_price: 0.0079,
      floor_price_symbol: "ETH",
      total_minted: 711,
      total_supply: null,
      total_volume: 16.98506879999996,
      one_day_volume: 0.006,
      seven_day_volume: 0.006,
      thirty_day_volume: 0.006,
      one_day_volume_change: 0.006,
      seven_day_volume_change: 3,
      thirty_day_volume_change: -2,
      total_sales: 594,
      one_day_sales: 3,
      seven_day_sales: 3,
      thirty_day_sales: 3,
      total_average_price: 0.028594391919191855,
      one_day_average_price: 0.002,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.002,
    },
    contracts: [
      {
        contract_address: "0xde2967afc57055b2041685f2d5b376bfc2d0b536",
      },
    ],
    id: 333,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:15:22.433Z",
    key: "unioverse-epic-heroes",
    name: "UNIOVERSE EPIC HEROES",
    description:
      "# Unio Coin hits exchanges! Start [here](https://medium.com/@unio_coin/unio-hits-exchanges-heres-how-to-use-it-and-what-s-coming-to-the-unioverse-99e723aa4f9f)\n\nThe Unioverse is a groundbreaking sci-fi franchise and game creation platform. Use **U**nioverse **H**eroes to play games like the Proving Grounds.",
    exchange_url: "https://opensea.io/collection/unioverse-epic-heroes",
    external_url: "https://unioverse.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/ac923ab2394c4fb7cb28e481b7717ee3.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/38a45dee89e0768af0df75c278774b95.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/38a45dee89e0768af0df75c278774b95.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/336cd0691ce57bdafc720eccb9cdc17c.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/theunioverse",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 379,
      floor_price: 0.011998,
      floor_price_symbol: "ETH",
      total_minted: 379,
      total_supply: null,
      total_volume: 14.425766687632581,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 386,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.03737245255863363,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x16a1dcd0f76947dc3d3ba5158952107ef0321ad9",
      },
    ],
    id: 334,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:17:01.468Z",
    key: "mntge-pass",
    name: "MNTGE Pass",
    description:
      "MNTGE Pass is our founding membership pass made up of 1,500 community members. MNTGE gives its pass holders opportunities to interface with fashion history, cultural touchstones, and rare collectibles that may otherwise be impossible for most people to own, wear, or experience. Become a Day One member and secure your spot.",
    exchange_url: "https://opensea.io/collection/mntge-pass",
    external_url: "https://www.mntge.io/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/cb50a7f504e957ff9c89e0eb9b83a437.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/4184149b8d5cd83982d95e21ed6cd6ba.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/4184149b8d5cd83982d95e21ed6cd6ba.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/6d2e9d056be58730a4fc969a83b4b03c.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/mntgeofficial",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 9.8934,
      num_owners: 904,
      floor_price: 0.006979,
      floor_price_symbol: "ETH",
      total_minted: 904,
      total_supply: null,
      total_volume: 865.179160196572,
      one_day_volume: 0,
      seven_day_volume: 0.0132,
      thirty_day_volume: 0.04453960003367578,
      one_day_volume_change: 0,
      seven_day_volume_change: 2,
      thirty_day_volume_change: -11,
      total_sales: 2061,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 7,
      total_average_price: 0.4197861039284677,
      one_day_average_price: 0,
      seven_day_average_price: 0.0066,
      thirty_day_average_price: 0.006362800004810826,
    },
    contracts: [
      {
        contract_address: "0xf8c72628bd822e54e1fb2bf0c3484c10d1963e28",
      },
    ],
    id: 335,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:16:43.293Z",
    key: "walker-world-lost-walkers",
    name: "Walker World: The Lost Walkers",
    description:
      "The Lost Walkers are the 3455 animated and fully game-rigged 3D characters ready for the Metaverse who got abducted by aliens in 2021. Now they are coming back. These unique Walker avatars can explore the environments of Web3, Augmented Reality and our upcoming game, spearheaded by a team of industry veterans from AAA game developers, including EA, DICE, Ubisoft, Rovio and Weta Workshop.\n\n[Walker World Trailer](https://www.youtube.com/watch?v=NSe-S8UIs3E)\n[Walker World: Genesis Walkers](https://opensea.io/collection/walkerworldgenesiswalkers)\n[Walker World: Women](https://opensea.io/collection/walkerworldwomen)\n[Walker World: Weapons](https://opensea.io/collection/walkerworldweapons)\n[Walker World: Bored Box Jetpacks](https://opensea.io/collection/walkerworldjetpacks)",
    exchange_url: "https://opensea.io/collection/walker-world-lost-walkers",
    external_url: "https://walkerworld.io",
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/s/raw/files/9fd6402de07d58b0968c55a983019fab.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 46.955518941176486,
      num_owners: 376,
      floor_price: 0.049999,
      floor_price_symbol: "ETH",
      total_minted: 376,
      total_supply: null,
      total_volume: 15.078260569041364,
      one_day_volume: 0,
      seven_day_volume: 0.5593860000000002,
      thirty_day_volume: 0.731482,
      one_day_volume_change: 0,
      seven_day_volume_change: 14,
      thirty_day_volume_change: 16,
      total_sales: 216,
      one_day_sales: 0,
      seven_day_sales: 17,
      thirty_day_sales: 25,
      total_average_price: 0.06980676189371002,
      one_day_average_price: 0,
      seven_day_average_price: 0.03290505882352942,
      thirty_day_average_price: 0.02925928,
    },
    contracts: [
      {
        contract_address: "0xcc2be05a69b52e27fd550f19169b4d6bfb144605",
      },
    ],
    id: 336,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:17:44.825Z",
    key: "never-fear-truth-by-jd",
    name: "Never Fear Truth  by Johnny Depp",
    description:
      "Never Fear Truth is the genesis collection of 3,850 NFTs created by Johnny Depp.\n\nEach NFT acts 1) as a membership key to his community and future releases, establishing a creative community of fans and friends through ownership on the Ethereum blockchain, 2) is backed by a single claimable physical edition. Head to the website to find out more and check whether a NFT's physical print has been claimed.\n\nFor him there has always been art. Before acting, and before music, art has always been an important outlet for his creativity. In this first public exposure of Johnny's art he has focussed on 'Friends and Heroes'. People he has known well, and who have inspired him as a person. Each image is an intimate reflection of their character in Johnny's eyes; a portrayal of how they have revealed themselves to him.\n\nPortraits of friends, heroes and family; created by Johnny and animated to create truly unique works of generative art.",
    exchange_url: "https://opensea.io/collection/never-fear-truth-by-jd",
    external_url: "http://www.neverfeartruth.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/b49e840e177b769899b4179c8e0ede47.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/e7KNgDyVUBU9aFRQyjI-jgosYsuQ1k_4DyWUpDE7v2ZsChL02rCFIv2n-lYFgvYqVX_TH3-KWU5pQ9J-Z64G1aVDfMdiZzYzFNDj?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/e7KNgDyVUBU9aFRQyjI-jgosYsuQ1k_4DyWUpDE7v2ZsChL02rCFIv2n-lYFgvYqVX_TH3-KWU5pQ9J-Z64G1aVDfMdiZzYzFNDj?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/55d77d27eefd79f6810a77973898bd25.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/neverfeartruth",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "johnnydeppnft",
    stats: {
      market_cap: 98.94500000000001,
      num_owners: 2115,
      floor_price: 0.02747940004000001,
      floor_price_symbol: "ETH",
      total_minted: 2115,
      total_supply: null,
      total_volume: 1886.212260137962,
      one_day_volume: 0,
      seven_day_volume: 0.1799,
      thirty_day_volume: 0.3574,
      one_day_volume_change: 0,
      seven_day_volume_change: 3,
      thirty_day_volume_change: 3,
      total_sales: 3365,
      one_day_sales: 0,
      seven_day_sales: 7,
      thirty_day_sales: 13,
      total_average_price: 0.5605385617051892,
      one_day_average_price: 0,
      seven_day_average_price: 0.0257,
      thirty_day_average_price: 0.02749230769230769,
    },
    contracts: [
      {
        contract_address: "0x06b3fcc9e79d724a08012f0b9f71bd03b415d334",
      },
    ],
    id: 337,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:17:41.210Z",
    key: "spellborne-apartments",
    name: "Spellborne Apartments",
    description:
      "**Spellborne** is an open-ended monster catching MMORPG! \r\n\r\nStart as one of three hunters, looking to achieve their own goals, and experience a unique adventure in every play-through. Capture monsters, farm crops and craft items in this ever expanding world where each decision you take affects your journey. \r\n\r\nFollow us on Twitter : [Twitter](https://twitter.com/spellbornegame)\r\n\r\nJoin our Discord and meet our amazing Community: [Discord](https://discord.gg/spellborne)",
    exchange_url: "https://opensea.io/collection/spellborne-apartments",
    external_url: "http://monstudios.co",
    banner_image_url:
      "https://i.seadn.io/gcs/files/0f1262a181f1c87caa2fa593320f5c77.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/cca13e450430a6f3289dc2390e25e4e8.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/cca13e450430a6f3289dc2390e25e4e8.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/01240866ed4bf277e123705fdc0d7540.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/spellborne",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 312.3708842727273,
      num_owners: 959,
      floor_price: 0.0769999,
      floor_price_symbol: "ETH",
      total_minted: 959,
      total_supply: null,
      total_volume: 1353.8000242117637,
      one_day_volume: 0,
      seven_day_volume: 2.3680770000000004,
      thirty_day_volume: 20.332826003000015,
      one_day_volume_change: 0,
      seven_day_volume_change: -64,
      thirty_day_volume_change: -22,
      total_sales: 7303,
      one_day_sales: 0,
      seven_day_sales: 22,
      thirty_day_sales: 195,
      total_average_price: 0.1853758762442508,
      one_day_average_price: 0,
      seven_day_average_price: 0.10763986363636366,
      thirty_day_average_price: 0.10427090257948726,
    },
    contracts: [
      {
        contract_address: "0x6e1404a557850551edaa9fd1311c9297baf7bd52",
      },
    ],
    id: 338,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:17:28.888Z",
    key: "cryptocoven",
    name: "Crypto Coven",
    description: "it's the season of the witch. 🌙",
    exchange_url: "https://opensea.io/collection/cryptocoven",
    external_url: "https://www.cryptocoven.xyz/",
    banner_image_url:
      "https://i.seadn.io/gae/M42Xf9Vbu_yodzKVFA1I6TYXIx5Hz699gEtp2lDg9vGT7g-S4z_5cx2iYPub1kytnOlexV5WDdGOmpGeuH4-N0CYXi7FaC_iqEm4gQ?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/5_8So8vKCwnu2li2QNRd43zcPlKFtc3MeZIRiKrFRyDFOTK7MiPnn0EKTEySs1lhGDbSmgL0e_YNtdyAdGNF-dTlwcsYZjYwwL89?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/5_8So8vKCwnu2li2QNRd43zcPlKFtc3MeZIRiKrFRyDFOTK7MiPnn0EKTEySs1lhGDbSmgL0e_YNtdyAdGNF-dTlwcsYZjYwwL89?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/E8MVasG7noxC0Fa_duhnexc2xze1PzT1jzyeaHsytOC4722C2Zeo7EhUR8-T6mSem9-4XE5ylrCtoAsceZ_lXez_kTaMufV5pfLc3Fk?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/uBdw66arpW",
    telegram_url: null,
    twitter_username: "crypto_coven",
    wiki_url: null,
    instagram_username: "crypto_coven",
    stats: {
      market_cap: 203.13243816666667,
      num_owners: 4908,
      floor_price: 0.029786,
      floor_price_symbol: "ETH",
      total_minted: 4908,
      total_supply: null,
      total_volume: 9051.696096215106,
      one_day_volume: 0.03,
      seven_day_volume: 0.12478700000000001,
      thirty_day_volume: 0.31304920004816006,
      one_day_volume_change: 0.000212999999999998,
      seven_day_volume_change: 6,
      thirty_day_volume_change: -55,
      total_sales: 11840,
      one_day_sales: 1,
      seven_day_sales: 6,
      thirty_day_sales: 15,
      total_average_price: 0.7645013594776272,
      one_day_average_price: 0,
      seven_day_average_price: 0.020797833333333335,
      thirty_day_average_price: 0.020869946669877338,
    },
    contracts: [
      {
        contract_address: "0x5180db8f5c931aae63c74266b211f580155ecac8",
      },
    ],
    id: 339,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:17:24.875Z",
    key: "nordstrumfineart",
    name: "Jake Nordstrum",
    description:
      "A collection of abstract portraits and cubist exploration.\n\nhttps://discord.gg/8GHtp62Gpn",
    exchange_url: "https://opensea.io/collection/nordstrumfineart",
    external_url: "http://www.nordstrumfineart.com",
    banner_image_url:
      "https://i.seadn.io/gae/h3aTsW93y5jTPLSiP9puU81Y3WKxpFqRCXdOlLPvH2HZhsmDMMnsdWOAPJ0EsmB-_mHrhYGlKBaVRaTunYYYTOSe4hFZBUIMa-KsIg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/H3Yg4gdOfhYExVcacbbbPiYU5n-TOFu-wPbnjVxs5y4_tYRiGpqRSDvzFoDD5A0QcL-tBKxqQt6RWqkOyqNyfszGnROLREmVzEG5_Q?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/H3Yg4gdOfhYExVcacbbbPiYU5n-TOFu-wPbnjVxs5y4_tYRiGpqRSDvzFoDD5A0QcL-tBKxqQt6RWqkOyqNyfszGnROLREmVzEG5_Q?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/-5-yRKI-9s6UgwgA_VhZQl8h4YzpuOs1pvJtv5RBtboj21QXR_IWz-_sOUkJSS3vyWhwpMXXABdMq2UjCPMG_8Ami_TnilbZkQHfCQ?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: "jakenordstrum",
    wiki_url: null,
    instagram_username: "jake_nordstrum",
    stats: {
      market_cap: 0,
      num_owners: 131,
      floor_price: 0.05,
      floor_price_symbol: "ETH",
      total_minted: 131,
      total_supply: null,
      total_volume: 68.73362688115009,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 334,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.2057893020393715,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 340,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:18:48.073Z",
    key: "timepieces-build-a-better-future-genesis-drop",
    name: "TIMEPieces Build a Better Future: Genesis Drop",
    description:
      "Launched in September 2021, TIMEPieces is our brand's evolution into web3 and this collection is the original, Genesis Drop.\r\n\r\nTo view this entire collection on TIME.com: https://www.time.com/timepieces\r\n\r\nhttps://discord.com/invite/timepieces\r\n\r\nLicense Agreement: https://time.com/privacy/timepieces_license_agreement.html",
    exchange_url:
      "https://opensea.io/collection/timepieces-build-a-better-future-genesis-drop",
    external_url: "http://time.com/timepieces",
    banner_image_url:
      "https://i.seadn.io/gae/FVi8U4E7FFBXXr0wd94ibJpcPm19v5UpL7hcL2QJxlZ2CMlqeGKAyZ0ADzRgwhdQzS_v3loIhhoZiLXa_IVZpHAoWvyA3y0Cm6OL?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/Xwvz5Rasf51wq0q1MZlFFtLsgNjPUWJpUXB9BNoRN-hK_5guCPcvbJ1V11HnQ5OS8SOTPwLI5kraLbPjFqzsgW-xsQ5QbmCdV4_g?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/Xwvz5Rasf51wq0q1MZlFFtLsgNjPUWJpUXB9BNoRN-hK_5guCPcvbJ1V11HnQ5OS8SOTPwLI5kraLbPjFqzsgW-xsQ5QbmCdV4_g?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/Dgjo2lwkH73btc3f-THAIuSdv-MdmszkHeMJHRrFdX1-xK1XBp9EnqQQ4hjRh_A-CVX_zjFshgUEswPyZ3w08YZar908sDEP84q7?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: "timepieces",
    wiki_url: null,
    instagram_username: "time",
    stats: {
      market_cap: 44.17875,
      num_owners: 2778,
      floor_price: 0.0119,
      floor_price_symbol: "ETH",
      total_minted: 2778,
      total_supply: null,
      total_volume: 9995.947116479078,
      one_day_volume: 0,
      seven_day_volume: 0.0189,
      thirty_day_volume: 0.20959600000000003,
      one_day_volume_change: 0,
      seven_day_volume_change: -8,
      thirty_day_volume_change: -12,
      total_sales: 7013,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 18,
      total_average_price: 1.425345375228729,
      one_day_average_price: 0,
      seven_day_average_price: 0.00945,
      thirty_day_average_price: 0.011644222222222224,
    },
    contracts: [
      {
        contract_address: "0xdd69da9a83cedc730bc4d3c56e96d29acc05ecde",
      },
    ],
    id: 341,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:18:26.685Z",
    key: "remivision",
    name: "Remivision",
    description:
      "A follow up to @MilAIdy Maker, one of the first Derivatives that pushed the boundaries of using Ai as a medium.",
    exchange_url: "https://opensea.io/collection/remivision",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/7247e460675d4c3415c9f539c666e77f.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/3770a4bbe0bf704de12d21d6110753e4.gif?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/3770a4bbe0bf704de12d21d6110753e4.gif?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/3770a4bbe0bf704de12d21d6110753e4.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 3.17682,
      num_owners: 306,
      floor_price: 0.0145,
      floor_price_symbol: "ETH",
      total_minted: 306,
      total_supply: null,
      total_volume: 52.80267209999664,
      one_day_volume: 0,
      seven_day_volume: 0.0159,
      thirty_day_volume: 0.0159,
      one_day_volume_change: 0,
      seven_day_volume_change: 5,
      thirty_day_volume_change: 3,
      total_sales: 1310,
      one_day_sales: 0,
      seven_day_sales: 5,
      thirty_day_sales: 5,
      total_average_price: 0.040307383282440185,
      one_day_average_price: 0,
      seven_day_average_price: 0.00318,
      thirty_day_average_price: 0.00318,
    },
    contracts: [
      {
        contract_address: "0x6c3491cc4347cd097fc6ebfe9c437109ef62cded",
      },
    ],
    id: 342,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:19:32.929Z",
    key: "holy-candle",
    name: "VOID CANDLES",
    description: "POOLVOID.ETH",
    exchange_url: "https://opensea.io/collection/holy-candle",
    external_url: null,
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/615591dda91873c7a79cec32f1efacb3.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/615591dda91873c7a79cec32f1efacb3.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/615591dda91873c7a79cec32f1efacb3.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/XqwT377PBy",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 732,
      floor_price: 0.00225,
      floor_price_symbol: "ETH",
      total_minted: 732,
      total_supply: null,
      total_volume: 24.180982673492665,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 644,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.03754810974144824,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x6b3e29bf728b9da369f8d09aa08a439058221f69",
      },
    ],
    id: 343,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:21:07.622Z",
    key: "respekt-v2",
    name: "RARE SCRILLA FAKE EDITIONS",
    description: null,
    exchange_url: "https://opensea.io/collection/respekt-v2",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/bbd199410f30778c4c60b5f870f28314.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/0faca7537d9b7b820de0b092393218be.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/0faca7537d9b7b820de0b092393218be.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/dbd1ab8c2578e8cf6136dcbd22de4a6e.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 396,
      floor_price: 0.005,
      floor_price_symbol: "ETH",
      total_minted: 396,
      total_supply: null,
      total_volume: 59.37603153639758,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 630,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.09424766910539299,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x6f52a9501d119e18d577ac32af3ad0485520066f",
      },
    ],
    id: 344,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:21:07.246Z",
    key: "fake-memes-s1",
    name: "FAKE MEMES S1",
    description: null,
    exchange_url: "https://opensea.io/collection/fake-memes-s1",
    external_url: "http://Fakememedirectory.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/01e742c670c7cc877690a57ab57659fc.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/e6427df1f1deacea7d1acac9a2484afa.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/e6427df1f1deacea7d1acac9a2484afa.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/6a84501d0fe6ca4e012cad9df875e834.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/fakes",
    telegram_url: "https://t.me/officialfakememes",
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 548,
      floor_price: 0.009,
      floor_price_symbol: "ETH",
      total_minted: 548,
      total_supply: null,
      total_volume: 12.326885889999996,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 293,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.042071282901023875,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x6bc082b245399e420f1673b45d498cb27810591f",
      },
    ],
    id: 345,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:21:06.827Z",
    key: "chametheon",
    name: "Chametheon",
    description:
      "Chametheon ┃ [Chametheon Lab](https://opensea.io/collection/chametheon-lab) ┃ [Chametheon Wear](https://opensea.io/collection/chametheon-wear) ┃ [HX1](https://opensea.io/collection/chametheon-hx1) ┃\n\n300 Interoperable VR-ready avatars on the Ethereum blockchain.\n\nEach come complete with high resolution 3D files. Optimised [VRM files](https://planetvr.shop/chametheon/vrm.html) can be downloaded from the Chametheon website\n\nClothed Chametheons can be obtained via the [Chametheon Lab](https://opensea.io/collection/chametheon-lab).",
    exchange_url: "https://opensea.io/collection/chametheon",
    external_url: "http://chametheon.com",
    banner_image_url:
      "https://i.seadn.io/gae/DE4kyLKhdo5v76JmQlaJNZ_Ec9J2bC5aTIvxxCGU9j9_IYWkkfS0dG5oRbftP6eQ8x63mLZDQo2iupm8AOj1q2kjn1Oz49sJsavoSw?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/av6980lgP402gNSm3vUlbLrAfbAdGGiMFRPA6halW1Sck7NG_mio4R75JcPGRrXsQM-LrxVPtgXG5PQBg7TqyL3YVFJSSUU5inH4BA?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/av6980lgP402gNSm3vUlbLrAfbAdGGiMFRPA6halW1Sck7NG_mio4R75JcPGRrXsQM-LrxVPtgXG5PQBg7TqyL3YVFJSSUU5inH4BA?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/G2iRdso8GwwJZLi6OC5arUMdu9Bv3994Fr9Vfo4y8ZQDS8vO9wZc4_nPYuA5lWGN5WEymXfuUXY3f_0wOxyGVDCy6jXrD9n_O0ammiY?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/8cXBfWnR42",
    telegram_url: null,
    twitter_username: "chametheon",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0.6225,
      num_owners: 65,
      floor_price: 0.0245,
      floor_price_symbol: "ETH",
      total_minted: 65,
      total_supply: null,
      total_volume: 57.732947835541694,
      one_day_volume: 0,
      seven_day_volume: 0.0083,
      thirty_day_volume: 0.0408,
      one_day_volume_change: 0,
      seven_day_volume_change: 2,
      thirty_day_volume_change: 6,
      total_sales: 268,
      one_day_sales: 0,
      seven_day_sales: 4,
      thirty_day_sales: 6,
      total_average_price: 0.21542144714754363,
      one_day_average_price: 0,
      seven_day_average_price: 0.002075,
      thirty_day_average_price: 0.006800000000000001,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 346,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:21:02.593Z",
    key: "shroom-fam",
    name: "Shroom Fam",
    description:
      "Step into ShroomFam's realm, where every NFT tells a story, and the magic of mushrooms unites us all!\nThe collection consist of 300 NFTs crafted from over 100 traits by MightyShroom including 34 legendary 1/1s, each a masterpiece by a different guest artist.",
    exchange_url: "https://opensea.io/collection/shroom-fam",
    external_url: null,
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/baaffec351f40af167318b88d22e441a.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/baaffec351f40af167318b88d22e441a.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/7b4516bd244e8164d031e7e9870aa248.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/8JSVahPZpX",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 140,
      floor_price: 0.03,
      floor_price_symbol: "ETH",
      total_minted: 140,
      total_supply: null,
      total_volume: 2.2631477798999997,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 84,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.026942235474999996,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x9a291a1d64ae3e5381278e1131107662cbd7b6ee",
      },
    ],
    id: 347,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:21:02.183Z",
    key: "in-flight-2",
    name: "In Flight",
    description:
      "Edition collection that serves as an upper layer and one extension portal of the Of a Feather collection by Catnip\nhttps://opensea.io/collection/of-a-feather-1\nHolders of the afformentioned collection will gain special access to these Editions, aswell as free mints on future collections.\nLet us fly",
    exchange_url: "https://opensea.io/collection/in-flight-2",
    external_url: null,
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/a396764380bad59394c666af3b42307a.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/a396764380bad59394c666af3b42307a.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/09463f34d1496ad2f0df4cd595bb1577.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 142,
      floor_price: 0.01,
      floor_price_symbol: "ETH",
      total_minted: 142,
      total_supply: null,
      total_volume: 0.008,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 1,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.008,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x9e02b367e85d42571b4074b03dbc81350aa6d4b5",
      },
    ],
    id: 348,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:21:01.716Z",
    key: "of-a-feather-1",
    name: "Of a Feather",
    description:
      "Of a Feather is a call to peace, a call to understanding where there is a lack. \nMeeting many styles upon one design, these generative pieces travel many multidimensional worlds. \nLike a bird flying overhead, viewing the earth below, above the mire of destruction, dismay or doubt.\nUsing AI models seeded by his painting, Catnip meticulously crafted this collection which utilized the AI tools of the day combined with post-processing and photoshop detailing.\nA simple silhouette can become anything.\nThis collection with a small supply of 144 embarks to serve as a pass to future collections, airdrops, and interactivity between artist and collector. This is just the beginning of a new flight to inspiration. Holding a piece grants you access to a new storytelling arc in Catnip's creative career.",
    exchange_url: "https://opensea.io/collection/of-a-feather-1",
    external_url: null,
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/ec1e75a01dbdb3b211d706a06737d8fa.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/ec1e75a01dbdb3b211d706a06737d8fa.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/5c7569050f33aa2ad11e789451c21746.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 122,
      floor_price: 0.02,
      floor_price_symbol: "ETH",
      total_minted: 122,
      total_supply: null,
      total_volume: 5.012668999999897,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 129,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.0388578992248054,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xb614be87fb0aacf0f59300a913d7702320f4f0ed",
      },
    ],
    id: 349,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:21:01.303Z",
    key: "jerks-lore",
    name: "JERKS LORE",
    description:
      "Dive into the Jerks Lore, where the captivating narrative of Jerks with unique pieces from the Jerks Artists ,unfolds one chapter at a time. Sundays at 10 am EST mark the release of each new piece of the puzzle, exclusively for holders. Collect all chapters and unlock a special physical asset delivered to your doorstep. All funds from Jerks Lore contribute to the Jerks Clubhouse's expansion.",
    exchange_url: "https://opensea.io/collection/jerks-lore",
    external_url: "https://homeofjerks.com/",
    banner_image_url:
      "https://i.seadn.io/s/raw/files/5c604b4e8d55ca03579aef00fe0fd187.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/5f0ae2f20c9ee0251ab38992a80b7a08.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/5f0ae2f20c9ee0251ab38992a80b7a08.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/5f0ae2f20c9ee0251ab38992a80b7a08.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/YwsZBM9Smf",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 107,
      floor_price: 0.002,
      floor_price_symbol: "ETH",
      total_minted: 107,
      total_supply: null,
      total_volume: 0.1704,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 9,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.018933333333333333,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x930de5db0960e231befe953a10abb14cae33cf3e",
      },
    ],
    id: 350,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:21:00.893Z",
    key: "capi-editions",
    name: "Capi Editions",
    description:
      'The "Capi edition" collection contains all the Open editions and limited editions created by Capi. \n\nRoundedPepes collection: https://opensea.io/collection/roundedpepes\nCapi\'s 1/1s collection: https://opensea.io/collection/capi-1-1',
    exchange_url: "https://opensea.io/collection/capi-editions",
    external_url: "https://linktr.ee/onlycapi",
    banner_image_url:
      "https://i.seadn.io/gcs/files/042567bbb2cb364655071cb0eb1abb1d.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/d21aebd7a6999c4b54e3bf6309374ca6.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/d21aebd7a6999c4b54e3bf6309374ca6.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/539c153bcbc4ff94ca791bc894076673.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 722,
      floor_price: 0.0055,
      floor_price_symbol: "ETH",
      total_minted: 722,
      total_supply: null,
      total_volume: 14.820101148887764,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 624,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.023750162097576542,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xc6634919514c6326d774d3de1ddcbf3463615765",
      },
    ],
    id: 351,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:21:00.505Z",
    key: "jerks-clubhouse-directory",
    name: "JERKS CLUBHOUSE DIRECTORY",
    description:
      "A dedicated space solely for our holders, where our Jerks Artists will unveil their unique and distinct editions once a week. These offerings are a token of appreciation, entirely free claim for Jerks holders, celebrating the artistry within our community. ",
    exchange_url: "https://opensea.io/collection/jerks-clubhouse-directory",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/s/raw/files/96245bca684cd7d4e8a3d55d40f9c0fa.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/5f0ae2f20c9ee0251ab38992a80b7a08.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/5f0ae2f20c9ee0251ab38992a80b7a08.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/5f0ae2f20c9ee0251ab38992a80b7a08.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/cmeNjNDm2c",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 157,
      floor_price: 0.003,
      floor_price_symbol: "ETH",
      total_minted: 157,
      total_supply: null,
      total_volume: 0.29680000000000006,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 17,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.01745882352941177,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xbf862c47f968465e8e7390549ce8a4b2e902b060",
      },
    ],
    id: 352,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:20:56.943Z",
    key: "hubtopia",
    name: "Hubtopia: Champions",
    description:
      "Hubtopia is your gateway to countless, unique gameplay experiences on the HYTOPIA platform. Powered by veteran minecraft server builders!",
    exchange_url: "https://opensea.io/collection/hubtopia",
    external_url: "https://hubtopia.net",
    banner_image_url:
      "https://i.seadn.io/s/raw/files/c06b194f2ef1a09f9c29f176c5a21393.png?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/s/raw/files/6b7f5f98dba9c69b59ec9effd2c1b087.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/hubtopia",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 23.38905,
      num_owners: 1061,
      floor_price: 0.0199,
      floor_price_symbol: "ETH",
      total_minted: 1061,
      total_supply: null,
      total_volume: 92.99567500000062,
      one_day_volume: 0,
      seven_day_volume: 0.0482,
      thirty_day_volume: 0.0482,
      one_day_volume_change: 0,
      seven_day_volume_change: 8,
      thirty_day_volume_change: 1,
      total_sales: 1341,
      one_day_sales: 0,
      seven_day_sales: 8,
      thirty_day_sales: 8,
      total_average_price: 0.06934800521998555,
      one_day_average_price: 0,
      seven_day_average_price: 0.006025,
      thirty_day_average_price: 0.006025,
    },
    contracts: [
      {
        contract_address: "0x5b97353bb450c2cc0d91c681bf6102166a7465c9",
      },
    ],
    id: 353,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:20:49.426Z",
    key: "720-minutes-by-alexis-andre",
    name: "720 Minutes by Alexis André",
    description:
      "Art Blocks Collection: Curated\n\nHeritage Art Blocks Collection: Curated series 2\n\nProject Description: A real-time live interactive piece that also acts as a clock. 720 unique ways to show the current time, one per minute over twelve hours. Each clock will activate on its given minute, giving you a special moment every twelve hours to consider what one minute means to you.",
    exchange_url: "https://opensea.io/collection/720-minutes-by-alexis-andre",
    external_url: "https://artblocks.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/ef2c459a8ae055f06e76a22d8b1c468c.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/7qK50XZFQ04mQzPmoloH45tV3_nfYPbBnidzV3BGp5doDGxioJr6_hXJS9OUfJUqCk_sQa_1Wm6RJiHHr3EqT6KUK5C4IP49-bGjnoo?w=500&auto=format",
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/7qK50XZFQ04mQzPmoloH45tV3_nfYPbBnidzV3BGp5doDGxioJr6_hXJS9OUfJUqCk_sQa_1Wm6RJiHHr3EqT6KUK5C4IP49-bGjnoo?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 113.4,
      num_owners: 456,
      floor_price: 0.27249,
      floor_price_symbol: "ETH",
      total_minted: 456,
      total_supply: null,
      total_volume: 2889.1187926290713,
      one_day_volume: 0,
      seven_day_volume: 0.315,
      thirty_day_volume: 0.6149,
      one_day_volume_change: 0,
      seven_day_volume_change: 2,
      thirty_day_volume_change: -8,
      total_sales: 1120,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 2.5795703505616707,
      one_day_average_price: 0,
      seven_day_average_price: 0.1575,
      thirty_day_average_price: 0.20496666666666666,
    },
    contracts: [
      {
        contract_address: "0xa7d8d9ef8d8ce8992df33d8b8cf4aebabd5bd270",
      },
    ],
    id: 354,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:20:45.656Z",
    key: "kentaro-waves",
    name: "KENTARO WAVES",
    description:
      "Kentaro: Leading the Web3 Influence Revolution\n\nExclusive Collection: 500 Core Node NFTs\nKentaro is at the forefront of Web3 innovation, showcasing a unique one-stop platform for influence aggregation. \n\nIn this exclusive collection of 500 NFTs, each represents a crucial node as a passcard within the Kentaro ecosystem, pivotal in unlocking new realms of influence and innovation.\n\nJoin this transformative journey and secure your position in the dynamic world of Web3 with Kentaro.\nRead more on our Twitter: @kentaroclub and official website: kentaroclub.com",
    exchange_url: "https://opensea.io/collection/kentaro-waves",
    external_url: "https://kentaroclub.com",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/2871c79b5104fba306cda5f0baf97126.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/2871c79b5104fba306cda5f0baf97126.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/19cd0665d0b7d7ab7a95c031be278745.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 1.2,
      num_owners: 387,
      floor_price: 0.0499,
      floor_price_symbol: "ETH",
      total_minted: 387,
      total_supply: null,
      total_volume: 122.43568999999992,
      one_day_volume: 0,
      seven_day_volume: 0.0024,
      thirty_day_volume: 0.0024,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 1,
      total_sales: 194,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 1,
      total_average_price: 0.6311118041237109,
      one_day_average_price: 0,
      seven_day_average_price: 0.0024,
      thirty_day_average_price: 0.0024,
    },
    contracts: [
      {
        contract_address: "0xa3f690a1129c5da8273c89ca7bb593bf89e6c638",
      },
    ],
    id: 355,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:20:30.686Z",
    key: "official-moar-by-joan-cornella",
    name: '"MOAR" by Joan Cornella',
    description:
      "MOAR is an unusual mansion at FWEN metaverse where 5,555 souls on blockchain including humans, cyborgs and zombies living peacefully together.\nImmerse yourself in the one-of-a-kind digital art world by Joan Cornellà and explore the nonsense. \nDownload FWEN Metaverse app now.",
    exchange_url:
      "https://opensea.io/collection/official-moar-by-joan-cornella",
    external_url: "https://app.fwenmetaverse.com/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/49eb178105e3d88c05031b02044a519d.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/CypyKknm6gD9Wcz3y9KaxwpEvEWXEC-tHnPbFO0n-obVc12mVOItr6upZAoYi5HkRugrHU7xTeiHVw0d2HuaYDQDZ4bqrV9JXEVdXg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/CypyKknm6gD9Wcz3y9KaxwpEvEWXEC-tHnPbFO0n-obVc12mVOItr6upZAoYi5HkRugrHU7xTeiHVw0d2HuaYDQDZ4bqrV9JXEVdXg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/Jy5vdUGruehtLi7sEc_fFzPnWKgkCAy4nUQBv81AhUzUXew-cY2OwwsEjCkQS-2YsLQbP9A7BYlyrFpK2Ux8Xqo83p8sYXct71K8?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/fwenclub",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "fwenclub",
    stats: {
      market_cap: 174.00898625,
      num_owners: 2952,
      floor_price: 0.034399,
      floor_price_symbol: "ETH",
      total_minted: 2952,
      total_supply: null,
      total_volume: 13190.475502570775,
      one_day_volume: 0,
      seven_day_volume: 0.125299,
      thirty_day_volume: 0.6780980000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -13,
      total_sales: 10087,
      one_day_sales: 0,
      seven_day_sales: 4,
      thirty_day_sales: 19,
      total_average_price: 1.3076708141737656,
      one_day_average_price: 0,
      seven_day_average_price: 0.03132475,
      thirty_day_average_price: 0.035689368421052636,
    },
    contracts: [
      {
        contract_address: "0xeb3a9a839dfeeaf71db1b4ed6a8ae0ccb171b227",
      },
    ],
    id: 356,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:20:26.644Z",
    key: "toonzwtf",
    name: "Toonz",
    description:
      "Toonz is a unique and exclusive collection of 3333 NFT’s born into WEB3. Aiming to find like-minded, independent individuals and bringing together talented artists, designers and creators.",
    exchange_url: "https://opensea.io/collection/toonzwtf",
    external_url: "https://www.toonz.wtf/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/c6e5a9afce0cd01c7b95796d7d4ae0e0.gif?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/feeeb5be7376965bd4027450303c5c9b.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 2518,
      floor_price: 0,
      floor_price_symbol: null,
      total_minted: 2518,
      total_supply: null,
      total_volume: 3.1159769999999893,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -3.1159769999999893,
      total_sales: 476,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.006546170168067204,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xbd2627990d59377ca2c72e1c13715d955b3fdc55",
      },
    ],
    id: 357,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:20:22.567Z",
    key: "strange-attractors-on-chain",
    name: "StrangeAttractors",
    description:
      "Simulating chaotic, three-dimensional systems directly on the Ethereum blockchain.\nhttps://strangeattractors.art/",
    exchange_url: "https://opensea.io/collection/strange-attractors-on-chain",
    external_url: "https://strangeattractors.art/",
    banner_image_url:
      "https://i.seadn.io/gae/Hyw0Mnebz9OgLYGwJqt2GEerYkZJ9sF1o_1EFeYy7UKfICDj0SfZfbUshPo1A-VqxIAb3liG4fdbc5QjbUTuNvj2gufnCubsKpcp?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/10cvb1p24DhK6V2YoRQTEmxrkPzDjNMPjOp5VrmK-SbWurEAJh4ExHe6fk0e3GIhqsPnXq5RobrH2DaU9gfF3LOWPdUXQ50HRrKOOw?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/10cvb1p24DhK6V2YoRQTEmxrkPzDjNMPjOp5VrmK-SbWurEAJh4ExHe6fk0e3GIhqsPnXq5RobrH2DaU9gfF3LOWPdUXQ50HRrKOOw?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/Nl4qUexaR1hI-Ks2PC5TUTFy-vtW4zaEragHKi_KPJmmoC3_dDxWeW9ZkkjIC7hYh99B1zA32qsCaCBxZZEghUEJvHQfiZWeQ1-I?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/SyYCfrtzkP",
    telegram_url: null,
    twitter_username: "StrngeAttrctors",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 10.371871428571428,
      num_owners: 283,
      floor_price: 0.0433,
      floor_price_symbol: "ETH",
      total_minted: 283,
      total_supply: null,
      total_volume: 59.56398799994858,
      one_day_volume: 0.0438,
      seven_day_volume: 0.2699,
      thirty_day_volume: 0.45529899994861855,
      one_day_volume_change: 0.0438,
      seven_day_volume_change: 12,
      thirty_day_volume_change: 14,
      total_sales: 264,
      one_day_sales: 1,
      seven_day_sales: 14,
      thirty_day_sales: 22,
      total_average_price: 0.2256211666664719,
      one_day_average_price: 0,
      seven_day_average_price: 0.019278571428571426,
      thirty_day_average_price: 0.02069540908857357,
    },
    contracts: [
      {
        contract_address: "0x1ca15ccdd91b55cd617a48dc9eefb98cae224757",
      },
    ],
    id: 358,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:22:06.487Z",
    key: "e-code",
    name: "Elysium Code",
    description:
      "| [Reveal Portal](https://www.elysiumshell.xyz/reveal) | [E-Shell](https://opensea.io/collection/e-shell) |\n\nTransform yourself into Elysium Shell. Embark on an exciting journey to the new world. \n\nIt’s a collection of 9999 pieces of fine 3D artwork presented by the Elysium production team. The genesis drop represents the singular point that triggers all excitement and possibilities. ",
    exchange_url: "https://opensea.io/collection/e-code",
    external_url: "https://www.elysiumshell.xyz/",
    banner_image_url:
      "https://i.seadn.io/gae/GY3AoLGtIadJXSNU80_ksWpBI8ZnjyI9UUY0KtccplP-Yi0b0PjLFdsi5DeKZQbW9QxfSNQDUAw_KZZuXVAzklbjZD-qAu1MqIqF6Q?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/kbLlEr7B0_YWvbct5NzwoTe4ci5oqFSMnKvMiqWYfRyr2AE35f6okSPR2qkK03toO1sBmJqz1L9s6FcU-2GKuXBvSUsg7HfnqzRkCQU?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/kbLlEr7B0_YWvbct5NzwoTe4ci5oqFSMnKvMiqWYfRyr2AE35f6okSPR2qkK03toO1sBmJqz1L9s6FcU-2GKuXBvSUsg7HfnqzRkCQU?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/tUHJXuSJEioP5doOvU2ksJeilnouZo-pUxF0Cs8CJYmmZ5-VVuORW7DmuRAIYh3JOoYEUvR3U2qzDWC40VnETnEKDdT-AX1xs06mSfw?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/elysiumshell",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "elysiumshell.official",
    stats: {
      market_cap: 0,
      num_owners: 1148,
      floor_price: 0.00415820012040905,
      floor_price_symbol: "ETH",
      total_minted: 1148,
      total_supply: null,
      total_volume: 2802.265419590779,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 8922,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.3140848934757654,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x9940bb667f64fca06fc4127861855696def7c69d",
      },
    ],
    id: 359,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:21:59.489Z",
    key: "madhoneybears",
    name: "Mad Honey Bears Genesis",
    description:
      'Mad Honey Bears is our Genesis OG collection of 3333 NFTs!\n\nMad Honey Bears gives our holders early access and benefits for our future collections. You will have access to tokengate discounts and a community ecosystem with your NFT.\n\nStoner Degen is creating a Global Lifestyle Brand with NFTs bridging the gap between web3 and IRL products. We are building a brand and proving business concept with our holders.\n\n"WE NFT DIFFERENT"\n\n*All art is owned by Stoner Degen You may request the right to license the art for commercial use online via contact form at https://StonerDegen.com',
    exchange_url: "https://opensea.io/collection/madhoneybears",
    external_url: "https://stonerdegen.com/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/babf55dc7fc618e75325d1f8e92ab4c6.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/6a5e0ecba7c2f0069a8cc2c4139fc154.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/6a5e0ecba7c2f0069a8cc2c4139fc154.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/6a5e0ecba7c2f0069a8cc2c4139fc154.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/EYqjfrrMyS",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 780,
      floor_price: 0.03,
      floor_price_symbol: "ETH",
      total_minted: 780,
      total_supply: null,
      total_volume: 18.433904275899945,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.004,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 2458,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 2,
      total_average_price: 0.007499554221277439,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.002,
    },
    contracts: [
      {
        contract_address: "0x3ffdfe1602aa95cf17b12fce2f3179dfb7c8dc1e",
      },
    ],
    id: 360,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:21:55.543Z",
    key: "eye-of-the-future-2",
    name: "Eye of the Future",
    description: null,
    exchange_url: "https://opensea.io/collection/eye-of-the-future-2",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url: null,
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 0.8,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x65ab5afc33a2f9e0f5887550c240c29e3c7a40a7",
      },
    ],
    id: 361,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:22:31.303Z",
    key: "broskeesnfts",
    name: "Broskees NFTs",
    description:
      "Broskees is a collection of 1691 individuals inspired by fashion, food and popular culture.\n\nWebsite: https://www.broskees.io\nTwitter: https://twitter.com/broskeesnfts ",
    exchange_url: "https://opensea.io/collection/broskeesnfts",
    external_url: "https://www.broskees.io/",
    banner_image_url:
      "https://i.seadn.io/gae/UmjPoNRiL4Wk8ttkWPr2zB3lMtZWVvEMYWE-tlqyD6cVA5sn-gR3F3PuyYs0bDGt2y9ON2tIOn0nVDBgd0m8BI9Gh-BLvqWrjGz_?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/ZHeL-rdJOnREJ4A8daVQH5Lgvgyzr2aVnlChrq5OWV6yliHdzHqxiuqZgNI5h8C-33FS_Ez_Q9DOthiD3c7YmLGw4TVqj0gLhxtxQP4?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/ZHeL-rdJOnREJ4A8daVQH5Lgvgyzr2aVnlChrq5OWV6yliHdzHqxiuqZgNI5h8C-33FS_Ez_Q9DOthiD3c7YmLGw4TVqj0gLhxtxQP4?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/yEmxT0kvKccQbQFXtrMY4ZmXNYVM8hWfx2La0ZFA7Rak6HCBdIbI8991jQmpYDbdL2tqAM5LHNehFpJeSonX5YimIK2fxfxbIs2WnA?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1001,
      floor_price: 0.009108802090456291,
      floor_price_symbol: "ETH",
      total_minted: 1001,
      total_supply: null,
      total_volume: 892.2820986826775,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.002,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -1,
      total_sales: 3495,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.25530246028116665,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.002,
    },
    contracts: [
      {
        contract_address: "0x0c9153d9abb5e0489c89b38837f248816f151f42",
      },
    ],
    id: 362,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:24:13.788Z",
    key: "docs-editions",
    name: "Doc's Editions",
    description: "bubble",
    exchange_url: "https://opensea.io/collection/docs-editions",
    external_url: "https://www.codeisart.xyz",
    banner_image_url:
      "https://i.seadn.io/gcs/files/105291fa6fd67619a4a1be59cacec691.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/105291fa6fd67619a4a1be59cacec691.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/105291fa6fd67619a4a1be59cacec691.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/105291fa6fd67619a4a1be59cacec691.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 301,
      floor_price: 0.0092,
      floor_price_symbol: "ETH",
      total_minted: 301,
      total_supply: null,
      total_volume: 7.256819798999993,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 214,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.033910372892523334,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x1bf89e551b8f6cd1619dc69d1b182595807f8640",
      },
    ],
    id: 363,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:24:06.014Z",
    key: "deckofdegeneracy",
    name: "Deck of Degeneracy",
    description:
      "Deck of Degeneracy is a collection of 50 decks of 54 NFT playing cards, 2,700 total NFTs on the Ethereum blockchain with art by Wes Henry. Your Deck of Degeneracy NFT gives you access to various potential real-world perks listed at https://DeckOfDegeneracy.com featuring Jonathan Little. Perks include weekly art drops, percentages of Jonathan and other poker pros' tournament action, physical items like Tungsten Cubes and uncut sheets of playing cards, and much more. All holders can request a physical deck to be mailed to them, the link is in Discord. The DoD Art Collection is here: https://opensea.io/collection/dodart. Experience the gallery at oncyber.io/degeneracy. Be sure join our Discord at https://discord.gg/Dna6465WQn and follow on Twitter at https://twitter.com/DegeneracyNFT.",
    exchange_url: "https://opensea.io/collection/deckofdegeneracy",
    external_url: "http://deckofdegeneracy.com",
    banner_image_url:
      "https://i.seadn.io/gae/HUzJ0nNbOOZft9-Kr3UXbEt5kEv4pckxKpDZ7Pwr59kep7kDKPWg3v5-OebQ99O8-mRnj11COQzqqccFRNKy1AqGXtRmBnUoxrbBbw?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/0Jn_74M89VHfV70ozcUhncJRv01cL_piaEIlbO6bVITxmlV3FkhHeCeyHaECOBNuN8NFPACFOp6Y2CkeLZzzgDdy8a5oFXFQP13xfQ?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/0Jn_74M89VHfV70ozcUhncJRv01cL_piaEIlbO6bVITxmlV3FkhHeCeyHaECOBNuN8NFPACFOp6Y2CkeLZzzgDdy8a5oFXFQP13xfQ?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/IhNtcRbyXlkz7vUQqfMQ0qP0E19Lfpt4uF1-agw1DpFjMCVR4NGRKiJuJu3N17MuhO51qwm9h8tQQKlNZTbiP68xMl6OkpXNg_mmR-M?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/Dna6465WQn",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 552,
      floor_price: 0.0091,
      floor_price_symbol: "ETH",
      total_minted: 552,
      total_supply: null,
      total_volume: 739.5385132564141,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0216,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 2,
      total_sales: 2315,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 3,
      total_average_price: 0.3194550813202653,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0072,
    },
    contracts: [
      {
        contract_address: "0x8b3c69abc8c588e3eceb2eedf3bccf8fea950241",
      },
    ],
    id: 364,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:23:47.980Z",
    key: "apereunion",
    name: "Ape Reunion",
    description:
      "[Official Rarity Tool](https://www.apereunion.xyz/rarityTool)\n\nSince our April 2022 launch as a free mint PFP on Eth, we've animated our collection, created [Reunion Species](https://opensea.io/collection/reunionspecies), launched ['Reunion'](https://world.apereunion.xyz/), our playable MMO RPG. Exciting game updates and a Bitcoin ordinals drop coming in 2024 to [Reunion.GG](https://reunion.gg)\n\n[Reunion Metaverse](https://world.apereunion.xyz/):\nOur dynamic pixel-art world designed for your Reunion NFTs.\n\nSwap between static/animated Apes: [My Apes](https://www.apereunion.xyz/myApes)\n\n[Reunion Species](https://opensea.io/collection/reunionspecies): Our second collection, expanding the reunion with 12 diverse species. Each NFT in this innovative series is designed to encompass multiple game characters, introducing a novel concept in the NFT space.",
    exchange_url: "https://opensea.io/collection/apereunion",
    external_url: "https://www.apereunion.xyz/#/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/1c68870f69232404a97a447f06aece3d.gif?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/wZouHLPUDPsYtmdUQg6iZZNjUvaknkCAQjDZdBY4Z1x_xuH7V-80-ZrdbZDCK8jFuVBRuibfntFlohhzDetPPQWep9OINvoRsrP9Hx0?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/wZouHLPUDPsYtmdUQg6iZZNjUvaknkCAQjDZdBY4Z1x_xuH7V-80-ZrdbZDCK8jFuVBRuibfntFlohhzDetPPQWep9OINvoRsrP9Hx0?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/87507c430a7ec1db3724f966496fb8fc.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/reuniongg",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 142.5339738888889,
      num_owners: 2699,
      floor_price: 0.01399492,
      floor_price_symbol: "ETH",
      total_minted: 2699,
      total_supply: null,
      total_volume: 3132.8065468498908,
      one_day_volume: 0.0104,
      seven_day_volume: 0.12828057650000002,
      thirty_day_volume: 0.7607076364999998,
      one_day_volume_change: -0.013998,
      seven_day_volume_change: -4,
      thirty_day_volume_change: -35,
      total_sales: 34068,
      one_day_sales: 1,
      seven_day_sales: 9,
      thirty_day_sales: 55,
      total_average_price: 0.09195745411676326,
      one_day_average_price: 0,
      seven_day_average_price: 0.01425339738888889,
      thirty_day_average_price: 0.013831047936363633,
    },
    contracts: [
      {
        contract_address: "0x47f3a38990ca12e39255e959f7d97fbe5906afd4",
      },
    ],
    id: 365,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:23:32.882Z",
    key: "humbl-ssceb3si48",
    name: "HUMBL - sscEB3si48",
    description: null,
    exchange_url: "https://opensea.io/collection/humbl-ssceb3si48",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url: null,
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 38,
      floor_price: 0,
      floor_price_symbol: null,
      total_minted: 38,
      total_supply: null,
      total_volume: 10.261199999999993,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 77,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.13326233766233758,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x8e9ae49e639492e440525370605ea665184a522f",
      },
    ],
    id: 366,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:24:46.421Z",
    key: "x-droids-planet-x",
    name: "X-Droids by Planet-X",
    description: "A collection of 10,000 unique X-Droids by Planet-X.",
    exchange_url: "https://opensea.io/collection/x-droids-planet-x",
    external_url: null,
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/e4d2eb138911c22c9dad0b4bb6ac9cc6.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/e4d2eb138911c22c9dad0b4bb6ac9cc6.png?w=500&auto=format",
    image_url: null,
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 223.19887500000004,
      num_owners: 124,
      floor_price: 0.084999,
      floor_price_symbol: "ETH",
      total_minted: 124,
      total_supply: null,
      total_volume: 28.017681000000003,
      one_day_volume: 0.126,
      seven_day_volume: 1.6605000000000003,
      thirty_day_volume: 6.003787,
      one_day_volume_change: 0.036000000000000004,
      seven_day_volume_change: 7,
      thirty_day_volume_change: 25,
      total_sales: 205,
      one_day_sales: 1,
      seven_day_sales: 12,
      thirty_day_sales: 60,
      total_average_price: 0.13667161463414634,
      one_day_average_price: 0,
      seven_day_average_price: 0.13837500000000003,
      thirty_day_average_price: 0.10006311666666666,
    },
    contracts: [
      {
        contract_address: "0x72c916aa1d33aa2b9fcf7a7a146d22efd22cdde8",
      },
    ],
    id: 367,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:24:42.440Z",
    key: "fijis",
    name: "Fijis",
    description:
      "Twitter  • [@FIJISNFT](https://twitter.com/FijisNFT) | Fijis are a collection of propaganda NFT images to inspire WORLD PEACE. To enlist in the World Peace Corps, visit your local WORLD PEACE COIN recruitment office [here](https://twitter.com/WPCERC20).\r\n\r\nCreated by [@juicyunlimited](https://twitter.com/juicyunlimited) & [@iamnick44](https://twitter.com/iamnick44)\r\n\r\n [🌐Telegram](https://t.me/worldpeacecoin) | $WPC : 0xc7c53760375530e5af29fded5e13989325299382",
    exchange_url: "https://opensea.io/collection/fijis",
    external_url: "https://peacecoin.world/",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/3e7ba4f18a7bfc1db9b110840039c0d8.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/3e7ba4f18a7bfc1db9b110840039c0d8.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/6ed48ea36b34a296379af54918543a24.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: "https://t.me/worldpeacecoin",
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 31.87794547368417,
      num_owners: 964,
      floor_price: 0.0092,
      floor_price_symbol: "ETH",
      total_minted: 964,
      total_supply: null,
      total_volume: 709.9789993440932,
      one_day_volume: 0.127056,
      seven_day_volume: 0.7271079999999991,
      thirty_day_volume: 3.7005829899999974,
      one_day_volume_change: 0.02581900000000001,
      seven_day_volume_change: 10,
      thirty_day_volume_change: 247,
      total_sales: 9635,
      one_day_sales: 13,
      seven_day_sales: 76,
      thirty_day_sales: 346,
      total_average_price: 0.07368749344515757,
      one_day_average_price: 0.009773538461538462,
      seven_day_average_price: 0.009567210526315777,
      thirty_day_average_price: 0.010695326560693634,
    },
    contracts: [
      {
        contract_address: "0x12dd66366d45f44128083233c6fbadfe7cbae221",
      },
    ],
    id: 368,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:24:38.669Z",
    key: "fatzukinft",
    name: "Fatzuki",
    description: null,
    exchange_url: "https://opensea.io/collection/fatzukinft",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/59cbbcac05fddcb39b924f6d045f5419.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/5412177d0043beed9813330614b6dfef.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/5412177d0043beed9813330614b6dfef.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/a1841e14e7d32f3cd2e172034c80451f.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/fatzuki",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 2313,
      floor_price: 0.004089,
      floor_price_symbol: "ETH",
      total_minted: 2313,
      total_supply: null,
      total_volume: 404.5138096462815,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.03959,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -109,
      total_sales: 12174,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 9,
      total_average_price: 0.033227682737496426,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.004398888888888889,
    },
    contracts: [
      {
        contract_address: "0x703e54bb5e5e03db13678af8fd6357348fa35d15",
      },
    ],
    id: 369,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:24:38.264Z",
    key: "angry-riders-society",
    name: "Angry Riders Society",
    description:
      "Meet the Angry Riders! Part 2 of the Angry Apes Society epic journey. A collection of 4248 Angry Apes riding through earth in search of their next adventure. \r\n\r\n[Angry Apes Society](https://opensea.io/collection/angryapes-society-nft)\r\n\r\n[Angry Apes: Portal Pass](https://opensea.io/collection/angry-apes-portal-pass)",
    exchange_url: "https://opensea.io/collection/angry-riders-society",
    external_url: "https://angryapessociety.com/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/bf54be0021505eeb86611e8716afa2dc.jpg?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/78715e6f15621b7b60a08da758739d35.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/angryapesnft",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 593,
      floor_price: 0.0045,
      floor_price_symbol: "ETH",
      total_minted: 593,
      total_supply: null,
      total_volume: 27.592841885554968,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.008,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -6,
      total_sales: 1206,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 2,
      total_average_price: 0.02287963672102402,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.004,
    },
    contracts: [
      {
        contract_address: "0xb0b3d18c186ffc8b8a40476272f16b23edf2342c",
      },
    ],
    id: 370,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:25:48.578Z",
    key: "sanjay",
    name: "SANJAY",
    description:
      "By purchasing SANJAY, you have full commercial rights to it and can use it anywhere!\n\nSANJAY is one of the main characters of SICKO UNIVERSE! The name SanJay is a portmanteau of it's two Siberian creators: Sanya and Jeka. \n\n\nA limited series of 1000 unique SANJAY! Every detail and clothing is hand-drawn, scanned, and assembled manually in CC. \n\n",
    exchange_url: "https://opensea.io/collection/sanjay",
    external_url: "http://sanjaycrew.com/",
    banner_image_url:
      "https://i.seadn.io/gae/L7U87BINhx0JzQjpyLn7y1pQM9eLN7PJoUsyqnWdJVdBh8lmcnH2sg7bpHQheRgxJHem4MxgGvYK8qjh6P63rgac8hreGHqAfi9fSA?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/pR28wXNIyBR8di2tCYof2tvaZstNasXQk3-QtSyJcllpnMcRaKOusJcDpsXAXzQmtZaH8db4vSp9pYLFuh4g2mLyMHP9DRauqmFfvzY?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/pR28wXNIyBR8di2tCYof2tvaZstNasXQk3-QtSyJcllpnMcRaKOusJcDpsXAXzQmtZaH8db4vSp9pYLFuh4g2mLyMHP9DRauqmFfvzY?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/H3bITxhYGkseGa_JKm2w1ZSj1c1B-z22fV0IfIa9ILEkOJa1q9c0lpU-pR5Wbf9eT4Vnjz6mKc8BIDbHhCw1nu_3csFQv5IhRv-8QQ?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/rHwD7EsVRs",
    telegram_url: null,
    twitter_username: "SANJAY_SICKO",
    wiki_url: null,
    instagram_username: "SICKO_UNIVERSE",
    stats: {
      market_cap: 0,
      num_owners: 317,
      floor_price: 0.02,
      floor_price_symbol: "ETH",
      total_minted: 317,
      total_supply: null,
      total_volume: 198.1627591958055,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0016,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 1999,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.09913094507043797,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0016,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 371,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:25:44.880Z",
    key: "glb69",
    name: "GLB Public Collection by TMWSTW",
    description: "https://twitter.com/TMWSTW_NFT",
    exchange_url: "https://opensea.io/collection/glb69",
    external_url: "https://tmwstw.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/8ebc13c726d456a2c2a07f89aa9c25cb.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/486a397174347875456a9898059c7540.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/486a397174347875456a9898059c7540.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/81a2296b2641c1d9aa9b838c5b56a6e3.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 306.1842500000001,
      num_owners: 28998,
      floor_price: 0.001,
      floor_price_symbol: "ETH",
      total_minted: 28998,
      total_supply: null,
      total_volume: 84.8343921500001,
      one_day_volume: 0,
      seven_day_volume: 0.018500000000000003,
      thirty_day_volume: 0.018500000000000003,
      one_day_volume_change: 0,
      seven_day_volume_change: 2,
      thirty_day_volume_change: -1,
      total_sales: 83,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 2,
      total_average_price: 1.022101110240965,
      one_day_average_price: 0,
      seven_day_average_price: 0.009250000000000001,
      thirty_day_average_price: 0.009250000000000001,
    },
    contracts: [
      {
        contract_address: "0xf1126bfbcbecaf5807378448e52ecaef23cf8a27",
      },
    ],
    id: 372,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:25:15.140Z",
    key: "gaia-protocol-gods",
    name: "Gaia Protocol - The Gods",
    description:
      "A membership NFT collection of Gaia Protocol consisting of 3,333 NFTs",
    exchange_url: "https://opensea.io/collection/gaia-protocol-gods",
    external_url: "https://gaiaprotocol.com/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/11dcb97ad8fa2e444b73d8b70c8c5dfc.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/555b9cce70ec62dc8959846e48eceed4.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/555b9cce70ec62dc8959846e48eceed4.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/de65b5f2ac2e2195a453813c6a92580c.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 641,
      floor_price: 0.04,
      floor_price_symbol: "ETH",
      total_minted: 641,
      total_supply: null,
      total_volume: 27.65496435448615,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 190,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.14555244397097974,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x134590acb661da2b318bcde6b39ef5cf8208e372",
      },
    ],
    id: 373,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:26:58.222Z",
    key: "tycoontigersclub",
    name: "Tycoon Tigers Club",
    description:
      "The Tycoon Tigers are hard-working entrepreneurs, settling business on the blockchain. As a collection, they aim to build the biggest NFT business network community, and to bring together fellow entrepreneurs and investors in web3..",
    exchange_url: "https://opensea.io/collection/tycoontigersclub",
    external_url: "http://tycoontigersclub.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/70a3e2b2bace6819e25dc6b7d49606d1.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/ff9e87c9bd532e7dbf2ac12c210c04b6.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/ff9e87c9bd532e7dbf2ac12c210c04b6.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/b4f29d40bbe7fdfa36cbd19afb9144f6.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "tycoontigers",
    stats: {
      market_cap: 16.813875,
      num_owners: 1041,
      floor_price: 0.0078,
      floor_price_symbol: "ETH",
      total_minted: 1041,
      total_supply: null,
      total_volume: 23.761185415917005,
      one_day_volume: 0,
      seven_day_volume: 0.017245,
      thirty_day_volume: 0.13578599,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: -31,
      total_sales: 4044,
      one_day_sales: 0,
      seven_day_sales: 4,
      thirty_day_sales: 17,
      total_average_price: 0.005875664049435461,
      one_day_average_price: 0,
      seven_day_average_price: 0.00431125,
      thirty_day_average_price: 0.007987411176470588,
    },
    contracts: [
      {
        contract_address: "0x32e136be91606c645ff62ff7075b2f0472fa13e1",
      },
    ],
    id: 374,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:26:36.004Z",
    key: "savannahbydoma",
    name: "savannah by Doma",
    description: "a connection that never ends, begins with a piece of art.",
    exchange_url: "https://opensea.io/collection/savannahbydoma",
    external_url: "https://bueno.art/aig79k0dtvwo5-sceeal/savannahbydoma",
    banner_image_url:
      "https://i.seadn.io/gcs/files/0769a1f5aec29077edd4b4c6f3378361.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/0769a1f5aec29077edd4b4c6f3378361.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/0769a1f5aec29077edd4b4c6f3378361.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/daf9193c13f874b491a9adb2f5594efc.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 372,
      floor_price: 0.0332,
      floor_price_symbol: "ETH",
      total_minted: 372,
      total_supply: null,
      total_volume: 48.2975843634522,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.017900000000000003,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 7,
      total_sales: 2394,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 7,
      total_average_price: 0.02017442955866842,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.002557142857142858,
    },
    contracts: [
      {
        contract_address: "0x8c9059b45b63f0565ac747bb45e26ecea5df7a11",
      },
    ],
    id: 375,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:26:31.918Z",
    key: "divineanarchy",
    name: "Divine Anarchy",
    description:
      "The Official Divine Anarchy Collection. 10,011 Children of Anarchy.\n\nThe world’s first NFT social RPG.\n\nDivine Anarchy is 10,011 unique anime themed digital collectibles living on the Ethereum blockchain. Your Child of Anarchy doubles as your playable character and grants special access to members-only benefits within the official world of Divine Anarchy. \nIn a world of chaos, there lies two factions, Heroes and Nemesis. Among these factions comes various unique characters from Atlanteans, Mongols, Genesis and more to be seen once acquainted within our world. \n\nMembers receive special early access to future collections which can be viewed through our roadmap of anarchy\n\nLatest Collection for DA Season 2: https://opensea.io/collection/da-wasteland ",
    exchange_url: "https://opensea.io/collection/divineanarchy",
    external_url: "http://divineanarchy.com/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/26a44bdf1740daed36ccf2f90a07b65d.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/ae1be11d0cebd314050010da43e11335.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/ae1be11d0cebd314050010da43e11335.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/99eb5f4977a453565ab020d1e1bba011.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/divineanarchy",
    telegram_url: null,
    twitter_username: "divineanarchy",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 34.48836317948718,
      num_owners: 4281,
      floor_price: 0.004082,
      floor_price_symbol: "ETH",
      total_minted: 4281,
      total_supply: null,
      total_volume: 5373.304824872376,
      one_day_volume: 0.00839,
      seven_day_volume: 0.13556200000000002,
      thirty_day_volume: 0.5789619999999999,
      one_day_volume_change: -0.017065000000000004,
      seven_day_volume_change: -6,
      thirty_day_volume_change: 55,
      total_sales: 18655,
      one_day_sales: 2,
      seven_day_sales: 39,
      thirty_day_sales: 90,
      total_average_price: 0.28803563789184544,
      one_day_average_price: 0.004195,
      seven_day_average_price: 0.003475948717948718,
      thirty_day_average_price: 0.00643291111111111,
    },
    contracts: [
      {
        contract_address: "0xc631164b6cb1340b5123c9162f8558c866de1926",
      },
    ],
    id: 376,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:26:24.187Z",
    key: "fivepenguins",
    name: "Five Penguins by Gavin Shapiro",
    description:
      "Five Penguins is a collectible concert visualizer that anyone can use for free at [fivepenguins.party](https://www.fivepenguins.party). It is a generative art series by Gavin Shapiro, available to collect on the Ethereum blockchain, and designed to fit your Twitter banner. Similar in spirit to generative collections like those found on ArtBlocks, this is first and foremost an art release, and there is no roadmap! Just majestic, endlessly marching penguins. And sometimes bees.\n\nFive Penguins can be burned to redeem [new artworks by Gavin Shapiro](https://manifold.gallery/fivepenguins).\n\nThe 3,125 squads in this collection consist of every possible combination of 5 different penguin types in 5 different positions (5^5). There is only one of each combination, and the rarity of these combinations is treated like poker hands (so getting five of the same penguin is much rarer than a pair). Each squad then gets a random background and a chance to spawn with special environmental traits.",
    exchange_url: "https://opensea.io/collection/fivepenguins",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/42ca23282bb48119cc21da41e7572452.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/42ca23282bb48119cc21da41e7572452.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/42ca23282bb48119cc21da41e7572452.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/acf0c80c9323d20ec1a901b3b03ce1eb.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: "shapiro500",
    wiki_url: null,
    instagram_username: "shapiro500",
    stats: {
      market_cap: 7.985320000000001,
      num_owners: 1151,
      floor_price: 0.0078,
      floor_price_symbol: "ETH",
      total_minted: 1151,
      total_supply: null,
      total_volume: 96.35273021599009,
      one_day_volume: 0,
      seven_day_volume: 0.013300000000000001,
      thirty_day_volume: 0.43704000000000004,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 35,
      total_sales: 1946,
      one_day_sales: 0,
      seven_day_sales: 5,
      thirty_day_sales: 57,
      total_average_price: 0.04951322210482533,
      one_day_average_price: 0,
      seven_day_average_price: 0.00266,
      thirty_day_average_price: 0.007667368421052632,
    },
    contracts: [
      {
        contract_address: "0x697e0a5e2a6be117760d192a03fac688e774efcf",
      },
    ],
    id: 377,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:27:58.968Z",
    key: "niji-nft",
    name: "NIJI NFT",
    description:
      "https://twitter.com/nijifriends\nhttps://discord.gg/nijifriends",
    exchange_url: "https://opensea.io/collection/niji-nft",
    external_url: "https://japannftmuseum.com/niji",
    banner_image_url:
      "https://i.seadn.io/gcs/files/934699733a80904d0b8f9a2103c54aa9.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/3623c7f82e7df39e41869019fcf1b2a2.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/3623c7f82e7df39e41869019fcf1b2a2.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/cbbf498bb60f392697f151511f5f2d1d.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/japandao",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1065,
      floor_price: 0.0039,
      floor_price_symbol: "ETH",
      total_minted: 1065,
      total_supply: null,
      total_volume: 270.6490846399786,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.005099999999999999,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 3,
      total_sales: 5915,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 3,
      total_average_price: 0.04575639638883831,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0017,
    },
    contracts: [
      {
        contract_address: "0x03558d808f9e73a4452ad8ca5cc14d5c0c59d364",
      },
    ],
    id: 378,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:27:58.563Z",
    key: "oh-ottie",
    name: "Oh Ottie!",
    description:
      "Oh Ottie! features 2000 avatars of a cherished crypto mascot - the ever-loving, curious and engaging Ottie. The collection showcases how Altlayer’s superior flashlayer functionality can boost a blockchain’s processing capacity on demand. Oh Ottie! is a true demonstration that scalability, when strategically applied, is the most coveted superpower in Web3.\n\n\n\nOtties are darling creatures and really know how to have a good time. Browse from a range of traits, professions, and colours and pick an Ottie that reflects you and your mood!",
    exchange_url: "https://opensea.io/collection/oh-ottie",
    external_url: "https://altlayer.io/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/9ff3dac83d33e4a3f3a4ca089ebfab89.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/7b2289b8c4bb2973e07745bae693a7cb.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/7b2289b8c4bb2973e07745bae693a7cb.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/b00ac40b1be4c491b46a65a98fa21480.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: "https://t.me/altlayer",
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 62.7371901178884,
      num_owners: 1077,
      floor_price: 0.0429,
      floor_price_symbol: "ETH",
      total_minted: 1077,
      total_supply: null,
      total_volume: 3257.781506312185,
      one_day_volume: 0.10647000000000001,
      seven_day_volume: 1.0037950418862145,
      thirty_day_volume: 1.799649641966214,
      one_day_volume_change: -0.025129000000000012,
      seven_day_volume_change: 9,
      thirty_day_volume_change: -178,
      total_sales: 6465,
      one_day_sales: 3,
      seven_day_sales: 32,
      thirty_day_sales: 58,
      total_average_price: 0.50391051915115,
      one_day_average_price: 0.03549,
      seven_day_average_price: 0.0313685950589442,
      thirty_day_average_price: 0.031028442102865757,
    },
    contracts: [
      {
        contract_address: "0x7ff5601b0a434b52345c57a01a28d63f3e892ac0",
      },
    ],
    id: 379,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:27:34.521Z",
    key: "supernormalbyzipcy",
    name: "SuperNormal",
    description:
      '**True Supply: 8888 (OS counts v1 ZIPS that\'s been upgraded to v2)**\r\n\r\n**[Harvest & Token Upgrade is Live!](https://upgrade.supernormal.art)** \r\n\r\n_"A thought-provoking, authentic, detailed exploration into the nuances of what it means to be extraordinary."_\r\n\r\nConsisting of over 1000 traits, these 8,888 Generative NFTs on the Ethereum blockchain represent individualism by portraying elements of the diverse and unique. This is done by allowing the singular, inventive works to be composed of six comprehensive styles, encompassing a variety of human identities and emotions. The collection seeks to invoke the viewer\'s interpretation of the art, through the personification of each piece and the features that make each... **"SuperNormal"**.\r\n\r\n**Benefits:** Premium Art, Fashion Brand, K-Pop, Metaverse, Utilities, Connections, Alphas, Offline Activations, Airdrops.\r\n\r\nDrawn by [Zipcy](https://www.instagram.com/zipcy/).\r\nBacked by team from **Coinbase, Microsoft, Snapchat, IBM, Blackberry.**',
    exchange_url: "https://opensea.io/collection/supernormalbyzipcy",
    external_url: "https://upgrade.supernormal.art",
    banner_image_url:
      "https://i.seadn.io/gcs/files/c7cf0458356a69939d3af294d15c725f.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/cZ0lurTxSFfA6lZ_5670kU-GB_okeuTv1QSxCWWF_A0goQOGnRxZvVIOnHl3Rkfeqq-Gdmn0CZbcR7_N_UYM00gJD3w7nCwEU0Ns8yY?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/cZ0lurTxSFfA6lZ_5670kU-GB_okeuTv1QSxCWWF_A0goQOGnRxZvVIOnHl3Rkfeqq-Gdmn0CZbcR7_N_UYM00gJD3w7nCwEU0Ns8yY?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/54e2537729a7b96c9f95b4249c0e639e.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/supernormal",
    telegram_url: "https://x.com/supernormal",
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 163.14705,
      num_owners: 2325,
      floor_price: 0.01945,
      floor_price_symbol: "ETH",
      total_minted: 2325,
      total_supply: null,
      total_volume: 28527.008339614265,
      one_day_volume: 0,
      seven_day_volume: 0.07590000000000001,
      thirty_day_volume: 0.16953699999999997,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: -28,
      total_sales: 20324,
      one_day_sales: 0,
      seven_day_sales: 4,
      thirty_day_sales: 8,
      total_average_price: 1.4036119041337465,
      one_day_average_price: 0,
      seven_day_average_price: 0.018975000000000002,
      thirty_day_average_price: 0.021192124999999996,
    },
    contracts: [
      {
        contract_address: "0xd532b88607b1877fe20c181cba2550e3bbd6b31c",
      },
    ],
    id: 380,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:27:27.298Z",
    key: "ogcollective200",
    name: "The OG Collective",
    description:
      "The OG Collective is a community of like-minded art collectors, artists and curators passionate about leveraging our collective experience, resources and networks to help artists and collectors find success as Web3 and digital art changes the world.\n\n##*  CREATE - COLLECT - CONNECT  *",
    exchange_url: "https://opensea.io/collection/ogcollective200",
    external_url: "https://www.ogcollective.xyz/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/52ce729e793389b979d07d8d8dc68407.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/7e2fd7900a4916cf97d32014d719a172.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/7e2fd7900a4916cf97d32014d719a172.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/60f529c3f20a7f0e879588455fa185af.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 88,
      floor_price: 0.0499,
      floor_price_symbol: "ETH",
      total_minted: 88,
      total_supply: null,
      total_volume: 11.3896,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0016,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 21,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.5423619047619047,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0016,
    },
    contracts: [
      {
        contract_address: "0xd1b9f497b547e6114c9df6df979f34a0388bbb8c",
      },
    ],
    id: 381,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:27:23.161Z",
    key: "2117-citizenship-bedu",
    name: "2117 - Citizenship by BEDU",
    description:
      "The 2117 citizenship comes with a full set of unique benefits for the 2117 Metaverse.\n\nThe citizenships are the most important asset of 2117 and the key to unlock all the features and mysteries of our journey to Mars.",
    exchange_url: "https://opensea.io/collection/2117-citizenship-bedu",
    external_url: "https://2117.io/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/49903977bc30c155bdec4ddc9d1dd28a.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/91894999c255e72bf06a569243bef3d2.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/91894999c255e72bf06a569243bef3d2.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/49be91636c09fd784e6c11f701a4687f.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/bedu",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1247,
      floor_price: 0.019542,
      floor_price_symbol: "ETH",
      total_minted: 1247,
      total_supply: null,
      total_volume: 474.189884591746,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.272,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 4,
      total_sales: 1915,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 14,
      total_average_price: 0.2476187386902068,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.01942857142857143,
    },
    contracts: [
      {
        contract_address: "0xcdd453e786ae1c565f5afb753a94ad9738434101",
      },
    ],
    id: 382,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:28:48.527Z",
    key: "shiryo-cards",
    name: "shiryo-cards",
    description:
      "Shiryo NFT trading cards. These cards allow holders to participated in the Shiryo NFT trading cards game. Visit Shiryo.com for more details",
    exchange_url: "https://opensea.io/collection/shiryo-cards",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gae/XGwdHAWyyFyEPOP-SNk2dki5hk8YWdDLvUlXtj-0Dw7Mte6LA83mmyCXdyWv5ojJ_7Q1bnRkPoJBuxDEGXxm-e4amWGGfQqbDfSY3fA?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/42l9x3dBfLAEsjtGGtKnBA0naBewMHpBeobxFCnJpFt6XKN_YFcMdZ4Rqi4F8dlsdtP9f_U2R8IkIWglYlG9Rc2KoJW81zyqVNy2mw?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/42l9x3dBfLAEsjtGGtKnBA0naBewMHpBeobxFCnJpFt6XKN_YFcMdZ4Rqi4F8dlsdtP9f_U2R8IkIWglYlG9Rc2KoJW81zyqVNy2mw?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/kd7mU_stJ8i7aaj_7Um_xYS50wudVIfBg9zwALQM2yrHriRkj5Cjnr9mHEm_dsfC6e5IXhL4IBIywjbJtbgZJmn-7RTN8GGbz2QIAKY?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/shiryo",
    telegram_url: "https://t.me/ShiryoINU",
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 1.4140648148148154,
      num_owners: 1032,
      floor_price: 0.0003,
      floor_price_symbol: "ETH",
      total_minted: 1032,
      total_supply: null,
      total_volume: 64.03565975000004,
      one_day_volume: 0.21739000000000008,
      seven_day_volume: 0.21817000000000009,
      thirty_day_volume: 0.2210600000000001,
      one_day_volume_change: 24,
      seven_day_volume_change: 25,
      thirty_day_volume_change: 14,
      total_sales: 4854,
      one_day_sales: 25,
      seven_day_sales: 27,
      thirty_day_sales: 30,
      total_average_price: 0.013192348526988059,
      one_day_average_price: 0.008695600000000003,
      seven_day_average_price: 0.008080370370370373,
      thirty_day_average_price: 0.00736866666666667,
    },
    contracts: [
      {
        contract_address: "0x0411f0ff4105fdc075e5e1bfdab47183c1b9df78",
      },
    ],
    id: 383,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:28:48.138Z",
    key: "thekoreans1945",
    name: "The Koreans 1945",
    description:
      "The Koreans is a collection of 1,945 generative NFTs that depicts iconic features of Korean culture, while paying homage to the most iconic NFT project of all time - the CryptoPunks.\n\nOn August 15, 1945, Korea was liberated from the forces of colonialism and its sovereignty was restored.  To commemorate this fact, we have chosen to mint 1,945 Koreans on August 15.\n\nThe Koreans were free to mint, and most of the secondary sale royalties generated by the project will go towards supporting up-and-coming artists and projects in web 3.  The rare 1-of-1s were made using the most iconic looks from Korean culture, and the parts were designed to be reminiscent of the everyday Koreans you’d meet in your daily commutes.\n\nWe hope that we can do our part in accelerating the adoption of web 3 culture in Korea, while simultaneously introducing our culture to the rest of web 3.  So help spread a little love with us, Korean-style ❤️",
    exchange_url: "https://opensea.io/collection/thekoreans1945",
    external_url: "https://soul.ink/thekoreans1945.eth",
    banner_image_url:
      "https://i.seadn.io/gcs/files/f0ea467a314f0b7d4dbefa0e4df3a226.png?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/3c9c35c25fcd515f604c592288ad78ca.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 456,
      floor_price: 0.18,
      floor_price_symbol: "ETH",
      total_minted: 456,
      total_supply: null,
      total_volume: 7.957337799999991,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 470,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.016930505957446787,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xa7298e98362625b65d08bb4c25992c503a0d48db",
      },
    ],
    id: 384,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:28:30.778Z",
    key: "baby-shiba-social-club-official",
    name: "Baby Shiba Social Club Official",
    description:
      'PLEASE BE AWARE THAT THIS COLLECTION IS MORPHED INTO A "NEW ERA" COLLECTION: https://opensea.io/collection/baby-shiba-social-club-new-era',
    exchange_url:
      "https://opensea.io/collection/baby-shiba-social-club-official",
    external_url: "https://theconfluence.world/",
    banner_image_url:
      "https://i.seadn.io/gae/mjozZH36pGByjkfKNvFpMGzl3SYfVUuEd2C9AqjWjMJBMcJCJDkkA4tx2jUoZQVoNDxmGuv8SdSgphbc6ehDFLhJ0fwHHAWVOpUEbA?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/kfewBO8NsaP0WNHzOHkzbusosAa25KW2Vib76i-6UMdTLSHKDSEqUxqCIhZv9CEB6cYgLkIOVoQyOu54U1f4m_HHdtb2Wx7jjqdfOQ?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/shibasocialclub",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "shibasocialclub_nft",
    stats: {
      market_cap: 16.748914285714285,
      num_owners: 4764,
      floor_price: 0.0037,
      floor_price_symbol: "ETH",
      total_minted: 4764,
      total_supply: null,
      total_volume: 1062.5722620966399,
      one_day_volume: 0,
      seven_day_volume: 0.0132,
      thirty_day_volume: 0.0537,
      one_day_volume_change: 0,
      seven_day_volume_change: 3,
      thirty_day_volume_change: 12,
      total_sales: 6980,
      one_day_sales: 0,
      seven_day_sales: 7,
      thirty_day_sales: 18,
      total_average_price: 0.15223098310840114,
      one_day_average_price: 0,
      seven_day_average_price: 0.001885714285714286,
      thirty_day_average_price: 0.002983333333333333,
    },
    contracts: [
      {
        contract_address: "0x081fac886fdcacdc826c4135ed4ba5b65ececfb8",
      },
    ],
    id: 385,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:29:56.340Z",
    key: "nft-polska-collective",
    name: "NFT Polska Collective",
    description:
      "A private group of Web3 builders & innovators from Poland.\n\nOffering 999 memberships, it strives to be a home for the next generation of Polish creators, entrepreneurs and investors, on the Polish and international market. It is designed to set new standards and change the face of NFT and web3 in Poland.",
    exchange_url: "https://opensea.io/collection/nft-polska-collective",
    external_url: "https://collective.nftpolska.net/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/2870c773f1c7e40cb7637184a4439f3b.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/d766b0a412bbb93e681b9d9bea1dd0cb.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/d766b0a412bbb93e681b9d9bea1dd0cb.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/d766b0a412bbb93e681b9d9bea1dd0cb.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/TGt5bAbG9s",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0.323,
      num_owners: 164,
      floor_price: 0.0199,
      floor_price_symbol: "ETH",
      total_minted: 164,
      total_supply: null,
      total_volume: 7.494599999999999,
      one_day_volume: 0.0019,
      seven_day_volume: 0.0019,
      thirty_day_volume: 0.0019,
      one_day_volume_change: 0.0019,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 1,
      total_sales: 39,
      one_day_sales: 1,
      seven_day_sales: 1,
      thirty_day_sales: 1,
      total_average_price: 0.19216923076923076,
      one_day_average_price: 0,
      seven_day_average_price: 0.0019,
      thirty_day_average_price: 0.0019,
    },
    contracts: [
      {
        contract_address: "0x4d6f3bb038a3e06c46e7b6aebe3cc84cd6ef3f5a",
      },
    ],
    id: 386,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:29:45.637Z",
    key: "rohki-genesis-key",
    name: "ROHKI Genesis Key",
    description: "Your portal into the RŌHKI world, coming soon...",
    exchange_url: "https://opensea.io/collection/rohki-genesis-key",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gae/z2Iw5Iotp3pD5qeixM8jv7Gugj-ivQHH4wJvFPCwzCA707iFTK87ioSXBfRxgIM5YvRNVoc1GTS0v6WxOUAcQq2nlLFWlNXp4pe8YA?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/ZilMs4PT-cclaMqTTOb4Dncd79KijKg1V-q_YJlI7NjU4uFmfDtzcp_HSYVXIz4UHNFkgw2Mgc-9jy6f5ZjDhz1K6yzapphhEM4G?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/ZilMs4PT-cclaMqTTOb4Dncd79KijKg1V-q_YJlI7NjU4uFmfDtzcp_HSYVXIz4UHNFkgw2Mgc-9jy6f5ZjDhz1K6yzapphhEM4G?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/jyOxrrZ5Nhton5vIAL10yCFexExXjLWhU_KfGYNjm7pC1conv3BzH1PUYGqyD_4cvAEskqs-gOCN5uhCbuKVdorh_MRwqitEjuWzDJs?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/UqcXWPDt",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 88,
      floor_price: 0.029899,
      floor_price_symbol: "ETH",
      total_minted: 88,
      total_supply: null,
      total_volume: 110.21322985009036,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 96,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 1.1480544776051078,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x0f1a39cdabd96c4da950d236219ecc78aef75661",
      },
    ],
    id: 387,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:30:59.513Z",
    key: "i-t-s-c-g",
    name: "ImpatientTigerSocialClub",
    description:
      'NO ROADMAP ! For The CULTURE ! " Impatient Tiger Social Club "\n\n🐯 : https://opensea.io/collection/i-t-s-c-b-o-x',
    exchange_url: "https://opensea.io/collection/i-t-s-c-g",
    external_url: "https://www.itsc-nft.io/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/58e8e16379a876bf43ec865605c59b5e.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/f747fc6e00fa9878009176fe1bbdbaa4.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/f747fc6e00fa9878009176fe1bbdbaa4.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/b1c815304204c2be0c8033f2557a6c3d.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/itsc",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 15.497599999999998,
      num_owners: 625,
      floor_price: 0.05291700020081914,
      floor_price_symbol: "ETH",
      total_minted: 625,
      total_supply: null,
      total_volume: 7.493714800041784,
      one_day_volume: 0,
      seven_day_volume: 0.0116,
      thirty_day_volume: 0.1359,
      one_day_volume_change: 0,
      seven_day_volume_change: -1,
      thirty_day_volume_change: 4,
      total_sales: 106,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 6,
      total_average_price: 0.07069542264190362,
      one_day_average_price: 0,
      seven_day_average_price: 0.0116,
      thirty_day_average_price: 0.02265,
    },
    contracts: [
      {
        contract_address: "0xa2ca2f4b7f29b6fe74ecb3d379b6d74778b3a55b",
      },
    ],
    id: 388,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:30:41.194Z",
    key: "deluxegoat-genesis",
    name: "DeluxeGoat - Genesis Collection",
    description:
      "The DeluxeGoat OG Collection is an exclusive supply of 333 unique, high-quality 3D art collected on the Ethereum Blockchain.\n\nWhen you hold a DeluxeGoat, you own more than a piece of art… you become part of an Exclusive Club with benefits that will continue to increase and develop over time.\n\nWe are part Social Club, part DAO, and all business.\n\nCome, join The Herd.",
    exchange_url: "https://opensea.io/collection/deluxegoat-genesis",
    external_url: "https://www.deluxelabs.xyz",
    banner_image_url:
      "https://i.seadn.io/gcs/files/9b24ba1d9ec2c462c22c4dadcb60302e.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/07bd734e84bf99de051f323f1528a62d.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/07bd734e84bf99de051f323f1528a62d.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/b1b66a6ac9748c583c9062c74369ed93.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/deluxegoat",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "deluxegoat.nft",
    stats: {
      market_cap: 0,
      num_owners: 189,
      floor_price: 0.034899,
      floor_price_symbol: "ETH",
      total_minted: 189,
      total_supply: null,
      total_volume: 92.17348359925302,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 491,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.1877260358436925,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xc0c0e56c109b68049c9c71d18d9c1b3169c120bd",
      },
    ],
    id: 389,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:30:23.205Z",
    key: "d-run-d-z",
    name: "D-RUN D'z",
    description:
      '"Find Your Running Buddy Near You"\nWelcome to the world of D-RUN! D-RUN is a WEB-3.0 based running community project. We have Ethereum based generative art PFP NFTs. Become a Dz and come run with us!',
    exchange_url: "https://opensea.io/collection/d-run-d-z",
    external_url: "https://d-runt.io/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/9a719dcde9ffdc6dbbb6de416cf24964.png?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/85799faa107cebebfdecdac1402c1f46.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/d-run",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 6.4961,
      num_owners: 540,
      floor_price: 0.0199,
      floor_price_symbol: "ETH",
      total_minted: 540,
      total_supply: null,
      total_volume: 28.24431999999998,
      one_day_volume: 0.0019,
      seven_day_volume: 0.0019,
      thirty_day_volume: 0.0019,
      one_day_volume_change: 0.0019,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 1,
      total_sales: 543,
      one_day_sales: 1,
      seven_day_sales: 1,
      thirty_day_sales: 1,
      total_average_price: 0.05201532228360954,
      one_day_average_price: 0,
      seven_day_average_price: 0.0019,
      thirty_day_average_price: 0.0019,
    },
    contracts: [
      {
        contract_address: "0xf7f02f28976a2e938224d4cf759ee6e7e788c6e3",
      },
    ],
    id: 390,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:30:22.507Z",
    key: "floki-inu-diamond-hands-bronze-tier",
    name: "Floki Inu - Diamond Hands - Bronze Tier",
    description:
      "The Genesis Floki NFT collection is the first official NFT collection brought to you by the Floki Team.\n\nThey have been granted as a gift to the community to reward them for their diamond hands. This Genesis collection consists of three tiers: Diamond, Silver and Bronze. Each of these tiers will have their specific benefits and utilities in the future. These utilities may vary from access to (pre-) sales to ingame-bonuses for the Floki NFT Gaming ecosystem.",
    exchange_url:
      "https://opensea.io/collection/floki-inu-diamond-hands-bronze-tier",
    external_url: "https://theflokiinu.com/",
    banner_image_url:
      "https://i.seadn.io/gae/es_FSIoPgZsG13Btk5fd-sASFCinFmwAvAOj2pwzTTuEeckyWCEkRwMJJ9WVoDKiE7_l-R3QycSl4rAosVtyiKLnsOtNPrJy-nFR0SA?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/fA6wdC8fQJIAN_kmDfwOzDyu8cj5JuVImxGE9wI5sDD3Cft6zfGzHCkgOZZz1aZVRtJkNDLbye9mGOieSlnh1pUJu4cOIfgEMVDf?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 8.754,
      num_owners: 1223,
      floor_price: 0.02097940004000001,
      floor_price_symbol: "ETH",
      total_minted: 1223,
      total_supply: null,
      total_volume: 36.513013201041176,
      one_day_volume: 0.006,
      seven_day_volume: 0.006,
      thirty_day_volume: 0.015899999999999997,
      one_day_volume_change: 1,
      seven_day_volume_change: 1,
      thirty_day_volume_change: -28,
      total_sales: 516,
      one_day_sales: 1,
      seven_day_sales: 1,
      thirty_day_sales: 3,
      total_average_price: 0.07076165349038988,
      one_day_average_price: 0.006,
      seven_day_average_price: 0.006,
      thirty_day_average_price: 0.005299999999999999,
    },
    contracts: [
      {
        contract_address: "0x177312b692f92f1d2498637fcfc90b79b1fc7719",
      },
    ],
    id: 391,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:30:18.677Z",
    key: "theaces",
    name: "The Aces",
    description:
      "!!READ!!\n\nThe Aces (Ethereum Collection): This collection has been deprecated and is no longer valid or supported. The Aces has officially migrated to Solana, where all updates, utilities, and new developments will take place. Please visit our Solana collection for the latest and most valuable versions of The Aces.",
    exchange_url: "https://opensea.io/collection/theaces",
    external_url: "https://theaces.xyz",
    banner_image_url:
      "https://i.seadn.io/gcs/files/d91d6bad55dfb75007270a5e66d6a924.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/800f42cd208f2c47fc9eaddcd70c0df2.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/800f42cd208f2c47fc9eaddcd70c0df2.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/b42eb53e5344a47aceafd2cd2fca4155.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/theaces-906359670195757087",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 3047,
      floor_price: 0.003505800281229233,
      floor_price_symbol: "ETH",
      total_minted: 3047,
      total_supply: null,
      total_volume: 1533.9757763944658,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0018,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 12258,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.125140787762642,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0018,
    },
    contracts: [
      {
        contract_address: "0xb3b814ccd178de120687a9ad01c6886c56399198",
      },
    ],
    id: 392,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:30:14.734Z",
    key: "remilio-babies",
    name: "Redacted Remilio Babies",
    description:
      "Redacted Remilio Babies is a collection of 10,000 neochibi pfpNFT's expanding the Milady Maker paradigm with the introduction of young J.I.T. energy and schizophrenic reactionary aesthetics. We are #REMILIONAIREs.",
    exchange_url: "https://opensea.io/collection/remilio-babies",
    external_url: "http://remilio.org",
    banner_image_url:
      "https://i.seadn.io/gcs/files/f80f846ee3f0ce3c83fad5bdc25e3fb2.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/f80f846ee3f0ce3c83fad5bdc25e3fb2.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/f80f846ee3f0ce3c83fad5bdc25e3fb2.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/9d6168e731afd02d5e878eb03876cfd4.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 7358.926074145051,
      num_owners: 4005,
      floor_price: 0.82428,
      floor_price_symbol: "ETH",
      total_minted: 4005,
      total_supply: null,
      total_volume: 49111.44724989106,
      one_day_volume: 129.30002899999997,
      seven_day_volume: 480.7499965550099,
      thirty_day_volume: 1912.103460789117,
      one_day_volume_change: 15,
      seven_day_volume_change: 363,
      thirty_day_volume_change: 1348,
      total_sales: 58880,
      one_day_sales: 157,
      seven_day_sales: 599,
      thirty_day_sales: 2013,
      total_average_price: 0.8340938731299433,
      one_day_average_price: 0.8235670636942674,
      seven_day_average_price: 0.8025876403255591,
      thirty_day_average_price: 0.9498775264724874,
    },
    contracts: [
      {
        contract_address: "0xd3d9ddd0cf0a5f0bfb8f7fceae075df687eaebab",
      },
    ],
    id: 393,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:33:01.817Z",
    key: "zotox",
    name: "Project Zotox",
    description:
      "A utopian society based on perfect freedom and individualism.",
    exchange_url: "https://opensea.io/collection/zotox",
    external_url: "https://zotox.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/f0c88a76a0ae762ea98395c75ce26661.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/b60bc8334050e379186ddc2e325df630.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/b60bc8334050e379186ddc2e325df630.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/8350df19899706e839d73612764154b0.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 2204,
      floor_price: 0.0005,
      floor_price_symbol: "ETH",
      total_minted: 2204,
      total_supply: null,
      total_volume: 3.202516224888881,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.001,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 673,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 2,
      total_average_price: 0.00475856794188541,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0005,
    },
    contracts: [
      {
        contract_address: "0xbaaae5261eb63a994b207da1838660b6242c7919",
      },
    ],
    id: 394,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:33:01.434Z",
    key: "realinfamousskullz",
    name: "REAL INFAMOUS SKULLZ",
    description:
      "10,000 skullz randomly generated as unique art pieces of the biggest cartoons this planet has ever seen and now you have the chance to own one with full commercial rights to your skull NFT.Many of these classic and legendary leading cartoons may have had their time of fame but the remains of their skullz are here to live on forever in the blockchain.Join our community to win giveaways, get perks and exclusive holder access on future drops, exclusive merch as well as our game where you will have opportunity to level up your NFT and win grand prizes.",
    exchange_url: "https://opensea.io/collection/realinfamousskullz",
    external_url: "https://www.infamousskullz.com/",
    banner_image_url:
      "https://i.seadn.io/gae/fbE6ig8fQgneJACTuHsXwlYciuIWi4SOR5CKNLWX1jZ8_h61DSVlzrKf5qKOlXAiXfBh0r-xeHEvMb6UIj9SwJ6YGKWPLBhvu_VlxA?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/xcHwqfr-KcOJL6ykQfnB6XmYfmX8qkOpbGtV3hxyZU4AoyRqNMLR76rBZCUaSSgNkzJkgAVwtNDLMaTN6U4B_gKCLbjqNkVhKXpsfw?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/infamousskullz",
    telegram_url: null,
    twitter_username: "infamousskullz",
    wiki_url: null,
    instagram_username: "infamousskullz",
    stats: {
      market_cap: 0,
      num_owners: 3325,
      floor_price: 0.0019,
      floor_price_symbol: "ETH",
      total_minted: 3325,
      total_supply: null,
      total_volume: 380.54048197162916,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 3944,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.09648592342079847,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x98ef6c09fb0002c682f2b817c9b2c2c7010deafd",
      },
    ],
    id: 395,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:32:43.940Z",
    key: "nomoreofficial",
    name: "no more official emates",
    description:
      "Do not buy eMATEs from this collection.\neMATEs in this collection are no longer genuine Imates.\n\nMigrated to Klaytn on February 25, 2022 at 9 PM KST.\n\n본 컬렉션의 이메이츠를 구입하지 마세요.\n본 컬렉션의 이메이츠는 더 이상 이메이츠 정품이 아닙니다. \n\n2022년 2월 25일 오후 9시(KST)에 클레이튼으로 마이그레이션 되었습니다.\n\nDSC Official Links : https://linktr.ee/dogesoundclub",
    exchange_url: "https://opensea.io/collection/nomoreofficial",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gae/TywdezlLLufnJT7iU4YEoHGSYMSQi2PRxnwig8-VPOBhhsvRFjcW-4tvbk_4YShWqHm1bzy0LVni0OY_6pyOzk5yRv6U5rjqTOZnLw?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/TywdezlLLufnJT7iU4YEoHGSYMSQi2PRxnwig8-VPOBhhsvRFjcW-4tvbk_4YShWqHm1bzy0LVni0OY_6pyOzk5yRv6U5rjqTOZnLw?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/TywdezlLLufnJT7iU4YEoHGSYMSQi2PRxnwig8-VPOBhhsvRFjcW-4tvbk_4YShWqHm1bzy0LVni0OY_6pyOzk5yRv6U5rjqTOZnLw?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/TywdezlLLufnJT7iU4YEoHGSYMSQi2PRxnwig8-VPOBhhsvRFjcW-4tvbk_4YShWqHm1bzy0LVni0OY_6pyOzk5yRv6U5rjqTOZnLw?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: "dogesoundclub",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1440,
      floor_price: 0.033,
      floor_price_symbol: "ETH",
      total_minted: 1440,
      total_supply: null,
      total_volume: 400.8243240000036,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 4076,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.0983376653581952,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xd0242443f18586c389a1013539e93f3a7b27018c",
      },
    ],
    id: 396,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:32:43.527Z",
    key: "sharigato",
    name: "SHARIGATO",
    description:
      '"SHARIGATO" is a new Japanese abbreviation created by mera takeru meaning "Thank you for being involved with SHARI." This special piece was created to commemorate the sell-out of SHARI, a collection celebrating the 4th anniversary of mera takeru\'s career as a crypto artist.\n\nSHARI (This is the Genesis Collection)\nhttps://opensea.io/collection/shari-nfts',
    exchange_url: "https://opensea.io/collection/sharigato",
    external_url: "https://opensea.io/ja/collection/shari-nfts",
    banner_image_url:
      "https://i.seadn.io/gcs/files/e0276893ebd545705e05f33b7d43db94.gif?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/e0276893ebd545705e05f33b7d43db94.gif?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/e0276893ebd545705e05f33b7d43db94.gif?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/e0276893ebd545705e05f33b7d43db94.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/AdeM6Z96qR",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 2649,
      floor_price: 0.023,
      floor_price_symbol: "ETH",
      total_minted: 2649,
      total_supply: null,
      total_volume: 7.4914196254317424,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 810,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.009248666204236719,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x1a1f1895ec88a83035b7c065e7c487f2e41727b3",
      },
    ],
    id: 397,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:32:43.134Z",
    key: "mike-karolos",
    name: "Mike Karolos Editions",
    description: null,
    exchange_url: "https://opensea.io/collection/mike-karolos",
    external_url: "https://smirapdesigns.com/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/f1db0f1cd8f4c3468a5f15c22601b69f.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/f1db0f1cd8f4c3468a5f15c22601b69f.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/f1db0f1cd8f4c3468a5f15c22601b69f.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/f1db0f1cd8f4c3468a5f15c22601b69f.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 821,
      floor_price: 0.0033,
      floor_price_symbol: "ETH",
      total_minted: 821,
      total_supply: null,
      total_volume: 1.48412878797,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 175,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.008480735931257142,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x48a2c36fc89f5c15766acaf1c42e8e4ea005b3dc",
      },
    ],
    id: 398,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:32:42.747Z",
    key: "mbsjq",
    name: "mbsjq artcars",
    description:
      "Welcome to the home of mbsjq editions on OpenSea. Discover the best automotive art in this editions collection by Surrealist Digital Artist & Automotive Enthusiast, mbsjq \n#mbsjqartcars",
    exchange_url: "https://opensea.io/collection/mbsjq",
    external_url: "https://www.madebystudiojq.com/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/7a268a2d00e0226f432b94dfb1c03316.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/6e4f74069588db162163b03778c8e577.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/6e4f74069588db162163b03778c8e577.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/dc684206b3fbf0cd0059246beb647fa6.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "madebystudiojq",
    stats: {
      market_cap: 0,
      num_owners: 3230,
      floor_price: 0.01,
      floor_price_symbol: "ETH",
      total_minted: 3230,
      total_supply: null,
      total_volume: 5.776413328675398,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 517,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.011172946477128428,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x130be08c513524139ee1f4850baeb3ffd5fc657c",
      },
    ],
    id: 399,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:32:42.215Z",
    key: "pepe-beanz",
    name: "PEPE BEANZ",
    description:
      "Peanz are coming from Kekistan. They are packed and ready to spill into your wallets. There are only few of them and you better hoard them before winter hits hard.",
    exchange_url: "https://opensea.io/collection/pepe-beanz",
    external_url: "http://peanz.shop",
    banner_image_url:
      "https://i.seadn.io/gcs/files/50570755e1146b042cda0356138b10be.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/bb922ebea392d902ac8a5b36b1d881dc.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/bb922ebea392d902ac8a5b36b1d881dc.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/c98e57e1454c0bdb6c0aab47f8d0a61b.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 863,
      floor_price: 0.0095,
      floor_price_symbol: "ETH",
      total_minted: 863,
      total_supply: null,
      total_volume: 0.6137662232100001,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 173,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.003547781637052024,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xa590d99cd10dc073f85e6c7b0d60e58f8b383063",
      },
    ],
    id: 400,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:32:37.414Z",
    key: "radioactive-punks",
    name: "Radioactive Punks by Pixantle",
    description:
      "THE CRYPTOPOCALYPSE HAS DAWNED\n\n☢️ [OPERATING SYS](https://radioactivepunks.xyz) ☢️  [RARITY.TOOLS](https://rarity.tools/radioactive-punks) ☢️  [PETS](https://opensea.io/collection/radioactive-pets) ☢️  [AIRDROPS](https://opensea.io/collection/radioactive-artdrops) ☢️  [COOL RANK](https://poprank.io/radioactive-punks)  ☢️  [0% FEE MARKET](https://marketplace.radioactivepunks.xyz)  ☢️\n\nA sludgy series of gen-art punks stored [100% onchain](https://etherscan.io/address/0x5694010444cC8fbbed96c23a65FbC3714F624A26) to ensure they survive nuclear fallout.  You get a sick PFP immune to radiation, full IP rights, and metaverse avatar integrations with [Worldwide Webb](worldwidewebbland)! Featured at Beeple's 2023 Cryptopunk Hangout ✨\n\n20 ultrarares in the set 👀\n\nArt [@pixantle](/pixantle) | Decentralized Tech [@iamwhitelights](/iamwhitelights) | Lore [@muchalec](/0x8003424A854469acb805c517100f8132c6730C21)\n\n🏆  [90/100 Audit by OpenGem](https://opengem.com/audits/score/radioactive-punks/) 🏆",
    exchange_url: "https://opensea.io/collection/radioactive-punks",
    external_url: "https://radioactivepunks.xyz",
    banner_image_url:
      "https://i.seadn.io/gae/VpoB7tQDsk_Onpaky3QwOlZJ_UxwrW2TdKPZ6kA0dHUPlPIEtEkYqz5k9_FPmen72JuRZIsIa49HK-1kKyGK8YjArRFbikZE1n5o?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/HeTVDgjX_Q_LB7OYL-rWnKWFggBcLurUoiOidQXzYhsc1RggxbNW3lzqy3saxrUL0A_14F8iBG8GYeC-U43Hb59Bl908VjxZYPO2?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/HeTVDgjX_Q_LB7OYL-rWnKWFggBcLurUoiOidQXzYhsc1RggxbNW3lzqy3saxrUL0A_14F8iBG8GYeC-U43Hb59Bl908VjxZYPO2?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/32167346d67fe362462caf168ab8d851.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/6XB8amqPCN",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 9.648,
      num_owners: 497,
      floor_price: 0.0098,
      floor_price_symbol: "ETH",
      total_minted: 497,
      total_supply: null,
      total_volume: 19.067472345469966,
      one_day_volume: 0,
      seven_day_volume: 0.012,
      thirty_day_volume: 0.013900000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 420,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.04539874367969039,
      one_day_average_price: 0,
      seven_day_average_price: 0.006,
      thirty_day_average_price: 0.004633333333333334,
    },
    contracts: [
      {
        contract_address: "0x073ca28e04719c05a5a48c1d992091b4075a0f84",
      },
    ],
    id: 401,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:32:22.699Z",
    key: "collectvoxthewalkingdead",
    name: "VOX Collectibles: The Walking Dead",
    description:
      "Meet VOX, the adorable collectible series from Gala. Own, play and earn rewards with your unique ERC721 avatar.\n\nLearn more at [CollectVOX.com](https://www.collectvox.com)",
    exchange_url: "https://opensea.io/collection/collectvoxthewalkingdead",
    external_url: "http://collectvox.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/6eebd378ba5e76265ef5b2afbf54742e.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/9b5e0c463581cc722c9c6baacb6cfaa8.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/9b5e0c463581cc722c9c6baacb6cfaa8.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/OWylmgHIgVkHzd1J0NztnmyKFTeEW6TqAK0mQ4pmYcBZeEMA0pxAGBdhIdM6sxGCKMHjfLlyJJ62dOYVp1olP7N2XYOZk5AphXKahA?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/vzcmSAUbNF",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "gogalagames",
    stats: {
      market_cap: 127.34242714285713,
      num_owners: 2745,
      floor_price: 0.011837,
      floor_price_symbol: "ETH",
      total_minted: 2745,
      total_supply: null,
      total_volume: 2632.9499737623883,
      one_day_volume: 0.0305,
      seven_day_volume: 0.549025,
      thirty_day_volume: 1.3123967499999998,
      one_day_volume_change: -0.032736,
      seven_day_volume_change: -12,
      thirty_day_volume_change: 2,
      total_sales: 5670,
      one_day_sales: 3,
      seven_day_sales: 35,
      thirty_day_sales: 90,
      total_average_price: 0.4643650747376346,
      one_day_average_price: 0.010166666666666666,
      seven_day_average_price: 0.01568642857142857,
      thirty_day_average_price: 0.014582186111111109,
    },
    contracts: [
      {
        contract_address: "0x338be3d8d0209815601e72f7a04ac7f37d61564b",
      },
    ],
    id: 402,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:34:09.933Z",
    key: "monftersclub",
    name: "Monfters Club",
    description:
      "Welcome to Monfters Club. The genesis NFT collection of Monfter, a premier NFT tool suite.",
    exchange_url: "https://opensea.io/collection/monftersclub",
    external_url: "https://www.monfter.com/",
    banner_image_url:
      "https://i.seadn.io/gae/lX5SBM8VyxAYuU8JBdDBn8Y1Wn4eK26N66EL2WrsPh9dNxgGwI_1WM7uGfpiewZNK2E4WG_CX1hR9_EngnpWUvGJscTIr37Ueqw6QQ?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/Ek3c83rPHpEwtlDCKYsq44xDQTfY_xa2r0-Xg-ywZJT8XnTQHtp0cnuWYooRLr6FlJ1esAhORdh3fPz-M7PzbKaDndUNIoO12tqdCw?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/Ek3c83rPHpEwtlDCKYsq44xDQTfY_xa2r0-Xg-ywZJT8XnTQHtp0cnuWYooRLr6FlJ1esAhORdh3fPz-M7PzbKaDndUNIoO12tqdCw?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/LUMJK3aqMXN6taHe04arCY5ZACTFRRmbPRg7e3FBumTzvjift0TeoWa4K5LEoEgvPuKCrgRvpwU6czfACbojwX9S_Y25oUXmyH0ceA?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/monfter",
    telegram_url: "https://t.me/monftercom",
    twitter_username: "monftercom",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 20.556,
      num_owners: 3348,
      floor_price: 0.004,
      floor_price_symbol: "ETH",
      total_minted: 3348,
      total_supply: null,
      total_volume: 3959.9118117854487,
      one_day_volume: 0.0019,
      seven_day_volume: 0.018000000000000002,
      thirty_day_volume: 0.09945455400000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 4,
      thirty_day_volume_change: 40,
      total_sales: 14980,
      one_day_sales: 1,
      seven_day_sales: 7,
      thirty_day_sales: 50,
      total_average_price: 0.26434658289622487,
      one_day_average_price: 0,
      seven_day_average_price: 0.002571428571428572,
      thirty_day_average_price: 0.00198909108,
    },
    contracts: [
      {
        contract_address: "0x5ad0f6563f83b68b69ed3db5dc69e0748a8a2e5c",
      },
    ],
    id: 403,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:33:34.541Z",
    key: "the-alya-valley",
    name: "Alya",
    description:
      "ALYA is a collection of 350 avatars allowing you to enter the Valley: A hub for traders, visionaries, investors, and gamers to build together and explore the infinite possibilities Web3 has to offer. Holding an ALYA NFT grants you access to exclusive knowledge and tools but also a network that will allow you to get the best out of yourself whatever corner of Web3 you decide to specialise on. Together. Learn. Build. Win. Share.",
    exchange_url: "https://opensea.io/collection/the-alya-valley",
    external_url: "https://www.alyavalley.com/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/07014459f241074effdb6fe7f4c77c3d.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/a1ae239856192ac81f4982fca5e0cf3a.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/a1ae239856192ac81f4982fca5e0cf3a.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/46ce76ee4c27bba45fef0839e8754f93.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 3.819,
      num_owners: 169,
      floor_price: 0.032833,
      floor_price_symbol: "ETH",
      total_minted: 169,
      total_supply: null,
      total_volume: 16.11269999997999,
      one_day_volume: 0,
      seven_day_volume: 0.0114,
      thirty_day_volume: 0.09040000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: -1,
      thirty_day_volume_change: 2,
      total_sales: 138,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 4,
      total_average_price: 0.11675869565202893,
      one_day_average_price: 0,
      seven_day_average_price: 0.0114,
      thirty_day_average_price: 0.022600000000000002,
    },
    contracts: [
      {
        contract_address: "0x9faf4d562a2733e53baaa12148854a85bb8a3926",
      },
    ],
    id: 404,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:33:34.057Z",
    key: "apollo-pass",
    name: "Apollo Pass",
    description:
      "A membership club supporting the acceleration of blockchain technology. Our members are the forward-thinking founders, creators and early adopters who were amongst the first to understand why this technology will change the world.\n\nIn addition to membership of our community and early access to partner projects, Pass holders gain free access to exclusive benefits including Apollo’s eco-system token that powers our flagship product Apollo Pay. As well as digital and physical rewards such as Editions – an extraordinary collection of curated digital art.",
    exchange_url: "https://opensea.io/collection/apollo-pass",
    external_url: "https://apollo.xyz/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/9fc44f373bf39bde38531ee9c28b2152.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/bef14156caae18fb242a18dba86dd68c.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/bef14156caae18fb242a18dba86dd68c.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/caf8296fd17a4d1ff36c7e55df13ad81.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 58.1696,
      num_owners: 349,
      floor_price: 0.044897,
      floor_price_symbol: "ETH",
      total_minted: 349,
      total_supply: null,
      total_volume: 5.926058399997835,
      one_day_volume: 0,
      seven_day_volume: 0.0122,
      thirty_day_volume: 0.5147000000000002,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 24,
      total_sales: 125,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 25,
      total_average_price: 0.04740846719998268,
      one_day_average_price: 0,
      seven_day_average_price: 0.0122,
      thirty_day_average_price: 0.020588000000000006,
    },
    contracts: [
      {
        contract_address: "0x1bb602b7a2ef2aecba8fe3df4b501c4c567b697d",
      },
    ],
    id: 405,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:35:10.830Z",
    key: "cosamonstra",
    name: "Cosa Monstra Genesis",
    description:
      "COSA MONSTRA GENESIS is a collection of 1,322 unique NFTs on the Ethereum blockchain by GABOR CSUPO, co-creator of Rugrats, Aaahh!!! Real Monsters, The Wild Thornberrys, Rocket Power and many more childhood classics.\n\nYour COSA MONSTRA GENESIS doubles as an Inkhead Studios Membership Pass with perks, utility and benefits.\n\nOwners of COSA MONSTRA GENESIS have IP & commercial rights with their characters.\n\nCosa Monstra Boss: https://opensea.io/collection/cosamonstraboss-collection\n\nCosa Monstra Augmented: https://opensea.io/collection/cosamonstraaugmented",
    exchange_url: "https://opensea.io/collection/cosamonstra",
    external_url: "https://www.cosamonstra.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/b3f4c507ba266e381ba6d60cb66bc13f.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/5d4f6fbb34a56c785e661da4761ebfb5.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/5d4f6fbb34a56c785e661da4761ebfb5.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/dd3cbf134fd9639329c6bbda32567b4b.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/YExEkvRxr3",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 363,
      floor_price: 0.0479,
      floor_price_symbol: "ETH",
      total_minted: 363,
      total_supply: null,
      total_volume: 162.8885136735637,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.002,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -2,
      total_sales: 1665,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.0978309391432815,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.002,
    },
    contracts: [
      {
        contract_address: "0xfb95762610b09fc586ec6e01fe87b15ab95c15ab",
      },
    ],
    id: 406,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:34:52.416Z",
    key: "psychedelia-man",
    name: "psychedelia man",
    description: null,
    exchange_url: "https://opensea.io/collection/psychedelia-man",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/s/raw/files/771992cb0e920aa63636fa4becfd2810.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 0.1,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x44cf6f7902367eec75b784b87a0c13f8966e680d",
      },
    ],
    id: 407,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:34:51.975Z",
    key: "33-curated-drop-open-editions-featuring-tom-yoo-le",
    name: "33 Curated Drop Open Editions featuring Tom Yoo Lefty Out There and Lach",
    description: null,
    exchange_url:
      "https://opensea.io/collection/33-curated-drop-open-editions-featuring-tom-yoo-le",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url: null,
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 211,
      floor_price: 0.1998,
      floor_price_symbol: "ETH",
      total_minted: 211,
      total_supply: null,
      total_volume: 21.736889999999992,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 80,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.2717111249999999,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x290ec8c839a8e6992319f5e3efd2de069c43080d",
      },
    ],
    id: 408,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:34:41.017Z",
    key: "sheboshis",
    name: "Sheboshis",
    description:
      "SHEboshis are 20000 lovely Shiba Inu generated NFTs. Another step in Shiba Inu's innovation journey, they are an experimental test enabled by the DN404 standard.\r\nTheir story began with the birth of their male partners, SHIBOSHIS. They waited for them, and now they are here. SHEboshis came to spread love. Join the mission.",
    exchange_url: "https://opensea.io/collection/sheboshis",
    external_url: null,
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/4e3d60af4c0a3e4be144adc16aece02c.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/4e3d60af4c0a3e4be144adc16aece02c.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/696b947d650d031f1ee481ab561f5161.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 201.80908264864865,
      num_owners: 1387,
      floor_price: 0.013708,
      floor_price_symbol: "ETH",
      total_minted: 1387,
      total_supply: null,
      total_volume: 2005.3653395471983,
      one_day_volume: 0.045399999999999996,
      seven_day_volume: 0.813126,
      thirty_day_volume: 2.123862979999997,
      one_day_volume_change: 0.045399999999999996,
      seven_day_volume_change: 26,
      thirty_day_volume_change: 35,
      total_sales: 19153,
      one_day_sales: 5,
      seven_day_sales: 74,
      thirty_day_sales: 142,
      total_average_price: 0.10470241421955821,
      one_day_average_price: 0.00908,
      seven_day_average_price: 0.01098818918918919,
      thirty_day_average_price: 0.014956781549295754,
    },
    contracts: [
      {
        contract_address: "0x7b463415d67b013d5f1106fd3df048973bc214dd",
      },
    ],
    id: 409,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:34:21.393Z",
    key: "scientists-by-animeme-labs",
    name: "Scientists by Animeme Labs",
    description:
      "Animeme Labs is a Web3 animation studio with 10 Million fans, 3 Billion views and 11 years of success. Ranging from “Yo Mama” to “Do You Want to Build a Meth Lab?” Welcome to the next generation of Web2, Web3 and Hollywood cartoons. Holders get to live their dream of being a part of an animation studio that knows no limits.",
    exchange_url: "https://opensea.io/collection/scientists-by-animeme-labs",
    external_url: "https://animemelabs.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/20f4c20415412d5490d6549cc0189aa8.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/fb0c7926df6c7eee5ad840b59878c60d.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/fb0c7926df6c7eee5ad840b59878c60d.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/xjYpaSrssrLgEljh0OGhJt-CQRpo9hRE2z3fMG08BmH8H2O51LFXKyYhNpakvnPK_5bjvrwokmmYScoVB8ynkyjJqgVq3o0H1wke2A?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 1.332,
      num_owners: 408,
      floor_price: 0.014,
      floor_price_symbol: "ETH",
      total_minted: 408,
      total_supply: null,
      total_volume: 16.4857539,
      one_day_volume: 0,
      seven_day_volume: 0.002,
      thirty_day_volume: 0.002,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 1,
      total_sales: 341,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 1,
      total_average_price: 0.048345319354838705,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.002,
    },
    contracts: [
      {
        contract_address: "0xb0bbbc0f43d611351b3115bd5e338f4c402ae8c2",
      },
    ],
    id: 410,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:34:14.072Z",
    key: "paradise-lost-by-ren",
    name: "Paradise Lost by Ren",
    description: null,
    exchange_url: "https://opensea.io/collection/paradise-lost-by-ren",
    external_url: "https://braindrops.cloud/",
    banner_image_url:
      "https://i.seadn.io/gae/t0_woEGvWyRRM9HyYnqd7oz--41yerZYave9nd2TmaECc0mdPZa2K12MvMlUsrouaVjV9kSSQPlUn7yhZ0AfzW2kSxdVUmmsiVaESg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/8c086efa657175f30891dc98dc2bb15e.jpg?w=500&auto=format",
    large_image_url: null,
    image_url:
      "https://i.seadn.io/s/raw/files/8c086efa657175f30891dc98dc2bb15e.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 5.208333333333332,
      num_owners: 279,
      floor_price: 0.015,
      floor_price_symbol: "ETH",
      total_minted: 279,
      total_supply: null,
      total_volume: 33.54687735987,
      one_day_volume: 0.0086,
      seven_day_volume: 0.12499999999999997,
      thirty_day_volume: 0.13499999999999998,
      one_day_volume_change: -0.0814,
      seven_day_volume_change: 12,
      thirty_day_volume_change: 8,
      total_sales: 413,
      one_day_sales: 1,
      seven_day_sales: 12,
      thirty_day_sales: 13,
      total_average_price: 0.0812273059561017,
      one_day_average_price: 0,
      seven_day_average_price: 0.010416666666666664,
      thirty_day_average_price: 0.010384615384615383,
    },
    contracts: [
      {
        contract_address: "0xdfde78d2baec499fe18f2be74b6c287eed9511d7",
      },
    ],
    id: 411,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:36:01.009Z",
    key: "tmwstw",
    name: "TMWSTW / The Man Who Sold The World",
    description:
      "Spherical earthlike MMORPG Metaverse of 10K NFT plots of land with resource based economy",
    exchange_url: "https://opensea.io/collection/tmwstw",
    external_url: "https://tmwstw.io/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/8e96cd546062b881e74deeb00e006df8.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/e0d7fb613b811b3baec891dd61739a64.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/e0d7fb613b811b3baec891dd61739a64.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/5cccd54ce7d1b1e509d8bb5b37022375.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/d56axYmRTa",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 58.53368462499999,
      num_owners: 601,
      floor_price: 0.007451,
      floor_price_symbol: "ETH",
      total_minted: 601,
      total_supply: null,
      total_volume: 52.425203480000235,
      one_day_volume: 0,
      seven_day_volume: 0.09368199999999999,
      thirty_day_volume: 0.20233200000000007,
      one_day_volume_change: 0,
      seven_day_volume_change: 14,
      thirty_day_volume_change: 5,
      total_sales: 1732,
      one_day_sales: 0,
      seven_day_sales: 16,
      thirty_day_sales: 36,
      total_average_price: 0.030268593233256487,
      one_day_average_price: 0,
      seven_day_average_price: 0.005855124999999999,
      thirty_day_average_price: 0.005620333333333335,
    },
    contracts: [
      {
        contract_address: "0xeed10864e9fd813d12a0f40eb5f73ff2d31b2abb",
      },
    ],
    id: 412,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:35:41.114Z",
    key: "ether-orcs",
    name: "EtherOrcs Genesis",
    description:
      "ACTUAL OWNER COUNT: 1520 as of 8/23/22 with 93% staked in gameplay.\n\nEtherOrcs Allies: https://opensea.io/collection/etherorcsallies\n\nEtherOrcs Loot: https://opensea.io/collection/etherorcsloot\n\nEtherOrcs Items: https://opensea.io/collection/etherorcs-items\n\nEtherOrcs is a collection of 5050 Orcs ready to pillage the blockchain. With no IPFS or API, these Orcs are the very first game that takes place 100% on-chain. \n\nUse your Orc to explore the world of Valkala, crawling real time dungeons, crafting equipment, and customizing your character and builds.\n\nVisit our site to learn more: https://etherorcs.com/",
    exchange_url: "https://opensea.io/collection/ether-orcs",
    external_url: "https://etherorcs.com/",
    banner_image_url:
      "https://i.seadn.io/gae/S_BAPZIdMoPD4YkUyP0nVv8K29JDudeXUFb-C6L164rhWTrsmebInAgXUZEuPaiA7k4GY0U8ZWIa83YxhIUZN2-CoId-85x8pomiXQ?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/986d6e47e335d824c7c4475ead6b9e0e.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/986d6e47e335d824c7c4475ead6b9e0e.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/986d6e47e335d824c7c4475ead6b9e0e.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: "etherorcs",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 80.51043,
      num_owners: 459,
      floor_price: 0.0293,
      floor_price_symbol: "ETH",
      total_minted: 459,
      total_supply: null,
      total_volume: 6448.276560072589,
      one_day_volume: 0.0114,
      seven_day_volume: 0.048258,
      thirty_day_volume: 0.20659699999999998,
      one_day_volume_change: 0.0114,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 6744,
      one_day_sales: 1,
      seven_day_sales: 3,
      thirty_day_sales: 10,
      total_average_price: 0.9561501423595179,
      one_day_average_price: 0,
      seven_day_average_price: 0.016086,
      thirty_day_average_price: 0.0206597,
    },
    contracts: [
      {
        contract_address: "0x3abedba3052845ce3f57818032bfa747cded3fca",
      },
    ],
    id: 413,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:35:30.838Z",
    key: "yogurt-verse",
    name: "Yogurt Verse",
    description:
      "Welcome to YogurtVerse. Purchase an alpha pass to gain access to a discord of 321 highly skilled NFT traders https://discord.gg/p2FZBUWTDn",
    exchange_url: "https://opensea.io/collection/yogurt-verse",
    external_url: "https://www.yogurtverse.xyz/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/39b34042120d31569d0e5c12391e555c.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/67a153bffae1ab085a1be85cdb908e51.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/67a153bffae1ab085a1be85cdb908e51.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/67a153bffae1ab085a1be85cdb908e51.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/UmnCcGn6BH",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 81.92,
      num_owners: 313,
      floor_price: 0.337765999999796,
      floor_price_symbol: "ETH",
      total_minted: 313,
      total_supply: null,
      total_volume: 558.5489876048996,
      one_day_volume: 0,
      seven_day_volume: 1.536,
      thirty_day_volume: 8.527365999999999,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -6,
      total_sales: 1438,
      one_day_sales: 0,
      seven_day_sales: 6,
      thirty_day_sales: 27,
      total_average_price: 0.3884207146070234,
      one_day_average_price: 0,
      seven_day_average_price: 0.256,
      thirty_day_average_price: 0.3158283703703703,
    },
    contracts: [
      {
        contract_address: "0xc34cc9f3cf4e1f8dd3cde01bbe985003dcfc169f",
      },
    ],
    id: 414,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:36:42.391Z",
    key: "magnum-nft",
    name: "Magnum by Thrush Holmes",
    description:
      "Other Collections\n- [Magnum Limited](https://opensea.io/collection/magnumlimited)\n- [Genesis Cubes](https://opensea.io/collection/genesis-cubes)\n\nThrush Holmes is a Canadian painter who explores traditional artistic themes in an aggressive, unapologetically contemporary way, contrasting poetic tropes with a punk sensibility. Discover his collection of 999 NFTs created from in studio works. All pieces are derived from physical elements from Thrush's studio. \n\n[Website](http://magnum.thrushholmes.com)\n[Discord](https://discord.gg/PKhyaHjFBe)\n[Twitter](https://twitter.com/thrushholmes)\n[Instagram](https://instagram.com/thrush_holmes)",
    exchange_url: "https://opensea.io/collection/magnum-nft",
    external_url: "http://magnum.thrushholmes.com",
    banner_image_url:
      "https://i.seadn.io/gae/NJPLHZRr6coQIVqw_40nY4eikbKeNRFEm4jzcagiEgtq2t1kJ-VnT58cx3RJ6zXJBxkQe0tywJcgyMdjlEGttLop2AY-RPULibkDuw?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/JcrpFkQEWoQjishXau0_dhyqZsFUzNEEjIjL1oCjTpJWDNaVyA9MWoYKJvGBnTe6zo7bBtUw_XPsMpTVQWssKUZdxk6G2_HlW2sO?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/JcrpFkQEWoQjishXau0_dhyqZsFUzNEEjIjL1oCjTpJWDNaVyA9MWoYKJvGBnTe6zo7bBtUw_XPsMpTVQWssKUZdxk6G2_HlW2sO?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/slimg6Qmpagvadz4N3Vf7Zsbm7iCwD1yhF8OXnoujuecDB9zKel2Awajm1O8AKW5sAyhLE45J9s5heT4bX7RPOFkNyRqs8rMgZR5PA?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/PKhyaHjFBe",
    telegram_url: null,
    twitter_username: "thrushholmes",
    wiki_url: null,
    instagram_username: "thrush_holmes",
    stats: {
      market_cap: 0,
      num_owners: 364,
      floor_price: 0.05,
      floor_price_symbol: "ETH",
      total_minted: 364,
      total_supply: null,
      total_volume: 13.885533835025441,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 223,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.062266967870069245,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x9523b6429924e4fac50568572cf1d24697190c1d",
      },
    ],
    id: 415,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:36:37.589Z",
    key: "current-events",
    name: "Current Events",
    description:
      "NFT Art that raises the bar. Current Events can be all types of Photography.",
    exchange_url: "https://opensea.io/collection/current-events",
    external_url: null,
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/147b715de79419cfad02fa3d26dd62b0.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/147b715de79419cfad02fa3d26dd62b0.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/01971df4af3f0d376b771c531c96e3db.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 6,
      floor_price: 0.15,
      floor_price_symbol: "ETH",
      total_minted: 6,
      total_supply: null,
      total_volume: 3.543,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 15,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.23620000000000002,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x9ab95a577cee62b87ddd4ec1eba2966a546d72ba",
      },
    ],
    id: 416,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:36:37.177Z",
    key: "bad-bunnies-nft",
    name: "Bad Bunnies NFT",
    description:
      "Bad Bunnies are a collection of hand-drawn, randomly generated NFTs, playing cards and an upcoming digital P2E Trading Card game - PAW WARZ! Bad Bunnies hold unique utility in PAW WARZ with each Bad Bunny to be represented as a 1/1 unique FULL BODY BUNNY in-game card. Get your Bunnies and dig, hop and brawl your way to victory!",
    exchange_url: "https://opensea.io/collection/bad-bunnies-nft",
    external_url: "https://badbunnies.xyz/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/fd37201d79c69575dd0104bc3746b1ce.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/c96abba476a5c962fdc6ec02d5eab0f2.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/c96abba476a5c962fdc6ec02d5eab0f2.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/99652797ce35e4adf4980645228f9d0b.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/aHJxGa3fYJ",
    telegram_url: null,
    twitter_username: "BadBunniesNFT",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1792,
      floor_price: 0.006,
      floor_price_symbol: "ETH",
      total_minted: 1792,
      total_supply: null,
      total_volume: 1614.7329344287082,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0243,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 7,
      total_sales: 8328,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 10,
      total_average_price: 0.19389204303898994,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.00243,
    },
    contracts: [
      {
        contract_address: "0x103ffe3aee66a048e22821145a00c4cabc0ff05b",
      },
    ],
    id: 417,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:36:33.068Z",
    key: "smilesss",
    name: "Smilesss",
    description:
      "The Smilesss collection consists of a generative full-body character designed by artist Waheed Zai. The collection of 8,888 NFTs was born out of the cultural crossroads of art, hip-hop, fashion and technology. Reimagining how fashion is experienced, we're pushing and flexing the boundaries across physical and digital realms.\n\nOther Official Collections:   \n[Smilesss x Shiesty Season](https://opensea.io/collection/smilesss-x-shiesty-season)  \n[Smilesss Collabs](https://opensea.io/collection/smilesss-collabs)  \n[Verifry'd Smilesss](https://opensea.io/collection/verifryd-smilesss)",
    exchange_url: "https://opensea.io/collection/smilesss",
    external_url: "https://www.smilesss.com",
    banner_image_url:
      "https://i.seadn.io/gae/Vtp93o3Ox6d2sjm0J--aYsksc9X7KcLs-M8XhPlYM9F82Sse5MTLIHjvGPekgizm7qdn5FYRkkIFuu7C6rV8bAMZP5S64Sd50Nvp?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/BPdQKm2Occ_hKbitaSuQqRNnHKXVyqZBfYz1vU82IgFSOKH7u2PBAo9RN9DbrZsnJJTifXJBL_yVGLIcJPPcYv1eqkGMjEvly8BLvg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/BPdQKm2Occ_hKbitaSuQqRNnHKXVyqZBfYz1vU82IgFSOKH7u2PBAo9RN9DbrZsnJJTifXJBL_yVGLIcJPPcYv1eqkGMjEvly8BLvg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/foDsTZSggCB_0Fjb12XLaWPMwYCj2W8BkNI31M-xYm78o9nGHU9ysI1gQG9GNva92YmewirwqXJpE1xOqJBnXKq1zxkRaAf4A8Wb?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: "smilesssvrs",
    wiki_url: null,
    instagram_username: "smilesssvrs",
    stats: {
      market_cap: 75.91886020437204,
      num_owners: 3924,
      floor_price: 0.0078,
      floor_price_symbol: "ETH",
      total_minted: 3924,
      total_supply: null,
      total_volume: 11094.886880144351,
      one_day_volume: 0.4690000000000001,
      seven_day_volume: 1.8535719899999985,
      thirty_day_volume: 3.7315658899999935,
      one_day_volume_change: -0.3854789900000005,
      seven_day_volume_change: 213,
      thirty_day_volume_change: 113,
      total_sales: 19460,
      one_day_sales: 39,
      seven_day_sales: 215,
      thirty_day_sales: 299,
      total_average_price: 0.5701380719498639,
      one_day_average_price: 0.012025641025641028,
      seven_day_average_price: 0.008621265069767434,
      thirty_day_average_price: 0.012480153478260848,
    },
    contracts: [
      {
        contract_address: "0x177ef8787ceb5d4596b6f011df08c86eb84380dc",
      },
    ],
    id: 418,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:36:25.294Z",
    key: "theo-nft",
    name: "NFTheo",
    description:
      "NFTheo is an art project of 3000 unique NFT Teddy Bears. Every Theo is one of a kind.\n\nThis project is entirely about the art, so manage your expectations accordingly.\n\nThere will only ever be 3000 Theos, comprised of multiple themed sets and ANIMATED Legendary Theos.",
    exchange_url: "https://opensea.io/collection/theo-nft",
    external_url: "http://assemble.nftheo.com",
    banner_image_url:
      "https://i.seadn.io/gae/nANFfUaCqEeEC2cD6I5czeXeqyn_UmKMAQ6F7v-ic4Mz1Gfc790hFuZ5NcCDHgMQOjWnAKrPLPxnuxotLEJTOOn3Rdk9ePVD_pz8?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/B3zYqlC093LnGlXu-3GXhKnMNjZz3wwDNM4QD9nZ6L5EUOXGG10e7jzMGm-Eb21dtiqO2Duh_QzLxmn5M1SyN1dYswZR1-zAwlMp1g?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/WFMAwPTT2U",
    telegram_url: null,
    twitter_username: "TheoNFT",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1142,
      floor_price: 0.0013,
      floor_price_symbol: "ETH",
      total_minted: 1142,
      total_supply: null,
      total_volume: 541.4253864189227,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.013600000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -5,
      total_sales: 2773,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 3,
      total_average_price: 0.19524896733462774,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.004533333333333334,
    },
    contracts: [
      {
        contract_address: "0x9e02ffd6643f51aaafa0f0e2a911bf25ef2684cb",
      },
    ],
    id: 419,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:36:20.948Z",
    key: "x-key",
    name: "X-Keys by Planet-X",
    description:
      "A collection of 500 X-Keys which have the ability to unlock X-Crates and other unique benefits in the Planet-X eco-system.",
    exchange_url: "https://opensea.io/collection/x-key",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/9840b0c0d417bb564c1a5fab002eedaf.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/9e373e4f459ee1cef7136619419ecb2f.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/9e373e4f459ee1cef7136619419ecb2f.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/5744dc56e7d6348ca6f3b1212cae5782.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/planet-x",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 34.56301393332216,
      num_owners: 143,
      floor_price: 0.089999,
      floor_price_symbol: "ETH",
      total_minted: 143,
      total_supply: null,
      total_volume: 55.32330949888122,
      one_day_volume: 0,
      seven_day_volume: 0.630967799999796,
      thirty_day_volume: 2.0686667999997956,
      one_day_volume_change: 0,
      seven_day_volume_change: 4,
      thirty_day_volume_change: 3,
      total_sales: 569,
      one_day_sales: 0,
      seven_day_sales: 9,
      thirty_day_sales: 26,
      total_average_price: 0.09722901493652236,
      one_day_average_price: 0,
      seven_day_average_price: 0.07010753333331067,
      thirty_day_average_price: 0.07956410769229984,
    },
    contracts: [
      {
        contract_address: "0xbcbba981bff1e9530cbca0f40f67aa85f8944038",
      },
    ],
    id: 420,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:36:20.452Z",
    key: "decentraland-wearables",
    name: "Decentraland Wearables",
    description:
      "Decentraland is an Ethereum blockchain-powered virtual world, developed and owned by its users, who can create, experience, and monetize content and applications. Wearables are worn in game by avatars, and collecting and trading these unique NFTs is a great way for users to integrate themselves into the growing community. The digital assets are dropped in limited-edition collections, and will be available to purchase right here in this store.",
    exchange_url: "https://opensea.io/collection/decentraland-wearables",
    external_url: "https://decentraland.org/",
    banner_image_url:
      "https://i.seadn.io/gcs/static/banners/dclwearables-banner.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/2jmnuuF-fHgazzVXwiEQh0OsjGgEjVz4ECYP8GMmP0yommN4Xj1J242MoRWZGwiYCtRx_eb8fUa7aHuo4XsA2ZYcJTx0HwJBacMs?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/2jmnuuF-fHgazzVXwiEQh0OsjGgEjVz4ECYP8GMmP0yommN4Xj1J242MoRWZGwiYCtRx_eb8fUa7aHuo4XsA2ZYcJTx0HwJBacMs?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/5KIxEGmnAiL5psnMCSLPlfSxDxfRSk4sTQRSyhPdgnu70nGb2YsuVxTmO2iKEkOZOfq476Bl1hAu6aJIKjs1myY?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/svZP5W7tmq",
    telegram_url: null,
    twitter_username: "decentraland",
    wiki_url: null,
    instagram_username: "decentraland_foundation/",
    stats: {
      market_cap: 0,
      num_owners: 11098,
      floor_price: 10,
      floor_price_symbol: "MANA",
      total_minted: 11098,
      total_supply: null,
      total_volume: 4237.183100055001,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0493,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -20,
      total_sales: 18490,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 6,
      total_average_price: 0.22916079502731213,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.008216666666666666,
    },
    contracts: [
      {
        contract_address: "0x09305998a531fade369ebe30adf868c96a34e813",
      },
    ],
    id: 421,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:38:58.231Z",
    key: "inft-assets-by-alethea-ai",
    name: "iNFT Assets by Alethea AI",
    description:
      "Alethea AI is building a decentralized iNFT Protocol to create an Intelligent Metaverse inhabited by Interactive and Intelligent NFTs. iNFT Assets not only enable iNFTs to enhance their capabilities but also own and evolve critical aspects of their identity.\r\n\r\nTOS: https://alethea.ai/pods/ARKIV",
    exchange_url: "https://opensea.io/collection/inft-assets-by-alethea-ai",
    external_url: "https://alethea.ai/",
    banner_image_url:
      "https://i.seadn.io/gae/2mTS35wxKPXPR8bc8yvNCGB5agoe7BQSCtwy8vjXkBOhdDrTMJE9ahwBSkpdAB6HBTfBEp_kjeYEGddfaOYRGqkVpo-3OeMvmGIS?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/_ZOA2EER0upz2YCQtMDMpv8cmU7X4yZoRjA2P2mz61tNJ-XZPYuKaRaT3GFKGalcRHRoWbE35EARrCYagPU4BsPqSbs1JehHRACHcT4?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/_ZOA2EER0upz2YCQtMDMpv8cmU7X4yZoRjA2P2mz61tNJ-XZPYuKaRaT3GFKGalcRHRoWbE35EARrCYagPU4BsPqSbs1JehHRACHcT4?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/l83Ga13cRv53TOuLzPji49oyCQ2SZW4e2e7gp4CNC2R0w82Y3JoYS6JvkKMe4TJnLdWCkydZrNoXTyUH05iN39M7grHnJSGbDXLVKwQ?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/aletheaai",
    telegram_url: "https://t.me/alethea_ai",
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 23.08464,
      num_owners: 860,
      floor_price: 0.01487,
      floor_price_symbol: "ETH",
      total_minted: 860,
      total_supply: null,
      total_volume: 36.8821681579877,
      one_day_volume: 0,
      seven_day_volume: 0.0246,
      thirty_day_volume: 0.12291900000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: -6,
      thirty_day_volume_change: 7,
      total_sales: 692,
      one_day_sales: 0,
      seven_day_sales: 5,
      thirty_day_sales: 18,
      total_average_price: 0.053297930864144076,
      one_day_average_price: 0,
      seven_day_average_price: 0.00492,
      thirty_day_average_price: 0.006828833333333334,
    },
    contracts: [
      {
        contract_address: "0xce69a87c02baa8c5f17ed7eb8b1c2657afc2e1af",
      },
    ],
    id: 422,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:38:48.093Z",
    key: "8-bit-budgies",
    name: "8-Bit Budgies",
    description:
      "**8-Bit Budgies are here!**\n\nMinted early 2021. There are 401 Budgies, stacked with rarity traits, including some 'special budgies'.  Some traits to look out for: \n\n- Angel \n- Heisenberg hat\n- Stoned eyes\n- Broken beak\n- Shades\n- Top hat \n- Cyclops\n- Medalion \n- Cigar\n- Miniature Budgies\n- Geek glasses  \n...and lots more! \n\nFull rarity ranking can be found in Discord: \n\n[Join the Budgies Discord: https://discord.com/invite/Nw5AHhMq9m](https://discord.com/invite/Nw5AHhMq9m) \n\n***Twitter: @BudgiesNFT***",
    exchange_url: "https://opensea.io/collection/8-bit-budgies",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/0cf6428bbdf100541aa8731df9309666.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/ijNJCBMba5LEUJQbYHk8ei2xdKdDlQZobQUD2L7O_Ej1QAkvgzQsvbIjZWsGrHEaAc0yN5tMK9W6JLEhIdN9pUrOdWUs7X5insGB?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/ijNJCBMba5LEUJQbYHk8ei2xdKdDlQZobQUD2L7O_Ej1QAkvgzQsvbIjZWsGrHEaAc0yN5tMK9W6JLEhIdN9pUrOdWUs7X5insGB?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/7147631c1b4b17e11e9e7fc2361a7589.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/VH75DMBk",
    telegram_url: null,
    twitter_username: "budgiesnft",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 143,
      floor_price: 0.01,
      floor_price_symbol: "ETH",
      total_minted: 143,
      total_supply: null,
      total_volume: 8.648189999999984,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0219,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 2,
      total_sales: 406,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 2,
      total_average_price: 0.021300960591132966,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.01095,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 423,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:38:29.407Z",
    key: "omgkirby-genesis",
    name: "omgkirby Genesis",
    description:
      "The omgkirby genesis collection includes the release of 3,000 unique pieces of generative lofi music. Each song and its accompanying visual is created via a beautiful cooperation between human and machine. The individual NFTs are a novel combination of algorithmically-assisted music and hand-drawn art. NFT holders will have complete ownership of the song in its entirety, including Master Recording and Publishing rights. ",
    exchange_url: "https://opensea.io/collection/omgkirby-genesis",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gae/tCzAUdO0ujJ68SSMFDlATbbbyDqzfzFqD9EofwmjHz71vgpCuA_MZ9iGF8v3TALdGcEqptGJ-ymh_P8Fw_6ThKDQ2okgv_9m_xPAIb0?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/tCzAUdO0ujJ68SSMFDlATbbbyDqzfzFqD9EofwmjHz71vgpCuA_MZ9iGF8v3TALdGcEqptGJ-ymh_P8Fw_6ThKDQ2okgv_9m_xPAIb0?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/tCzAUdO0ujJ68SSMFDlATbbbyDqzfzFqD9EofwmjHz71vgpCuA_MZ9iGF8v3TALdGcEqptGJ-ymh_P8Fw_6ThKDQ2okgv_9m_xPAIb0?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/CO64oiGOdZ3TLtpiD13lZVpN5mKiJLfOHpAns3WH9VhzVjAlk1kOmr2UT8ENF5f-oYFeO-md_AHGwFmXtdEcvX64Vq7yH6Ca2RPo6w?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/omgkirby",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "omgkirby_",
    stats: {
      market_cap: 11.633849333333334,
      num_owners: 1703,
      floor_price: 0.008452,
      floor_price_symbol: "ETH",
      total_minted: 1703,
      total_supply: null,
      total_volume: 922.0483283326867,
      one_day_volume: 0,
      seven_day_volume: 0.011708000000000001,
      thirty_day_volume: 0.033506,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 4914,
      one_day_sales: 0,
      seven_day_sales: 3,
      thirty_day_sales: 8,
      total_average_price: 0.18763702245272418,
      one_day_average_price: 0,
      seven_day_average_price: 0.003902666666666667,
      thirty_day_average_price: 0.00418825,
    },
    contracts: [
      {
        contract_address: "0xafef885027a59603dff7837c280dad772c476b82",
      },
    ],
    id: 424,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:38:28.966Z",
    key: "pathfinders-by-luxpris",
    name: "Pathfinders by luxpris",
    description:
      "Art Blocks Collection: Presents\n\nHeritage Art Blocks Collection: Playground\n\nProject Description: Pathfinders is an interactive generative drawing project. The script sets color palettes, brush textures, a unique avatar, and assorted start screen layouts from token data. When viewing Pathfinders, left-click the starting image to erase your canvas and watch the deterministically chosen brush trail across the screen. When you are satisfied with the output, left-click again to pause, right-click and save your image, then share your results with others.",
    exchange_url: "https://opensea.io/collection/pathfinders-by-luxpris",
    external_url: "https://artblocks.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/ef2c459a8ae055f06e76a22d8b1c468c.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/fPFuj3Hl-6UYifskDxADvMT1QoetDgVjdxObKG7ejwrfhfYpAH0oLr-VPNda5dvz5rS7OyZDU2p9AlGw0hGV4lhTeIf22L0bIY0Lwew?w=500&auto=format",
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/fPFuj3Hl-6UYifskDxADvMT1QoetDgVjdxObKG7ejwrfhfYpAH0oLr-VPNda5dvz5rS7OyZDU2p9AlGw0hGV4lhTeIf22L0bIY0Lwew?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 6.7,
      num_owners: 502,
      floor_price: 0.0246626,
      floor_price_symbol: "ETH",
      total_minted: 502,
      total_supply: null,
      total_volume: 733.6023786358203,
      one_day_volume: 0,
      seven_day_volume: 0.0067,
      thirty_day_volume: 0.07479999999999999,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: -4,
      total_sales: 1369,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 5,
      total_average_price: 0.5358673328238278,
      one_day_average_price: 0,
      seven_day_average_price: 0.0067,
      thirty_day_average_price: 0.014959999999999998,
    },
    contracts: [
      {
        contract_address: "0xa7d8d9ef8d8ce8992df33d8b8cf4aebabd5bd270",
      },
    ],
    id: 425,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:38:14.448Z",
    key: "mistletoadz",
    name: "MistleToadz by GREMPLIN",
    description:
      "A festive, warty, amphibious creature spawned from the metaverse in the holiday season of 2021",
    exchange_url: "https://opensea.io/collection/mistletoadz",
    external_url: "https://cryptoadz.io",
    banner_image_url:
      "https://i.seadn.io/gae/3zjvakTZSqaNxuj0GZlyxjMkVjngg_5H9YA5P-TRoDCXH6VYYlZ89C-POERG98busWdGCMl2UPBGZ9hDTj4T0TnIDFI-vIJuQPEXjQ?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/vhTXzo8apGMs8bPy-cnUNBA0B1mxITnS8mtVjNPXL5u_fhMbQTYr_yD5OamC_p6NYyMBoxR4K4JEclZ3kvFEv9MCxhdbD8Cxn8uIrw?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/vhTXzo8apGMs8bPy-cnUNBA0B1mxITnS8mtVjNPXL5u_fhMbQTYr_yD5OamC_p6NYyMBoxR4K4JEclZ3kvFEv9MCxhdbD8Cxn8uIrw?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/vhTXzo8apGMs8bPy-cnUNBA0B1mxITnS8mtVjNPXL5u_fhMbQTYr_yD5OamC_p6NYyMBoxR4K4JEclZ3kvFEv9MCxhdbD8Cxn8uIrw?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/qSFAu4uU",
    telegram_url: null,
    twitter_username: "cryptoadzNFT",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1960,
      floor_price: 0.012499,
      floor_price_symbol: "ETH",
      total_minted: 1960,
      total_supply: null,
      total_volume: 245.47958581967094,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.028296999899999998,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -42,
      total_sales: 3561,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 3,
      total_average_price: 0.06893557591116847,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.009432333299999998,
    },
    contracts: [
      {
        contract_address: "0x7fcbb823ff16110e5a14c3c897dc0af334423e4f",
      },
    ],
    id: 426,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:39:59.508Z",
    key: "s-p-100",
    name: "S&P 100 - Live Market Cap Pricing",
    description:
      "Where every stock is worth its' market cap as of today. Buy now and never sell for less than the CAP. The decentralized 1 of 1 Standard and Poor's market. Every coin was minted with their market cap as of 2/12/25 per Bloomberg terminal pricing, scaled down. Let's drive these prices to normal market price. ",
    exchange_url: "https://opensea.io/collection/s-p-100",
    external_url: null,
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/42c362fd6214fcaf981886c723dea652.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/42c362fd6214fcaf981886c723dea652.jpg?w=500&auto=format",
    image_url: null,
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 0.262,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x156d3c7619b7f62a8841af5d3c8cd19137816788",
      },
    ],
    id: 427,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:39:59.105Z",
    key: "sheet-fighter",
    name: "Sheet Fighter",
    description:
      "💥 ChatGPT generated fighting spreadsheets.  \n\n🔗 100% On-ETH Chain.\n\n📝 Launched Feb 2022. 😎 We did it before it was cool. \n\n*Unique owner count does not account for staked Sheet Fighters.",
    exchange_url: "https://opensea.io/collection/sheet-fighter",
    external_url: "https://sheetfighter.io/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/c91acf3d328e053f95739d961bee7455.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/c2dca5dd6adaea72b3c6e63df66d37b6.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/c2dca5dd6adaea72b3c6e63df66d37b6.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/22497243fc634b9f786772d19256e372.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/AEWCdcWKpH",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0.0000884,
      num_owners: 1056,
      floor_price: 0.019854600361639323,
      floor_price_symbol: "ETH",
      total_minted: 1056,
      total_supply: null,
      total_volume: 1581.5575147136717,
      one_day_volume: 0,
      seven_day_volume: 4e-8,
      thirty_day_volume: 5.0725e-8,
      one_day_volume_change: 0,
      seven_day_volume_change: 4,
      thirty_day_volume_change: 5,
      total_sales: 9359,
      one_day_sales: 0,
      seven_day_sales: 4,
      thirty_day_sales: 5,
      total_average_price: 0.16898787420810682,
      one_day_average_price: 0,
      seven_day_average_price: 1e-8,
      thirty_day_average_price: 1.0145e-8,
    },
    contracts: [
      {
        contract_address: "0x0c734134d68adbc6eeeb7477f77409fdf7bc9dee",
      },
    ],
    id: 428,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:39:58.713Z",
    key: "yeethzeditionz",
    name: "yeethz editionz",
    description: "yeethz editionz on eth minted with my own manifold contract",
    exchange_url: "https://opensea.io/collection/yeethzeditionz",
    external_url: "https://linktr.ee/yeethz",
    banner_image_url:
      "https://i.seadn.io/gcs/files/95ae7eb0e1c31820b1d04e5bf2d7a23d.gif?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/09e5b2330b6891db2d57fecd0e139f43.gif?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/09e5b2330b6891db2d57fecd0e139f43.gif?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/09e5b2330b6891db2d57fecd0e139f43.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/2crpZGtnNU",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1585,
      floor_price: 0.0269,
      floor_price_symbol: "ETH",
      total_minted: 1585,
      total_supply: null,
      total_volume: 1.7715899999999989,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 76,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.023310394736842092,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x6d6776b068a01257e5a54a2fa1b2e393760415cb",
      },
    ],
    id: 429,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T00:39:44.551Z",
    key: "line-gardens",
    name: "Line Gardens",
    description:
      "Line Gardens are 365 randomly generated works developed by me, Kushgrandma. Line Gardens depict the tension and flow of simple shapes and colors as they compound across the canvas. All code written in p5.js",
    exchange_url: "https://opensea.io/collection/line-gardens",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gae/w1eCzAlC4pR33FQTnylTV07N7vZW8RJ1S58dSkqDjDZqd1DX1_yh5G37R7IQzYKDelnt11tkXjLKLLr9uj_HFMoE_OYdb2u8_k6_bA?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/Qz6rytBVQBBXMv7F4BG_OvvwbZRw080viY9EksdaKVTTzk_VMgF--8tv6zcjk-qFT7wOrE-9zdjTN_PMPGEh5KOKNJOoqFc4sfQb?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/Qz6rytBVQBBXMv7F4BG_OvvwbZRw080viY9EksdaKVTTzk_VMgF--8tv6zcjk-qFT7wOrE-9zdjTN_PMPGEh5KOKNJOoqFc4sfQb?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/O0FxulLHRbt--v3SXPBxAwhZRRQsbgJtECtPSG1DUSfQsq-Wj6BL30KYNv4xjIpF_2mVZDXr7MtKp97mmhMFGGeWgatzuDBltflfkw?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 249,
      floor_price: 0.00575820012040905,
      floor_price_symbol: "ETH",
      total_minted: 249,
      total_supply: null,
      total_volume: 86.17528899999989,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 463,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.18612373434125246,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x016cb05fe18c0960a605a3a25320439c20824aac",
      },
    ],
    id: 430,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:42:59.310Z",
    key: "elmonx-charles-salvador-excessive-incarceration",
    name: "ElmonX x Charles Salvador Bronson Excessive Incarceration",
    description:
      "Charles Salvador, one of Britain’s most notorious prisoners, has spent 50 years behind bars since 1974. To mark this remarkable milestone of survival, ElmonX presents 50 exclusive physical and digital pieces, each crafted by Charles Salvador ‘Bronson’ on authentic prison paper. \r\n\r\nThe physical artwork is available to the primary buyer. ElmonX and Charles Salvador 'Bronson' does not accept responsibility for failure to acknowledge this status. To redeem your piece, please contact support@elmonx.com or open a support ticket on the ElmonX Discord: https://discord.gg/elmonx.",
    exchange_url:
      "https://opensea.io/collection/elmonx-charles-salvador-excessive-incarceration",
    external_url: "https://ElmonX.com",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/5488efc5d3d4289085cb3b1bb5107a24.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/5488efc5d3d4289085cb3b1bb5107a24.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/0e86e53f72acadc4240c2607f31d5e09.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/elmonx",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 41,
      floor_price: 0.06485,
      floor_price_symbol: "ETH",
      total_minted: 41,
      total_supply: null,
      total_volume: 0.3663,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 5,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.07326,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x7838c71c33b21776c0017a751bc27912e419e689",
      },
    ],
    id: 431,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:42:48.349Z",
    key: "weird",
    name: "WEIRD",
    description: null,
    exchange_url: "https://opensea.io/collection/weird",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url: null,
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0.4685727272727273,
      num_owners: 207,
      floor_price: 0.0059,
      floor_price_symbol: "ETH",
      total_minted: 207,
      total_supply: null,
      total_volume: 32.83344013254424,
      one_day_volume: 0.0621,
      seven_day_volume: 0.0621,
      thirty_day_volume: 0.26059999999999994,
      one_day_volume_change: 0.0621,
      seven_day_volume_change: 10,
      thirty_day_volume_change: 44,
      total_sales: 503,
      one_day_sales: 11,
      seven_day_sales: 11,
      thirty_day_sales: 46,
      total_average_price: 0.06527522889173805,
      one_day_average_price: 0.005645454545454546,
      seven_day_average_price: 0.005645454545454546,
      thirty_day_average_price: 0.005665217391304347,
    },
    contracts: [
      {
        contract_address: "0xb3faf6e8af293bd2f87662e785b06ccd35af03bc",
      },
    ],
    id: 432,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:42:37.686Z",
    key: "wits-official",
    name: "DO NOT BUY ! WITS IP Packs (ETH SNAPSHOT JANUARY 25TH 3:00 PM EST)",
    description:
      "Snapshot taken\nETH SNAPSHOT JANUARY 25TH 3:00 PM EST\n\nWITS, short for 'What is This Sorcery?', is an innovative and immersive trading card game (TCG) set in a fantastical universe called Catena. Imagine a world where wizards and mythical creatures are not just part of folklore but are deeply intertwined with the revolutionary technology of blockchain and cryptocurrencies.\n\nIn WITS, players collect and trade digital cards, each representing unique characters, spells, and artifacts. These cards are not just virtual assets; they are NFTs (Non-Fungible Tokens), making each one unique, owned securely on a blockchain, and potentially increasing in value based on rarity and demand.",
    exchange_url: "https://opensea.io/collection/wits-official",
    external_url: "https://www.wits.academy",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/0f2d42779532eb1c6c9586fe26e7f286.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/0f2d42779532eb1c6c9586fe26e7f286.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/232c695c079fe672a1551ed9c60d7bee.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/wits",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0.004,
      num_owners: 855,
      floor_price: 0.003,
      floor_price_symbol: "ETH",
      total_minted: 855,
      total_supply: null,
      total_volume: 9.67648886994495,
      one_day_volume: 0,
      seven_day_volume: 0.001,
      thirty_day_volume: 1.4772969999999996,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: -263,
      total_sales: 2315,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 142,
      total_average_price: 0.00417990879911229,
      one_day_average_price: 0,
      seven_day_average_price: 0.001,
      thirty_day_average_price: 0.010403499999999998,
    },
    contracts: [
      {
        contract_address: "0x2b0243f5a0f8c690bcdae0e00c669e45e44d6a0d",
      },
    ],
    id: 433,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:42:18.947Z",
    key: "blu3prints",
    name: "BLU3PRINTS",
    description:
      "1,489 forgotten BLU3PRINTS were found, left behind by a distant civilization.\n\nA free drop from @abwagmi with a unique Sybil-resistant allowlist method.\n\nTraits generated on-chain, and BLU3PRINTS art is permanently mirrored in the contract.\n\nOwners can swap between portrait and landscape orientation at will. Each piece in the collection implicitly comes with both orientations.",
    exchange_url: "https://opensea.io/collection/blu3prints",
    external_url: "https://ab.dev",
    banner_image_url:
      "https://i.seadn.io/gae/v0tNR_UcGmMtNfPelDOpNIQIQSaD75NzQQ92drLV7w1U06_BBY3JBVhOmVmeFQiIGipCayp0pcQUoaLuEgOcQRPINcuVj4V6T8M1gQ?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/qq067XOTofyBAQJdpvmqBWzyGB6ot6ux2vii2_BMFE8AGBOEIGe4lzuQyed84VFC0gFHKIsrBmZp-2e-HweFqlULaV04LZHmdc6PXg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/qq067XOTofyBAQJdpvmqBWzyGB6ot6ux2vii2_BMFE8AGBOEIGe4lzuQyed84VFC0gFHKIsrBmZp-2e-HweFqlULaV04LZHmdc6PXg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/Aun2bWXtaQWD6Wu2AKE0xgnJToB00jjautjaRKVtxdsaP10DMhuG_2Gql_R8IEoWIKuFGcbvQ7dx3m2ALGcYE6RAP_lw-D_JaX537w?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/filaments",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1097,
      floor_price: 0.0069,
      floor_price_symbol: "ETH",
      total_minted: 1097,
      total_supply: null,
      total_volume: 244.08171226121402,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0018,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -1,
      total_sales: 927,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.26330281797326216,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0018,
    },
    contracts: [
      {
        contract_address: "0x6a5d1449263c0ddde0a30bf48714ff97503597dc",
      },
    ],
    id: 434,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:42:08.047Z",
    key: "dwellers-xo",
    name: "dwellers",
    description:
      "the lost, the suffering, the forgotten who have finally found love, family, and a home. they are the people of the abyss. they are dwellers",
    exchange_url: "https://opensea.io/collection/dwellers-xo",
    external_url: "https://www.dwellers.art/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/db7e95f8815f902f833c8959e36a1e04.gif?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/c6b64480656ec6b70318bc6aee1de5ad.gif?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/c6b64480656ec6b70318bc6aee1de5ad.gif?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/c6b64480656ec6b70318bc6aee1de5ad.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 728,
      floor_price: 0.0059,
      floor_price_symbol: "ETH",
      total_minted: 728,
      total_supply: null,
      total_volume: 11.193648278119962,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0017,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -1,
      total_sales: 1431,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.007822255959552734,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0017,
    },
    contracts: [
      {
        contract_address: "0x6bf14d09f5600ed683abce94b6c43f7cb429d308",
      },
    ],
    id: 435,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:42:03.415Z",
    key: "hawnter99",
    name: "hawnter99",
    description: null,
    exchange_url: "https://opensea.io/collection/hawnter99",
    external_url: "https://www.instagram.com/hawnter99/",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/gae/ohvNuheZSh8KJY7UK5CuqNYUlgAYlQvq35MuP8uouui1R8e2icFJ68L6LsYBQ64HR7ry3fGRxhitPviuBd-5a7_94bZkNj0NquvkEQ?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/ohvNuheZSh8KJY7UK5CuqNYUlgAYlQvq35MuP8uouui1R8e2icFJ68L6LsYBQ64HR7ry3fGRxhitPviuBd-5a7_94bZkNj0NquvkEQ?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/zf2CK-c71ugN_I0hGJQzwiF9mrFhOl5wmuFw_Sf-SATHkB4czSg8F86X7-55Bsj302rg-Doa_K1O7C74ybinA3-1kvci2u_JhpR37Q?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: "Hawnter99",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 22,
      floor_price: 0.2,
      floor_price_symbol: "ETH",
      total_minted: 22,
      total_supply: null,
      total_volume: 0.047799999999999995,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 41,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.001165853658536585,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x0733411463d71e33a41c73b63367389b886c1d12",
      },
    ],
    id: 436,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:41:59.048Z",
    key: "littlepeckers",
    name: "Little Peckers",
    description: null,
    exchange_url: "https://opensea.io/collection/littlepeckers",
    external_url: "http://littlepeckers.farm",
    banner_image_url:
      "https://i.seadn.io/gcs/files/2d5489aedb313ab5d8f4e3373e6a2283.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/1146cd86299644fc618cd8158bf3fbd3.gif?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/1146cd86299644fc618cd8158bf3fbd3.gif?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/1146cd86299644fc618cd8158bf3fbd3.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 311,
      floor_price: 0.03,
      floor_price_symbol: "ETH",
      total_minted: 311,
      total_supply: null,
      total_volume: 7.855950421333334,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0619,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 3,
      total_sales: 214,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 3,
      total_average_price: 0.03671004869781932,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.020633333333333333,
    },
    contracts: [
      {
        contract_address: "0x72892b05fa09a317f5b223b3e2684f8e606e70ee",
      },
    ],
    id: 437,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:41:12.508Z",
    key: "my-sassy-sister-emily-1",
    name: "My sassy Sister (Emily)",
    description:
      "My Sassy Sister (Emily) is a bold and artistic NFT collection celebrating the many moods and styles of Emily. From playful to fierce, each piece showcases her unapologetic personality through diverse artistic expressions. This collection is a tribute to confidence, individuality, and the limitless power of art.",
    exchange_url: "https://opensea.io/collection/my-sassy-sister-emily-1",
    external_url: null,
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/bf510ff85814105b6554994c43910f67.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/bf510ff85814105b6554994c43910f67.jpg?w=500&auto=format",
    image_url: null,
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1,
      floor_price: 0.2,
      floor_price_symbol: "ETH",
      total_minted: 1,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xc3c3b0e3f503bb531c3ce0a91b641e2ef514da65",
      },
    ],
    id: 438,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:44:07.631Z",
    key: "the-grifters-nfts",
    name: "The Grifters NFTs",
    description:
      "Art by Rare Designer\n\nThe Grifters NFTs is a 5,555 collection inspired by an assorted and representative cast of YouTube and Twitter influencers, meme project devs, and NFA investment gurus. The Grifters are modern day matchstick men, snake oil salesman, financial advice gurus, NFT and crypto advocates, Web3 creators and ponzi protectors. \n\nLets Get Fucking Grifty\n\n",
    exchange_url: "https://opensea.io/collection/the-grifters-nfts",
    external_url: "https://www.griftersofficial.com/nfts",
    banner_image_url:
      "https://i.seadn.io/gcs/files/ecabd4480ce021634e77514d0f0a359d.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/75ff49267df443322838ce1000d3cf32.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/75ff49267df443322838ce1000d3cf32.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/0e337572e74f1d2c254a626101f56924.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/thegrifters",
    telegram_url: "https://t.me/griftersofficial",
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 21.6684,
      num_owners: 641,
      floor_price: 0.003,
      floor_price_symbol: "ETH",
      total_minted: 641,
      total_supply: null,
      total_volume: 159.9456733338291,
      one_day_volume: 0.0039,
      seven_day_volume: 0.0039,
      thirty_day_volume: 0.0181,
      one_day_volume_change: 0.0039,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -20,
      total_sales: 6567,
      one_day_sales: 1,
      seven_day_sales: 1,
      thirty_day_sales: 5,
      total_average_price: 0.024355972793334717,
      one_day_average_price: 0,
      seven_day_average_price: 0.0039,
      thirty_day_average_price: 0.00362,
    },
    contracts: [
      {
        contract_address: "0xb05fd8abd64e6421fde30d5db879a3dad54e251b",
      },
    ],
    id: 439,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:44:03.687Z",
    key: "digidaigakumaskedvillains",
    name: "DigiDaigaku Masked Villains",
    description:
      "DigiDaigaku Masked Villains is a collection of unique characters developed by Limit Break. Please follow us on Twitter: https://twitter.com/DigiDaigaku or visit our website https://digidaigaku.com for instructions on how to unmask.",
    exchange_url: "https://opensea.io/collection/digidaigakumaskedvillains",
    external_url: "http://digidaigaku.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/3d526c75733186332efc18f93878e9bd.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/433771839c2e7da802600c06a406dcde.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/433771839c2e7da802600c06a406dcde.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/abe0b33364d69b0e751ef4d324284092.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/qHqsDJMTha",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 18.2528,
      num_owners: 1435,
      floor_price: 0.01047,
      floor_price_symbol: "ETH",
      total_minted: 1435,
      total_supply: null,
      total_volume: 1747.9162815433283,
      one_day_volume: 0.0154,
      seven_day_volume: 0.0713,
      thirty_day_volume: 0.4665170000000002,
      one_day_volume_change: -0.031100000000000006,
      seven_day_volume_change: 5,
      thirty_day_volume_change: 11,
      total_sales: 7033,
      one_day_sales: 2,
      seven_day_sales: 12,
      thirty_day_sales: 51,
      total_average_price: 0.24853068129437342,
      one_day_average_price: 0.0077,
      seven_day_average_price: 0.005941666666666667,
      thirty_day_average_price: 0.00914739215686275,
    },
    contracts: [
      {
        contract_address: "0x812f5cf0d10539ef9534929940f3aeede3d3d967",
      },
    ],
    id: 440,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:43:55.772Z",
    key: "shroomieznfts",
    name: "Shroomiez NFTs",
    description:
      "These hand drawn mushrooms allow you to govern the Shroomieverse, by voting on what dApps & NFT projects should be viewed and accessed by millions of new users.",
    exchange_url: "https://opensea.io/collection/shroomieznfts",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/b06d2370400dbc57975473d88ba2f6fa.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/a56400b5ad6339ddbf7572d38f186948.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/a56400b5ad6339ddbf7572d38f186948.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/764209ceb424ad8f5a0314c08baf06de.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/ecG6ChgKwx",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 9.353,
      num_owners: 187,
      floor_price: 0.07995,
      floor_price_symbol: "ETH",
      total_minted: 187,
      total_supply: null,
      total_volume: 2.259698899999999,
      one_day_volume: 0.0235,
      seven_day_volume: 0.0235,
      thirty_day_volume: 0.0535,
      one_day_volume_change: 0.0235,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -3,
      total_sales: 27,
      one_day_sales: 1,
      seven_day_sales: 1,
      thirty_day_sales: 2,
      total_average_price: 0.08369255185185182,
      one_day_average_price: 0,
      seven_day_average_price: 0.0235,
      thirty_day_average_price: 0.02675,
    },
    contracts: [
      {
        contract_address: "0x9fa4ef95e229790ce1452a49ccede42650376b4b",
      },
    ],
    id: 441,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:40:54.969Z",
    key: "cryptoleos",
    name: "CryptoLeos",
    description:
      "CryptoLeos a collection celebrating pop culture by world renowned artist David Gersch.\n\nEach NFT is a multi utility asset, ownership of a CryptoLeo welcomes you to the Leo party, an exclusive club of stylish Oscar winning winners!\n\nhttps://cryptoleos.com/\n\nhttps://opensea.io/collection/the-multiverse-of-leos",
    exchange_url: "https://opensea.io/collection/cryptoleos",
    external_url: "https://cryptoleos.com/",
    banner_image_url:
      "https://i.seadn.io/gae/ghsN5qLRK8C5dzigcXGHLEBrmWWYrei4fbJJaVp69UidcgGVNkGo3picxNGE8MJcKPmknjPw2F8M8SEoVCviOsNnS2uQheYTZednkw?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/m2Yfr-CoJjmsHapF6nBY2RtNWqZ-xR5fpHGhD8sikmwOzNf-S-yiUyMqDt4547T-fCOeiPa4MueTld_TQF_dFXqvjWnEEISK1V0BRA?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/m2Yfr-CoJjmsHapF6nBY2RtNWqZ-xR5fpHGhD8sikmwOzNf-S-yiUyMqDt4547T-fCOeiPa4MueTld_TQF_dFXqvjWnEEISK1V0BRA?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/Ivs4p2ru7hQ1MJ7DTO4gDk9AbPVK89WdLHT38xK3RRJLJXSQNnytcdzkQeqbyrIXuAGvEKzVdrtixULoq32z9D3c94gZFn89UR1s7w?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/Ywszu5xPAb",
    telegram_url: null,
    twitter_username: "CryptoLeos",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 391,
      floor_price: 0.019,
      floor_price_symbol: "ETH",
      total_minted: 391,
      total_supply: null,
      total_volume: 370.35887724119084,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0188,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -8,
      total_sales: 1561,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.23725744858500375,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0188,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 442,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:40:40.667Z",
    key: "zombie-apes-official-nft",
    name: "Zombie Apes Official NFT",
    description:
      "6,667 Zombie Ape escaping from a top secret facility onto the Ethereum blockchain! Zombie DAO, passive staking, and much more on the [roadmap](https://zombieapes.io/#roadmap).\n\nThe Zombie Apes are stored as ERC-721 tokens on the Ethereum blockchain.\n\nCheck out our [Zombie Zebra NFT Collection](https://opensea.io/collection/zombie-zebras-official) (sold out) .\n\nCheck out our first [comic book release](https://opensea.io/collection/zombie-comics-issue-1-covers) (sold out) .\n\nGet Infected with us! Join the Herd!",
    exchange_url: "https://opensea.io/collection/zombie-apes-official-nft",
    external_url: "https://zombieapes.io/",
    banner_image_url:
      "https://i.seadn.io/gae/KFi_gWx6A2DDkMPFa-kEpqXPWJnRHDPMha3A8wzjymVpQp4gq7guzQ9xbV4rVlUOvBYhtaeASOxYo-5g-qxBmthUs2RnzaXDFLPa5Q?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/Yyh4ktOr2vnpLOhclqT9k_iDCiXjNkh1BXy0Zy8WK8laEJA4hjsm0EfJXXzjE3BrrY_a02GF5DmbBAB4vThmWlilJ3soxpZEHZ6fvA?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/Yyh4ktOr2vnpLOhclqT9k_iDCiXjNkh1BXy0Zy8WK8laEJA4hjsm0EfJXXzjE3BrrY_a02GF5DmbBAB4vThmWlilJ3soxpZEHZ6fvA?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/-9EVeDfSXSQNGnOBoc-D9nVGP67OpXJnt7nr39vzTNwlLVua4wjNVy4qhIkESqpiRakNC4EPNvillPonskmgDAQde2m-_ZNtDsRLfhc?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/urpC36PAuP",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "zombieapesnft/",
    stats: {
      market_cap: 0,
      num_owners: 1627,
      floor_price: 0.0029,
      floor_price_symbol: "ETH",
      total_minted: 1627,
      total_supply: null,
      total_volume: 147.61827196912677,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 2832,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.05212509603429617,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xb732ba22292259085ac15f0ba0183638e3615104",
      },
    ],
    id: 443,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:40:35.562Z",
    key: "tailopez",
    name: "OG (original garage) Social Club by Tai Lopez",
    description:
      'The "OG (original garage) Social Club" NFT collection by Tai Lopez consists of Silver "Mentorship" cards (Tier 1), Gold "Mastermind" cards (Tier 2), and Black "1 on 1 Mentorship" cards (Tier 3).\r\nThe vision behind this project is to create a members only club where only NFT holders members get access to millionaire mentors and entrepreneurs through a collection of masterminds, hotels, night clubs, restaurants, popup events, physical and digital seminars, training courses, in person mentorships, conferences, fireside chats, and so much more!\r\nWhen you buy an OG (original garage) Social Club NFT, you\'re not just buying another digital NFT - you\'re gaining access to a new way of life that makes this NFT valuable for the long run.\r\nPlus when you\'ve learned enough you can just trade the NFT to someone else who needs it.\r\nRemember, "The More You Learn, The More You Earn."',
    exchange_url: "https://opensea.io/collection/tailopez",
    external_url: "https://www.originalgarage.com",
    banner_image_url:
      "https://i.seadn.io/gae/-g8XbsLU53U4hxzBfrg17VfeaZnztIsi1xR5MmC771mdaCZpRWBtDnrpbSAWafYwm-vfMzAkbrUu8fNyv0tNUqFicYr_qqsh7Wh_sdY?w=500&auto=format",
    featured_image_url: null,
    large_image_url:
      "https://i.seadn.io/gae/BIM6g-WkeWkVG7eO_9vgksgaEqPQsMHRMeO29WNDh2ESFqj8P85u3ilS0uNhsMMS1a77BJ10VqDHA7Oyxa-DhVMCvNYT4FqTo28wOlc?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/BIM6g-WkeWkVG7eO_9vgksgaEqPQsMHRMeO29WNDh2ESFqj8P85u3ilS0uNhsMMS1a77BJ10VqDHA7Oyxa-DhVMCvNYT4FqTo28wOlc?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 928,
      floor_price: 0.0489,
      floor_price_symbol: "ETH",
      total_minted: 928,
      total_supply: null,
      total_volume: 485.2910083715147,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0018,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 1271,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.3818182599303813,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0018,
    },
    contracts: [
      {
        contract_address: "0x2070f7821d9c8ebfdecc1bc981d1308cc0d93843",
      },
    ],
    id: 444,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:40:35.165Z",
    key: "gamaspacestation",
    name: "GAMA SPACE STATION",
    description:
      "GAMA is a decentralized organization that is sending 10k crew members into space to complete energy harnessing missions across the universe.\n\nOwning a GAMA NFT provides an exclusive membership to the GAMA Space Station Metaverse, an unprecedented virtual experience consisting of innovative social interactions, new forms of entertainment, and decentralized gaming mechanics. Other perks include staking opportunities, tickets to GAMA Studios, limited edition merch, and live events.\n\nGAMA’s future roadmap is the research and development of a real world clean energy initiative.\n\nWebsite: https://gama.io\n\nDiscord: https://discord.gg/gama\n\nGAMA NFT Ownership Rights Agreement: https://gama.io/terms",
    exchange_url: "https://opensea.io/collection/gamaspacestation",
    external_url: "https://gama.io",
    banner_image_url:
      "https://i.seadn.io/gae/572AL34hGV9kJZCc7NpHplFAyJPjelqxGiHAu9dL7Rn6wpR49PiHXKRPbSNcfZD0LYBQWx--jbCEJB4OD_-ggVJvWzBpL5souWz7RQ?w=500&auto=format",
    featured_image_url: null,
    large_image_url:
      "https://i.seadn.io/gae/PMUVqsUQ5n2GfS4ir5zX2DRYJuxkrPk6xZy3cpjERrE5SZMEiWSWnGygYg2c0yoYdfJwLxev9PmQygiVkXyh-c2ilxJe0RDH84ihpQ?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/a3r4gRwiN5zSriBtxMANn6WCJLyuKkeDfrmQkcDH4MaLEvo5WhUfXqieAjRss6vLGwT12sNRkzthGY8uB5ECzeeRWUxC0SB0Zz9ofA?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/gama",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "gama_nft",
    stats: {
      market_cap: 0,
      num_owners: 792,
      floor_price: 0.003498,
      floor_price_symbol: "ETH",
      total_minted: 792,
      total_supply: null,
      total_volume: 272.4470749800006,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 1709,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.15941900232884762,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xa142c94656fc57b4a8aa725341a2b496df375da7",
      },
    ],
    id: 445,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:40:24.366Z",
    key: "bullsandapes-apes",
    name: "Bulls and Apes Project - Apes",
    description:
      "B.A.P. Apes give you control over your digital identity. You no longer have to win the mint lotto or hope someone paper hands your ideal NFT. Our Apes are dynamic. This means you can choose from thousands of traits to make an amazing 3D pfp that's perfect for YOU. \n\nWith over 700 traits to choose from and more being added, the possibilities are endless. \n\nThe Ape Invasion has begun. What kind of Ape will you choose to be?\n\n[Learn More](http://discord.com/invite/bullsandapesproject)\n\nExplore [Ape Traits](https://opensea.io/collection/bullsandapes-apetraits) \n\nGet a [Genesis Bull](https://opensea.io/collection/bullsandapes-genesis) and join BAP’s [Inner Circle](https://www.BullsAndApesProject.com)",
    exchange_url: "https://opensea.io/collection/bullsandapes-apes",
    external_url: "https://www.bullsandapesproject.com/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/dc47db967e7a030ca5c05f5ed1620308.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/38d0b74d10b9bba1968bdb24317cd863.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/38d0b74d10b9bba1968bdb24317cd863.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/208eab9f894c313ae636812ed526cf4d.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/bapcustom",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 137.9862,
      num_owners: 864,
      floor_price: 0.02027,
      floor_price_symbol: "ETH",
      total_minted: 864,
      total_supply: null,
      total_volume: 392.94715462077164,
      one_day_volume: 0,
      seven_day_volume: 0.0414,
      thirty_day_volume: 0.8045231899999999,
      one_day_volume_change: 0,
      seven_day_volume_change: 2,
      thirty_day_volume_change: 5,
      total_sales: 3488,
      one_day_sales: 0,
      seven_day_sales: 3,
      thirty_day_sales: 38,
      total_average_price: 0.11265686772384507,
      one_day_average_price: 0,
      seven_day_average_price: 0.0138,
      thirty_day_average_price: 0.02117166289473684,
    },
    contracts: [
      {
        contract_address: "0x7f29b85834d6a2ba4bb1c64325686c6057b1b3c5",
      },
    ],
    id: 446,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:40:05.138Z",
    key: "theinfiniteuniverse",
    name: "THE BIRTH OF ARTIFICIAL INTELLIGENCE / Painting with AI by Star Im & Godwits AI",
    description:
      "THE BIRTH OF ARTIFICIAL INTELLIGENCE: INFINITE UNIVERSE AI: Stories of The Infinite Universe is a collection of paintings created through a collaboration between machine learning and the artists Star Im & Godwits. Each painting in this collection represents an untold story of the universe, inviting viewers to explore and interpret their own imaginations through these visual arts.\n\nDive into each artwork and let your creativity run wild. Create your own narratives and stories, expanding your mind as you engage with every detail in the art. Become the storyteller of these paintings, uncovering the depths of each creation and experiencing the boundless possibilities of the infinite universe. Become involved with the artwork and become a master storyteller. ",
    exchange_url: "https://opensea.io/collection/theinfiniteuniverse",
    external_url: "https://starim.org",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/2f48e56443fde1d5d25824826049c048.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/2f48e56443fde1d5d25824826049c048.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/0bea1b7d949d53b5ffbb7e9673cab549.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: "https://godwits.com",
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 26.5356795,
      num_owners: 275,
      floor_price: 0.007,
      floor_price_symbol: "ETH",
      total_minted: 275,
      total_supply: null,
      total_volume: 7.4511277899999655,
      one_day_volume: 0,
      seven_day_volume: 0.015923,
      thirty_day_volume: 0.35999299000000007,
      one_day_volume_change: 0,
      seven_day_volume_change: -7,
      thirty_day_volume_change: -32,
      total_sales: 947,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 26,
      total_average_price: 0.007868139165786658,
      one_day_average_price: 0,
      seven_day_average_price: 0.0079615,
      thirty_day_average_price: 0.013845884230769233,
    },
    contracts: [
      {
        contract_address: "0xdd71f248c4d784e67d838850d4440cc2c300cfbe",
      },
    ],
    id: 447,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:40:04.726Z",
    key: "veefriends-series-2",
    name: "VeeFriends Series 2",
    description:
      "[VeeFriends](https://opensea.io/collection/veefriends) Characters have now evolved. Welcome to VeeFriends Series 2!",
    exchange_url: "https://opensea.io/collection/veefriends-series-2",
    external_url: "https://series2.veefriends.com",
    banner_image_url:
      "https://i.seadn.io/gae/l7-Zz6ZYWJBu4kkFBxnHchfzg3uJlwmCZsfJt7QMJuiX1v7SQgUp-PveFFPi-Zd8J4m0ROQsGFgDcs96OXZu7JOIqC60kzTu7sQGAA?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/v5RN5nPGPkNScToAsH3ZtGevPBBZ1I3I4UZudqSw6vss5yteBBCsOI3EM94KHcjE9iyWmtnAYvqhZuffISL2OqRJFPmCW8pdseTQ?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/v5RN5nPGPkNScToAsH3ZtGevPBBZ1I3I4UZudqSw6vss5yteBBCsOI3EM94KHcjE9iyWmtnAYvqhZuffISL2OqRJFPmCW8pdseTQ?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/7c968bade1414b10fb5fd77d7c82e565.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/veefriends",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "veefriends",
    stats: {
      market_cap: 4003.151069365856,
      num_owners: 20025,
      floor_price: 0.053847,
      floor_price_symbol: "ETH",
      total_minted: 20025,
      total_supply: null,
      total_volume: 35106.364881806105,
      one_day_volume: 0.655947,
      seven_day_volume: 5.938856000000004,
      thirty_day_volume: 45.03504924544446,
      one_day_volume_change: -0.3950330000000001,
      seven_day_volume_change: -47,
      thirty_day_volume_change: -743,
      total_sales: 50339,
      one_day_sales: 10,
      seven_day_sales: 82,
      thirty_day_sales: 457,
      total_average_price: 0.697398932871255,
      one_day_average_price: 0.06559469999999999,
      seven_day_average_price: 0.07242507317073175,
      thirty_day_average_price: 0.09854496552613667,
    },
    contracts: [
      {
        contract_address: "0x9378368ba6b85c1fba5b131b530f5f5bedf21a18",
      },
    ],
    id: 448,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:40:00.465Z",
    key: "forecast-by-manuel-larino",
    name: "Forecast by Manuel Larino",
    description:
      "Art Blocks Collection: Presents\n\nProject Description: ##### **Forecast** abstractly captures the essence of rainfall on a stone-paved road, drawing an analogy between weather and human emotions, comparing the outcome of a weather forecast to the range of feelings a rainy day can evoke, inviting viewers to reflect on their own relationship with rain and the emotions it evokes in them. #####\n####  ####\n` `\nThe code creatively **recreates a weather forecast** to determine where on the canvas rain will fall. It emulates barometric pressure and humidity to alter a circle packing **algorithm that acts like clouds over the canvas**, generating the necessary data to calculate the probability of precipitation for each piece and distribute rain on the canvas in a visually appealing way.\n\n**Geometry, color, and natural forces work together to create an abstract representation of rain** that pays homage to where I was born, “Galicia, where rain is art”.\n #### ####\n  #### ####\n   #### ####\n ***\n  #### ####\n` `\n###### **The Concept**\n` `\nIn the northwest of Spain lies Galicia, a region where rain holds a special place.\n\n**With approximately half of the year consisting of rainy days**, it's no surprise that the Galician language has evolved to encompass a rich vocabulary of over 100 words to describe its various forms and moments. **Rain has become an art form in our everyday lives**, expressed through our language and the nuances of our conversations.\n\nIt was within this setting of rich traditions and linguistic nuances that **inspiration took hold on a rainy Sunday afternoon, as I wandered through the old part of town, captivated by the movement of raindrops and mesmerizing water ripples on the stone-paved road**, nurtured by the deep connection between Galicia's cultural heritage of intricate vocabulary of rain.\n\nThis intriguing interplay between weather and language extends far beyond Galicia, languages like Japanese, Welsh, and even Hawaiian bear witness to this captivating phenomenon, where **weather molds the very fabric of our linguistic expressions.** It serves as a testament to the **profound influence of weather on our collective human experience.**\n\nWhile rain and weather influencing language ignited my inspiration, I sought to explore further, embarking on a creative journey that **explores the profound impact rain has on emotions and feelings**—a shared human language that transcends borders and requires no translations.\n\nTo express the diverse range of emotions rain can evoke, I created color palettes inspired by personal memories and experiences, capturing the essence of how those moments, events, and places made me feel. To further enhance the expression of emotions, I use size and proportion symbolizing and amplifying the intensity of those feelings. This approach brings forth the emotional impact of rain in our lives, **inviting viewers to reflect on their own relationship with rain and the feelings it evokes in them.**\n\nTo add depth and significance to its compositions Forecast uses a creative approach woven into its code, that became such an important part of the piece that gave its name to the project. **The code simulates a weather forecast emulating barometric pressure, and humidity** – variables that dynamically influence a circle packing algorithm that symbolizes clouds over the canvas, generating the necessary data to calculate the probability of precipitation for each piece and distribute rain across the canvas in a visually appealing way. The result is a perfect balance between randomness and control that added an extra layer of depth to the artwork.\n\n**Prints**\nPrints will be available for Forecast owners. For more details, [visit this link](https://www.mlarino.com/work/forecast \"order prints\").\n\n***\n\\\n**Keys**\n**[S]** - Download image.\n\nPress the **[LEFT ARROW]** key to explore the different elements that help build the final image.\n\nTo switch between different aspect ratios, use the following keys:\n**[0]** 3:4 Print (default)\n**[1]** 9:16 ratio\n**[2]** 1:1 ratio",
    exchange_url: "https://opensea.io/collection/forecast-by-manuel-larino",
    external_url: "https://artblocks.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/6a0193895d5538c3e04da84ec9ec4f76.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/d349466d8b6c50f34613d633a0e6a18c.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/d349466d8b6c50f34613d633a0e6a18c.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/d46df62809875fe7374b641878f923f0.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 167,
      floor_price: 0.0489,
      floor_price_symbol: "ETH",
      total_minted: 167,
      total_supply: null,
      total_volume: 61.36725188209998,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0264,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -4,
      total_sales: 406,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.15115086670467975,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0264,
    },
    contracts: [
      {
        contract_address: "0x99a9b7c1116f9ceeb1652de04d5969cce509b069",
      },
    ],
    id: 449,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:39:53.010Z",
    key: "punk-toadz",
    name: "Punk-Toadz",
    description: "Just vibes and no roadmap! ",
    exchange_url: "https://opensea.io/collection/punk-toadz",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/c735074dcc4422ee5a8d9e505ee6bd23.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 416,
      floor_price: 0.01,
      floor_price_symbol: "ETH",
      total_minted: 416,
      total_supply: null,
      total_volume: 10.108222310099986,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 1668,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.006060085317805747,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x5610e03421168ceaa95070249cc6ada2629d9b26",
      },
    ],
    id: 450,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:39:34.307Z",
    key: "celephais-dreamers",
    name: "Celephais: Dreamers",
    description: "Dreamers Only.",
    exchange_url: "https://opensea.io/collection/celephais-dreamers",
    external_url: "http://celephais.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/94a4ad57405236b7a585d61e10458f20.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/94a4ad57405236b7a585d61e10458f20.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/94a4ad57405236b7a585d61e10458f20.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/a3d72691e105f115714e10d8a1aac893.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/celephais",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0.333,
      num_owners: 1373,
      floor_price: 0.0004,
      floor_price_symbol: "ETH",
      total_minted: 1373,
      total_supply: null,
      total_volume: 174.29547904980114,
      one_day_volume: 0.0002,
      seven_day_volume: 0.0003,
      thirty_day_volume: 0.0003,
      one_day_volume_change: 2,
      seven_day_volume_change: 3,
      thirty_day_volume_change: 3,
      total_sales: 3106,
      one_day_sales: 2,
      seven_day_sales: 3,
      thirty_day_sales: 3,
      total_average_price: 0.05611573697675504,
      one_day_average_price: 0.0001,
      seven_day_average_price: 0.0001,
      thirty_day_average_price: 0.0001,
    },
    contracts: [
      {
        contract_address: "0xe41c7e05838f180938ad08643d7a2fe0a9e5f4e4",
      },
    ],
    id: 451,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:39:19.385Z",
    key: "meta-legends",
    name: "Meta Legends",
    description:
      "Meta Legends is a collection of 12345 NFTs on the Ethereum blockchain composed of 7 distinctive classes and generated with thousands of uniquely designed 3D traits.\n\nBuilding a social HUB with [Nexy](https://bit.ly/48DbCiW)! 🌐 [Join now](https://bit.ly/48DbCiW)",
    exchange_url: "https://opensea.io/collection/meta-legends",
    external_url: "https://www.meta-legends.com/",
    banner_image_url:
      "https://i.seadn.io/gae/x3GPJZegIf8K4ZI4cMzifRsLdzULZ4VqkAoryJ4ozt6z5YHfOKB5igT1o1PN2Vgm7CwRdyLctNF0kCpu_8CEhfpP29SZqKL-b0MX?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/gWAu9PKf0N6-va3SK6C0qB8DbS-D8Xien4trb2zxL8LJElQ3BTnP7sKJLpCEUyKObXlaL9wQt7_LSL87kOH_frA0iqwBDNrIJHpn?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/gWAu9PKf0N6-va3SK6C0qB8DbS-D8Xien4trb2zxL8LJElQ3BTnP7sKJLpCEUyKObXlaL9wQt7_LSL87kOH_frA0iqwBDNrIJHpn?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/G6oiHHDRJreAXlpneSeaaYM5HVyst2HYd2nQH9Zzw02g8mUfBTSNGl4zlwASuFZl01XbiaXjWX_6rf7l5roJTAaq1o1-EevvOsFFGg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: "metalegendsnft",
    wiki_url: null,
    instagram_username: "meta.legends/",
    stats: {
      market_cap: 391.38463009389926,
      num_owners: 4286,
      floor_price: 0.019549,
      floor_price_symbol: "ETH",
      total_minted: 4286,
      total_supply: null,
      total_volume: 3680.700739498487,
      one_day_volume: 0.1528,
      seven_day_volume: 2.346278566667899,
      thirty_day_volume: 4.285124666667899,
      one_day_volume_change: -0.06239,
      seven_day_volume_change: 65,
      thirty_day_volume_change: 17,
      total_sales: 12598,
      one_day_sales: 8,
      seven_day_sales: 74,
      thirty_day_sales: 131,
      total_average_price: 0.2921654817827026,
      one_day_average_price: 0.0191,
      seven_day_average_price: 0.03170646711713377,
      thirty_day_average_price: 0.032710875318075566,
    },
    contracts: [
      {
        contract_address: "0xf9c362cdd6eeba080dd87845e88512aa0a18c615",
      },
    ],
    id: 452,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:39:18.992Z",
    key: "chiko-roko-art-v2",
    name: "Chiko & Roko Art V2",
    description: null,
    exchange_url: "https://opensea.io/collection/chiko-roko-art-v2",
    external_url:
      "https://app.rarible.com/collection/0xacd1ff45068ccc269e6496fcfb085f63c735a41a",
    banner_image_url: null,
    featured_image_url: null,
    large_image_url:
      "https://i.seadn.io/gae/z7ZFDWqFpfRVQKkBwQOjz8ioP0nNLf8EkFK9r6Av8U80mEvLhZAQWz8eHkf1yQq6Ogem9Um3wh87goY2IntBaKRYcjcoZY_DMc_PmkE?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/z7ZFDWqFpfRVQKkBwQOjz8ioP0nNLf8EkFK9r6Av8U80mEvLhZAQWz8eHkf1yQq6Ogem9Um3wh87goY2IntBaKRYcjcoZY_DMc_PmkE?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 522,
      floor_price: 0.04,
      floor_price_symbol: "ETH",
      total_minted: 522,
      total_supply: null,
      total_volume: 1.8908000000000005,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 24,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.07878333333333336,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xacd1ff45068ccc269e6496fcfb085f63c735a41a",
      },
    ],
    id: 453,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:39:14.786Z",
    key: "voxversev2",
    name: "VOXverse Fantasy Land v2",
    description: null,
    exchange_url: "https://opensea.io/collection/voxversev2",
    external_url: "https://collectvox.com/",
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/bab8a3390bb16ed078be3bcfaa96ea62.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/bab8a3390bb16ed078be3bcfaa96ea62.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/2ce7a0d1bea8a048d10a6a5ee737e4cf.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/vzcmSAUbNF",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 340,
      floor_price: 0.01277820012040905,
      floor_price_symbol: "ETH",
      total_minted: 340,
      total_supply: null,
      total_volume: 7.15368499999586,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0237,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -2,
      total_sales: 37,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 4,
      total_average_price: 0.19334283783772593,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.005925,
    },
    contracts: [
      {
        contract_address: "0x90a32d4171a915eacafbedca9024804efb8aa75b",
      },
    ],
    id: 454,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:38:52.647Z",
    key: "noise-secondstate",
    name: "N O I S E",
    description:
      "N O I S E consists of 3 dynamic creations by the name of, \n\nSoul, responding to the $ASH Ecosystem,\n\nImpulse, responding to it's collectors, as well as part of the $ASH ecosystem,\n\nand Auctōrem, a  version dedicated to the creator of $ASH.\n\n\nI challenge you,\nbe impulsive, and silence the noise,\none decibel at a time,\nyour mind, body, and soul will thank you later.\n\n",
    exchange_url: "https://opensea.io/collection/noise-secondstate",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gae/-P-uyWk9l7QtDyV9fG2tok4s3s3VdMvSea4sXk_TwOll6eRq5ak8mI3-wj4XF4XvFVOxyDyRfSw3-nsrLiTY3NjSPiSOVCWSsstNoA?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/MYgUaZHFObLIomPp7Yl5EXDqgO77rLoS4PyB9FMgWBcdzGFEy63lFnKDyFZ4g5-kAj5tS3ZqfSoA1Tv1cOMV313GXvhIM643mtMO?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/MYgUaZHFObLIomPp7Yl5EXDqgO77rLoS4PyB9FMgWBcdzGFEy63lFnKDyFZ4g5-kAj5tS3ZqfSoA1Tv1cOMV313GXvhIM643mtMO?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/EBa021hdPVa47iSR2u012S-tvK0-CpLJxzrNg7WjQhwYikXvXEhfX3rpilApM-pmwiWK7I6jwhMUN27eAgoK9gLqDltDMo-Er0Yo?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 441,
      floor_price: 0.01,
      floor_price_symbol: "ETH",
      total_minted: 441,
      total_supply: null,
      total_volume: 5.377337097499995,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 696,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.007726059048132176,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x995e2ed939f074bc1dd65c53072490cea1b0fc26",
      },
    ],
    id: 455,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:38:37.291Z",
    key: "love-death-robots-official",
    name: "Love, Death + Robots Official",
    description:
      "Nine Love, Death + Robots QR-Coded Artworks have been strewn across the digital and physical world. Each piece of special, limited edition imagery reflects Love, Death + Robots’ unique collective of visual perspectives and creative storytelling from Volume 3. To collect them all, you’ll have to be vigilant.",
    exchange_url: "https://opensea.io/collection/love-death-robots-official",
    external_url: "https://lovedeathandart.com",
    banner_image_url:
      "https://i.seadn.io/gae/9ePoUZNQhu3xXRFg_NvwQidD2-lBSmM8c9IwWt67Ki6UjXzEID2nn94PLLjp9lHHweCXrJte4MWm5fk-c36H90oQU5XNRdG_4l073ts?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/S1AceNBOr1LJ99Uj-yn4aLTbAXPyEFFgI7ymKb4CtnWmF3GSI0ze1JTqe4tlkSW41K3y_VZso5IdNx74RESEvpU3hIrC7IfbPc4waRs?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/S1AceNBOr1LJ99Uj-yn4aLTbAXPyEFFgI7ymKb4CtnWmF3GSI0ze1JTqe4tlkSW41K3y_VZso5IdNx74RESEvpU3hIrC7IfbPc4waRs?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/RlK90xsdiBPiOq96fNycbKJD6hkfyWAOpgMuW15TQmGHBQIapx4oa3gfF8f6T66UUgQybHBgJJIl0ZJUlfl3x2vjYsnxzTmh88nbJLU?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 32525,
      floor_price: 0.0011,
      floor_price_symbol: "ETH",
      total_minted: 32525,
      total_supply: null,
      total_volume: 42.15961704007761,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 11588,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.003638213413883122,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xfd43d1da000558473822302e1d44d81da2e4cc0d",
      },
    ],
    id: 456,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:37:51.855Z",
    key: "fadingmemories",
    name: "Fading Memories - Editions",
    description:
      "When was the last time that you stood under the rain and felt the gentle touch of a raindrop crashing against your skin?\n\nWhen was the last time that you stopped for a few seconds to just look at life pass and take it all in?\n\nThe beauty of life relies on those small things that we can easily forget to see due to the fast pace of life, and that’s why my art was born, to give you a space to stop, breathe, and enjoy the fleeting gesture of life in a state of perpetual meditation through the soothing spirit of the Japanese daily life with a cinematic touch...",
    exchange_url: "https://opensea.io/collection/fadingmemories",
    external_url: "http://www.dreamingtokyo.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/4019221c0420f216ef568ed183400bd5.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/b81c5e8d27bd5898b22b34d6424ea2b3.gif?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/b81c5e8d27bd5898b22b34d6424ea2b3.gif?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/b81c5e8d27bd5898b22b34d6424ea2b3.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 86,
      floor_price: 0.1777,
      floor_price_symbol: "ETH",
      total_minted: 86,
      total_supply: null,
      total_volume: 11.0844174373,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 26,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.4263237475884616,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xeb6d90f523d6e3dcc051093e788267f0c9c73ffe",
      },
    ],
    id: 457,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:36:54.758Z",
    key: "fishballerz",
    name: "FishBallerz",
    description:
      "FishBallerz are 4,444 one-of-a-kind pieces of art minted on the Ethereum blockchain and the genesis generative collection for Sloppy Studios. Sloppy Studios was founded by former Rick & Morty Animation Supervisor Sloppypencil, and is releasing FishBallerz in partnership with Backhouse Music.\r\n\r\nThe collection is composed of over 200 visual traits and 100 audio traits. Each NFT will be an MP4 file with an accompanying GIF as the cover image. We created our own in-house code to apply an audio layer to your NFT, unlocking a new meta for you to experience.\r\n\r\n \r\n\r\nFishBallerz are an experiment created by Capt'n Glubber. After losing his father during a fishing trip while he was young, Glubber swore revenge on all fish in the sea. Day in, day out, Capt'n Glubber can be found sweeping the seas or experimenting on Fish, granting them consciousness to do his bidding.\r\n\r\nFishBallerz Glub Members grant holder-only benefits and exclusive access to Sloppy Studios.",
    exchange_url: "https://opensea.io/collection/fishballerz",
    external_url: "https://launchpad.heymint.xyz/mint/fishballerz",
    banner_image_url:
      "https://i.seadn.io/gcs/files/3ea8e5ee05a1b8225c58b170f2fcb276.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/50f74c871db31c97e9e4d275f65297a5.gif?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/50f74c871db31c97e9e4d275f65297a5.gif?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/ff8133d612bb5f1f5f8aa27241cdc92c.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/sloppystudios",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 38.22786765217392,
      num_owners: 777,
      floor_price: 0.009889,
      floor_price_symbol: "ETH",
      total_minted: 777,
      total_supply: null,
      total_volume: 21.092459959913878,
      one_day_volume: 0.009986,
      seven_day_volume: 0.19784900000000005,
      thirty_day_volume: 0.3978080000000001,
      one_day_volume_change: -0.000177,
      seven_day_volume_change: 11,
      thirty_day_volume_change: -266,
      total_sales: 1118,
      one_day_sales: 1,
      seven_day_sales: 23,
      thirty_day_sales: 49,
      total_average_price: 0.018866243255736923,
      one_day_average_price: 0,
      seven_day_average_price: 0.00860213043478261,
      thirty_day_average_price: 0.0081185306122449,
    },
    contracts: [
      {
        contract_address: "0x7e7d01e39ae07ba3653ae967ca35abbe73fd5b44",
      },
    ],
    id: 458,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:36:41.031Z",
    key: "themeanswhatdoyoumean",
    name: "What do you mean?",
    description:
      "The What do you Mean? collection is part of The Means, a The Memes by @punk6529 derivative collection. These pieces break away from The Means in terms of art, but not in terms of substance. Meaning is everywhere – here, we’ll be having a little more fun with it.\n\nMain collection: https://opensea.io/collection/themeans\n\nCollection art - Ana Novo (@Ana_Novo) – designer, digital artist, NFT portfolio manager, physical miniature extraordinaire. Collection concept – Sónia (@MOJnfts) – copywriter, idea-haver and stuff-doer",
    exchange_url: "https://opensea.io/collection/themeanswhatdoyoumean",
    external_url: "http://themeanscreator.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/473192b874a8fa41c004e4ed50ec7142.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/b844bc890e5da8b829fa118bb95902d4.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/b844bc890e5da8b829fa118bb95902d4.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/b844bc890e5da8b829fa118bb95902d4.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 178,
      floor_price: 0.015,
      floor_price_symbol: "ETH",
      total_minted: 178,
      total_supply: null,
      total_volume: 15.596019999999989,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 951,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.016399600420609874,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 459,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:36:36.329Z",
    key: "yokai-kingdom",
    name: "Yokai Kingdom Genesis",
    description:
      "Inspired by ancient Japanese mythology, Yokai Kingdom is a web3 game universe, building the roguelike deckbuilder game ONI'S QUEST\n\nPLAY NOW!\nThe early-access beta version of ONI'S QUEST is now free to try on Hyperplay: \nhttps://store.hyperplay.xyz/game/onisquest\n\nFollow our socials for future game updates:\nhttps://linktr.ee/YokaiKingdom",
    exchange_url: "https://opensea.io/collection/yokai-kingdom",
    external_url: "https://yokai-kingdom.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/206e02a81ab326ca00486bba43658efc.png?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/2a36c20035c7620b698a6e117801526c.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/FncuawMDyZ",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 33.06613333333333,
      num_owners: 3269,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 3269,
      total_supply: null,
      total_volume: 2703.032102889424,
      one_day_volume: 0.0112,
      seven_day_volume: 0.0112,
      thirty_day_volume: 0.0252,
      one_day_volume_change: 3,
      seven_day_volume_change: 3,
      thirty_day_volume_change: 6,
      total_sales: 14425,
      one_day_sales: 3,
      seven_day_sales: 3,
      thirty_day_sales: 10,
      total_average_price: 0.18738524110151986,
      one_day_average_price: 0.003733333333333333,
      seven_day_average_price: 0.003733333333333333,
      thirty_day_average_price: 0.00252,
    },
    contracts: [
      {
        contract_address: "0x35b0ecc952cef736c12a7ef3a830f438f67912b3",
      },
    ],
    id: 460,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:36:26.798Z",
    key: "aicatgirl",
    name: "AI Catgirl",
    description:
      "AI Catgirl NFT collection powered by NyanGPT. Each Catgirl has been engineered to purrfection, eagerly awaiting to shower you with love and devoted service.",
    exchange_url: "https://opensea.io/collection/aicatgirl",
    external_url: "https://aicatgirl.wtf",
    banner_image_url:
      "https://i.seadn.io/gcs/files/bbbad011dd908a7855ae226472cee28b.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/0dc7c927acde7a4a398f9522ef2125ba.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/0dc7c927acde7a4a398f9522ef2125ba.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/8baa661718dcbd7eb3d3b7b6625b3719.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 2,
      num_owners: 340,
      floor_price: 0.0688,
      floor_price_symbol: "ETH",
      total_minted: 340,
      total_supply: null,
      total_volume: 6.220422989999988,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.004,
      one_day_volume_change: 0,
      seven_day_volume_change: 2,
      thirty_day_volume_change: 2,
      total_sales: 323,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 2,
      total_average_price: 0.019258275510835875,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.002,
    },
    contracts: [
      {
        contract_address: "0xedc58b286fd420cc479f101fc1e5e972e4659f27",
      },
    ],
    id: 461,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:36:36.329Z",
    key: "yokai-kingdom",
    name: "Yokai Kingdom Genesis",
    description:
      "Inspired by ancient Japanese mythology, Yokai Kingdom is a web3 game universe, building the roguelike deckbuilder game ONI'S QUEST\n\nPLAY NOW!\nThe early-access beta version of ONI'S QUEST is now free to try on Hyperplay: \nhttps://store.hyperplay.xyz/game/onisquest\n\nFollow our socials for future game updates:\nhttps://linktr.ee/YokaiKingdom",
    exchange_url: "https://opensea.io/collection/yokai-kingdom",
    external_url: "https://yokai-kingdom.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/206e02a81ab326ca00486bba43658efc.png?w=500&auto=format",
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/2a36c20035c7620b698a6e117801526c.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/FncuawMDyZ",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 33.06613333333333,
      num_owners: 3269,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 3269,
      total_supply: null,
      total_volume: 2703.032102889424,
      one_day_volume: 0.0112,
      seven_day_volume: 0.0112,
      thirty_day_volume: 0.0252,
      one_day_volume_change: 3,
      seven_day_volume_change: 3,
      thirty_day_volume_change: 6,
      total_sales: 14425,
      one_day_sales: 3,
      seven_day_sales: 3,
      thirty_day_sales: 10,
      total_average_price: 0.18738524110151986,
      one_day_average_price: 0.003733333333333333,
      seven_day_average_price: 0.003733333333333333,
      thirty_day_average_price: 0.00252,
    },
    contracts: [
      {
        contract_address: "0x35b0ecc952cef736c12a7ef3a830f438f67912b3",
      },
    ],
    id: 462,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:35:55.367Z",
    key: "osf2",
    name: "OSF Editions Season 2",
    description: "Your second pint.",
    exchange_url: "https://opensea.io/collection/osf2",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/323e56b82d16081abcdcfa0374985dd9.gif?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/323e56b82d16081abcdcfa0374985dd9.gif?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/323e56b82d16081abcdcfa0374985dd9.gif?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/323e56b82d16081abcdcfa0374985dd9.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0.0416,
      num_owners: 374,
      floor_price: 0.0142,
      floor_price_symbol: "ETH",
      total_minted: 374,
      total_supply: null,
      total_volume: 64.695966190014,
      one_day_volume: 0.0208,
      seven_day_volume: 0.0208,
      thirty_day_volume: 0.048799999999999996,
      one_day_volume_change: 0.0208,
      seven_day_volume_change: 5,
      thirty_day_volume_change: -2,
      total_sales: 513,
      one_day_sales: 5,
      seven_day_sales: 5,
      thirty_day_sales: 7,
      total_average_price: 0.12611299452244445,
      one_day_average_price: 0.00416,
      seven_day_average_price: 0.00416,
      thirty_day_average_price: 0.006971428571428571,
    },
    contracts: [
      {
        contract_address: "0xd0020febf800010187a1f90cbeea764fa19d646f",
      },
    ],
    id: 463,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:46:38.024Z",
    key: "markbyfigure31",
    name: "MARK by Figure31",
    description:
      "Manifestations of fictive identities rendered in the style of shared visual language. Human markers, fingerprints, imagined by a machine, embodied in collective memory.  \n\nMARKS are GAN-generated images of fingerprints expressed in the shared visual language of blockchain art aesthetics: pixelation. They are unique identifiers of a fictive digital identity, coupled with names generated from a list of shortened common surnames. Once five of them are assembled, they can be used to claim a set of five rings. This second state, an unbreakable link between the digital and the physical realm, creates a trust bond between the artist and the collectors. Information about an Ethereum wallet address, private key, and a domain name is engraved on the inner side of the rings.\n\nThere are 500 MARKS, and only 42 sets of rings are available (42 have been claimed as of 22/07/2022 01:45 EST)\n\nBy Figure31 in collaboration with (GALLERY)",
    exchange_url: "https://opensea.io/collection/markbyfigure31",
    external_url: "https://www.figure31.com/introduction-to-mark",
    banner_image_url:
      "https://i.seadn.io/gcs/files/450a17c3f51d4e6e7d09c92d14ef34b8.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/60e75a2f7c649d69ae31562d2717796c.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/60e75a2f7c649d69ae31562d2717796c.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/21d8e6ed481639287910afa5f0ee3665.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: "https://t.me/guild.xyz/fic",
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 164,
      floor_price: 0.0149,
      floor_price_symbol: "ETH",
      total_minted: 164,
      total_supply: null,
      total_volume: 103.7350024898998,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 1000,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.1037350024898998,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x5872c9360cb6d6a0309f3045376e2bf8e7837971",
      },
    ],
    id: 464,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:45:51.874Z",
    key: "mekaapes",
    name: "MekaApes Game by OogaVerse",
    description:
      "With the MekaApes Game, [OogaVerse](https://opensea.io/collection/oogaverse) introduces exciting new game mechanics such as evolution, fusion and a unique levelling-up system. These features, combined with the expansive OogaVerse collection, will make MekaApes the most in depth strategy game available on the Ethereum blockchain.\r\n\r\nYour NFTs may accumulate an ERC-20 utility token (“OG”) when they are staked in the smart contract. OG has no other functionality other than within the MekaApes Game ecosystem, and it cannot be purchased from The MekaApes Game Developers. (1 OG = 1 OG)",
    exchange_url: "https://opensea.io/collection/mekaapes",
    external_url: "http://mekaapes.game",
    banner_image_url:
      "https://i.seadn.io/gae/2xNFSLA_eBjkU0Vnt2UO1J0ZpcVjfzHTusfEN5v9zjHmJkugff5KPC2Yxf36G8oTooOUW93MYr-_QX84MQ2oqEl-Y1IoJCX2O8cgww?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/Ng_rWG3WsEFVwNexF0udzvuMg4BnoxKlq3XAKhTkZXF6Xd_FjJbgnYCE1VBhHj4p78uFAjSW38r86hq5wEJUwp_ew-xNulnlupOk-Q?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/Ng_rWG3WsEFVwNexF0udzvuMg4BnoxKlq3XAKhTkZXF6Xd_FjJbgnYCE1VBhHj4p78uFAjSW38r86hq5wEJUwp_ew-xNulnlupOk-Q?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/JyBj6Saua8aKejfxRGvndGs_qp-AwSmXMDG780QR6zlIocvNPUNm0fy8c5QVdCPBv4j0VcIng2JhVwR2P-H8cDSMyhpw2zCM-WOf-g?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/BNDGbDb98n",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 145.41178,
      num_owners: 2200,
      floor_price: 0.0030999,
      floor_price_symbol: "ETH",
      total_minted: 2200,
      total_supply: null,
      total_volume: 7441.216310359667,
      one_day_volume: 0.012299999999999998,
      seven_day_volume: 0.018099999999999998,
      thirty_day_volume: 0.018099999999999998,
      one_day_volume_change: 0.012299999999999998,
      seven_day_volume_change: 5,
      thirty_day_volume_change: -32,
      total_sales: 28523,
      one_day_sales: 3,
      seven_day_sales: 5,
      thirty_day_sales: 5,
      total_average_price: 0.2608847705486683,
      one_day_average_price: 0.004099999999999999,
      seven_day_average_price: 0.00362,
      thirty_day_average_price: 0.00362,
    },
    contracts: [
      {
        contract_address: "0xc71a726d390bf02b4af8920c0820970310d0f367",
      },
    ],
    id: 465,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:45:41.091Z",
    key: "eternal-rose-nft",
    name: "Eternal Roses",
    description:
      "The dreary machinations of this troubled plane foiled a daring sacrifice to transmute an item of grand significance.\r\n\r\nBut transcendent power cannot be silenced. Suppress it in one world, and it will bloom in another. Perhaps in another form than you knew.\r\n\r\nBut its soul rings true, and the story renews.",
    exchange_url: "https://opensea.io/collection/eternal-rose-nft",
    external_url: "https://twitter.com/lotus_keeper",
    banner_image_url:
      "https://i.seadn.io/gcs/files/828af659849b7e7331f6adb3eee96db0.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/ba50889233a4260775f6c45361e532ef.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/ba50889233a4260775f6c45361e532ef.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/ad46452fff492e2d8f60e107349e3cb6.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 461,
      floor_price: 0.0799,
      floor_price_symbol: "ETH",
      total_minted: 461,
      total_supply: null,
      total_volume: 6.7137286898751745,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0016,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 102,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.06582086950858014,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0016,
    },
    contracts: [
      {
        contract_address: "0x12cbc389519e05245879016636220903aa4d2139",
      },
    ],
    id: 466,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:45:12.687Z",
    key: "babyrareapepeyachtclub",
    name: "Baby Rare Apepe YC",
    description:
      "\nStaking here: https://staking.babyrareapepeyc.xyz/\nBaby Rare Apepes is an homage to two of NFT culture's most iconic works: @BoredApeYC and #RarePepes (unaffiliated). \nCollections of 5,555 hand-drawn Baby Rare Apepes that inspired from [Rare Apepe YC](https://opensea.io/collection/rareapepeyachtclub)",
    exchange_url: "https://opensea.io/collection/babyrareapepeyachtclub",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gcs/files/9ed31afe09ed98965159f21b373e22c1.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/9ed31afe09ed98965159f21b373e22c1.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/9ed31afe09ed98965159f21b373e22c1.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/880620d960105bc6aa4f22c1eaaefd25.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1138,
      floor_price: 0.0077,
      floor_price_symbol: "ETH",
      total_minted: 1138,
      total_supply: null,
      total_volume: 861.3237987780458,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0048,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 8508,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 3,
      total_average_price: 0.10123692980465983,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0016,
    },
    contracts: [
      {
        contract_address: "0x9450ff0503f3fbf2bc85e9d71f46e47d61777f63",
      },
    ],
    id: 467,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:44:36.089Z",
    key: "the-treachery-of-images-open-editions-by-highlight",
    name: "The Treachery of Images | Open Editions by Highlight",
    description:
      "# Open Editions by Highlight \r\n\r\n# 02\r\n\r\n# Title\r\n\r\nThe Treachery of Images (Remix) \r\n\r\n# Description\r\n\r\nThe Treachery of Images (French: La Trahison des Images) is a 1929 painting by Belgian surrealist painter René Magritte. The painting is sometimes given as an example of meta message conveyed by paralanguage. Magritte painted it when he was 30 years old and it is now on display at the Los Angeles County Museum of Art.\r\n\r\n“The famous pipe. How people reproached me for it! And yet, could you stuff my pipe? No, it's just a representation, is it not? So if I had written on my picture “This is a pipe”, I'd have been lying!” —René Magritte\r\n\r\nhighlight.xyz\r\n⎄",
    exchange_url:
      "https://opensea.io/collection/the-treachery-of-images-open-editions-by-highlight",
    external_url: "http://highlight.xyz",
    banner_image_url:
      "https://i.seadn.io/gcs/files/50ebd15584ed7e9d7636d93c9d5ba366.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/555ccc8345f727507c1e1a0ce36a78cc.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/555ccc8345f727507c1e1a0ce36a78cc.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/7ef659f159bebb7454bd4a97981b6cbb.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 2277,
      floor_price: 0.098,
      floor_price_symbol: "ETH",
      total_minted: 2277,
      total_supply: null,
      total_volume: 428.9987418709,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0064,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 4,
      total_sales: 393,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 4,
      total_average_price: 1.0915998520888042,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0016,
    },
    contracts: [
      {
        contract_address: "0xb0cf1a355bf66170cfbdd4f314d56c1a02fb08b2",
      },
    ],
    id: 468,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:35:44.529Z",
    key: "miladyrave",
    name: "MiladyRave",
    description:
      "milady rave maker is a collection of 5,000 generative pfp nft's in a neochibi aesthetic inspired by the milady rave.",
    exchange_url: "https://opensea.io/collection/miladyrave",
    external_url: "http://miladyrave.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/62ab7586a4585a441d329816ce4705bf.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/37d64cd13544707cb8d0a42830a69733.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/37d64cd13544707cb8d0a42830a69733.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/37d64cd13544707cb8d0a42830a69733.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/Ac85vEmRhg",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 5,
      num_owners: 816,
      floor_price: 0.0139,
      floor_price_symbol: "ETH",
      total_minted: 816,
      total_supply: null,
      total_volume: 8.991078253536315,
      one_day_volume: 0.002,
      seven_day_volume: 0.002,
      thirty_day_volume: 0.08265800000000001,
      one_day_volume_change: 0.002,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 4,
      total_sales: 506,
      one_day_sales: 1,
      seven_day_sales: 1,
      thirty_day_sales: 7,
      total_average_price: 0.017768929354814854,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.011808285714285716,
    },
    contracts: [
      {
        contract_address: "0x880a965fae95f72fe3a3c8e87ed2c9478c8e0a29",
      },
    ],
    id: 469,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:35:09.909Z",
    key: "glyph-punks",
    name: "Glyph Punks",
    description:
      "Boutique collection that uses Punks as canvas to explore fun themes and styles.     \nMade out of glyphs using an original technique. 100% Glyph, 100% Punk !   \nTotal Supply: 500    \n \nFor non-punk glyph pieces check out the [Glyph Punk Specials](https://foundation.app/@glyphart)    \n      \n*Not affiliated with Larva Labs*",
    exchange_url: "https://opensea.io/collection/glyph-punks",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gae/aodSF1TH1-4ZqLN-KcYfdJU71Q6wwMIcWv9_DKuXiBwZOTMuW16oKJcj17RkbkDqMQdd9DQT-lOhA5Q0Wsgkmm7dL0yGw3QI-GNB8A?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/aodSF1TH1-4ZqLN-KcYfdJU71Q6wwMIcWv9_DKuXiBwZOTMuW16oKJcj17RkbkDqMQdd9DQT-lOhA5Q0Wsgkmm7dL0yGw3QI-GNB8A?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/aodSF1TH1-4ZqLN-KcYfdJU71Q6wwMIcWv9_DKuXiBwZOTMuW16oKJcj17RkbkDqMQdd9DQT-lOhA5Q0Wsgkmm7dL0yGw3QI-GNB8A?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/pRYeMNxHv8wbZfHTn9oNDPj0HNgphYDl4XUiDLGyWDBKAF9OVuAPk-LGoFzTlrAObwqXJM4rVxkMtwhGMWR3_G2pqmxpt_MOF8mh?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/UFEHggEe",
    telegram_url: null,
    twitter_username: "GlyphPunksNFT",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 202,
      floor_price: 0.03844820000000002,
      floor_price_symbol: "ETH",
      total_minted: 202,
      total_supply: null,
      total_volume: 42.053305180167015,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.194,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 4,
      total_sales: 593,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 5,
      total_average_price: 0.07091619760567794,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.0388,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 470,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:34:53.633Z",
    key: "proof-of-beauty",
    name: "HASH by Pob Studio",
    description:
      "A series of generative art collections generated from on-chain transaction records on Ethereum to represent moments of blockchain history with NFTs.\r\n\r\nThis collection page is no longer in use. \r\n\r\nMigrate your HASH NFT to the new ERC-721 HASH collection contract on https://hash.pob.studio\r\n\r\nNew collection page: https://opensea.io/collection/hash-by-pob\r\n\r\nTo learn more about HASH by Pob Studio visit: https://www.pob.studio/hash",
    exchange_url: "https://opensea.io/collection/proof-of-beauty",
    external_url: "https://hash.pob.studio",
    banner_image_url:
      "https://i.seadn.io/gae/uUQs83zN4FM6z-UiC-ZlyALuBvP0snQQjCVKI3zLTxE6KQZPaCxqWnCsGEbaIhYdz0MgeTZNXetXKa5wDJtdNxQ6ifok1K7Rb3Afjg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/Q65gKkAR54vU-vFKYp2dcMbOrq6gLc2VHIRL1f-t84iAs-azBLIaS_ebt6Oju-MicveecKKl7bM4Pf9z-fUNj_pIFgJdGeXoXn9H3A?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/Q65gKkAR54vU-vFKYp2dcMbOrq6gLc2VHIRL1f-t84iAs-azBLIaS_ebt6Oju-MicveecKKl7bM4Pf9z-fUNj_pIFgJdGeXoXn9H3A?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/yxShAIl3R-SWTGVTE9a6vhVtLfqC86R7k6aCvJw0MDUiOmbhDL65BpvPl2XTbxYsensjEbDioaM9k89Ea1nO9C9tCzD_8FcUdPSB?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/pob",
    telegram_url: null,
    twitter_username: "prrfbeauty",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 2421,
      floor_price: 0.0045,
      floor_price_symbol: "ETH",
      total_minted: 2421,
      total_supply: null,
      total_volume: 625.8693541433745,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 1566,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.3996611456854243,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xe18a32192ed95b0fe9d70d19e5025f103475d7ba",
      },
    ],
    id: 471,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:34:12.094Z",
    key: "a5c11-punk5",
    name: "A5C11 PUNK5",
    description:
      "PUNK5 with a ASCII twist, hacking the Ethereum Blockchain.\n\nA collection that gives the user a choice of how they see the image, in ASCII or PIXEL form by clicking a button on the Image!\n\n*Please Manually Refresh Metadata if Image doesn't automatically have the ASCII/PIXEL Button in Top Left Corner of Image*",
    exchange_url: "https://opensea.io/collection/a5c11-punk5",
    external_url: "http://a5c11punk5.xyz",
    banner_image_url:
      "https://i.seadn.io/gcs/files/749cd91b7ef5815c8011cb2069bd596f.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/749cd91b7ef5815c8011cb2069bd596f.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/749cd91b7ef5815c8011cb2069bd596f.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/02d0cfaee9d5284cf6490dfa3313f8da.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/pw3kf8xTaF",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1468,
      floor_price: 0.0029,
      floor_price_symbol: "ETH",
      total_minted: 1468,
      total_supply: null,
      total_volume: 15.53091536999984,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 1721,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.00902435524113878,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xa8386f29cd53533c4670abdf64dcf66d7d5b2925",
      },
    ],
    id: 472,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:33:56.366Z",
    key: "sinsofshadow",
    name: "Sins of Shadow",
    description: "377 Genesis SINS NFTs from Sombra Network ",
    exchange_url: "https://opensea.io/collection/sinsofshadow",
    external_url: "https://sinsofshadow.io",
    banner_image_url:
      "https://i.seadn.io/gae/Ct_CuuyVgbJZ-YoVWbRfZMPxjUVg6JbCaq_957N79yjKy7pS6YAhI3zxPKrEGOuoFhXnKECyR-kTfJzV9b-ZlYxHTVnlVAxUPFxxUA?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/RWixg2mUMR6lCGIbcXItOagaE3socZ2qmRXnvSXR7KWl056etb8q35PMQ6YRSbg5wKnxxvm68Vz4yTO367JGfPEBKg9KyAJVA6e3?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/RWixg2mUMR6lCGIbcXItOagaE3socZ2qmRXnvSXR7KWl056etb8q35PMQ6YRSbg5wKnxxvm68Vz4yTO367JGfPEBKg9KyAJVA6e3?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/u8VKO3PJsl7VWj5htk41mfLv9XzQP1LPsrYtj1Yuk8FBmVoYFxd0oYJ1-g8YgtHxbA2LoUyHNrboTOZxDdB9ZVJQLGApeHxjc1rH4A?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/sombranetwork",
    telegram_url: "https://t.me/sombranetwork",
    twitter_username: null,
    wiki_url: null,
    instagram_username: "sombranetwork",
    stats: {
      market_cap: 0,
      num_owners: 130,
      floor_price: 0.0229,
      floor_price_symbol: "ETH",
      total_minted: 130,
      total_supply: null,
      total_volume: 6.9097,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 62,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.11144677419354838,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x7fdc538356b1c137dc238001e92d480f197dedeb",
      },
    ],
    id: 473,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:33:48.196Z",
    key: "pranksy",
    name: "Pranksy",
    description:
      "Having spent years in the world of dapps, nfts and tokenised art, Pranksy offers a unique creative perspective of the technological revolution of the blockchain.",
    exchange_url: "https://opensea.io/collection/pranksy",
    external_url: null,
    banner_image_url: null,
    featured_image_url:
      "https://storage.googleapis.com/opensea-static/featured-images/pranksy-featured.png",
    large_image_url:
      "https://i.seadn.io/gae/RedNcZ_RXChPLM0oh0D-4_sO4TX_IB3gdateoykU5F-22IZUywmZrqsI5wqi5u7SfmWvN3YVZAXmMIZOV6ZeaN1NOQ?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/RedNcZ_RXChPLM0oh0D-4_sO4TX_IB3gdateoykU5F-22IZUywmZrqsI5wqi5u7SfmWvN3YVZAXmMIZOV6ZeaN1NOQ?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 106,
      floor_price: 0.056,
      floor_price_symbol: "ETH",
      total_minted: 106,
      total_supply: null,
      total_volume: 105.71079311256457,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 249,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.42454133780146414,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xc563b7d10c04c1e1ffccbfa31cb3d67b9698aa8a",
      },
    ],
    id: 474,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:33:30.628Z",
    key: "async-music",
    name: "Async Music",
    description:
      'Create and collect #ProgrammableArt and #ProgrammableMusic: digital paintings and music split into "Layers" which let YOU affect the overall work.',
    exchange_url: "https://opensea.io/collection/async-music",
    external_url: "http://async.art/music",
    banner_image_url:
      "https://i.seadn.io/gae/QzHcRAHyFKFe8vHcuyvsO5nrIYsFrLB49eIfeQspHCeXxeZFoLodCGEHPAJdDMp0x3y7H0uTfx62S1MMkMord8f_g9m6xrY49J8ORg?w=500&auto=format",
    featured_image_url:
      "https://storage.googleapis.com/opensea-prod.appspot.com/static/featured/async-art-featured.png",
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/GHuVPCTdGQZvPQc-Q8sSDXkNg_RepaUOZk5J6cU9AKzwfABb2lOkA3pB_5i_CJPDzmzrRchZtZdM5zNrxaN40HY?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: "asyncart",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1006,
      floor_price: 0.0081,
      floor_price_symbol: "ETH",
      total_minted: 1006,
      total_supply: null,
      total_volume: 122.41327100000004,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 988,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.12390007186234822,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x100b8361baa522d69df839f0089fa1728aaa1aa8",
      },
    ],
    id: 475,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:33:08.112Z",
    key: "pollenbypetio",
    name: "Pollen by Petio",
    description: "Pollen Collection by Petio",
    exchange_url: "https://opensea.io/collection/pollenbypetio",
    external_url: "https://www.pollennfts.art/",
    banner_image_url:
      "https://i.seadn.io/gcs/files/f41e6f65594a9d2594517ccf235c4a61.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/2666def8c382ae81776717975aeb8e94.gif?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/2666def8c382ae81776717975aeb8e94.gif?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/2666def8c382ae81776717975aeb8e94.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1458,
      floor_price: 0.0033,
      floor_price_symbol: "ETH",
      total_minted: 1458,
      total_supply: null,
      total_volume: 411.21027459163963,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 5462,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.07528565993988276,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xfc97521a6105f23be6be2dd4201da22e55dc5b8d",
      },
    ],
    id: 476,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:32:41.451Z",
    key: "tomb-index-marker",
    name: "Tomb Index Marker",
    description: null,
    exchange_url: "https://opensea.io/collection/tomb-index-marker",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gcs/files/ae61e1a917503dc25e35fd10e93b68e5.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 668,
      floor_price: 0.025,
      floor_price_symbol: "ETH",
      total_minted: 668,
      total_supply: null,
      total_volume: 1.08,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 7,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.1542857142857143,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xa5c93e5d9eb8fb1b40228bb93fd40990913db523",
      },
    ],
    id: 477,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:32:41.047Z",
    key: "pathways-open-edition",
    name: "Pathways Open Edition",
    description: "None",
    exchange_url: "https://opensea.io/collection/pathways-open-edition",
    external_url: null,
    banner_image_url: null,
    featured_image_url: null,
    large_image_url:
      "https://i.seadn.io/gae/FQyEYb0AhaJELZYUE9Z32Fyz4zssN5lR7SLo5whQbYCsEQpRxoznrgNGYOf-4-zU9MGj7R2h2GIuWMze5G9iR_6pDtPPdS3gVcko?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/FQyEYb0AhaJELZYUE9Z32Fyz4zssN5lR7SLo5whQbYCsEQpRxoznrgNGYOf-4-zU9MGj7R2h2GIuWMze5G9iR_6pDtPPdS3gVcko?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 9.6,
      num_owners: 169,
      floor_price: 0.07,
      floor_price_symbol: "ETH",
      total_minted: 169,
      total_supply: null,
      total_volume: 22.703730890000003,
      one_day_volume: 0,
      seven_day_volume: 0.06,
      thirty_day_volume: 0.09,
      one_day_volume_change: 0,
      seven_day_volume_change: 2,
      thirty_day_volume_change: 2,
      total_sales: 77,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.29485364792207797,
      one_day_average_price: 0,
      seven_day_average_price: 0.03,
      thirty_day_average_price: 0.03,
    },
    contracts: [
      {
        contract_address: "0x787c99ce12603a1d2809b42a1024253724e8c9e8",
      },
    ],
    id: 478,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:32:27.035Z",
    key: "enterblitz",
    name: "Blitz",
    description:
      "Join the revival: https://discord.gg/Vu7eywFQFW\n\nBlitz is the next evolution of social communities. A gamified representation of humanity. Creating the abyss of collective consciousness. Accelerate the creation of social bonds.",
    exchange_url: "https://opensea.io/collection/enterblitz",
    external_url: null,
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/7b74b0622fcdd8ad1bac367147f0e62d.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/7b74b0622fcdd8ad1bac367147f0e62d.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/c0369fd2ca926bfeb942bfcba2b8de6d.gif?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1371,
      floor_price: 0.0043,
      floor_price_symbol: "ETH",
      total_minted: 1371,
      total_supply: null,
      total_volume: 27.452751999,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.0119,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 2,
      total_sales: 985,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 2,
      total_average_price: 0.02787081421218274,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.005950000000000001,
    },
    contracts: [
      {
        contract_address: "0x9ae799e88bacadbe798f1ee8040f6672b1470a29",
      },
    ],
    id: 479,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:32:22.876Z",
    key: "fourscore",
    name: "Fourscore",
    description:
      "500 randomly generated paintings, made with images of fresh paint on canvas and paper. Created with p5.js.",
    exchange_url: "https://opensea.io/collection/fourscore",
    external_url: "https://nft.bueno.art/mint/1wBI1sjmZEL4J4ho3pdzO",
    banner_image_url:
      "https://i.seadn.io/gcs/files/f13d94e6b4437cba9e9594046b31a4a7.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/e30fc0590825049eda68c53fdc35f343.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/e30fc0590825049eda68c53fdc35f343.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/3f5076021036c63c4c543b1876e15d2f.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/h2fCvk3RyA",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 186,
      floor_price: 0.0087,
      floor_price_symbol: "ETH",
      total_minted: 186,
      total_supply: null,
      total_volume: 37.92236027888796,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 782,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.0484940668527979,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x691bb1d9731b589ff832edcb2ada68539d5a8a57",
      },
    ],
    id: 480,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:32:10.902Z",
    key: "cryptopia-metaverse",
    name: "Cryptopia - Frontier Ships",
    description:
      "Ahoy Seadog! Mint your [Jolly Roger edition](https://app.cryptopia.com/early-access/#pirates) now.\r\n\r\nCryptopia—Embark on a Blockchain Adventure: A New Generation of Game Where You Make Eternal Decisions and Face Real Consequences. Master Your Craft and Ascend to Grandmaster. Become Indispensable to Players and Forge your Fortunes!\r\n\r\nOpt into Cryptopia’s Early Access to Claim Land, get a Special Edition Ship, and Explore the World of Cryptopia Ahead of Everyone else.\r\n\r\n[Claim while you still can](https://app.cryptopia.com/early-access)",
    exchange_url: "https://opensea.io/collection/cryptopia-metaverse",
    external_url: "https://app.cryptopia.com/early-access",
    banner_image_url:
      "https://i.seadn.io/gcs/files/2e7d88cd3408656cf735591a9b00214e.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/beffb76f341b16c9e933b05d01ae266c.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/beffb76f341b16c9e933b05d01ae266c.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/49189d61e57f6817c7cdbcfe3eeb610a.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/cryptopia",
    telegram_url: "https://t.me/cryptopia_ofcl2022",
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 295,
      floor_price: 0.09,
      floor_price_symbol: "ETH",
      total_minted: 295,
      total_supply: null,
      total_volume: 4.564,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.09,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 11,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.4149090909090909,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.09,
    },
    contracts: [
      {
        contract_address: "0xa28e9f5a71890340c51cfa08e08d705d8c8233f8",
      },
    ],
    id: 481,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:32:10.467Z",
    key: "memories-of-landscape-303",
    name: "Memories of Landscape 303 by Dao Bomb",
    description:
      'The combination of the Chinese Song Dynasty\'s "Thousand Miles of Rivers and Mountains " with a futuristic background creates a unique visual effect. The colours in the painting are predominantly azure, echoing the assorted mineral pigments of the original, while adding a futuristic atmosphere.The figures and scenery in the paintings are blurred and abstracted, leaving only some abstract lines and colour blocks. This is to express a feeling of dissolution and alienation of traditional culture, as well as to highlight a sense of imagination and exploration of the future world.',
    exchange_url: "https://opensea.io/collection/memories-of-landscape-303",
    external_url: "https://linktr.ee/ULTILAND",
    banner_image_url:
      "https://i.seadn.io/s/raw/files/9360e2f997109abc2323d6380a5c2c1c.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/s/raw/files/fcbfaec62774c86f3793199739e91497.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/fcbfaec62774c86f3793199739e91497.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/19b98d473c9cde24196e9a7c46af2c8b.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/ultiland",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 225,
      floor_price: 0.0199,
      floor_price_symbol: "ETH",
      total_minted: 225,
      total_supply: null,
      total_volume: 19.067699999989998,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 138,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.1381717391303623,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0xea2b1f40a25d93d2e55af86c9292e29e1833998a",
      },
    ],
    id: 482,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:32:05.729Z",
    key: "2023-u-s-womens-open-artball",
    name: "2023 U.S. Women’s Open ArtBall",
    description:
      "Own the ball. Own the shot. Own the moment.\n\nThe 2023 U.S. Women’s Open ArtBall exists at the intersection of sport and innovation, a program that unlocks a new course to keep fans in the championship – on and off the green.\n\nCombining the ArtBall legacy with the storied history of the U.S. Women’s Open and Pebble Beach Golf Links, the U.S. Women’s Open ArtBall aims to amplify the key elements that made the ArtBall successful: real championship data, gamification and fantasy showcases the skill of the players, the beauty of the course while delivering a new channel for fans to engage in the game of golf.\n\nhttps://linktr.ee/0xArtBall",
    exchange_url: "https://opensea.io/collection/2023-u-s-womens-open-artball",
    external_url: "https://linktr.ee/0xartball",
    banner_image_url:
      "https://i.seadn.io/gcs/files/f8891be8587ef8fd61aca0afb093f4b9.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/52579e0d7daf7331b5b31a045bfcc690.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/52579e0d7daf7331b5b31a045bfcc690.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/bb2fa032dcef64f9219be0ebdbacc078.png?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/wJbBPtM5P8",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1491,
      floor_price: 0.0015,
      floor_price_symbol: "ETH",
      total_minted: 1491,
      total_supply: null,
      total_volume: 1.7839254980000003,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.004,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 4,
      total_sales: 260,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 4,
      total_average_price: 0.006861251915384617,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.001,
    },
    contracts: [
      {
        contract_address: "0xad3adc8a375d27f29a4a16c6a91c133555dec6a5",
      },
    ],
    id: 483,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:31:53.691Z",
    key: "pgfk",
    name: "PGFK",
    description:
      "PGFKs are a collection of 19,061 unique NFTs that function as avatars for the Polyient Games ecosystem. PGFKs have been migrated to the Avalanche network and have no utility on the Ethereum network.",
    exchange_url: "https://opensea.io/collection/pgfk",
    external_url: "https://www.polyientx.com",
    banner_image_url:
      "https://i.seadn.io/gae/PleIRI5dgUzvJg1K2Gu4OZHFSGz_F5tD1HkfJzI_gkQY2FI02DSSQMRrUwXQXcWMD4wW1Ciu5GAw28Du0kS5ui-7BWjsIxFLKEXYAw?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/KeO-d8SoEaa-5eC5CZPvVZRRzdim58q0yW8m3SpjMLsi6b3BNdiuzGEY4Dzj4ri2k6Bm7Hd47sbkogVLaVnJ0els7YfYJaEw3zqVb5U?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/KeO-d8SoEaa-5eC5CZPvVZRRzdim58q0yW8m3SpjMLsi6b3BNdiuzGEY4Dzj4ri2k6Bm7Hd47sbkogVLaVnJ0els7YfYJaEw3zqVb5U?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/KeO-d8SoEaa-5eC5CZPvVZRRzdim58q0yW8m3SpjMLsi6b3BNdiuzGEY4Dzj4ri2k6Bm7Hd47sbkogVLaVnJ0els7YfYJaEw3zqVb5U?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/AMPJtmF",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 936,
      floor_price: 0.0048,
      floor_price_symbol: "ETH",
      total_minted: 936,
      total_supply: null,
      total_volume: 5361.3535464889455,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 6033,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.88867123263533,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x9f9c171afde4cc6bbf6d38ae4012c83633653b85",
      },
    ],
    id: 484,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:31:49.088Z",
    key: "the-140-collection",
    name: "The 140 Collection by Twitter",
    description:
      "Yes, it’s the real Twitter. No, you cannot have an edit button.",
    exchange_url: "https://opensea.io/collection/the-140-collection",
    external_url:
      "https://app.rarible.com/collection/0xbc4ca343167a5e2d9f700cf5b6b3f849585cd6fc",
    banner_image_url:
      "https://i.seadn.io/gae/c7-0p7zsWzAlTPVsn5-cE2-Jv-Rcl9fBw4Th7QA4u_-6xJaOpwoVgKemWoExUTkazWojQY_ZvhSK6vv2cLRPtGQg4l-6jTRdR0mX?w=500&auto=format",
    featured_image_url: null,
    large_image_url:
      "https://i.seadn.io/gae/H3h0VnG9Ejh6lA4ZDKhfSmVMvfVEk4CBkshSavo4aN24POglK_g-zrk9YhkrkoKPtCThrOg832EOqnoeTcpSFZ_i6L-kvHZq-aMZCJk?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/H3h0VnG9Ejh6lA4ZDKhfSmVMvfVEk4CBkshSavo4aN24POglK_g-zrk9YhkrkoKPtCThrOg832EOqnoeTcpSFZ_i6L-kvHZq-aMZCJk?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: "Twitter",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 98,
      floor_price: 4.69,
      floor_price_symbol: "ETH",
      total_minted: 98,
      total_supply: null,
      total_volume: 3103.37625,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 1.1,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 123,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 25.230701219512195,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 1.1,
    },
    contracts: [
      {
        contract_address: "0xbc4ca343167a5e2d9f700cf5b6b3f849585cd6fc",
      },
    ],
    id: 485,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:31:45.068Z",
    key: "leo-messi-king-piece",
    name: "Lionel Messi: The King Piece",
    description:
      "Enter the “Messiverse,” an exclusive, one-of-a-kind journey into the world of Lionel Messi through his first appearance on the blockchain with authenticated NFT collections.\n\nThis collection is the ultimate way for fans to connect with Lionel Messi, featuring unique and rare moments from his career. This collection showcases Messi’s achievements, including a record 6 Ballon d’Or awards, 750 career goals, the most goals ever for a single club, the Argentine record, and 34 career trophies from La Liga & UEFA Champions League Titles to the recent Copa America crown. He’s won the Golden Ball and made the World Cup Finals. As the first-ever NFT collection of Messi, fans have the opportunity to own a piece of his legacy in digital form.",
    exchange_url: "https://opensea.io/collection/leo-messi-king-piece",
    external_url: "http://ethernity.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/4c4aa4fb707a76c3bcbf1554a6ba6783.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/2e7af8c797f33ff2391cfc89376da08d.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/2e7af8c797f33ff2391cfc89376da08d.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/b7a372dc8638870c090be7c126f99218.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: "https://t.me/ethernitychain",
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 1458,
      floor_price: 0.0127,
      floor_price_symbol: "ETH",
      total_minted: 1458,
      total_supply: null,
      total_volume: 243.15380613729513,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 1274,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.19085856054732742,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x3df25f701c97f8f95590c8dd7b0ce34d61e3b590",
      },
    ],
    id: 486,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:31:28.867Z",
    key: "paper-armada-by-kjetil-golid",
    name: "Paper Armada by Kjetil Golid",
    description:
      "Art Blocks Collection: Presents\n\nHeritage Art Blocks Collection: Playground\n\nProject Description: Perfectly symmetric - imperfectly drawn. Exploring the contrast between precision and chance in a playful spacecraft / papercraft setting. ",
    exchange_url: "https://opensea.io/collection/paper-armada-by-kjetil-golid",
    external_url: "https://artblocks.io",
    banner_image_url:
      "https://i.seadn.io/gcs/files/ef2c459a8ae055f06e76a22d8b1c468c.jpg?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/pun7k5zB0oYp2KiFdUrEkfc9PZuueRWtptwkAKYj8gc-kq6L6kdynwuMd3XKfUk1GkhLBD2Z_oRUW7XKOC27Hd10kDrwQZdV_ozAtQ?w=500&auto=format",
    large_image_url: null,
    image_url:
      "https://i.seadn.io/gae/pun7k5zB0oYp2KiFdUrEkfc9PZuueRWtptwkAKYj8gc-kq6L6kdynwuMd3XKfUk1GkhLBD2Z_oRUW7XKOC27Hd10kDrwQZdV_ozAtQ?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 894,
      floor_price: 0.075,
      floor_price_symbol: "ETH",
      total_minted: 894,
      total_supply: null,
      total_volume: 2011.2453874386038,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.3176,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: -7,
      total_sales: 3453,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 5,
      total_average_price: 0.5824631877899229,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.06352,
    },
    contracts: [
      {
        contract_address: "0xa7d8d9ef8d8ce8992df33d8b8cf4aebabd5bd270",
      },
    ],
    id: 487,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:31:01.333Z",
    key: "cpg-pop",
    name: "CPG Pop",
    description:
      "[Crypto Packaged Goods](https://www.cryptopackagedgoods.com) presents Pop.\n\nJoin community: https://medium.com/@cryptopackagedgoods/cpg-telegram-entry-faq-4e27378370a8",
    exchange_url: "https://opensea.io/collection/cpg-pop",
    external_url: "https://cryptopackagedgoods.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/c06f1dc108cff45f26ef3b1f3c886d16.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/39f2d857ccdf8ef7106301202b3e00e4.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/39f2d857ccdf8ef7106301202b3e00e4.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/39f2d857ccdf8ef7106301202b3e00e4.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: "clubcpg",
    stats: {
      market_cap: 13.875,
      num_owners: 1862,
      floor_price: 0.01,
      floor_price_symbol: "ETH",
      total_minted: 1862,
      total_supply: null,
      total_volume: 3797.871361685542,
      one_day_volume: 0,
      seven_day_volume: 0.005,
      thirty_day_volume: 0.015,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: -9,
      total_sales: 2744,
      one_day_sales: 0,
      seven_day_sales: 1,
      thirty_day_sales: 2,
      total_average_price: 1.384063907319804,
      one_day_average_price: 0,
      seven_day_average_price: 0.005,
      thirty_day_average_price: 0.0075,
    },
    contracts: [
      {
        contract_address: "0x7eaa96d48380802a75ed6d74b91e2b30c3d474c1",
      },
    ],
    id: 488,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:30:57.110Z",
    key: "graycraft1",
    name: "GRAYCRAFT1",
    description:
      "As the first statement of the GRAYCRAFT collection, GRAYCRAFT1 is the first ever NFT spaceship, a pioneer among pioneers, paving the way for all to follow. \n\nOur vision for the GRAYCRAFT1 was to create an art piece that can traverse through all aspects of reality. The GRAYCRAFT1 first begins as an NFT visual audio animation that you can display in your virtual and physical galleries. It then continues its journey as a 3D model that you can use in the Metaverse. Lastly, the GRAYCRAFT1 exists as a limited edition physical sculpture machined from aerospace grade aluminium.\n\nDiscover more at [GRAYCRAFT.com](https://graycraft.com/gc1)\n\nOur other collections: [GRAYCRAFT Omegas](https://opensea.io/collection/graycraft) & [GRAYCRAFT2](https://opensea.io/collection/graycraft-2)",
    exchange_url: "https://opensea.io/collection/graycraft1",
    external_url: "https://graycraft.com/gc1",
    banner_image_url:
      "https://i.seadn.io/gae/itCWNfeCGdTM4e3Rpott7WI5aNMHpiAWnMBje5sIbWerJn6ccFvjH4OZe5jhEDZvos-oUeaKCtgtnU-Kzvh_hmqg2cPCsc1h9wB7Ag?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/P8aDhuBpVJBDeHGh8njF9ja6fvK7b9wQTPlYMLLQ8W2SE-9_Hcx_GPpptqckUOfjcFL1J58l5P_IolCCHA4hlbgFeoDwSU62egcM?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/P8aDhuBpVJBDeHGh8njF9ja6fvK7b9wQTPlYMLLQ8W2SE-9_Hcx_GPpptqckUOfjcFL1J58l5P_IolCCHA4hlbgFeoDwSU62egcM?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/f335dd2c4d166907e9df6bc6025ecc2c.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/graycraft",
    telegram_url: null,
    twitter_username: "graycraftnft",
    wiki_url: null,
    instagram_username: "graycraftnft",
    stats: {
      market_cap: 0,
      num_owners: 58,
      floor_price: 0.0849,
      floor_price_symbol: "ETH",
      total_minted: 58,
      total_supply: null,
      total_volume: 137.46176369851565,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 127,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 1.0823760921142964,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x9030807ba4c71831808408cbf892bfa1261a6e7d",
      },
    ],
    id: 489,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:30:53.023Z",
    key: "photonknight-collection",
    name: "The Collection: into the metaverse",
    description: "The truth you can not deny",
    exchange_url: "https://opensea.io/collection/photonknight-collection",
    external_url: null,
    banner_image_url:
      "https://i.seadn.io/gae/ID6Zb6HJPZb54IeygqUK9NXL-LKQfDosMx4XzVNPEk-MyKPk0PMc2CX3JqMuil1WpM8knJ1mPWbNvYkkXX0r4DWjcflrw5bOoknxfw?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/ID6Zb6HJPZb54IeygqUK9NXL-LKQfDosMx4XzVNPEk-MyKPk0PMc2CX3JqMuil1WpM8knJ1mPWbNvYkkXX0r4DWjcflrw5bOoknxfw?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/ID6Zb6HJPZb54IeygqUK9NXL-LKQfDosMx4XzVNPEk-MyKPk0PMc2CX3JqMuil1WpM8knJ1mPWbNvYkkXX0r4DWjcflrw5bOoknxfw?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/wcMBwfV5nwmGoKoMddRrxIXEV3gy4KulFo6M4HeOmXCkZFC8EmNLSeqUn2WUgOPOFvyn2BB1HncFJ-Z3-y-tBsZZDX9QpuslYj5w?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 23,
      floor_price: 0.05,
      floor_price_symbol: "ETH",
      total_minted: 23,
      total_supply: null,
      total_volume: 1.0800000000000003,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 24,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.04500000000000001,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x495f947276749ce646f68ac8c248420045cb7b5e",
      },
    ],
    id: 490,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:30:48.837Z",
    key: "unfoldrian",
    name: "Unfoldrian by Adam Swaab",
    description:
      "Unfoldrian is a generative series of motion pieces that explores the inner beauty of Kd-Trees through a custom unfolding algorithm. This algorithm transforms the Kd-Trees to reveal a new structure, both complex and beautiful.",
    exchange_url: "https://opensea.io/collection/unfoldrian",
    external_url: "https://www.adamswaab.com/unfoldrian",
    banner_image_url:
      "https://i.seadn.io/gae/cRngzYAI02KHaMl5gpvC0lXOj6xZe7BZsfP5voIXHARV2dl9WyKGP9qhTMkPHAgk8wPH9TVGspP2k_2RjWZ4A1LsU8GN-kZQoYDJ1Qs?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/em_aGkJC5lr8VFFeIjKPzU31czXSbX8tahuxIy8mD2sUGyYJ0HGlIojVVm4sTLehmmuj77pvUi-oLTJNLrsPPTM3TZuH6dw_UE1gGg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/em_aGkJC5lr8VFFeIjKPzU31czXSbX8tahuxIy8mD2sUGyYJ0HGlIojVVm4sTLehmmuj77pvUi-oLTJNLrsPPTM3TZuH6dw_UE1gGg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/aHCsBHHxgha9LzxllcsJXr6veJMzylqsRzrZi9jhBBiVQCKo36Xfg8raZMlDM5wjP9NxvnYzPhTTHcyCmP21G2n4vrvumUU7NBRb?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 70,
      floor_price: 0.0349,
      floor_price_symbol: "ETH",
      total_minted: 70,
      total_supply: null,
      total_volume: 35.0418,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 42,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.8343285714285715,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x778e48a87b2ee5120288f4e51e59305aeb527ca2",
      },
    ],
    id: 491,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:30:35.379Z",
    key: "classics-art",
    name: "Classics",
    description:
      "'Classics' This artistic project is a celebration of the NFT space's evolution. It's a nod to the roots of Ethereum-based collections while trying to push the boundaries of contemporary art on the blockchain and in the 'PFP market'. \n\nJust a sleek reinterpretation that pays homage to the classics. \n\n\"Classics\" is my way of blending pfp project with contemporary flair, redefining these legendary NFTs in a fresh, avant-garde light. \n\nDisclaimer: Each one is hand drawn and unique but pays tribute to an existing token; this artistic project is not affiliated with any of your favorites collections.",
    exchange_url: "https://opensea.io/collection/classics-art",
    external_url: null,
    banner_image_url: null,
    featured_image_url:
      "https://i.seadn.io/s/raw/files/60aa33d12cc434c7cfe4285a852c8de7.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/s/raw/files/60aa33d12cc434c7cfe4285a852c8de7.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/s/raw/files/626da2eeb7bbabd1363f1fa967f98996.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 13,
      floor_price: 1,
      floor_price_symbol: "ETH",
      total_minted: 13,
      total_supply: null,
      total_volume: 0,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 0,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x64aa47d6a0cfb1d804250323d71c028f6491bbc8",
      },
    ],
    id: 492,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:30:31.289Z",
    key: "metaanigen",
    name: "MetaaniGEN",
    description: "Metaani is CryptoArt Collaboration Avatar for metaverse",
    exchange_url: "https://opensea.io/collection/metaanigen",
    external_url: "https://conata.world/metaani/gen",
    banner_image_url:
      "https://i.seadn.io/gae/TocEXIa9yhikehjmSO5-hLoqhdvUvDGPaGgEeQNnMgNGcFZ3qdX_Pq1c_G6vfKPTxHWKtz330Tt1TuYhUM34WL2vh2iXWZXJmAjDUA?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gae/cISAuRN7K1L0if7Wmrf1at7GXy1tseXL2TNTRGKFVy0qujxzQetN6lodDHo9ams0kYLOZyrknFwLB86R0phBhm5E65GBQbU4buitag?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gae/cISAuRN7K1L0if7Wmrf1at7GXy1tseXL2TNTRGKFVy0qujxzQetN6lodDHo9ams0kYLOZyrknFwLB86R0phBhm5E65GBQbU4buitag?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gae/IbbrOhfQ4eCNbP1CQwK2zb03mpXrsFHkIa8Ok0r4CFdV3wSzwAVZzTSUMtzeaI2-dyj9qUp6au6zsgzte5VTu2wwSDJf-5ctnSv6FnM?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/TKMpdE6TkH",
    telegram_url: null,
    twitter_username: "metaani2",
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 845,
      floor_price: 0.006,
      floor_price_symbol: "ETH",
      total_minted: 845,
      total_supply: null,
      total_volume: 99.5515524801587,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0.000901,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 1,
      total_sales: 504,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 1,
      total_average_price: 0.19752292158761647,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0.000901,
    },
    contracts: [
      {
        contract_address: "0xa467ab9447afa5db0c70325348d810d2058dde18",
      },
    ],
    id: 493,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:30:18.948Z",
    key: "decal-by-rata",
    name: "Decal by Rata",
    description:
      "An interpretation of the Decal by Rata. A symbol of permissionless creativity. Series Eight.",
    exchange_url: "https://opensea.io/collection/decal-by-rata",
    external_url: "http://deca.art/decal",
    banner_image_url:
      "https://i.seadn.io/gcs/files/ac1d43b17c32e6b31fbfe9b79f1b418b.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/ac1d43b17c32e6b31fbfe9b79f1b418b.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/ac1d43b17c32e6b31fbfe9b79f1b418b.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/030d14ae4e9d16dd1782a2e9e38d8138.png?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 98,
      floor_price: 0.0288,
      floor_price_symbol: "ETH",
      total_minted: 98,
      total_supply: null,
      total_volume: 9.153199,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 74,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.12369187837837839,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x2b656d331607e2bd6f75b6af309d0ad76f8ff03b",
      },
    ],
    id: 494,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:30:10.113Z",
    key: "decal-by-tj-thorne",
    name: "Decal by TJ Thorne",
    description:
      "An interpretation of the Decal by TJ Thorne. A symbol of permissionless creativity. Series Nine.",
    exchange_url: "https://opensea.io/collection/decal-by-tj-thorne",
    external_url: "https://deca.art/decal",
    banner_image_url:
      "https://i.seadn.io/gcs/files/15e16e9b5947c692f280d0f0c1490e23.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/e6193dbf033f73c9ba082a7d9ebca07f.jpg?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/e6193dbf033f73c9ba082a7d9ebca07f.jpg?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/50215262dec2270e118d82fe8cdd09b1.jpg?w=500&auto=format",
    chat_url: null,
    discord_url: null,
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 0,
      num_owners: 88,
      floor_price: 0.0785,
      floor_price_symbol: "ETH",
      total_minted: 88,
      total_supply: null,
      total_volume: 6.85533,
      one_day_volume: 0,
      seven_day_volume: 0,
      thirty_day_volume: 0,
      one_day_volume_change: 0,
      seven_day_volume_change: 0,
      thirty_day_volume_change: 0,
      total_sales: 52,
      one_day_sales: 0,
      seven_day_sales: 0,
      thirty_day_sales: 0,
      total_average_price: 0.13183326923076924,
      one_day_average_price: 0,
      seven_day_average_price: 0,
      thirty_day_average_price: 0,
    },
    contracts: [
      {
        contract_address: "0x50eed5a685377406f2f255dbc7d1b6f8f0ab102c",
      },
    ],
    id: 495,
  },
  {
    exchange: "opensea",
    update_at: "2025-02-16T21:29:45.288Z",
    key: "thesaudis",
    name: "The Saudis",
    description:
      "🇸🇦 5,555 Saudis are here to save your bags Alhamdulillah #MAXBIDDING\r\n\r\n🎟 Each Saudi is your entry ticket into our great Kingdom.\r\n\r\n🏰 Join the Kingdom — the strongest community in crypto — and relish in all it has to offer.",
    exchange_url: "https://opensea.io/collection/thesaudis",
    external_url: "https://www.thesaudisnft.com",
    banner_image_url:
      "https://i.seadn.io/gcs/files/2aca425f2fa402915868429bd2028151.png?w=500&auto=format",
    featured_image_url:
      "https://i.seadn.io/gcs/files/2bf748e68b1d84575c206bc9ebdd8ef8.png?w=500&auto=format",
    large_image_url:
      "https://i.seadn.io/gcs/files/2bf748e68b1d84575c206bc9ebdd8ef8.png?w=500&auto=format",
    image_url:
      "https://i.seadn.io/gcs/files/ce8eae747454d95cc98781c4654ffe30.gif?w=500&auto=format",
    chat_url: null,
    discord_url: "https://discord.gg/sShWbkjfnq",
    telegram_url: null,
    twitter_username: null,
    wiki_url: null,
    instagram_username: null,
    stats: {
      market_cap: 181.0309256785074,
      num_owners: 1770,
      floor_price: 0.035,
      floor_price_symbol: "ETH",
      total_minted: 1770,
      total_supply: null,
      total_volume: 14920.024874001483,
      one_day_volume: 0.732,
      seven_day_volume: 2.188968059999999,
      thirty_day_volume: 4.314260000000001,
      one_day_volume_change: 0.6953,
      seven_day_volume_change: 41,
      thirty_day_volume_change: 69,
      total_sales: 22128,
      one_day_sales: 19,
      seven_day_sales: 67,
      thirty_day_sales: 155,
      total_average_price: 0.6742599816522724,
      one_day_average_price: 0.038526315789473686,
      seven_day_average_price: 0.032671165074626855,
      thirty_day_average_price: 0.02783393548387097,
    },
    contracts: [
      {
        contract_address: "0xe21ebcd28d37a67757b9bc7b290f4c4928a430b1",
      },
    ],
    id: 496,
  },
];

export default data;
